
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("8Xuap", function(module, exports) {

$parcel$export(module.exports, "Integrations", () => $685b3bf3fb523046$export$99d02219d259eb94);
$parcel$export(module.exports, "FunctionToString", () => (parcelRequire("hJxS5")).FunctionToString);
$parcel$export(module.exports, "Hub", () => (parcelRequire("egVmm")).Hub);
$parcel$export(module.exports, "InboundFilters", () => (parcelRequire("lQehn")).InboundFilters);
$parcel$export(module.exports, "ModuleMetadata", () => (parcelRequire("3HnEg")).ModuleMetadata);
$parcel$export(module.exports, "SDK_VERSION", () => (parcelRequire("itB3p")).SDK_VERSION);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_OP", () => (parcelRequire("5ukjY")).SEMANTIC_ATTRIBUTE_SENTRY_OP);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN", () => (parcelRequire("5ukjY")).SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE", () => (parcelRequire("5ukjY")).SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_SOURCE", () => (parcelRequire("5ukjY")).SEMANTIC_ATTRIBUTE_SENTRY_SOURCE);
$parcel$export(module.exports, "Scope", () => (parcelRequire("XZfNs")).Scope);
$parcel$export(module.exports, "addBreadcrumb", () => (parcelRequire("fq71H")).addBreadcrumb);
$parcel$export(module.exports, "addEventProcessor", () => (parcelRequire("diF5W")).addEventProcessor);
$parcel$export(module.exports, "addGlobalEventProcessor", () => (parcelRequire("bu7hL")).addGlobalEventProcessor);
$parcel$export(module.exports, "addIntegration", () => (parcelRequire("6emiv")).addIntegration);
$parcel$export(module.exports, "addTracingExtensions", () => (parcelRequire("13ShQ")).addTracingExtensions);
$parcel$export(module.exports, "captureEvent", () => (parcelRequire("fq71H")).captureEvent);
$parcel$export(module.exports, "captureException", () => (parcelRequire("fq71H")).captureException);
$parcel$export(module.exports, "captureMessage", () => (parcelRequire("fq71H")).captureMessage);
$parcel$export(module.exports, "captureSession", () => (parcelRequire("fq71H")).captureSession);
$parcel$export(module.exports, "close", () => (parcelRequire("fq71H")).close);
$parcel$export(module.exports, "configureScope", () => (parcelRequire("fq71H")).configureScope);
$parcel$export(module.exports, "continueTrace", () => (parcelRequire("9fRGu")).continueTrace);
$parcel$export(module.exports, "createTransport", () => (parcelRequire("ldUUe")).createTransport);
$parcel$export(module.exports, "endSession", () => (parcelRequire("fq71H")).endSession);
$parcel$export(module.exports, "extractTraceparentData", () => (parcelRequire("jL5ha")).extractTraceparentData);
$parcel$export(module.exports, "flush", () => (parcelRequire("fq71H")).flush);
$parcel$export(module.exports, "functionToStringIntegration", () => (parcelRequire("hJxS5")).functionToStringIntegration);
$parcel$export(module.exports, "getActiveSpan", () => (parcelRequire("9fRGu")).getActiveSpan);
$parcel$export(module.exports, "getActiveTransaction", () => (parcelRequire("jL5ha")).getActiveTransaction);
$parcel$export(module.exports, "getClient", () => (parcelRequire("fq71H")).getClient);
$parcel$export(module.exports, "getCurrentHub", () => (parcelRequire("egVmm")).getCurrentHub);
$parcel$export(module.exports, "getCurrentScope", () => (parcelRequire("fq71H")).getCurrentScope);
$parcel$export(module.exports, "getHubFromCarrier", () => (parcelRequire("egVmm")).getHubFromCarrier);
$parcel$export(module.exports, "getSpanStatusFromHttpCode", () => (parcelRequire("lBW6h")).getSpanStatusFromHttpCode);
$parcel$export(module.exports, "inboundFiltersIntegration", () => (parcelRequire("lQehn")).inboundFiltersIntegration);
$parcel$export(module.exports, "isInitialized", () => (parcelRequire("fq71H")).isInitialized);
$parcel$export(module.exports, "lastEventId", () => (parcelRequire("fq71H")).lastEventId);
$parcel$export(module.exports, "makeMain", () => (parcelRequire("egVmm")).makeMain);
$parcel$export(module.exports, "makeMultiplexedTransport", () => (parcelRequire("bdOVf")).makeMultiplexedTransport);
$parcel$export(module.exports, "metrics", () => (parcelRequire("i6lAy")).metrics);
$parcel$export(module.exports, "moduleMetadataIntegration", () => (parcelRequire("3HnEg")).moduleMetadataIntegration);
$parcel$export(module.exports, "parameterize", () => (parcelRequire("lRIP3")).parameterize);
$parcel$export(module.exports, "setContext", () => (parcelRequire("fq71H")).setContext);
$parcel$export(module.exports, "setCurrentClient", () => (parcelRequire("4tdNk")).setCurrentClient);
$parcel$export(module.exports, "setExtra", () => (parcelRequire("fq71H")).setExtra);
$parcel$export(module.exports, "setExtras", () => (parcelRequire("fq71H")).setExtras);
$parcel$export(module.exports, "setHttpStatus", () => (parcelRequire("lBW6h")).setHttpStatus);
$parcel$export(module.exports, "setMeasurement", () => (parcelRequire("j1eGv")).setMeasurement);
$parcel$export(module.exports, "setTag", () => (parcelRequire("fq71H")).setTag);
$parcel$export(module.exports, "setTags", () => (parcelRequire("fq71H")).setTags);
$parcel$export(module.exports, "setUser", () => (parcelRequire("fq71H")).setUser);
$parcel$export(module.exports, "spanStatusfromHttpCode", () => (parcelRequire("lBW6h")).spanStatusfromHttpCode);
$parcel$export(module.exports, "startInactiveSpan", () => (parcelRequire("9fRGu")).startInactiveSpan);
$parcel$export(module.exports, "startSession", () => (parcelRequire("fq71H")).startSession);
$parcel$export(module.exports, "startSpan", () => (parcelRequire("9fRGu")).startSpan);
$parcel$export(module.exports, "startSpanManual", () => (parcelRequire("9fRGu")).startSpanManual);
$parcel$export(module.exports, "startTransaction", () => (parcelRequire("fq71H")).startTransaction);
$parcel$export(module.exports, "trace", () => (parcelRequire("9fRGu")).trace);
$parcel$export(module.exports, "withActiveSpan", () => (parcelRequire("fq71H")).withActiveSpan);
$parcel$export(module.exports, "withIsolationScope", () => (parcelRequire("fq71H")).withIsolationScope);
$parcel$export(module.exports, "withScope", () => (parcelRequire("fq71H")).withScope);
$parcel$export(module.exports, "WINDOW", () => (parcelRequire("i8T1U")).WINDOW);
$parcel$export(module.exports, "BrowserClient", () => (parcelRequire("cGpn8")).BrowserClient);
$parcel$export(module.exports, "makeFetchTransport", () => (parcelRequire("2pZps")).makeFetchTransport);
$parcel$export(module.exports, "makeXHRTransport", () => (parcelRequire("ecgG4")).makeXHRTransport);
$parcel$export(module.exports, "chromeStackLineParser", () => (parcelRequire("h8rWQ")).chromeStackLineParser);
$parcel$export(module.exports, "defaultStackLineParsers", () => (parcelRequire("h8rWQ")).defaultStackLineParsers);
$parcel$export(module.exports, "defaultStackParser", () => (parcelRequire("h8rWQ")).defaultStackParser);
$parcel$export(module.exports, "geckoStackLineParser", () => (parcelRequire("h8rWQ")).geckoStackLineParser);
$parcel$export(module.exports, "opera10StackLineParser", () => (parcelRequire("h8rWQ")).opera10StackLineParser);
$parcel$export(module.exports, "opera11StackLineParser", () => (parcelRequire("h8rWQ")).opera11StackLineParser);
$parcel$export(module.exports, "winjsStackLineParser", () => (parcelRequire("h8rWQ")).winjsStackLineParser);
$parcel$export(module.exports, "eventFromException", () => (parcelRequire("g9ymE")).eventFromException);
$parcel$export(module.exports, "eventFromMessage", () => (parcelRequire("g9ymE")).eventFromMessage);
$parcel$export(module.exports, "exceptionFromError", () => (parcelRequire("g9ymE")).exceptionFromError);
$parcel$export(module.exports, "createUserFeedbackEnvelope", () => (parcelRequire("fZzwf")).createUserFeedbackEnvelope);
$parcel$export(module.exports, "captureUserFeedback", () => (parcelRequire("5kOsg")).captureUserFeedback);
$parcel$export(module.exports, "defaultIntegrations", () => (parcelRequire("5kOsg")).defaultIntegrations);
$parcel$export(module.exports, "forceLoad", () => (parcelRequire("5kOsg")).forceLoad);
$parcel$export(module.exports, "getDefaultIntegrations", () => (parcelRequire("5kOsg")).getDefaultIntegrations);
$parcel$export(module.exports, "init", () => (parcelRequire("5kOsg")).init);
$parcel$export(module.exports, "onLoad", () => (parcelRequire("5kOsg")).onLoad);
$parcel$export(module.exports, "showReportDialog", () => (parcelRequire("5kOsg")).showReportDialog);
$parcel$export(module.exports, "wrap", () => (parcelRequire("5kOsg")).wrap);
$parcel$export(module.exports, "Breadcrumbs", () => (parcelRequire("7abYO")).Breadcrumbs);
$parcel$export(module.exports, "breadcrumbsIntegration", () => (parcelRequire("7abYO")).breadcrumbsIntegration);
$parcel$export(module.exports, "Dedupe", () => (parcelRequire("AU319")).Dedupe);
$parcel$export(module.exports, "GlobalHandlers", () => (parcelRequire("aan6Q")).GlobalHandlers);
$parcel$export(module.exports, "globalHandlersIntegration", () => (parcelRequire("aan6Q")).globalHandlersIntegration);
$parcel$export(module.exports, "HttpContext", () => (parcelRequire("fRQU9")).HttpContext);
$parcel$export(module.exports, "httpContextIntegration", () => (parcelRequire("fRQU9")).httpContextIntegration);
$parcel$export(module.exports, "LinkedErrors", () => (parcelRequire("5nexQ")).LinkedErrors);
$parcel$export(module.exports, "linkedErrorsIntegration", () => (parcelRequire("5nexQ")).linkedErrorsIntegration);
$parcel$export(module.exports, "TryCatch", () => (parcelRequire("bDzZk")).TryCatch);
$parcel$export(module.exports, "browserApiErrorsIntegration", () => (parcelRequire("bDzZk")).browserApiErrorsIntegration);
$parcel$export(module.exports, "Replay", () => (parcelRequire("hq3wB")).InternalReplay);
$parcel$export(module.exports, "getReplay", () => (parcelRequire("hq3wB")).internalGetReplay);
$parcel$export(module.exports, "replayIntegration", () => (parcelRequire("hq3wB")).internalReplayIntegration);
$parcel$export(module.exports, "ReplayCanvas", () => (parcelRequire("7xQsu")).ReplayCanvas);
$parcel$export(module.exports, "replayCanvasIntegration", () => (parcelRequire("7xQsu")).replayCanvasIntegration);
$parcel$export(module.exports, "Feedback", () => (parcelRequire("hq3wB")).Feedback);
$parcel$export(module.exports, "feedbackIntegration", () => (parcelRequire("hq3wB")).feedbackIntegration);
$parcel$export(module.exports, "sendFeedback", () => (parcelRequire("hq3wB")).sendFeedback);
$parcel$export(module.exports, "captureConsoleIntegration", () => (parcelRequire("13Shy")).captureConsoleIntegration);
$parcel$export(module.exports, "contextLinesIntegration", () => (parcelRequire("ahC8I")).contextLinesIntegration);
$parcel$export(module.exports, "debugIntegration", () => (parcelRequire("aRfWy")).debugIntegration);
$parcel$export(module.exports, "dedupeIntegration", () => (parcelRequire("cDASn")).dedupeIntegration);
$parcel$export(module.exports, "extraErrorDataIntegration", () => (parcelRequire("24Tbz")).extraErrorDataIntegration);
$parcel$export(module.exports, "httpClientIntegration", () => (parcelRequire("co6wL")).httpClientIntegration);
$parcel$export(module.exports, "reportingObserverIntegration", () => (parcelRequire("iXVbD")).reportingObserverIntegration);
$parcel$export(module.exports, "rewriteFramesIntegration", () => (parcelRequire("8jpeT")).rewriteFramesIntegration);
$parcel$export(module.exports, "sessionTimingIntegration", () => (parcelRequire("3wp2s")).sessionTimingIntegration);
$parcel$export(module.exports, "BrowserTracing", () => (parcelRequire("2G2rZ")).BrowserTracing);
$parcel$export(module.exports, "browserTracingIntegration", () => (parcelRequire("fnUdv")).browserTracingIntegration);
$parcel$export(module.exports, "defaultRequestInstrumentationOptions", () => (parcelRequire("dwq5q")).defaultRequestInstrumentationOptions);
$parcel$export(module.exports, "instrumentOutgoingRequests", () => (parcelRequire("dwq5q")).instrumentOutgoingRequests);
$parcel$export(module.exports, "startBrowserTracingNavigationSpan", () => (parcelRequire("fnUdv")).startBrowserTracingNavigationSpan);
$parcel$export(module.exports, "startBrowserTracingPageLoadSpan", () => (parcelRequire("fnUdv")).startBrowserTracingPageLoadSpan);
$parcel$export(module.exports, "makeBrowserOfflineTransport", () => (parcelRequire("6umDS")).makeBrowserOfflineTransport);
$parcel$export(module.exports, "onProfilingStartRouteTransaction", () => (parcelRequire("6cDJJ")).onProfilingStartRouteTransaction);
$parcel$export(module.exports, "BrowserProfilingIntegration", () => (parcelRequire("4Ux1y")).BrowserProfilingIntegration);
$parcel$export(module.exports, "browserProfilingIntegration", () => (parcelRequire("4Ux1y")).browserProfilingIntegration);

var $fq71H = parcelRequire("fq71H");
var $diF5W = parcelRequire("diF5W");
var $bu7hL = parcelRequire("bu7hL");
var $6emiv = parcelRequire("6emiv");
var $13ShQ = parcelRequire("13ShQ");
var $9fRGu = parcelRequire("9fRGu");
var $ldUUe = parcelRequire("ldUUe");
var $jL5ha = parcelRequire("jL5ha");
var $hJxS5 = parcelRequire("hJxS5");
var $egVmm = parcelRequire("egVmm");
var $lBW6h = parcelRequire("lBW6h");
var $lQehn = parcelRequire("lQehn");
var $f9ZNq = parcelRequire("f9ZNq");
var $bdOVf = parcelRequire("bdOVf");
var $i6lAy = parcelRequire("i6lAy");
var $3HnEg = parcelRequire("3HnEg");
var $lRIP3 = parcelRequire("lRIP3");
var $XZfNs = parcelRequire("XZfNs");
var $itB3p = parcelRequire("itB3p");
var $5ukjY = parcelRequire("5ukjY");
var $4tdNk = parcelRequire("4tdNk");
var $j1eGv = parcelRequire("j1eGv");

var $i8T1U = parcelRequire("i8T1U");

var $cGpn8 = parcelRequire("cGpn8");

var $2pZps = parcelRequire("2pZps");

var $ecgG4 = parcelRequire("ecgG4");

var $h8rWQ = parcelRequire("h8rWQ");

var $g9ymE = parcelRequire("g9ymE");

var $fZzwf = parcelRequire("fZzwf");

var $5kOsg = parcelRequire("5kOsg");

var $7abYO = parcelRequire("7abYO");

var $AU319 = parcelRequire("AU319");

var $aan6Q = parcelRequire("aan6Q");

var $fRQU9 = parcelRequire("fRQU9");

var $5nexQ = parcelRequire("5nexQ");

var $bDzZk = parcelRequire("bDzZk");

var $1UG7K = parcelRequire("1UG7K");

var $hq3wB = parcelRequire("hq3wB");

var $7xQsu = parcelRequire("7xQsu");

var $hq3wB = parcelRequire("hq3wB");

var $13Shy = parcelRequire("13Shy");
var $ahC8I = parcelRequire("ahC8I");
var $aRfWy = parcelRequire("aRfWy");
var $cDASn = parcelRequire("cDASn");
var $24Tbz = parcelRequire("24Tbz");
var $co6wL = parcelRequire("co6wL");
var $iXVbD = parcelRequire("iXVbD");
var $8jpeT = parcelRequire("8jpeT");
var $3wp2s = parcelRequire("3wp2s");

var $2G2rZ = parcelRequire("2G2rZ");
var $fnUdv = parcelRequire("fnUdv");
var $dwq5q = parcelRequire("dwq5q");

var $6umDS = parcelRequire("6umDS");

var $6cDJJ = parcelRequire("6cDJJ");

var $4Ux1y = parcelRequire("4Ux1y");
let $685b3bf3fb523046$var$windowIntegrations = {};
/** @deprecated Import the integration function directly, e.g. `inboundFiltersIntegration()` instead of `new Integrations.InboundFilter(). */ const $685b3bf3fb523046$export$99d02219d259eb94 = {
    ...$685b3bf3fb523046$var$windowIntegrations,
    // eslint-disable-next-line deprecation/deprecation
    ...(0, $f9ZNq.Integrations),
    ...$1UG7K
};

});
parcelRegister("diF5W", function(module, exports) {

$parcel$export(module.exports, "BaseClient", () => $9aecd55ddcd89637$export$4f22f74eddb7716a);
$parcel$export(module.exports, "addEventProcessor", () => $9aecd55ddcd89637$export$9aac0b9f77928fbf);

var $cSKRv = parcelRequire("cSKRv");
var $1y8R2 = parcelRequire("1y8R2");
var $dlAFs = parcelRequire("dlAFs");
var $lN8pX = parcelRequire("lN8pX");
var $3w9d5 = parcelRequire("3w9d5");
var $57iGk = parcelRequire("57iGk");
var $OGB8C = parcelRequire("OGB8C");

var $1UtEE = parcelRequire("1UtEE");

var $cQ4mt = parcelRequire("cQ4mt");

var $eIUO3 = parcelRequire("eIUO3");

var $fq71H = parcelRequire("fq71H");

var $egVmm = parcelRequire("egVmm");

var $6emiv = parcelRequire("6emiv");

var $g9AJ2 = parcelRequire("g9AJ2");

var $AQ9Bo = parcelRequire("AQ9Bo");

var $7AtVc = parcelRequire("7AtVc");

var $1WSQk = parcelRequire("1WSQk");
const $9aecd55ddcd89637$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */ class $9aecd55ddcd89637$export$4f22f74eddb7716a {
    /**
   * A reference to a metrics aggregator
   *
   * @experimental Note this is alpha API. It may experience breaking changes in the future.
   */ /** Options passed to the SDK. */ /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */ /** Array of set up integrations. */ /** Indicates whether this client's integrations have been set up. */ /** Number of calls being processed */ /** Holds flushable  */ // eslint-disable-next-line @typescript-eslint/ban-types
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        this._options = options;
        this._integrations = {};
        this._integrationsInitialized = false;
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        if (options.dsn) this._dsn = (0, $3w9d5.makeDsn)(options.dsn);
        else (0, $cQ4mt.DEBUG_BUILD) && (0, $lN8pX.logger).warn('No DSN provided, client will not send events.');
        if (this._dsn) {
            const url = (0, $1UtEE.getEnvelopeEndpointWithUrlEncodedAuth)(this._dsn, options);
            this._transport = options.transport({
                tunnel: this._options.tunnel,
                recordDroppedEvent: this.recordDroppedEvent.bind(this),
                ...options.transportOptions,
                url: url
            });
        }
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    captureException(exception, hint, scope) {
        // ensure we haven't captured this very object before
        if ((0, $1y8R2.checkOrSetAlreadyCaught)(exception)) {
            (0, $cQ4mt.DEBUG_BUILD) && (0, $lN8pX.logger).log($9aecd55ddcd89637$var$ALREADY_SEEN_ERROR);
            return;
        }
        let eventId = hint && hint.event_id;
        this._process(this.eventFromException(exception, hint).then((event)=>this._captureEvent(event, hint, scope)).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureMessage(message, // eslint-disable-next-line deprecation/deprecation
    level, hint, scope) {
        let eventId = hint && hint.event_id;
        const eventMessage = (0, $dlAFs.isParameterizedString)(message) ? message : String(message);
        const promisedEvent = (0, $dlAFs.isPrimitive)(message) ? this.eventFromMessage(eventMessage, level, hint) : this.eventFromException(message, hint);
        this._process(promisedEvent.then((event)=>this._captureEvent(event, hint, scope)).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureEvent(event, hint, scope) {
        // ensure we haven't captured this very object before
        if (hint && hint.originalException && (0, $1y8R2.checkOrSetAlreadyCaught)(hint.originalException)) {
            (0, $cQ4mt.DEBUG_BUILD) && (0, $lN8pX.logger).log($9aecd55ddcd89637$var$ALREADY_SEEN_ERROR);
            return;
        }
        let eventId = hint && hint.event_id;
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
        this._process(this._captureEvent(event, hint, capturedSpanScope || scope).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureSession(session) {
        if (!(typeof session.release === 'string')) (0, $cQ4mt.DEBUG_BUILD) && (0, $lN8pX.logger).warn('Discarded session because of missing or non-string release');
        else {
            this.sendSession(session);
            // After sending, we set init false to indicate it's not the first occurrence
            (0, $AQ9Bo.updateSession)(session, {
                init: false
            });
        }
    }
    /**
   * @inheritDoc
   */ getDsn() {
        return this._dsn;
    }
    /**
   * @inheritDoc
   */ getOptions() {
        return this._options;
    }
    /**
   * @see SdkMetadata in @sentry/types
   *
   * @return The metadata of the SDK
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * @inheritDoc
   */ getTransport() {
        return this._transport;
    }
    /**
   * @inheritDoc
   */ flush(timeout) {
        const transport = this._transport;
        if (transport) {
            if (this.metricsAggregator) this.metricsAggregator.flush();
            return this._isClientDoneProcessing(timeout).then((clientFinished)=>{
                return transport.flush(timeout).then((transportFlushed)=>clientFinished && transportFlushed);
            });
        } else return (0, $57iGk.resolvedSyncPromise)(true);
    }
    /**
   * @inheritDoc
   */ close(timeout) {
        return this.flush(timeout).then((result)=>{
            this.getOptions().enabled = false;
            if (this.metricsAggregator) this.metricsAggregator.close();
            return result;
        });
    }
    /** Get all installed event processors. */ getEventProcessors() {
        return this._eventProcessors;
    }
    /** @inheritDoc */ addEventProcessor(eventProcessor) {
        this._eventProcessors.push(eventProcessor);
    }
    /**
   * This is an internal function to setup all integrations that should run on the client.
   * @deprecated Use `client.init()` instead.
   */ setupIntegrations(forceInitialize) {
        if (forceInitialize && !this._integrationsInitialized || this._isEnabled() && !this._integrationsInitialized) this._setupIntegrations();
    }
    /** @inheritdoc */ init() {
        if (this._isEnabled()) this._setupIntegrations();
    }
    /**
   * Gets an installed integration by its `id`.
   *
   * @returns The installed integration or `undefined` if no integration with that `id` was installed.
   * @deprecated Use `getIntegrationByName()` instead.
   */ getIntegrationById(integrationId) {
        return this.getIntegrationByName(integrationId);
    }
    /**
   * Gets an installed integration by its name.
   *
   * @returns The installed integration or `undefined` if no integration with that `name` was installed.
   */ getIntegrationByName(integrationName) {
        return this._integrations[integrationName];
    }
    /**
   * Returns the client's instance of the given integration class, it any.
   * @deprecated Use `getIntegrationByName()` instead.
   */ getIntegration(integration) {
        try {
            return this._integrations[integration.id] || null;
        } catch (_oO) {
            (0, $cQ4mt.DEBUG_BUILD) && (0, $lN8pX.logger).warn(`Cannot retrieve integration ${integration.id} from the current Client`);
            return null;
        }
    }
    /**
   * @inheritDoc
   */ addIntegration(integration) {
        const isAlreadyInstalled = this._integrations[integration.name];
        // This hook takes care of only installing if not already installed
        (0, $6emiv.setupIntegration)(this, integration, this._integrations);
        // Here we need to check manually to make sure to not run this multiple times
        if (!isAlreadyInstalled) (0, $6emiv.afterSetupIntegrations)(this, [
            integration
        ]);
    }
    /**
   * @inheritDoc
   */ sendEvent(event, hint = {}) {
        this.emit('beforeSendEvent', event, hint);
        let env = (0, $eIUO3.createEventEnvelope)(event, this._dsn, this._options._metadata, this._options.tunnel);
        for (const attachment of hint.attachments || [])env = (0, $cSKRv.addItemToEnvelope)(env, (0, $cSKRv.createAttachmentEnvelopeItem)(attachment, this._options.transportOptions && this._options.transportOptions.textEncoder));
        const promise = this._sendEnvelope(env);
        if (promise) promise.then((sendResponse)=>this.emit('afterSendEvent', event, sendResponse), null);
    }
    /**
   * @inheritDoc
   */ sendSession(session) {
        const env = (0, $eIUO3.createSessionEnvelope)(session, this._dsn, this._options._metadata, this._options.tunnel);
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(env);
    }
    /**
   * @inheritDoc
   */ recordDroppedEvent(reason, category, eventOrCount) {
        if (this._options.sendClientReports) {
            // TODO v9: We do not need the `event` passed as third argument anymore, and can possibly remove this overload
            // If event is passed as third argument, we assume this is a count of 1
            const count = typeof eventOrCount === 'number' ? eventOrCount : 1;
            // We want to track each category (error, transaction, session, replay_event) separately
            // but still keep the distinction between different type of outcomes.
            // We could use nested maps, but it's much easier to read and type this way.
            // A correct type for map-based implementation if we want to go that route
            // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
            // With typescript 4.1 we could even use template literal types
            const key = `${reason}:${category}`;
            (0, $cQ4mt.DEBUG_BUILD) && (0, $lN8pX.logger).log(`Recording outcome: "${key}"${count > 1 ? ` (${count} times)` : ''}`);
            this._outcomes[key] = (this._outcomes[key] || 0) + count;
        }
    }
    /**
   * @inheritDoc
   */ captureAggregateMetrics(metricBucketItems) {
        (0, $cQ4mt.DEBUG_BUILD) && (0, $lN8pX.logger).log(`Flushing aggregated metrics, number of metrics: ${metricBucketItems.length}`);
        const metricsEnvelope = (0, $g9AJ2.createMetricEnvelope)(metricBucketItems, this._dsn, this._options._metadata, this._options.tunnel);
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(metricsEnvelope);
    }
    // Keep on() & emit() signatures in sync with types' client.ts interface
    /* eslint-disable @typescript-eslint/unified-signatures */ /** @inheritdoc */ /** @inheritdoc */ on(hook, callback) {
        if (!this._hooks[hook]) this._hooks[hook] = [];
        // @ts-expect-error We assue the types are correct
        this._hooks[hook].push(callback);
    }
    /** @inheritdoc */ /** @inheritdoc */ emit(hook, ...rest) {
        if (this._hooks[hook]) this._hooks[hook].forEach((callback)=>callback(...rest));
    }
    /* eslint-enable @typescript-eslint/unified-signatures */ /** Setup integrations for this client. */ _setupIntegrations() {
        const { integrations: integrations } = this._options;
        this._integrations = (0, $6emiv.setupIntegrations)(this, integrations);
        (0, $6emiv.afterSetupIntegrations)(this, integrations);
        // TODO v8: We don't need this flag anymore
        this._integrationsInitialized = true;
    }
    /** Updates existing session based on the provided event */ _updateSessionFromEvent(session, event) {
        let crashed = false;
        let errored = false;
        const exceptions = event.exception && event.exception.values;
        if (exceptions) {
            errored = true;
            for (const ex of exceptions){
                const mechanism = ex.mechanism;
                if (mechanism && mechanism.handled === false) {
                    crashed = true;
                    break;
                }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        const sessionNonTerminal = session.status === 'ok';
        const shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            (0, $AQ9Bo.updateSession)(session, {
                ...crashed && {
                    status: 'crashed'
                },
                errors: session.errors || Number(errored || crashed)
            });
            this.captureSession(session);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ _isClientDoneProcessing(timeout) {
        return new (0, $57iGk.SyncPromise)((resolve)=>{
            let ticked = 0;
            const tick = 1;
            const interval = setInterval(()=>{
                if (this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                } else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    }
    /** Determines whether this SDK is enabled and a transport is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._transport !== undefined;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, scope, isolationScope = (0, $egVmm.getIsolationScope)()) {
        const options = this.getOptions();
        const integrations = Object.keys(this._integrations);
        if (!hint.integrations && integrations.length > 0) hint.integrations = integrations;
        this.emit('preprocessEvent', event, hint);
        return (0, $1WSQk.prepareEvent)(options, event, hint, scope, this, isolationScope).then((evt)=>{
            if (evt === null) return evt;
            const propagationContext = {
                ...isolationScope.getPropagationContext(),
                ...scope ? scope.getPropagationContext() : undefined
            };
            const trace = evt.contexts && evt.contexts.trace;
            if (!trace && propagationContext) {
                const { traceId: trace_id, spanId: spanId, parentSpanId: parentSpanId, dsc: dsc } = propagationContext;
                evt.contexts = {
                    trace: {
                        trace_id: trace_id,
                        span_id: spanId,
                        parent_span_id: parentSpanId
                    },
                    ...evt.contexts
                };
                const dynamicSamplingContext = dsc ? dsc : (0, $7AtVc.getDynamicSamplingContextFromClient)(trace_id, this, scope);
                evt.sdkProcessingMetadata = {
                    dynamicSamplingContext: dynamicSamplingContext,
                    ...evt.sdkProcessingMetadata
                };
            }
            return evt;
        });
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, scope) {
        return this._processEvent(event, hint, scope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if (0, $cQ4mt.DEBUG_BUILD) {
                // If something's gone wrong, log the error as a warning. If it's just us having used a `SentryError` for
                // control flow, log just the message (no stack) as a log-level log.
                const sentryError = reason;
                if (sentryError.logLevel === 'log') (0, $lN8pX.logger).log(sentryError.message);
                else (0, $lN8pX.logger).warn(sentryError);
            }
            return undefined;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, scope) {
        const options = this.getOptions();
        const { sampleRate: sampleRate } = options;
        const isTransaction = $9aecd55ddcd89637$var$isTransactionEvent(event);
        const isError = $9aecd55ddcd89637$var$isErrorEvent(event);
        const eventType = event.type || 'error';
        const beforeSendLabel = `before send for type \`${eventType}\``;
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        if (isError && typeof sampleRate === 'number' && Math.random() > sampleRate) {
            this.recordDroppedEvent('sample_rate', 'error', event);
            return (0, $57iGk.rejectedSyncPromise)(new (0, $OGB8C.SentryError)(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`, 'log'));
        }
        const dataCategory = eventType === 'replay_event' ? 'replay' : eventType;
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
        return this._prepareEvent(event, hint, scope, capturedSpanIsolationScope).then((prepared)=>{
            if (prepared === null) {
                this.recordDroppedEvent('event_processor', dataCategory, event);
                throw new (0, $OGB8C.SentryError)('An event processor returned `null`, will not send event.', 'log');
            }
            const isInternalException = hint.data && hint.data.__sentry__ === true;
            if (isInternalException) return prepared;
            const result = $9aecd55ddcd89637$var$processBeforeSend(options, prepared, hint);
            return $9aecd55ddcd89637$var$_validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent('before_send', dataCategory, event);
                if (isTransaction) {
                    const spans = event.spans || [];
                    // the transaction itself counts as one span, plus all the child spans that are added
                    const spanCount = 1 + spans.length;
                    this.recordDroppedEvent('before_send', 'span', spanCount);
                }
                throw new (0, $OGB8C.SentryError)(`${beforeSendLabel} returned \`null\`, will not send event.`, 'log');
            }
            const session = scope && scope.getSession();
            if (!isTransaction && session) this._updateSessionFromEvent(session, processedEvent);
            if (isTransaction) {
                const spanCountBefore = processedEvent.sdkProcessingMetadata && processedEvent.sdkProcessingMetadata.spanCountBeforeProcessing || 0;
                const spanCountAfter = processedEvent.spans ? processedEvent.spans.length : 0;
                const droppedSpanCount = spanCountBefore - spanCountAfter;
                if (droppedSpanCount > 0) this.recordDroppedEvent('before_send', 'span', droppedSpanCount);
            }
            // None of the Sentry built event processor will update transaction name,
            // so if the transaction name has been changed by an event processor, we know
            // it has to come from custom event processor added by a user
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = 'custom';
                processedEvent.transaction_info = {
                    ...transactionInfo,
                    source: source
                };
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if (reason instanceof (0, $OGB8C.SentryError)) throw reason;
            this.captureException(reason, {
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw new (0, $OGB8C.SentryError)(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(promise) {
        this._numProcessing++;
        promise.then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            return reason;
        });
    }
    /**
   * @inheritdoc
   */ _sendEnvelope(envelope) {
        this.emit('beforeEnvelope', envelope);
        if (this._isEnabled() && this._transport) return this._transport.send(envelope).then(null, (reason)=>{
            (0, $cQ4mt.DEBUG_BUILD) && (0, $lN8pX.logger).error('Error while sending event:', reason);
        });
        else (0, $cQ4mt.DEBUG_BUILD) && (0, $lN8pX.logger).error('Transport disabled');
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.keys(outcomes).map((key)=>{
            const [reason, category] = key.split(':');
            return {
                reason: reason,
                category: category,
                quantity: outcomes[key]
            };
        });
    }
}
/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */ function $9aecd55ddcd89637$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ((0, $dlAFs.isThenable)(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!(0, $dlAFs.isPlainObject)(event) && event !== null) throw new (0, $OGB8C.SentryError)(invalidValueError);
        return event;
    }, (e)=>{
        throw new (0, $OGB8C.SentryError)(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!(0, $dlAFs.isPlainObject)(beforeSendResult) && beforeSendResult !== null) throw new (0, $OGB8C.SentryError)(invalidValueError);
    return beforeSendResult;
}
/**
 * Process the matching `beforeSendXXX` callback.
 */ function $9aecd55ddcd89637$var$processBeforeSend(options, event, hint) {
    const { beforeSend: beforeSend, beforeSendTransaction: beforeSendTransaction } = options;
    if ($9aecd55ddcd89637$var$isErrorEvent(event) && beforeSend) return beforeSend(event, hint);
    if ($9aecd55ddcd89637$var$isTransactionEvent(event) && beforeSendTransaction) {
        if (event.spans) {
            // We store the # of spans before processing in SDK metadata,
            // so we can compare it afterwards to determine how many spans were dropped
            const spanCountBefore = event.spans.length;
            event.sdkProcessingMetadata = {
                ...event.sdkProcessingMetadata,
                spanCountBeforeProcessing: spanCountBefore
            };
        }
        return beforeSendTransaction(event, hint);
    }
    return event;
}
function $9aecd55ddcd89637$var$isErrorEvent(event) {
    return event.type === undefined;
}
function $9aecd55ddcd89637$var$isTransactionEvent(event) {
    return event.type === 'transaction';
}
/**
 * Add an event processor to the current client.
 * This event processor will run for all events processed by this client.
 */ function $9aecd55ddcd89637$export$9aac0b9f77928fbf(callback) {
    const client = (0, $fq71H.getClient)();
    if (!client || !client.addEventProcessor) return;
    client.addEventProcessor(callback);
}

});
parcelRegister("cSKRv", function(module, exports) {

$parcel$export(module.exports, "createEnvelope", () => $960ee101d5d06233$export$f93f7f385160c44e);
$parcel$export(module.exports, "addItemToEnvelope", () => $960ee101d5d06233$export$d650323442802f6f);
$parcel$export(module.exports, "forEachEnvelopeItem", () => $960ee101d5d06233$export$c56c55acf0136fd3);
$parcel$export(module.exports, "envelopeContainsItemType", () => $960ee101d5d06233$export$604a45d95a155e2b);
$parcel$export(module.exports, "serializeEnvelope", () => $960ee101d5d06233$export$32f9b428425aac85);
$parcel$export(module.exports, "parseEnvelope", () => $960ee101d5d06233$export$3338d0c7b6e17a2b);
$parcel$export(module.exports, "createAttachmentEnvelopeItem", () => $960ee101d5d06233$export$d8fc80952cc31fa4);
$parcel$export(module.exports, "envelopeItemTypeToDataCategory", () => $960ee101d5d06233$export$b11169581eeaf237);
$parcel$export(module.exports, "getSdkMetadataForEnvelopeHeader", () => $960ee101d5d06233$export$d369f3b2758f6743);
$parcel$export(module.exports, "createEventEnvelopeHeaders", () => $960ee101d5d06233$export$92b6093782fe661b);

var $3w9d5 = parcelRequire("3w9d5");

var $j15Q6 = parcelRequire("j15Q6");

var $aLrZa = parcelRequire("aLrZa");
/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $960ee101d5d06233$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $960ee101d5d06233$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function $960ee101d5d06233$export$c56c55acf0136fd3(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function $960ee101d5d06233$export$604a45d95a155e2b(envelope, types) {
    return $960ee101d5d06233$export$c56c55acf0136fd3(envelope, (_, type)=>types.includes(type));
}
/**
 * Encode a string to UTF8.
 */ function $960ee101d5d06233$var$encodeUTF8(input, textEncoder) {
    const utf8 = textEncoder || new TextEncoder();
    return utf8.encode(input);
}
/**
 * Serializes an envelope.
 */ function $960ee101d5d06233$export$32f9b428425aac85(envelope, textEncoder) {
    const [envHeaders, items] = envelope;
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === 'string') parts = typeof next === 'string' ? parts + next : [
            $960ee101d5d06233$var$encodeUTF8(parts, textEncoder),
            next
        ];
        else parts.push(typeof next === 'string' ? $960ee101d5d06233$var$encodeUTF8(next, textEncoder) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`\n${JSON.stringify(itemHeaders)}\n`);
        if (typeof payload === 'string' || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch (e) {
                // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.strinify()` still
                // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                // performance impact but in this case a performance hit is better than throwing.
                stringifiedPayload = JSON.stringify((0, $j15Q6.normalize)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === 'string' ? parts : $960ee101d5d06233$var$concatBuffers(parts);
}
function $960ee101d5d06233$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
/**
 * Parses an envelope
 */ function $960ee101d5d06233$export$3338d0c7b6e17a2b(env, textEncoder, textDecoder) {
    let buffer = typeof env === 'string' ? textEncoder.encode(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) i = buffer.length;
        return JSON.parse(textDecoder.decode(readBinary(i)));
    }
    const envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === 'number' ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates attachment envelope items
 */ function $960ee101d5d06233$export$d8fc80952cc31fa4(attachment, textEncoder) {
    const buffer = typeof attachment.data === 'string' ? $960ee101d5d06233$var$encodeUTF8(attachment.data, textEncoder) : attachment.data;
    return [
        (0, $aLrZa.dropUndefinedKeys)({
            type: 'attachment',
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        }),
        buffer
    ];
}
const $960ee101d5d06233$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
    session: 'session',
    sessions: 'session',
    attachment: 'attachment',
    transaction: 'transaction',
    event: 'error',
    client_report: 'internal',
    user_report: 'default',
    profile: 'profile',
    replay_event: 'replay',
    replay_recording: 'replay',
    check_in: 'monitor',
    feedback: 'feedback',
    span: 'span',
    statsd: 'metric_bucket'
};
/**
 * Maps the type of an envelope item to a data category.
 */ function $960ee101d5d06233$export$b11169581eeaf237(type) {
    return $960ee101d5d06233$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}
/** Extracts the minimal SDK info from the metadata or an events */ function $960ee101d5d06233$export$d369f3b2758f6743(metadataOrEvent) {
    if (!metadataOrEvent || !metadataOrEvent.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function $960ee101d5d06233$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    const dynamicSamplingContext = event.sdkProcessingMetadata && event.sdkProcessingMetadata.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $3w9d5.dsnToString)(dsn)
        },
        ...dynamicSamplingContext && {
            trace: (0, $aLrZa.dropUndefinedKeys)({
                ...dynamicSamplingContext
            })
        }
    };
}

});
parcelRegister("3w9d5", function(module, exports) {

$parcel$export(module.exports, "dsnToString", () => $28fb813210d9e2c1$export$44d472fbb931a776);
$parcel$export(module.exports, "dsnFromString", () => $28fb813210d9e2c1$export$b892860177f70a30);
$parcel$export(module.exports, "makeDsn", () => $28fb813210d9e2c1$export$128827c3562ec0cb);

var $jK6Z8 = parcelRequire("jK6Z8");

var $lN8pX = parcelRequire("lN8pX");
/** Regular expression used to parse a Dsn. */ const $28fb813210d9e2c1$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $28fb813210d9e2c1$var$isValidProtocol(protocol) {
    return protocol === 'http' || protocol === 'https';
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function $28fb813210d9e2c1$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ''}` + `@${host}${port ? `:${port}` : ''}/${path ? `${path}/` : path}${projectId}`;
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */ function $28fb813210d9e2c1$export$b892860177f70a30(str) {
    const match = $28fb813210d9e2c1$var$DSN_REGEX.exec(str);
    if (!match) {
        // This should be logged to the console
        (0, $lN8pX.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return undefined;
    }
    const [protocol, publicKey, pass = '', host, port = '', lastPath] = match.slice(1);
    let path = '';
    let projectId = lastPath;
    const split = projectId.split('/');
    if (split.length > 1) {
        path = split.slice(0, -1).join('/');
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $28fb813210d9e2c1$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $28fb813210d9e2c1$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || '',
        pass: components.pass || '',
        host: components.host,
        port: components.port || '',
        path: components.path || '',
        projectId: components.projectId
    };
}
function $28fb813210d9e2c1$var$validateDsn(dsn) {
    if (!(0, $jK6Z8.DEBUG_BUILD)) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        'protocol',
        'publicKey',
        'host',
        'projectId'
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, $lN8pX.logger).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $lN8pX.logger).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$28fb813210d9e2c1$var$isValidProtocol(protocol)) {
        (0, $lN8pX.logger).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $lN8pX.logger).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */ function $28fb813210d9e2c1$export$128827c3562ec0cb(from) {
    const components = typeof from === 'string' ? $28fb813210d9e2c1$export$b892860177f70a30(from) : $28fb813210d9e2c1$var$dsnFromComponents(from);
    if (!components || !$28fb813210d9e2c1$var$validateDsn(components)) return undefined;
    return components;
}

});


parcelRegister("OGB8C", function(module, exports) {

$parcel$export(module.exports, "SentryError", () => $0985b6b3b810b296$export$5949942ba2a7c0e2);
/** An error emitted by Sentry SDKs and related utilities. */ class $0985b6b3b810b296$export$5949942ba2a7c0e2 extends Error {
    /** Display name of this error instance. */ constructor(message, logLevel = 'warn'){
        super(message);
        this.message = message;
        this.name = new.target.prototype.constructor.name;
        // This sets the prototype to be `Error`, not `SentryError`. It's unclear why we do this, but commenting this line
        // out causes various (seemingly totally unrelated) playwright tests consistently time out. FYI, this makes
        // instances of `SentryError` fail `obj instanceof SentryError` checks.
        Object.setPrototypeOf(this, new.target.prototype);
        this.logLevel = logLevel;
    }
}

});

parcelRegister("1UtEE", function(module, exports) {

$parcel$export(module.exports, "getEnvelopeEndpointWithUrlEncodedAuth", () => $16420630b4c3ae1e$export$9964600bfe84e6a3);
$parcel$export(module.exports, "getReportDialogEndpoint", () => $16420630b4c3ae1e$export$671c7ed8e40a7a57);

var $3w9d5 = parcelRequire("3w9d5");
var $aLrZa = parcelRequire("aLrZa");
const $16420630b4c3ae1e$var$SENTRY_API_VERSION = '7';
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $16420630b4c3ae1e$var$getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : '';
    const port = dsn.port ? `:${dsn.port}` : '';
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ''}/api/`;
}
/** Returns the ingest API endpoint for target. */ function $16420630b4c3ae1e$var$_getIngestEndpoint(dsn) {
    return `${$16420630b4c3ae1e$var$getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $16420630b4c3ae1e$var$_encodedAuth(dsn, sdkInfo) {
    return (0, $aLrZa.urlEncode)({
        // We send only the minimum set of required information. See
        // https://github.com/getsentry/sentry-javascript/issues/2572.
        sentry_key: dsn.publicKey,
        sentry_version: $16420630b4c3ae1e$var$SENTRY_API_VERSION,
        ...sdkInfo && {
            sentry_client: `${sdkInfo.name}/${sdkInfo.version}`
        }
    });
}
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */ function $16420630b4c3ae1e$export$9964600bfe84e6a3(dsn, // TODO (v8): Remove `tunnelOrOptions` in favor of `options`, and use the substitute code below
// options: ClientOptions = {} as ClientOptions,
tunnelOrOptions = {}) {
    // TODO (v8): Use this code instead
    // const { tunnel, _metadata = {} } = options;
    // return tunnel ? tunnel : `${_getIngestEndpoint(dsn)}?${_encodedAuth(dsn, _metadata.sdk)}`;
    const tunnel = typeof tunnelOrOptions === 'string' ? tunnelOrOptions : tunnelOrOptions.tunnel;
    const sdkInfo = typeof tunnelOrOptions === 'string' || !tunnelOrOptions._metadata ? undefined : tunnelOrOptions._metadata.sdk;
    return tunnel ? tunnel : `${$16420630b4c3ae1e$var$_getIngestEndpoint(dsn)}?${$16420630b4c3ae1e$var$_encodedAuth(dsn, sdkInfo)}`;
}
/** Returns the url to the report dialog endpoint. */ function $16420630b4c3ae1e$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    const dsn = (0, $3w9d5.makeDsn)(dsnLike);
    if (!dsn) return '';
    const endpoint = `${$16420630b4c3ae1e$var$getBaseApiEndpoint(dsn)}embed/error-page/`;
    let encodedOptions = `dsn=${(0, $3w9d5.dsnToString)(dsn)}`;
    for(const key in dialogOptions){
        if (key === 'dsn') continue;
        if (key === 'onClose') continue;
        if (key === 'user') {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}

});

parcelRegister("eIUO3", function(module, exports) {

$parcel$export(module.exports, "createSessionEnvelope", () => $ab813d48b87b7f72$export$124b03c077baa2f3);
$parcel$export(module.exports, "createEventEnvelope", () => $ab813d48b87b7f72$export$c31057337a18010f);

var $cSKRv = parcelRequire("cSKRv");
var $3w9d5 = parcelRequire("3w9d5");
/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function $ab813d48b87b7f72$var$enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = [
        ...event.sdk.integrations || [],
        ...sdkInfo.integrations || []
    ];
    event.sdk.packages = [
        ...event.sdk.packages || [],
        ...sdkInfo.packages || []
    ];
    return event;
}
/** Creates an envelope from a Session */ function $ab813d48b87b7f72$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    const sdkInfo = (0, $cSKRv.getSdkMetadataForEnvelopeHeader)(metadata);
    const envelopeHeaders = {
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $3w9d5.dsnToString)(dsn)
        }
    };
    const envelopeItem = 'aggregates' in session ? [
        {
            type: 'sessions'
        },
        session
    ] : [
        {
            type: 'session'
        },
        session.toJSON()
    ];
    return (0, $cSKRv.createEnvelope)(envelopeHeaders, [
        envelopeItem
    ]);
}
/**
 * Create an Envelope from an event.
 */ function $ab813d48b87b7f72$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    const sdkInfo = (0, $cSKRv.getSdkMetadataForEnvelopeHeader)(metadata);
    /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjut a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */ const eventType = event.type && event.type !== 'replay_event' ? event.type : 'event';
    $ab813d48b87b7f72$var$enhanceEventWithSdkInfo(event, metadata && metadata.sdk);
    const envelopeHeaders = (0, $cSKRv.createEventEnvelopeHeaders)(event, sdkInfo, tunnel, dsn);
    // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $cSKRv.createEnvelope)(envelopeHeaders, [
        eventItem
    ]);
}

});

parcelRegister("6emiv", function(module, exports) {

$parcel$export(module.exports, "getIntegrationsToSetup", () => $489558b1e0aa5447$export$68bc4c01ab8ae766);
$parcel$export(module.exports, "setupIntegrations", () => $489558b1e0aa5447$export$51abed9797baa598);
$parcel$export(module.exports, "setupIntegration", () => $489558b1e0aa5447$export$e7390a03b70a6f2f);
$parcel$export(module.exports, "afterSetupIntegrations", () => $489558b1e0aa5447$export$35abcfd71227c6ca);
$parcel$export(module.exports, "addIntegration", () => $489558b1e0aa5447$export$2d8f5188773bcddd);
$parcel$export(module.exports, "convertIntegrationFnToClass", () => $489558b1e0aa5447$export$afa219bf23651160);
$parcel$export(module.exports, "defineIntegration", () => $489558b1e0aa5447$export$2323046b9414659f);

var $1y8R2 = parcelRequire("1y8R2");
var $lN8pX = parcelRequire("lN8pX");

var $cQ4mt = parcelRequire("cQ4mt");

var $bu7hL = parcelRequire("bu7hL");

var $fq71H = parcelRequire("fq71H");

var $egVmm = parcelRequire("egVmm");
const $489558b1e0aa5447$export$b14a8888f80a0b3e = [];
/** Map of integrations assigned to a client */ /**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preseve the order of integrations in the array.
 *
 * @private
 */ function $489558b1e0aa5447$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
        // default instance to overwrite an existing user instance
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.keys(integrationsByName).map((k)=>integrationsByName[k]);
}
/** Gets integrations to install */ function $489558b1e0aa5447$export$68bc4c01ab8ae766(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === 'function') integrations = (0, $1y8R2.arrayify)(userIntegrations(defaultIntegrations));
    else integrations = defaultIntegrations;
    const finalIntegrations = $489558b1e0aa5447$var$filterDuplicates(integrations);
    // The `Debug` integration prints copies of the `event` and `hint` which will be passed to `beforeSend` or
    // `beforeSendTransaction`. It therefore has to run after all other integrations, so that the changes of all event
    // processors will be reflected in the printed values. For lack of a more elegant way to guarantee that, we therefore
    // locate it and, assuming it exists, pop it out of its current spot and shove it onto the end of the array.
    const debugIndex = $489558b1e0aa5447$var$findIndex(finalIntegrations, (integration)=>integration.name === 'Debug');
    if (debugIndex !== -1) {
        const [debugInstance] = finalIntegrations.splice(debugIndex, 1);
        finalIntegrations.push(debugInstance);
    }
    return finalIntegrations;
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */ function $489558b1e0aa5447$export$51abed9797baa598(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        // guard against empty provided integrations
        if (integration) $489558b1e0aa5447$export$e7390a03b70a6f2f(client, integration, integrationIndex);
    });
    return integrationIndex;
}
/**
 * Execute the `afterAllSetup` hooks of the given integrations.
 */ function $489558b1e0aa5447$export$35abcfd71227c6ca(client, integrations) {
    for (const integration of integrations)// guard against empty provided integrations
    if (integration && integration.afterAllSetup) integration.afterAllSetup(client);
}
/** Setup a single integration.  */ function $489558b1e0aa5447$export$e7390a03b70a6f2f(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        (0, $cQ4mt.DEBUG_BUILD) && (0, $lN8pX.logger).log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    // `setupOnce` is only called the first time
    if ($489558b1e0aa5447$export$b14a8888f80a0b3e.indexOf(integration.name) === -1) {
        // eslint-disable-next-line deprecation/deprecation
        integration.setupOnce((0, $bu7hL.addGlobalEventProcessor), (0, $egVmm.getCurrentHub));
        $489558b1e0aa5447$export$b14a8888f80a0b3e.push(integration.name);
    }
    // `setup` is run for each client
    if (integration.setup && typeof integration.setup === 'function') integration.setup(client);
    if (client.on && typeof integration.preprocessEvent === 'function') {
        const callback = integration.preprocessEvent.bind(integration);
        client.on('preprocessEvent', (event, hint)=>callback(event, hint, client));
    }
    if (client.addEventProcessor && typeof integration.processEvent === 'function') {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    (0, $cQ4mt.DEBUG_BUILD) && (0, $lN8pX.logger).log(`Integration installed: ${integration.name}`);
}
/** Add an integration to the current hub's client. */ function $489558b1e0aa5447$export$2d8f5188773bcddd(integration) {
    const client = (0, $fq71H.getClient)();
    if (!client || !client.addIntegration) {
        (0, $cQ4mt.DEBUG_BUILD) && (0, $lN8pX.logger).warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
// Polyfill for Array.findIndex(), which is not supported in ES5
function $489558b1e0aa5447$var$findIndex(arr, callback) {
    for(let i = 0; i < arr.length; i++){
        if (callback(arr[i]) === true) return i;
    }
    return -1;
}
/**
 * Convert a new integration function to the legacy class syntax.
 * In v8, we can remove this and instead export the integration functions directly.
 *
 * @deprecated This will be removed in v8!
 */ function $489558b1e0aa5447$export$afa219bf23651160(name, fn) {
    return Object.assign(function ConvertedIntegration(...args) {
        return fn(...args);
    }, {
        id: name
    });
}
/**
 * Define an integration function that can be used to create an integration instance.
 * Note that this by design hides the implementation details of the integration, as they are considered internal.
 */ function $489558b1e0aa5447$export$2323046b9414659f(fn) {
    return fn;
}

});

parcelRegister("g9AJ2", function(module, exports) {

$parcel$export(module.exports, "createMetricEnvelope", () => $bc29f97dd2e37326$export$f23eb96e33154901);

var $cSKRv = parcelRequire("cSKRv");
var $3w9d5 = parcelRequire("3w9d5");

var $8umlm = parcelRequire("8umlm");
/**
 * Create envelope from a metric aggregate.
 */ function $bc29f97dd2e37326$export$f23eb96e33154901(metricBucketItems, dsn, metadata, tunnel) {
    const headers = {
        sent_at: new Date().toISOString()
    };
    if (metadata && metadata.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && dsn) headers.dsn = (0, $3w9d5.dsnToString)(dsn);
    const item = $bc29f97dd2e37326$var$createMetricEnvelopeItem(metricBucketItems);
    return (0, $cSKRv.createEnvelope)(headers, [
        item
    ]);
}
function $bc29f97dd2e37326$var$createMetricEnvelopeItem(metricBucketItems) {
    const payload = (0, $8umlm.serializeMetricBuckets)(metricBucketItems);
    const metricHeaders = {
        type: 'statsd',
        length: payload.length
    };
    return [
        metricHeaders,
        payload
    ];
}

});
parcelRegister("8umlm", function(module, exports) {

$parcel$export(module.exports, "getBucketKey", () => $62e2750c11db1dd7$export$b8bd8c4dffa5aa2d);
$parcel$export(module.exports, "simpleHash", () => $62e2750c11db1dd7$export$b211ce59c0ea1cfb);
$parcel$export(module.exports, "serializeMetricBuckets", () => $62e2750c11db1dd7$export$66decd709db01dc8);
$parcel$export(module.exports, "sanitizeUnit", () => $62e2750c11db1dd7$export$2d8c9911396bbf5f);
$parcel$export(module.exports, "sanitizeMetricKey", () => $62e2750c11db1dd7$export$d3b3167f2ebbcecc);
$parcel$export(module.exports, "sanitizeTags", () => $62e2750c11db1dd7$export$ae49af12dbdf2477);

var $aLrZa = parcelRequire("aLrZa");
/**
 * Generate bucket key from metric properties.
 */ function $62e2750c11db1dd7$export$b8bd8c4dffa5aa2d(metricType, name, unit, tags) {
    const stringifiedTags = Object.entries((0, $aLrZa.dropUndefinedKeys)(tags)).sort((a, b)=>a[0].localeCompare(b[0]));
    return `${metricType}${name}${unit}${stringifiedTags}`;
}
/* eslint-disable no-bitwise */ /**
 * Simple hash function for strings.
 */ function $62e2750c11db1dd7$export$b211ce59c0ea1cfb(s) {
    let rv = 0;
    for(let i = 0; i < s.length; i++){
        const c = s.charCodeAt(i);
        rv = (rv << 5) - rv + c;
        rv &= rv;
    }
    return rv >>> 0;
}
/* eslint-enable no-bitwise */ /**
 * Serialize metrics buckets into a string based on statsd format.
 *
 * Example of format:
 * metric.name@second:1:1.2|d|#a:value,b:anothervalue|T12345677
 * Segments:
 * name: metric.name
 * unit: second
 * value: [1, 1.2]
 * type of metric: d (distribution)
 * tags: { a: value, b: anothervalue }
 * timestamp: 12345677
 */ function $62e2750c11db1dd7$export$66decd709db01dc8(metricBucketItems) {
    let out = '';
    for (const item of metricBucketItems){
        const tagEntries = Object.entries(item.tags);
        const maybeTags = tagEntries.length > 0 ? `|#${tagEntries.map(([key, value])=>`${key}:${value}`).join(',')}` : '';
        out += `${item.name}@${item.unit}:${item.metric}|${item.metricType}${maybeTags}|T${item.timestamp}\n`;
    }
    return out;
}
/** Sanitizes units */ function $62e2750c11db1dd7$export$2d8c9911396bbf5f(unit) {
    return unit.replace(/[^\w]+/gi, '_');
}
/** Sanitizes metric keys */ function $62e2750c11db1dd7$export$d3b3167f2ebbcecc(key) {
    return key.replace(/[^\w\-.]+/gi, '_');
}
function $62e2750c11db1dd7$var$sanitizeTagKey(key) {
    return key.replace(/[^\w\-./]+/gi, '');
}
const $62e2750c11db1dd7$var$tagValueReplacements = [
    [
        '\n',
        '\\n'
    ],
    [
        '\r',
        '\\r'
    ],
    [
        '\t',
        '\\t'
    ],
    [
        '\\',
        '\\\\'
    ],
    [
        '|',
        '\\u{7c}'
    ],
    [
        ',',
        '\\u{2c}'
    ]
];
function $62e2750c11db1dd7$var$getCharOrReplacement(input) {
    for (const [search, replacement] of $62e2750c11db1dd7$var$tagValueReplacements){
        if (input === search) return replacement;
    }
    return input;
}
function $62e2750c11db1dd7$var$sanitizeTagValue(value) {
    return [
        ...value
    ].reduce((acc, char)=>acc + $62e2750c11db1dd7$var$getCharOrReplacement(char), '');
}
/**
 * Sanitizes tags.
 */ function $62e2750c11db1dd7$export$ae49af12dbdf2477(unsanitizedTags) {
    const tags = {};
    for(const key in unsanitizedTags)if (Object.prototype.hasOwnProperty.call(unsanitizedTags, key)) {
        const sanitizedKey = $62e2750c11db1dd7$var$sanitizeTagKey(key);
        tags[sanitizedKey] = $62e2750c11db1dd7$var$sanitizeTagValue(String(unsanitizedTags[key]));
    }
    return tags;
}

});



parcelRegister("13ShQ", function(module, exports) {

$parcel$export(module.exports, "startIdleTransaction", () => $0c602e7c854fa5f5$export$479dbd817e392a4f);
$parcel$export(module.exports, "addTracingExtensions", () => $0c602e7c854fa5f5$export$653d0ef2bad9cdf9);

var $lN8pX = parcelRequire("lN8pX");

var $cQ4mt = parcelRequire("cQ4mt");

var $egVmm = parcelRequire("egVmm");

var $aYVgD = parcelRequire("aYVgD");

var $74ST1 = parcelRequire("74ST1");

var $9XkOL = parcelRequire("9XkOL");

var $kDNXp = parcelRequire("kDNXp");

var $dfUqJ = parcelRequire("dfUqJ");
/** Returns all trace headers that are currently on the top scope. */ // eslint-disable-next-line deprecation/deprecation
function $0c602e7c854fa5f5$var$traceHeaders() {
    // eslint-disable-next-line deprecation/deprecation
    const scope = this.getScope();
    // eslint-disable-next-line deprecation/deprecation
    const span = scope.getSpan();
    return span ? {
        'sentry-trace': (0, $aYVgD.spanToTraceHeader)(span)
    } : {};
}
/**
 * Creates a new transaction and adds a sampling decision if it doesn't yet have one.
 *
 * The Hub.startTransaction method delegates to this method to do its work, passing the Hub instance in as `this`, as if
 * it had been called on the hub directly. Exists as a separate function so that it can be injected into the class as an
 * "extension method."
 *
 * @param this: The Hub starting the transaction
 * @param transactionContext: Data used to configure the transaction
 * @param CustomSamplingContext: Optional data to be provided to the `tracesSampler` function (if any)
 *
 * @returns The new transaction
 *
 * @see {@link Hub.startTransaction}
 */ function $0c602e7c854fa5f5$var$_startTransaction(// eslint-disable-next-line deprecation/deprecation
transactionContext, customSamplingContext) {
    // eslint-disable-next-line deprecation/deprecation
    const client = this.getClient();
    const options = client && client.getOptions() || {};
    const configInstrumenter = options.instrumenter || 'sentry';
    const transactionInstrumenter = transactionContext.instrumenter || 'sentry';
    if (configInstrumenter !== transactionInstrumenter) {
        (0, $cQ4mt.DEBUG_BUILD) && (0, $lN8pX.logger).error(`A transaction was started with instrumenter=\`${transactionInstrumenter}\`, but the SDK is configured with the \`${configInstrumenter}\` instrumenter.
The transaction will not be sampled. Please use the ${configInstrumenter} instrumentation to start transactions.`);
        // eslint-disable-next-line deprecation/deprecation
        transactionContext.sampled = false;
    }
    // eslint-disable-next-line deprecation/deprecation
    let transaction = new (0, $dfUqJ.Transaction)(transactionContext, this);
    transaction = (0, $kDNXp.sampleTransaction)(transaction, options, {
        name: transactionContext.name,
        parentSampled: transactionContext.parentSampled,
        transactionContext: transactionContext,
        attributes: {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.data,
            ...transactionContext.attributes
        },
        ...customSamplingContext
    });
    if (transaction.isRecording()) transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    if (client && client.emit) client.emit('startTransaction', transaction);
    return transaction;
}
/**
 * Create new idle transaction.
 */ function $0c602e7c854fa5f5$export$479dbd817e392a4f(// eslint-disable-next-line deprecation/deprecation
hub, transactionContext, idleTimeout, finalTimeout, onScope, customSamplingContext, heartbeatInterval, delayAutoFinishUntilSignal = false) {
    // eslint-disable-next-line deprecation/deprecation
    const client = hub.getClient();
    const options = client && client.getOptions() || {};
    // eslint-disable-next-line deprecation/deprecation
    let transaction = new (0, $9XkOL.IdleTransaction)(transactionContext, hub, idleTimeout, finalTimeout, heartbeatInterval, onScope, delayAutoFinishUntilSignal);
    transaction = (0, $kDNXp.sampleTransaction)(transaction, options, {
        name: transactionContext.name,
        parentSampled: transactionContext.parentSampled,
        transactionContext: transactionContext,
        attributes: {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.data,
            ...transactionContext.attributes
        },
        ...customSamplingContext
    });
    if (transaction.isRecording()) transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    if (client && client.emit) client.emit('startTransaction', transaction);
    return transaction;
}
/**
 * Adds tracing extensions to the global hub.
 */ function $0c602e7c854fa5f5$export$653d0ef2bad9cdf9() {
    const carrier = (0, $egVmm.getMainCarrier)();
    if (!carrier.__SENTRY__) return;
    carrier.__SENTRY__.extensions = carrier.__SENTRY__.extensions || {};
    if (!carrier.__SENTRY__.extensions.startTransaction) carrier.__SENTRY__.extensions.startTransaction = $0c602e7c854fa5f5$var$_startTransaction;
    if (!carrier.__SENTRY__.extensions.traceHeaders) carrier.__SENTRY__.extensions.traceHeaders = $0c602e7c854fa5f5$var$traceHeaders;
    (0, $74ST1.registerErrorInstrumentation)();
}

});
parcelRegister("74ST1", function(module, exports) {

$parcel$export(module.exports, "registerErrorInstrumentation", () => $52737b6f726454d0$export$637857c1d87b640c);

var $7hreB = parcelRequire("7hreB");
var $aeUoj = parcelRequire("aeUoj");
var $lN8pX = parcelRequire("lN8pX");

var $cQ4mt = parcelRequire("cQ4mt");

var $jL5ha = parcelRequire("jL5ha");
let $52737b6f726454d0$var$errorsInstrumented = false;
/**
 * Configures global error listeners
 */ function $52737b6f726454d0$export$637857c1d87b640c() {
    if ($52737b6f726454d0$var$errorsInstrumented) return;
    $52737b6f726454d0$var$errorsInstrumented = true;
    (0, $7hreB.addGlobalErrorInstrumentationHandler)($52737b6f726454d0$var$errorCallback);
    (0, $aeUoj.addGlobalUnhandledRejectionInstrumentationHandler)($52737b6f726454d0$var$errorCallback);
}
/**
 * If an error or unhandled promise occurs, we mark the active transaction as failed
 */ function $52737b6f726454d0$var$errorCallback() {
    // eslint-disable-next-line deprecation/deprecation
    const activeTransaction = (0, $jL5ha.getActiveTransaction)();
    if (activeTransaction) {
        const status = 'internal_error';
        (0, $cQ4mt.DEBUG_BUILD) && (0, $lN8pX.logger).log(`[Tracing] Transaction: ${status} -> Global error occured`);
        activeTransaction.setStatus(status);
    }
}
// The function name will be lost when bundling but we need to be able to identify this listener later to maintain the
// node.js default exit behaviour
$52737b6f726454d0$var$errorCallback.tag = 'sentry_tracingErrorCallback';

});
parcelRegister("7hreB", function(module, exports) {

$parcel$export(module.exports, "addGlobalErrorInstrumentationHandler", () => $54cf3f235d93ba1d$export$55b5c3ba2194f0c6);

var $4mb67 = parcelRequire("4mb67");

var $bjmDL = parcelRequire("bjmDL");
let $54cf3f235d93ba1d$var$_oldOnErrorHandler = null;
/**
 * Add an instrumentation handler for when an error is captured by the global error handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $54cf3f235d93ba1d$export$55b5c3ba2194f0c6(handler) {
    const type = 'error';
    (0, $bjmDL.addHandler)(type, handler);
    (0, $bjmDL.maybeInstrument)(type, $54cf3f235d93ba1d$var$instrumentError);
}
function $54cf3f235d93ba1d$var$instrumentError() {
    $54cf3f235d93ba1d$var$_oldOnErrorHandler = (0, $4mb67.GLOBAL_OBJ).onerror;
    (0, $4mb67.GLOBAL_OBJ).onerror = function(msg, url, line, column, error) {
        const handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        (0, $bjmDL.triggerHandlers)('error', handlerData);
        if ($54cf3f235d93ba1d$var$_oldOnErrorHandler && !$54cf3f235d93ba1d$var$_oldOnErrorHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $54cf3f235d93ba1d$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    (0, $4mb67.GLOBAL_OBJ).onerror.__SENTRY_INSTRUMENTED__ = true;
}

});
parcelRegister("bjmDL", function(module, exports) {

$parcel$export(module.exports, "addHandler", () => $83c307fb8ca1a1cf$export$a4e09611e30da72e);
$parcel$export(module.exports, "maybeInstrument", () => $83c307fb8ca1a1cf$export$e18d6c5462c01368);
$parcel$export(module.exports, "triggerHandlers", () => $83c307fb8ca1a1cf$export$b18c893e424d3127);

var $jK6Z8 = parcelRequire("jK6Z8");

var $lN8pX = parcelRequire("lN8pX");

var $jVtDJ = parcelRequire("jVtDJ");
// We keep the handlers globally
const $83c307fb8ca1a1cf$var$handlers = {};
const $83c307fb8ca1a1cf$var$instrumented = {};
/** Add a handler function. */ function $83c307fb8ca1a1cf$export$a4e09611e30da72e(type, handler) {
    $83c307fb8ca1a1cf$var$handlers[type] = $83c307fb8ca1a1cf$var$handlers[type] || [];
    $83c307fb8ca1a1cf$var$handlers[type].push(handler);
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function $83c307fb8ca1a1cf$export$b17eab759a1cb5fe() {
    Object.keys($83c307fb8ca1a1cf$var$handlers).forEach((key)=>{
        $83c307fb8ca1a1cf$var$handlers[key] = undefined;
    });
}
/** Maybe run an instrumentation function, unless it was already called. */ function $83c307fb8ca1a1cf$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$83c307fb8ca1a1cf$var$instrumented[type]) {
        instrumentFn();
        $83c307fb8ca1a1cf$var$instrumented[type] = true;
    }
}
/** Trigger handlers for a given instrumentation type. */ function $83c307fb8ca1a1cf$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $83c307fb8ca1a1cf$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $jK6Z8.DEBUG_BUILD) && (0, $lN8pX.logger).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $jVtDJ.getFunctionName)(handler)}\nError:`, e);
    }
}

});


parcelRegister("aeUoj", function(module, exports) {

$parcel$export(module.exports, "addGlobalUnhandledRejectionInstrumentationHandler", () => $7746f44da5507653$export$8bf4fc6858821a4e);

var $4mb67 = parcelRequire("4mb67");

var $bjmDL = parcelRequire("bjmDL");
let $7746f44da5507653$var$_oldOnUnhandledRejectionHandler = null;
/**
 * Add an instrumentation handler for when an unhandled promise rejection is captured.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $7746f44da5507653$export$8bf4fc6858821a4e(handler) {
    const type = 'unhandledrejection';
    (0, $bjmDL.addHandler)(type, handler);
    (0, $bjmDL.maybeInstrument)(type, $7746f44da5507653$var$instrumentUnhandledRejection);
}
function $7746f44da5507653$var$instrumentUnhandledRejection() {
    $7746f44da5507653$var$_oldOnUnhandledRejectionHandler = (0, $4mb67.GLOBAL_OBJ).onunhandledrejection;
    (0, $4mb67.GLOBAL_OBJ).onunhandledrejection = function(e) {
        const handlerData = e;
        (0, $bjmDL.triggerHandlers)('unhandledrejection', handlerData);
        if ($7746f44da5507653$var$_oldOnUnhandledRejectionHandler && !$7746f44da5507653$var$_oldOnUnhandledRejectionHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $7746f44da5507653$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    (0, $4mb67.GLOBAL_OBJ).onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}

});

parcelRegister("jL5ha", function(module, exports) {

$parcel$export(module.exports, "getActiveTransaction", () => $e6267fcd5752cfe1$export$a7feb32fdd923295);
$parcel$export(module.exports, "extractTraceparentData", () => $e6267fcd5752cfe1$export$8e9a29865c0a1226);

var $27K1p = parcelRequire("27K1p");

var $egVmm = parcelRequire("egVmm");
/**
 * Grabs active transaction off scope.
 *
 * @deprecated You should not rely on the transaction, but just use `startSpan()` APIs instead.
 */ // eslint-disable-next-line deprecation/deprecation
function $e6267fcd5752cfe1$export$a7feb32fdd923295(maybeHub) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = maybeHub || (0, $egVmm.getCurrentHub)();
    // eslint-disable-next-line deprecation/deprecation
    const scope = hub.getScope();
    // eslint-disable-next-line deprecation/deprecation
    return scope.getTransaction();
}
/**
 * The `extractTraceparentData` function and `TRACEPARENT_REGEXP` constant used
 * to be declared in this file. It was later moved into `@sentry/utils` as part of a
 * move to remove `@sentry/tracing` dependencies from `@sentry/node` (`extractTraceparentData`
 * is the only tracing function used by `@sentry/node`).
 *
 * These exports are kept here for backwards compatability's sake.
 *
 * See https://github.com/getsentry/sentry-javascript/issues/4642 for more details.
 *
 * @deprecated Import this function from `@sentry/utils` instead
 */ const $e6267fcd5752cfe1$export$8e9a29865c0a1226 = (0, $27K1p.extractTraceparentData);

});


parcelRegister("9XkOL", function(module, exports) {

$parcel$export(module.exports, "TRACING_DEFAULTS", () => $73f9c5b4448a375a$export$809a2b7987fd5306);
$parcel$export(module.exports, "IdleTransaction", () => $73f9c5b4448a375a$export$b279e6bd7040371f);

var $lN8pX = parcelRequire("lN8pX");
var $leMLP = parcelRequire("leMLP");

var $cQ4mt = parcelRequire("cQ4mt");

var $aYVgD = parcelRequire("aYVgD");

var $bJ5g8 = parcelRequire("bJ5g8");

var $dfUqJ = parcelRequire("dfUqJ");
const $73f9c5b4448a375a$export$809a2b7987fd5306 = {
    idleTimeout: 1000,
    finalTimeout: 30000,
    heartbeatInterval: 5000
};
const $73f9c5b4448a375a$var$FINISH_REASON_TAG = 'finishReason';
const $73f9c5b4448a375a$var$IDLE_TRANSACTION_FINISH_REASONS = [
    'heartbeatFailed',
    'idleTimeout',
    'documentHidden',
    'finalTimeout',
    'externalFinish',
    'cancelled'
];
/**
 * @inheritDoc
 */ class $73f9c5b4448a375a$export$370d6113c18ba86c extends (0, $bJ5g8.SpanRecorder) {
    constructor(_pushActivity, _popActivity, transactionSpanId, maxlen){
        super(maxlen);
        this._pushActivity = _pushActivity;
        this._popActivity = _popActivity;
        this.transactionSpanId = transactionSpanId;
    }
    /**
   * @inheritDoc
   */ add(span) {
        // We should make sure we do not push and pop activities for
        // the transaction that this span recorder belongs to.
        if (span.spanContext().spanId !== this.transactionSpanId) {
            // We patch span.end() to pop an activity after setting an endTimestamp.
            // eslint-disable-next-line @typescript-eslint/unbound-method
            const originalEnd = span.end;
            span.end = (...rest)=>{
                this._popActivity(span.spanContext().spanId);
                return originalEnd.apply(span, rest);
            };
            // We should only push new activities if the span does not have an end timestamp.
            if ((0, $aYVgD.spanToJSON)(span).timestamp === undefined) this._pushActivity(span.spanContext().spanId);
        }
        super.add(span);
    }
}
/**
 * An IdleTransaction is a transaction that automatically finishes. It does this by tracking child spans as activities.
 * You can have multiple IdleTransactions active, but if the `onScope` option is specified, the idle transaction will
 * put itself on the scope on creation.
 */ class $73f9c5b4448a375a$export$b279e6bd7040371f extends (0, $dfUqJ.Transaction) {
    // Activities store a list of active spans
    // Track state of activities in previous heartbeat
    // Amount of times heartbeat has counted. Will cause transaction to finish after 3 beats.
    // We should not use heartbeat if we finished a transaction
    // Idle timeout was canceled and we should finish the transaction with the last span end.
    /**
   * Timer that tracks Transaction idleTimeout
   */ /**
   * @deprecated Transactions will be removed in v8. Use spans instead.
   */ constructor(transactionContext, // eslint-disable-next-line deprecation/deprecation
    _idleHub, /**
     * The time to wait in ms until the idle transaction will be finished. This timer is started each time
     * there are no active spans on this transaction.
     */ _idleTimeout = $73f9c5b4448a375a$export$809a2b7987fd5306.idleTimeout, /**
     * The final value in ms that a transaction cannot exceed
     */ _finalTimeout = $73f9c5b4448a375a$export$809a2b7987fd5306.finalTimeout, _heartbeatInterval = $73f9c5b4448a375a$export$809a2b7987fd5306.heartbeatInterval, // Whether or not the transaction should put itself on the scope when it starts and pop itself off when it ends
    _onScope = false, /**
     * When set to `true`, will disable the idle timeout (`_idleTimeout` option) and heartbeat mechanisms (`_heartbeatInterval`
     * option) until the `sendAutoFinishSignal()` method is called. The final timeout mechanism (`_finalTimeout` option)
     * will not be affected by this option, meaning the transaction will definitely be finished when the final timeout is
     * reached, no matter what this option is configured to.
     *
     * Defaults to `false`.
     */ delayAutoFinishUntilSignal = false){
        super(transactionContext, _idleHub);
        this._idleHub = _idleHub;
        this._idleTimeout = _idleTimeout;
        this._finalTimeout = _finalTimeout;
        this._heartbeatInterval = _heartbeatInterval;
        this._onScope = _onScope;
        this.activities = {};
        this._heartbeatCounter = 0;
        this._finished = false;
        this._idleTimeoutCanceledPermanently = false;
        this._beforeFinishCallbacks = [];
        this._finishReason = $73f9c5b4448a375a$var$IDLE_TRANSACTION_FINISH_REASONS[4];
        this._autoFinishAllowed = !delayAutoFinishUntilSignal;
        if (_onScope) {
            // We set the transaction here on the scope so error events pick up the trace
            // context and attach it to the error.
            (0, $cQ4mt.DEBUG_BUILD) && (0, $lN8pX.logger).log(`Setting idle transaction on scope. Span ID: ${this.spanContext().spanId}`);
            // eslint-disable-next-line deprecation/deprecation
            _idleHub.getScope().setSpan(this);
        }
        if (!delayAutoFinishUntilSignal) this._restartIdleTimeout();
        setTimeout(()=>{
            if (!this._finished) {
                this.setStatus('deadline_exceeded');
                this._finishReason = $73f9c5b4448a375a$var$IDLE_TRANSACTION_FINISH_REASONS[3];
                this.end();
            }
        }, this._finalTimeout);
    }
    /** {@inheritDoc} */ end(endTimestamp) {
        const endTimestampInS = (0, $aYVgD.spanTimeInputToSeconds)(endTimestamp);
        this._finished = true;
        this.activities = {};
        // eslint-disable-next-line deprecation/deprecation
        if (this.op === 'ui.action.click') this.setAttribute($73f9c5b4448a375a$var$FINISH_REASON_TAG, this._finishReason);
        // eslint-disable-next-line deprecation/deprecation
        if (this.spanRecorder) {
            (0, $cQ4mt.DEBUG_BUILD) && // eslint-disable-next-line deprecation/deprecation
            (0, $lN8pX.logger).log('[Tracing] finishing IdleTransaction', new Date(endTimestampInS * 1000).toISOString(), this.op);
            for (const callback of this._beforeFinishCallbacks)callback(this, endTimestampInS);
            // eslint-disable-next-line deprecation/deprecation
            this.spanRecorder.spans = this.spanRecorder.spans.filter((span)=>{
                // If we are dealing with the transaction itself, we just return it
                if (span.spanContext().spanId === this.spanContext().spanId) return true;
                // We cancel all pending spans with status "cancelled" to indicate the idle transaction was finished early
                if (!(0, $aYVgD.spanToJSON)(span).timestamp) {
                    span.setStatus('cancelled');
                    span.end(endTimestampInS);
                    (0, $cQ4mt.DEBUG_BUILD) && (0, $lN8pX.logger).log('[Tracing] cancelling span since transaction ended early', JSON.stringify(span, undefined, 2));
                }
                const { start_timestamp: startTime, timestamp: endTime } = (0, $aYVgD.spanToJSON)(span);
                const spanStartedBeforeTransactionFinish = startTime && startTime < endTimestampInS;
                // Add a delta with idle timeout so that we prevent false positives
                const timeoutWithMarginOfError = (this._finalTimeout + this._idleTimeout) / 1000;
                const spanEndedBeforeFinalTimeout = endTime && startTime && endTime - startTime < timeoutWithMarginOfError;
                if (0, $cQ4mt.DEBUG_BUILD) {
                    const stringifiedSpan = JSON.stringify(span, undefined, 2);
                    if (!spanStartedBeforeTransactionFinish) (0, $lN8pX.logger).log('[Tracing] discarding Span since it happened after Transaction was finished', stringifiedSpan);
                    else if (!spanEndedBeforeFinalTimeout) (0, $lN8pX.logger).log('[Tracing] discarding Span since it finished after Transaction final timeout', stringifiedSpan);
                }
                return spanStartedBeforeTransactionFinish && spanEndedBeforeFinalTimeout;
            });
            (0, $cQ4mt.DEBUG_BUILD) && (0, $lN8pX.logger).log('[Tracing] flushing IdleTransaction');
        } else (0, $cQ4mt.DEBUG_BUILD) && (0, $lN8pX.logger).log('[Tracing] No active IdleTransaction');
        // if `this._onScope` is `true`, the transaction put itself on the scope when it started
        if (this._onScope) {
            // eslint-disable-next-line deprecation/deprecation
            const scope = this._idleHub.getScope();
            // eslint-disable-next-line deprecation/deprecation
            if (scope.getTransaction() === this) // eslint-disable-next-line deprecation/deprecation
            scope.setSpan(undefined);
        }
        return super.end(endTimestamp);
    }
    /**
   * Register a callback function that gets executed before the transaction finishes.
   * Useful for cleanup or if you want to add any additional spans based on current context.
   *
   * This is exposed because users have no other way of running something before an idle transaction
   * finishes.
   */ registerBeforeFinishCallback(callback) {
        this._beforeFinishCallbacks.push(callback);
    }
    /**
   * @inheritDoc
   */ initSpanRecorder(maxlen) {
        // eslint-disable-next-line deprecation/deprecation
        if (!this.spanRecorder) {
            const pushActivity = (id)=>{
                if (this._finished) return;
                this._pushActivity(id);
            };
            const popActivity = (id)=>{
                if (this._finished) return;
                this._popActivity(id);
            };
            // eslint-disable-next-line deprecation/deprecation
            this.spanRecorder = new $73f9c5b4448a375a$export$370d6113c18ba86c(pushActivity, popActivity, this.spanContext().spanId, maxlen);
            // Start heartbeat so that transactions do not run forever.
            (0, $cQ4mt.DEBUG_BUILD) && (0, $lN8pX.logger).log('Starting heartbeat');
            this._pingHeartbeat();
        }
        // eslint-disable-next-line deprecation/deprecation
        this.spanRecorder.add(this);
    }
    /**
   * Cancels the existing idle timeout, if there is one.
   * @param restartOnChildSpanChange Default is `true`.
   *                                 If set to false the transaction will end
   *                                 with the last child span.
   */ cancelIdleTimeout(endTimestamp, { restartOnChildSpanChange: restartOnChildSpanChange } = {
        restartOnChildSpanChange: true
    }) {
        this._idleTimeoutCanceledPermanently = restartOnChildSpanChange === false;
        if (this._idleTimeoutID) {
            clearTimeout(this._idleTimeoutID);
            this._idleTimeoutID = undefined;
            if (Object.keys(this.activities).length === 0 && this._idleTimeoutCanceledPermanently) {
                this._finishReason = $73f9c5b4448a375a$var$IDLE_TRANSACTION_FINISH_REASONS[5];
                this.end(endTimestamp);
            }
        }
    }
    /**
   * Temporary method used to externally set the transaction's `finishReason`
   *
   * ** WARNING**
   * This is for the purpose of experimentation only and will be removed in the near future, do not use!
   *
   * @internal
   *
   */ setFinishReason(reason) {
        this._finishReason = reason;
    }
    /**
   * Permits the IdleTransaction to automatically end itself via the idle timeout and heartbeat mechanisms when the `delayAutoFinishUntilSignal` option was set to `true`.
   */ sendAutoFinishSignal() {
        if (!this._autoFinishAllowed) {
            (0, $cQ4mt.DEBUG_BUILD) && (0, $lN8pX.logger).log('[Tracing] Received finish signal for idle transaction.');
            this._restartIdleTimeout();
            this._autoFinishAllowed = true;
        }
    }
    /**
   * Restarts idle timeout, if there is no running idle timeout it will start one.
   */ _restartIdleTimeout(endTimestamp) {
        this.cancelIdleTimeout();
        this._idleTimeoutID = setTimeout(()=>{
            if (!this._finished && Object.keys(this.activities).length === 0) {
                this._finishReason = $73f9c5b4448a375a$var$IDLE_TRANSACTION_FINISH_REASONS[1];
                this.end(endTimestamp);
            }
        }, this._idleTimeout);
    }
    /**
   * Start tracking a specific activity.
   * @param spanId The span id that represents the activity
   */ _pushActivity(spanId) {
        this.cancelIdleTimeout(undefined, {
            restartOnChildSpanChange: !this._idleTimeoutCanceledPermanently
        });
        (0, $cQ4mt.DEBUG_BUILD) && (0, $lN8pX.logger).log(`[Tracing] pushActivity: ${spanId}`);
        this.activities[spanId] = true;
        (0, $cQ4mt.DEBUG_BUILD) && (0, $lN8pX.logger).log('[Tracing] new activities count', Object.keys(this.activities).length);
    }
    /**
   * Remove an activity from usage
   * @param spanId The span id that represents the activity
   */ _popActivity(spanId) {
        if (this.activities[spanId]) {
            (0, $cQ4mt.DEBUG_BUILD) && (0, $lN8pX.logger).log(`[Tracing] popActivity ${spanId}`);
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete this.activities[spanId];
            (0, $cQ4mt.DEBUG_BUILD) && (0, $lN8pX.logger).log('[Tracing] new activities count', Object.keys(this.activities).length);
        }
        if (Object.keys(this.activities).length === 0) {
            const endTimestamp = (0, $leMLP.timestampInSeconds)();
            if (this._idleTimeoutCanceledPermanently) {
                if (this._autoFinishAllowed) {
                    this._finishReason = $73f9c5b4448a375a$var$IDLE_TRANSACTION_FINISH_REASONS[5];
                    this.end(endTimestamp);
                }
            } else // We need to add the timeout here to have the real endtimestamp of the transaction
            // Remember timestampInSeconds is in seconds, timeout is in ms
            this._restartIdleTimeout(endTimestamp + this._idleTimeout / 1000);
        }
    }
    /**
   * Checks when entries of this.activities are not changing for 3 beats.
   * If this occurs we finish the transaction.
   */ _beat() {
        // We should not be running heartbeat if the idle transaction is finished.
        if (this._finished) return;
        const heartbeatString = Object.keys(this.activities).join('');
        if (heartbeatString === this._prevHeartbeatString) this._heartbeatCounter++;
        else this._heartbeatCounter = 1;
        this._prevHeartbeatString = heartbeatString;
        if (this._heartbeatCounter >= 3) {
            if (this._autoFinishAllowed) {
                (0, $cQ4mt.DEBUG_BUILD) && (0, $lN8pX.logger).log('[Tracing] Transaction finished because of no change for 3 heart beats');
                this.setStatus('deadline_exceeded');
                this._finishReason = $73f9c5b4448a375a$var$IDLE_TRANSACTION_FINISH_REASONS[0];
                this.end();
            }
        } else this._pingHeartbeat();
    }
    /**
   * Pings the heartbeat
   */ _pingHeartbeat() {
        (0, $cQ4mt.DEBUG_BUILD) && (0, $lN8pX.logger).log(`pinging Heartbeat -> current counter: ${this._heartbeatCounter}`);
        setTimeout(()=>{
            this._beat();
        }, this._heartbeatInterval);
    }
}

});
parcelRegister("bJ5g8", function(module, exports) {

$parcel$export(module.exports, "SpanRecorder", () => $8897fa0b88fef380$export$10c95c129cd0d4fe);
$parcel$export(module.exports, "Span", () => $8897fa0b88fef380$export$5f1714a13ed34c01);

var $aLrZa = parcelRequire("aLrZa");
var $lN8pX = parcelRequire("lN8pX");
var $leMLP = parcelRequire("leMLP");
var $1y8R2 = parcelRequire("1y8R2");

var $cQ4mt = parcelRequire("cQ4mt");

var $5viWL = parcelRequire("5viWL");

var $5ukjY = parcelRequire("5ukjY");

var $iB4pU = parcelRequire("iB4pU");

var $aYVgD = parcelRequire("aYVgD");

var $lBW6h = parcelRequire("lBW6h");
/**
 * Keeps track of finished spans for a given transaction
 * @internal
 * @hideconstructor
 * @hidden
 */ class $8897fa0b88fef380$export$10c95c129cd0d4fe {
    constructor(maxlen = 1000){
        this._maxlen = maxlen;
        this.spans = [];
    }
    /**
   * This is just so that we don't run out of memory while recording a lot
   * of spans. At some point we just stop and flush out the start of the
   * trace tree (i.e.the first n spans with the smallest
   * start_timestamp).
   */ add(span) {
        if (this.spans.length > this._maxlen) // eslint-disable-next-line deprecation/deprecation
        span.spanRecorder = undefined;
        else this.spans.push(span);
    }
}
/**
 * Span contains all data about a span
 */ class $8897fa0b88fef380$export$5f1714a13ed34c01 {
    /**
   * Tags for the span.
   * @deprecated Use `spanToJSON(span).atttributes` instead.
   */ /**
   * Data for the span.
   * @deprecated Use `spanToJSON(span).atttributes` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    /**
   * List of spans that were finalized
   *
   * @deprecated This property will no longer be public. Span recording will be handled internally.
   */ /**
   * @inheritDoc
   * @deprecated Use top level `Sentry.getRootSpan()` instead
   */ /**
   * The instrumenter that created this span.
   *
   * TODO (v8): This can probably be replaced by an `instanceOf` check of the span class.
   *            the instrumenter can only be sentry or otel so we can check the span instance
   *            to verify which one it is and remove this field entirely.
   *
   * @deprecated This field will be removed.
   */ /** Epoch timestamp in seconds when the span started. */ /** Epoch timestamp in seconds when the span ended. */ /** Internal keeper of the status */ /**
   * You should never call the constructor manually, always use `Sentry.startTransaction()`
   * or call `startChild()` on an existing span.
   * @internal
   * @hideconstructor
   * @hidden
   */ constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $1y8R2.uuid4)();
        this._spanId = spanContext.spanId || (0, $1y8R2.uuid4)().substring(16);
        this._startTime = spanContext.startTimestamp || (0, $leMLP.timestampInSeconds)();
        // eslint-disable-next-line deprecation/deprecation
        this.tags = spanContext.tags ? {
            ...spanContext.tags
        } : {};
        // eslint-disable-next-line deprecation/deprecation
        this.data = spanContext.data ? {
            ...spanContext.data
        } : {};
        // eslint-disable-next-line deprecation/deprecation
        this.instrumenter = spanContext.instrumenter || 'sentry';
        this._attributes = {};
        this.setAttributes({
            [(0, $5ukjY.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: spanContext.origin || 'manual',
            [(0, $5ukjY.SEMANTIC_ATTRIBUTE_SENTRY_OP)]: spanContext.op,
            ...spanContext.attributes
        });
        // eslint-disable-next-line deprecation/deprecation
        this._name = spanContext.name || spanContext.description;
        if (spanContext.parentSpanId) this._parentSpanId = spanContext.parentSpanId;
        // We want to include booleans as well here
        if ('sampled' in spanContext) this._sampled = spanContext.sampled;
        if (spanContext.status) this._status = spanContext.status;
        if (spanContext.endTimestamp) this._endTime = spanContext.endTimestamp;
        if (spanContext.exclusiveTime !== undefined) this._exclusiveTime = spanContext.exclusiveTime;
        this._measurements = spanContext.measurements ? {
            ...spanContext.measurements
        } : {};
    }
    // This rule conflicts with another eslint rule :(
    /* eslint-disable @typescript-eslint/member-ordering */ /**
   * An alias for `description` of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ get name() {
        return this._name || '';
    }
    /**
   * Update the name of the span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ set name(name) {
        this.updateName(name);
    }
    /**
   * Get the description of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ get description() {
        return this._name;
    }
    /**
   * Get the description of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ set description(description) {
        this._name = description;
    }
    /**
   * The ID of the trace.
   * @deprecated Use `spanContext().traceId` instead.
   */ get traceId() {
        return this._traceId;
    }
    /**
   * The ID of the trace.
   * @deprecated You cannot update the traceId of a span after span creation.
   */ set traceId(traceId) {
        this._traceId = traceId;
    }
    /**
   * The ID of the span.
   * @deprecated Use `spanContext().spanId` instead.
   */ get spanId() {
        return this._spanId;
    }
    /**
   * The ID of the span.
   * @deprecated You cannot update the spanId of a span after span creation.
   */ set spanId(spanId) {
        this._spanId = spanId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `startSpan` functions instead.
   */ set parentSpanId(string) {
        this._parentSpanId = string;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON(span).parent_span_id` instead.
   */ get parentSpanId() {
        return this._parentSpanId;
    }
    /**
   * Was this span chosen to be sent as part of the sample?
   * @deprecated Use `isRecording()` instead.
   */ get sampled() {
        return this._sampled;
    }
    /**
   * Was this span chosen to be sent as part of the sample?
   * @deprecated You cannot update the sampling decision of a span after span creation.
   */ set sampled(sampled) {
        this._sampled = sampled;
    }
    /**
   * Attributes for the span.
   * @deprecated Use `spanToJSON(span).atttributes` instead.
   */ get attributes() {
        return this._attributes;
    }
    /**
   * Attributes for the span.
   * @deprecated Use `setAttributes()` instead.
   */ set attributes(attributes) {
        this._attributes = attributes;
    }
    /**
   * Timestamp in seconds (epoch time) indicating when the span started.
   * @deprecated Use `spanToJSON()` instead.
   */ get startTimestamp() {
        return this._startTime;
    }
    /**
   * Timestamp in seconds (epoch time) indicating when the span started.
   * @deprecated In v8, you will not be able to update the span start time after creation.
   */ set startTimestamp(startTime) {
        this._startTime = startTime;
    }
    /**
   * Timestamp in seconds when the span ended.
   * @deprecated Use `spanToJSON()` instead.
   */ get endTimestamp() {
        return this._endTime;
    }
    /**
   * Timestamp in seconds when the span ended.
   * @deprecated Set the end time via `span.end()` instead.
   */ set endTimestamp(endTime) {
        this._endTime = endTime;
    }
    /**
   * The status of the span.
   *
   * @deprecated Use `spanToJSON().status` instead to get the status.
   */ get status() {
        return this._status;
    }
    /**
   * The status of the span.
   *
   * @deprecated Use `.setStatus()` instead to set or update the status.
   */ set status(status) {
        this._status = status;
    }
    /**
   * Operation of the span
   *
   * @deprecated Use `spanToJSON().op` to read the op instead.
   */ get op() {
        return this._attributes[0, $5ukjY.SEMANTIC_ATTRIBUTE_SENTRY_OP];
    }
    /**
   * Operation of the span
   *
   * @deprecated Use `startSpan()` functions to set or `span.setAttribute(SEMANTIC_ATTRIBUTE_SENTRY_OP, 'op')
   *             to update the span instead.
   */ set op(op) {
        this.setAttribute((0, $5ukjY.SEMANTIC_ATTRIBUTE_SENTRY_OP), op);
    }
    /**
   * The origin of the span, giving context about what created the span.
   *
   * @deprecated Use `spanToJSON().origin` to read the origin instead.
   */ get origin() {
        return this._attributes[0, $5ukjY.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN];
    }
    /**
   * The origin of the span, giving context about what created the span.
   *
   * @deprecated Use `startSpan()` functions to set the origin instead.
   */ set origin(origin) {
        this.setAttribute((0, $5ukjY.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN), origin);
    }
    /* eslint-enable @typescript-eslint/member-ordering */ /** @inheritdoc */ spanContext() {
        const { _spanId: spanId, _traceId: traceId, _sampled: sampled } = this;
        return {
            spanId: spanId,
            traceId: traceId,
            traceFlags: sampled ? (0, $aYVgD.TRACE_FLAG_SAMPLED) : (0, $aYVgD.TRACE_FLAG_NONE)
        };
    }
    /**
   * Creates a new `Span` while setting the current `Span.id` as `parentSpanId`.
   * Also the `sampled` decision will be inherited.
   *
   * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
   */ startChild(spanContext) {
        const childSpan = new $8897fa0b88fef380$export$5f1714a13ed34c01({
            ...spanContext,
            parentSpanId: this._spanId,
            sampled: this._sampled,
            traceId: this._traceId
        });
        // eslint-disable-next-line deprecation/deprecation
        childSpan.spanRecorder = this.spanRecorder;
        // eslint-disable-next-line deprecation/deprecation
        if (childSpan.spanRecorder) // eslint-disable-next-line deprecation/deprecation
        childSpan.spanRecorder.add(childSpan);
        const rootSpan = (0, $iB4pU.getRootSpan)(this);
        // TODO: still set span.transaction here until we have a more permanent solution
        // Probably similarly to the weakmap we hold in node-experimental
        // eslint-disable-next-line deprecation/deprecation
        childSpan.transaction = rootSpan;
        if ((0, $cQ4mt.DEBUG_BUILD) && rootSpan) {
            const opStr = spanContext && spanContext.op || '< unknown op >';
            const nameStr = (0, $aYVgD.spanToJSON)(childSpan).description || '< unknown name >';
            const idStr = rootSpan.spanContext().spanId;
            const logMessage = `[Tracing] Starting '${opStr}' span on transaction '${nameStr}' (${idStr}).`;
            (0, $lN8pX.logger).log(logMessage);
            this._logMessage = logMessage;
        }
        return childSpan;
    }
    /**
   * Sets the tag attribute on the current span.
   *
   * Can also be used to unset a tag, by passing `undefined`.
   *
   * @param key Tag key
   * @param value Tag value
   * @deprecated Use `setAttribute()` instead.
   */ setTag(key, value) {
        // eslint-disable-next-line deprecation/deprecation
        this.tags = {
            ...this.tags,
            [key]: value
        };
        return this;
    }
    /**
   * Sets the data attribute on the current span
   * @param key Data key
   * @param value Data value
   * @deprecated Use `setAttribute()` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setData(key, value) {
        // eslint-disable-next-line deprecation/deprecation
        this.data = {
            ...this.data,
            [key]: value
        };
        return this;
    }
    /** @inheritdoc */ setAttribute(key, value) {
        if (value === undefined) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._attributes[key];
        else this._attributes[key] = value;
    }
    /** @inheritdoc */ setAttributes(attributes) {
        Object.keys(attributes).forEach((key)=>this.setAttribute(key, attributes[key]));
    }
    /**
   * @inheritDoc
   */ setStatus(value) {
        this._status = value;
        return this;
    }
    /**
   * @inheritDoc
   * @deprecated Use top-level `setHttpStatus()` instead.
   */ setHttpStatus(httpStatus) {
        (0, $lBW6h.setHttpStatus)(this, httpStatus);
        return this;
    }
    /**
   * @inheritdoc
   *
   * @deprecated Use `.updateName()` instead.
   */ setName(name) {
        this.updateName(name);
    }
    /**
   * @inheritDoc
   */ updateName(name) {
        this._name = name;
        return this;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON(span).status === 'ok'` instead.
   */ isSuccess() {
        return this._status === 'ok';
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `.end()` instead.
   */ finish(endTimestamp) {
        return this.end(endTimestamp);
    }
    /** @inheritdoc */ end(endTimestamp) {
        // If already ended, skip
        if (this._endTime) return;
        const rootSpan = (0, $iB4pU.getRootSpan)(this);
        if ((0, $cQ4mt.DEBUG_BUILD) && // Don't call this for transactions
        rootSpan && rootSpan.spanContext().spanId !== this._spanId) {
            const logMessage = this._logMessage;
            if (logMessage) (0, $lN8pX.logger).log(logMessage.replace('Starting', 'Finishing'));
        }
        this._endTime = (0, $aYVgD.spanTimeInputToSeconds)(endTimestamp);
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToTraceHeader()` instead.
   */ toTraceparent() {
        return (0, $aYVgD.spanToTraceHeader)(this);
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON()` or access the fields directly instead.
   */ toContext() {
        return (0, $aLrZa.dropUndefinedKeys)({
            data: this._getData(),
            description: this._name,
            endTimestamp: this._endTime,
            // eslint-disable-next-line deprecation/deprecation
            op: this.op,
            parentSpanId: this._parentSpanId,
            sampled: this._sampled,
            spanId: this._spanId,
            startTimestamp: this._startTime,
            status: this._status,
            // eslint-disable-next-line deprecation/deprecation
            tags: this.tags,
            traceId: this._traceId
        });
    }
    /**
   * @inheritDoc
   *
   * @deprecated Update the fields directly instead.
   */ updateWithContext(spanContext) {
        // eslint-disable-next-line deprecation/deprecation
        this.data = spanContext.data || {};
        // eslint-disable-next-line deprecation/deprecation
        this._name = spanContext.name || spanContext.description;
        this._endTime = spanContext.endTimestamp;
        // eslint-disable-next-line deprecation/deprecation
        this.op = spanContext.op;
        this._parentSpanId = spanContext.parentSpanId;
        this._sampled = spanContext.sampled;
        this._spanId = spanContext.spanId || this._spanId;
        this._startTime = spanContext.startTimestamp || this._startTime;
        this._status = spanContext.status;
        // eslint-disable-next-line deprecation/deprecation
        this.tags = spanContext.tags || {};
        this._traceId = spanContext.traceId || this._traceId;
        return this;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToTraceContext()` util function instead.
   */ getTraceContext() {
        return (0, $aYVgD.spanToTraceContext)(this);
    }
    /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */ getSpanJSON() {
        return (0, $aLrZa.dropUndefinedKeys)({
            data: this._getData(),
            description: this._name,
            op: this._attributes[0, $5ukjY.SEMANTIC_ATTRIBUTE_SENTRY_OP],
            parent_span_id: this._parentSpanId,
            span_id: this._spanId,
            start_timestamp: this._startTime,
            status: this._status,
            // eslint-disable-next-line deprecation/deprecation
            tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
            timestamp: this._endTime,
            trace_id: this._traceId,
            origin: this._attributes[0, $5ukjY.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN],
            _metrics_summary: (0, $5viWL.getMetricSummaryJsonForSpan)(this),
            profile_id: this._attributes[0, $5ukjY.SEMANTIC_ATTRIBUTE_PROFILE_ID],
            exclusive_time: this._exclusiveTime,
            measurements: Object.keys(this._measurements).length > 0 ? this._measurements : undefined
        });
    }
    /** @inheritdoc */ isRecording() {
        return !this._endTime && !!this._sampled;
    }
    /**
   * Convert the object to JSON.
   * @deprecated Use `spanToJSON(span)` instead.
   */ toJSON() {
        return this.getSpanJSON();
    }
    /**
   * Get the merged data for this span.
   * For now, this combines `data` and `attributes` together,
   * until eventually we can ingest `attributes` directly.
   */ _getData() {
        // eslint-disable-next-line deprecation/deprecation
        const { data: data, _attributes: attributes } = this;
        const hasData = Object.keys(data).length > 0;
        const hasAttributes = Object.keys(attributes).length > 0;
        if (!hasData && !hasAttributes) return undefined;
        if (hasData && hasAttributes) return {
            ...data,
            ...attributes
        };
        return hasData ? data : attributes;
    }
}

});
parcelRegister("5viWL", function(module, exports) {

$parcel$export(module.exports, "getMetricSummaryJsonForSpan", () => $401e8b6d4fb7b324$export$2e7205e45c58797d);
$parcel$export(module.exports, "updateMetricSummaryOnActiveSpan", () => $401e8b6d4fb7b324$export$aefd1a302602f922);

var $aLrZa = parcelRequire("aLrZa");




var $9fRGu = parcelRequire("9fRGu");
/**
 * key: bucketKey
 * value: [exportKey, MetricSummary]
 */ let $401e8b6d4fb7b324$var$SPAN_METRIC_SUMMARY;
function $401e8b6d4fb7b324$var$getMetricStorageForSpan(span) {
    return $401e8b6d4fb7b324$var$SPAN_METRIC_SUMMARY ? $401e8b6d4fb7b324$var$SPAN_METRIC_SUMMARY.get(span) : undefined;
}
/**
 * Fetches the metric summary if it exists for the passed span
 */ function $401e8b6d4fb7b324$export$2e7205e45c58797d(span) {
    const storage = $401e8b6d4fb7b324$var$getMetricStorageForSpan(span);
    if (!storage) return undefined;
    const output = {};
    for (const [, [exportKey, summary]] of storage){
        if (!output[exportKey]) output[exportKey] = [];
        output[exportKey].push((0, $aLrZa.dropUndefinedKeys)(summary));
    }
    return output;
}
/**
 * Updates the metric summary on the currently active span
 */ function $401e8b6d4fb7b324$export$aefd1a302602f922(metricType, sanitizedName, value, unit, tags, bucketKey) {
    const span = (0, $9fRGu.getActiveSpan)();
    if (span) {
        const storage = $401e8b6d4fb7b324$var$getMetricStorageForSpan(span) || new Map();
        const exportKey = `${metricType}:${sanitizedName}@${unit}`;
        const bucketItem = storage.get(bucketKey);
        if (bucketItem) {
            const [, summary] = bucketItem;
            storage.set(bucketKey, [
                exportKey,
                {
                    min: Math.min(summary.min, value),
                    max: Math.max(summary.max, value),
                    count: summary.count += 1,
                    sum: summary.sum += value,
                    tags: summary.tags
                }
            ]);
        } else storage.set(bucketKey, [
            exportKey,
            {
                min: value,
                max: value,
                count: 1,
                sum: value,
                tags: tags
            }
        ]);
        if (!$401e8b6d4fb7b324$var$SPAN_METRIC_SUMMARY) $401e8b6d4fb7b324$var$SPAN_METRIC_SUMMARY = new WeakMap();
        $401e8b6d4fb7b324$var$SPAN_METRIC_SUMMARY.set(span, storage);
    }
}

});
parcelRegister("9fRGu", function(module, exports) {

$parcel$export(module.exports, "trace", () => $6bcf285ecdd049ed$export$357889f174732d38);
$parcel$export(module.exports, "startSpan", () => $6bcf285ecdd049ed$export$a1bd95187356f372);
$parcel$export(module.exports, "startSpanManual", () => $6bcf285ecdd049ed$export$c10292ad04b92aea);
$parcel$export(module.exports, "startInactiveSpan", () => $6bcf285ecdd049ed$export$63dbba021a6b4047);
$parcel$export(module.exports, "getActiveSpan", () => $6bcf285ecdd049ed$export$1be426a8e585c83e);
$parcel$export(module.exports, "continueTrace", () => $6bcf285ecdd049ed$export$d2ee9b39b25437b3);
$parcel$export(module.exports, "getCapturedScopesOnSpan", () => $6bcf285ecdd049ed$export$c08fbc656a245d03);

var $aLrZa = parcelRequire("aLrZa");
var $lN8pX = parcelRequire("lN8pX");
var $27K1p = parcelRequire("27K1p");

var $cQ4mt = parcelRequire("cQ4mt");

var $egVmm = parcelRequire("egVmm");

var $aYVgD = parcelRequire("aYVgD");



var $7AtVc = parcelRequire("7AtVc");

var $fq71H = parcelRequire("fq71H");

var $h1wvX = parcelRequire("h1wvX");

var $bcruQ = parcelRequire("bcruQ");
/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 *
 * This function is meant to be used internally and may break at any time. Use at your own risk.
 *
 * @internal
 * @private
 *
 * @deprecated Use `startSpan` instead.
 */ function $6bcf285ecdd049ed$export$357889f174732d38(context, callback, // eslint-disable-next-line @typescript-eslint/no-empty-function
onError = ()=>{}, // eslint-disable-next-line @typescript-eslint/no-empty-function
afterFinish = ()=>{}) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $egVmm.getCurrentHub)();
    const scope = (0, $fq71H.getCurrentScope)();
    // eslint-disable-next-line deprecation/deprecation
    const parentSpan = scope.getSpan();
    const spanContext = $6bcf285ecdd049ed$var$normalizeContext(context);
    const activeSpan = $6bcf285ecdd049ed$var$createChildSpanOrTransaction(hub, {
        parentSpan: parentSpan,
        spanContext: spanContext,
        forceTransaction: false,
        scope: scope
    });
    // eslint-disable-next-line deprecation/deprecation
    scope.setSpan(activeSpan);
    return (0, $h1wvX.handleCallbackErrors)(()=>callback(activeSpan), (error)=>{
        activeSpan && activeSpan.setStatus('internal_error');
        onError(error, activeSpan);
    }, ()=>{
        activeSpan && activeSpan.end();
        // eslint-disable-next-line deprecation/deprecation
        scope.setSpan(parentSpan);
        afterFinish();
    });
}
/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getSpan()`, as long as the function is executed while the scope is active.
 *
 * If you want to create a span that is not set as active, use {@link startInactiveSpan}.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */ function $6bcf285ecdd049ed$export$a1bd95187356f372(context, callback) {
    const spanContext = $6bcf285ecdd049ed$var$normalizeContext(context);
    return (0, $egVmm.runWithAsyncContext)(()=>{
        return (0, $fq71H.withScope)(context.scope, (scope)=>{
            // eslint-disable-next-line deprecation/deprecation
            const hub = (0, $egVmm.getCurrentHub)();
            // eslint-disable-next-line deprecation/deprecation
            const parentSpan = scope.getSpan();
            const shouldSkipSpan = context.onlyIfParent && !parentSpan;
            const activeSpan = shouldSkipSpan ? undefined : $6bcf285ecdd049ed$var$createChildSpanOrTransaction(hub, {
                parentSpan: parentSpan,
                spanContext: spanContext,
                forceTransaction: context.forceTransaction,
                scope: scope
            });
            return (0, $h1wvX.handleCallbackErrors)(()=>callback(activeSpan), ()=>{
                // Only update the span status if it hasn't been changed yet
                if (activeSpan) {
                    const { status: status } = (0, $aYVgD.spanToJSON)(activeSpan);
                    if (!status || status === 'ok') activeSpan.setStatus('internal_error');
                }
            }, ()=>activeSpan && activeSpan.end());
        });
    });
}
/**
 * @deprecated Use {@link startSpan} instead.
 */ const $6bcf285ecdd049ed$export$cb9e396e6b90b703 = $6bcf285ecdd049ed$export$a1bd95187356f372;
/**
 * Similar to `Sentry.startSpan`. Wraps a function with a transaction/span, but does not finish the span
 * after the function is done automatically. You'll have to call `span.end()` manually.
 *
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */ function $6bcf285ecdd049ed$export$c10292ad04b92aea(context, callback) {
    const spanContext = $6bcf285ecdd049ed$var$normalizeContext(context);
    return (0, $egVmm.runWithAsyncContext)(()=>{
        return (0, $fq71H.withScope)(context.scope, (scope)=>{
            // eslint-disable-next-line deprecation/deprecation
            const hub = (0, $egVmm.getCurrentHub)();
            // eslint-disable-next-line deprecation/deprecation
            const parentSpan = scope.getSpan();
            const shouldSkipSpan = context.onlyIfParent && !parentSpan;
            const activeSpan = shouldSkipSpan ? undefined : $6bcf285ecdd049ed$var$createChildSpanOrTransaction(hub, {
                parentSpan: parentSpan,
                spanContext: spanContext,
                forceTransaction: context.forceTransaction,
                scope: scope
            });
            function finishAndSetSpan() {
                activeSpan && activeSpan.end();
            }
            return (0, $h1wvX.handleCallbackErrors)(()=>callback(activeSpan, finishAndSetSpan), ()=>{
                // Only update the span status if it hasn't been changed yet, and the span is not yet finished
                if (activeSpan && activeSpan.isRecording()) {
                    const { status: status } = (0, $aYVgD.spanToJSON)(activeSpan);
                    if (!status || status === 'ok') activeSpan.setStatus('internal_error');
                }
            });
        });
    });
}
/**
 * Creates a span. This span is not set as active, so will not get automatic instrumentation spans
 * as children or be able to be accessed via `Sentry.getSpan()`.
 *
 * If you want to create a span that is set as active, use {@link startSpan}.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate` or `tracesSampler`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */ function $6bcf285ecdd049ed$export$63dbba021a6b4047(context) {
    if (!(0, $bcruQ.hasTracingEnabled)()) return undefined;
    const spanContext = $6bcf285ecdd049ed$var$normalizeContext(context);
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $egVmm.getCurrentHub)();
    const parentSpan = context.scope ? context.scope.getSpan() : $6bcf285ecdd049ed$export$1be426a8e585c83e();
    const shouldSkipSpan = context.onlyIfParent && !parentSpan;
    if (shouldSkipSpan) return undefined;
    const scope = context.scope || (0, $fq71H.getCurrentScope)();
    // Even though we don't actually want to make this span active on the current scope,
    // we need to make it active on a temporary scope that we use for event processing
    // as otherwise, it won't pick the correct span for the event when processing it
    const temporaryScope = scope.clone();
    return $6bcf285ecdd049ed$var$createChildSpanOrTransaction(hub, {
        parentSpan: parentSpan,
        spanContext: spanContext,
        forceTransaction: context.forceTransaction,
        scope: temporaryScope
    });
}
/**
 * Returns the currently active span.
 */ function $6bcf285ecdd049ed$export$1be426a8e585c83e() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $fq71H.getCurrentScope)().getSpan();
}
const $6bcf285ecdd049ed$export$d2ee9b39b25437b3 = ({ sentryTrace: sentryTrace, baggage: baggage }, callback)=>{
    // TODO(v8): Change this function so it doesn't do anything besides setting the propagation context on the current scope:
    /*
    return withScope((scope) => {
      const propagationContext = propagationContextFromHeaders(sentryTrace, baggage);
      scope.setPropagationContext(propagationContext);
      return callback();
    })
  */ const currentScope = (0, $fq71H.getCurrentScope)();
    // eslint-disable-next-line deprecation/deprecation
    const { traceparentData: traceparentData, dynamicSamplingContext: dynamicSamplingContext, propagationContext: propagationContext } = (0, $27K1p.tracingContextFromHeaders)(sentryTrace, baggage);
    currentScope.setPropagationContext(propagationContext);
    if ((0, $cQ4mt.DEBUG_BUILD) && traceparentData) (0, $lN8pX.logger).log(`[Tracing] Continuing trace ${traceparentData.traceId}.`);
    const transactionContext = {
        ...traceparentData,
        metadata: (0, $aLrZa.dropUndefinedKeys)({
            dynamicSamplingContext: dynamicSamplingContext
        })
    };
    if (!callback) return transactionContext;
    return (0, $egVmm.runWithAsyncContext)(()=>{
        return callback(transactionContext);
    });
};
function $6bcf285ecdd049ed$var$createChildSpanOrTransaction(// eslint-disable-next-line deprecation/deprecation
hub, { parentSpan: parentSpan, spanContext: spanContext, forceTransaction: forceTransaction, scope: scope }) {
    if (!(0, $bcruQ.hasTracingEnabled)()) return undefined;
    const isolationScope = (0, $egVmm.getIsolationScope)();
    let span;
    if (parentSpan && !forceTransaction) // eslint-disable-next-line deprecation/deprecation
    span = parentSpan.startChild(spanContext);
    else if (parentSpan) {
        // If we forced a transaction but have a parent span, make sure to continue from the parent span, not the scope
        const dsc = (0, $7AtVc.getDynamicSamplingContextFromSpan)(parentSpan);
        const { traceId: traceId, spanId: parentSpanId } = parentSpan.spanContext();
        const sampled = (0, $aYVgD.spanIsSampled)(parentSpan);
        // eslint-disable-next-line deprecation/deprecation
        span = hub.startTransaction({
            traceId: traceId,
            parentSpanId: parentSpanId,
            parentSampled: sampled,
            ...spanContext,
            metadata: {
                dynamicSamplingContext: dsc,
                // eslint-disable-next-line deprecation/deprecation
                ...spanContext.metadata
            }
        });
    } else {
        const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: sampled } = {
            ...isolationScope.getPropagationContext(),
            ...scope.getPropagationContext()
        };
        // eslint-disable-next-line deprecation/deprecation
        span = hub.startTransaction({
            traceId: traceId,
            parentSpanId: parentSpanId,
            parentSampled: sampled,
            ...spanContext,
            metadata: {
                dynamicSamplingContext: dsc,
                // eslint-disable-next-line deprecation/deprecation
                ...spanContext.metadata
            }
        });
    }
    // We always set this as active span on the scope
    // In the case of this being an inactive span, we ensure to pass a detached scope in here in the first place
    // But by having this here, we can ensure that the lookup through `getCapturedScopesOnSpan` results in the correct scope & span combo
    // eslint-disable-next-line deprecation/deprecation
    scope.setSpan(span);
    $6bcf285ecdd049ed$var$setCapturedScopesOnSpan(span, scope, isolationScope);
    return span;
}
/**
 * This converts StartSpanOptions to TransactionContext.
 * For the most part (for now) we accept the same options,
 * but some of them need to be transformed.
 *
 * Eventually the StartSpanOptions will be more aligned with OpenTelemetry.
 */ function $6bcf285ecdd049ed$var$normalizeContext(context) {
    if (context.startTime) {
        const ctx = {
            ...context
        };
        ctx.startTimestamp = (0, $aYVgD.spanTimeInputToSeconds)(context.startTime);
        delete ctx.startTime;
        return ctx;
    }
    return context;
}
const $6bcf285ecdd049ed$var$SCOPE_ON_START_SPAN_FIELD = '_sentryScope';
const $6bcf285ecdd049ed$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD = '_sentryIsolationScope';
function $6bcf285ecdd049ed$var$setCapturedScopesOnSpan(span, scope, isolationScope) {
    if (span) {
        (0, $aLrZa.addNonEnumerableProperty)(span, $6bcf285ecdd049ed$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD, isolationScope);
        (0, $aLrZa.addNonEnumerableProperty)(span, $6bcf285ecdd049ed$var$SCOPE_ON_START_SPAN_FIELD, scope);
    }
}
/**
 * Grabs the scope and isolation scope off a span that were active when the span was started.
 */ function $6bcf285ecdd049ed$export$c08fbc656a245d03(span) {
    return {
        scope: span[$6bcf285ecdd049ed$var$SCOPE_ON_START_SPAN_FIELD],
        isolationScope: span[$6bcf285ecdd049ed$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD]
    };
}

});
parcelRegister("h1wvX", function(module, exports) {

$parcel$export(module.exports, "handleCallbackErrors", () => $c64bc05d53615e2e$export$18ce21a8b7efd7e9);

var $dlAFs = parcelRequire("dlAFs");
/**
 * Wrap a callback function with error handling.
 * If an error is thrown, it will be passed to the `onError` callback and re-thrown.
 *
 * If the return value of the function is a promise, it will be handled with `maybeHandlePromiseRejection`.
 *
 * If an `onFinally` callback is provided, this will be called when the callback has finished
 * - so if it returns a promise, once the promise resolved/rejected,
 * else once the callback has finished executing.
 * The `onFinally` callback will _always_ be called, no matter if an error was thrown or not.
 */ function $c64bc05d53615e2e$export$18ce21a8b7efd7e9(fn, onError, // eslint-disable-next-line @typescript-eslint/no-empty-function
onFinally = ()=>{}) {
    let maybePromiseResult;
    try {
        maybePromiseResult = fn();
    } catch (e) {
        onError(e);
        onFinally();
        throw e;
    }
    return $c64bc05d53615e2e$var$maybeHandlePromiseRejection(maybePromiseResult, onError, onFinally);
}
/**
 * Maybe handle a promise rejection.
 * This expects to be given a value that _may_ be a promise, or any other value.
 * If it is a promise, and it rejects, it will call the `onError` callback.
 * Other than this, it will generally return the given value as-is.
 */ function $c64bc05d53615e2e$var$maybeHandlePromiseRejection(value, onError, onFinally) {
    if ((0, $dlAFs.isThenable)(value)) // @ts-expect-error - the isThenable check returns the "wrong" type here
    return value.then((res)=>{
        onFinally();
        return res;
    }, (e)=>{
        onError(e);
        onFinally();
        throw e;
    });
    onFinally();
    return value;
}

});

parcelRegister("bcruQ", function(module, exports) {

$parcel$export(module.exports, "hasTracingEnabled", () => $827624f281a34124$export$5008da00b1b6dee6);

var $fq71H = parcelRequire("fq71H");
// Treeshakable guard to remove all code related to tracing
/**
 * Determines if tracing is currently enabled.
 *
 * Tracing is enabled when at least one of `tracesSampleRate` and `tracesSampler` is defined in the SDK config.
 */ function $827624f281a34124$export$5008da00b1b6dee6(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === 'boolean' && !__SENTRY_TRACING__) return false;
    const client = (0, $fq71H.getClient)();
    const options = maybeOptions || client && client.getOptions();
    return !!options && (options.enableTracing || 'tracesSampleRate' in options || 'tracesSampler' in options);
}

});



parcelRegister("5ukjY", function(module, exports) {

$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_SOURCE", () => $3fef8470fbd0c7c6$export$d7a7d984b0791405);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE", () => $3fef8470fbd0c7c6$export$ccfe0a40627cc34b);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_OP", () => $3fef8470fbd0c7c6$export$1a413bd9a88fdb09);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN", () => $3fef8470fbd0c7c6$export$cca8dd30f57f805e);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_PROFILE_ID", () => $3fef8470fbd0c7c6$export$1efec95406bbe327);
/**
 * Use this attribute to represent the source of a span.
 * Should be one of: custom, url, route, view, component, task, unknown
 *
 */ const $3fef8470fbd0c7c6$export$d7a7d984b0791405 = 'sentry.source';
/**
 * Use this attribute to represent the sample rate used for a span.
 */ const $3fef8470fbd0c7c6$export$ccfe0a40627cc34b = 'sentry.sample_rate';
/**
 * Use this attribute to represent the operation of a span.
 */ const $3fef8470fbd0c7c6$export$1a413bd9a88fdb09 = 'sentry.op';
/**
 * Use this attribute to represent the origin of a span.
 */ const $3fef8470fbd0c7c6$export$cca8dd30f57f805e = 'sentry.origin';
/**
 * The id of the profile that this span occured in.
 */ const $3fef8470fbd0c7c6$export$1efec95406bbe327 = 'profile_id';

});

parcelRegister("lBW6h", function(module, exports) {

$parcel$export(module.exports, "getSpanStatusFromHttpCode", () => $fbba1f29799ff884$export$5fd4dc48a2131589);
$parcel$export(module.exports, "spanStatusfromHttpCode", () => $fbba1f29799ff884$export$ac65c70d78fcdb55);
$parcel$export(module.exports, "setHttpStatus", () => $fbba1f29799ff884$export$2ad6630ec8164254);
/** The status of an Span.
 *
 * @deprecated Use string literals - if you require type casting, cast to SpanStatusType type
 */ var $fbba1f29799ff884$export$beb8e6a823e89c5d;
(function(SpanStatus) {
    /** The operation completed successfully. */ const Ok = 'ok';
    SpanStatus["Ok"] = Ok;
    /** Deadline expired before operation could complete. */ const DeadlineExceeded = 'deadline_exceeded';
    SpanStatus["DeadlineExceeded"] = DeadlineExceeded;
    /** 401 Unauthorized (actually does mean unauthenticated according to RFC 7235) */ const Unauthenticated = 'unauthenticated';
    SpanStatus["Unauthenticated"] = Unauthenticated;
    /** 403 Forbidden */ const PermissionDenied = 'permission_denied';
    SpanStatus["PermissionDenied"] = PermissionDenied;
    /** 404 Not Found. Some requested entity (file or directory) was not found. */ const NotFound = 'not_found';
    SpanStatus["NotFound"] = NotFound;
    /** 429 Too Many Requests */ const ResourceExhausted = 'resource_exhausted';
    SpanStatus["ResourceExhausted"] = ResourceExhausted;
    /** Client specified an invalid argument. 4xx. */ const InvalidArgument = 'invalid_argument';
    SpanStatus["InvalidArgument"] = InvalidArgument;
    /** 501 Not Implemented */ const Unimplemented = 'unimplemented';
    SpanStatus["Unimplemented"] = Unimplemented;
    /** 503 Service Unavailable */ const Unavailable = 'unavailable';
    SpanStatus["Unavailable"] = Unavailable;
    /** Other/generic 5xx. */ const InternalError = 'internal_error';
    SpanStatus["InternalError"] = InternalError;
    /** Unknown. Any non-standard HTTP status code. */ const UnknownError = 'unknown_error';
    SpanStatus["UnknownError"] = UnknownError;
    /** The operation was cancelled (typically by the user). */ const Cancelled = 'cancelled';
    SpanStatus["Cancelled"] = Cancelled;
    /** Already exists (409) */ const AlreadyExists = 'already_exists';
    SpanStatus["AlreadyExists"] = AlreadyExists;
    /** Operation was rejected because the system is not in a state required for the operation's */ const FailedPrecondition = 'failed_precondition';
    SpanStatus["FailedPrecondition"] = FailedPrecondition;
    /** The operation was aborted, typically due to a concurrency issue. */ const Aborted = 'aborted';
    SpanStatus["Aborted"] = Aborted;
    /** Operation was attempted past the valid range. */ const OutOfRange = 'out_of_range';
    SpanStatus["OutOfRange"] = OutOfRange;
    /** Unrecoverable data loss or corruption */ const DataLoss = 'data_loss';
    SpanStatus["DataLoss"] = DataLoss;
})($fbba1f29799ff884$export$beb8e6a823e89c5d || ($fbba1f29799ff884$export$beb8e6a823e89c5d = {}));
/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ function $fbba1f29799ff884$export$5fd4dc48a2131589(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return 'ok';
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return 'unauthenticated';
        case 403:
            return 'permission_denied';
        case 404:
            return 'not_found';
        case 409:
            return 'already_exists';
        case 413:
            return 'failed_precondition';
        case 429:
            return 'resource_exhausted';
        default:
            return 'invalid_argument';
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return 'unimplemented';
        case 503:
            return 'unavailable';
        case 504:
            return 'deadline_exceeded';
        default:
            return 'internal_error';
    }
    return 'unknown_error';
}
/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @deprecated Use {@link spanStatusFromHttpCode} instead.
 * This export will be removed in v8 as the signature contains a typo.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ const $fbba1f29799ff884$export$ac65c70d78fcdb55 = $fbba1f29799ff884$export$5fd4dc48a2131589;
/**
 * Sets the Http status attributes on the current span based on the http code.
 * Additionally, the span's status is updated, depending on the http code.
 */ function $fbba1f29799ff884$export$2ad6630ec8164254(span, httpStatus) {
    // TODO (v8): Remove these calls
    // Relay does not require us to send the status code as a tag
    // For now, just because users might expect it to land as a tag we keep sending it.
    // Same with data.
    // In v8, we replace both, simply with
    // span.setAttribute('http.response.status_code', httpStatus);
    // eslint-disable-next-line deprecation/deprecation
    span.setTag('http.status_code', String(httpStatus));
    // eslint-disable-next-line deprecation/deprecation
    span.setData('http.response.status_code', httpStatus);
    const spanStatus = $fbba1f29799ff884$export$5fd4dc48a2131589(httpStatus);
    if (spanStatus !== 'unknown_error') span.setStatus(spanStatus);
}

});


parcelRegister("dfUqJ", function(module, exports) {

$parcel$export(module.exports, "Transaction", () => $9a6872f2828519a0$export$febc5573c75cefb0);

var $aLrZa = parcelRequire("aLrZa");
var $lN8pX = parcelRequire("lN8pX");

var $cQ4mt = parcelRequire("cQ4mt");

var $egVmm = parcelRequire("egVmm");

var $5viWL = parcelRequire("5viWL");

var $5ukjY = parcelRequire("5ukjY");

var $aYVgD = parcelRequire("aYVgD");

var $7AtVc = parcelRequire("7AtVc");

var $bJ5g8 = parcelRequire("bJ5g8");

var $9fRGu = parcelRequire("9fRGu");
/** JSDoc */ class $9a6872f2828519a0$export$febc5573c75cefb0 extends (0, $bJ5g8.Span) {
    /**
   * The reference to the current hub.
   */ // eslint-disable-next-line deprecation/deprecation
    // DO NOT yet remove this property, it is used in a hack for v7 backwards compatibility.
    /**
   * This constructor should never be called manually. Those instrumenting tracing should use
   * `Sentry.startTransaction()`, and internal methods should use `hub.startTransaction()`.
   * @internal
   * @hideconstructor
   * @hidden
   *
   * @deprecated Transactions will be removed in v8. Use spans instead.
   */ // eslint-disable-next-line deprecation/deprecation
    constructor(transactionContext, hub){
        super(transactionContext);
        this._contexts = {};
        // eslint-disable-next-line deprecation/deprecation
        this._hub = hub || (0, $egVmm.getCurrentHub)();
        this._name = transactionContext.name || '';
        this._metadata = {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.metadata
        };
        this._trimEnd = transactionContext.trimEnd;
        // this is because transactions are also spans, and spans have a transaction pointer
        // TODO (v8): Replace this with another way to set the root span
        // eslint-disable-next-line deprecation/deprecation
        this.transaction = this;
        // If Dynamic Sampling Context is provided during the creation of the transaction, we freeze it as it usually means
        // there is incoming Dynamic Sampling Context. (Either through an incoming request, a baggage meta-tag, or other means)
        const incomingDynamicSamplingContext = this._metadata.dynamicSamplingContext;
        if (incomingDynamicSamplingContext) // We shallow copy this in case anything writes to the original reference of the passed in `dynamicSamplingContext`
        this._frozenDynamicSamplingContext = {
            ...incomingDynamicSamplingContext
        };
    }
    // This sadly conflicts with the getter/setter ordering :(
    /* eslint-disable @typescript-eslint/member-ordering */ /**
   * Getter for `name` property.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ get name() {
        return this._name;
    }
    /**
   * Setter for `name` property, which also sets `source` as custom.
   * @deprecated Use `updateName()` and `setMetadata()` instead.
   */ set name(newName) {
        // eslint-disable-next-line deprecation/deprecation
        this.setName(newName);
    }
    /**
   * Get the metadata for this transaction.
   * @deprecated Use `spanGetMetadata(transaction)` instead.
   */ get metadata() {
        // We merge attributes in for backwards compatibility
        return {
            // Defaults
            // eslint-disable-next-line deprecation/deprecation
            source: 'custom',
            spanMetadata: {},
            // Legacy metadata
            ...this._metadata,
            // From attributes
            ...this._attributes[0, $5ukjY.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] && {
                source: this._attributes[0, $5ukjY.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]
            },
            ...this._attributes[0, $5ukjY.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE] && {
                sampleRate: this._attributes[0, $5ukjY.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE]
            }
        };
    }
    /**
   * Update the metadata for this transaction.
   * @deprecated Use `spanGetMetadata(transaction)` instead.
   */ set metadata(metadata) {
        this._metadata = metadata;
    }
    /* eslint-enable @typescript-eslint/member-ordering */ /**
   * Setter for `name` property, which also sets `source` on the metadata.
   *
   * @deprecated Use `.updateName()` and `.setAttribute()` instead.
   */ setName(name, source = 'custom') {
        this._name = name;
        this.setAttribute((0, $5ukjY.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE), source);
    }
    /** @inheritdoc */ updateName(name) {
        this._name = name;
        return this;
    }
    /**
   * Attaches SpanRecorder to the span itself
   * @param maxlen maximum number of spans that can be recorded
   */ initSpanRecorder(maxlen = 1000) {
        // eslint-disable-next-line deprecation/deprecation
        if (!this.spanRecorder) // eslint-disable-next-line deprecation/deprecation
        this.spanRecorder = new (0, $bJ5g8.SpanRecorder)(maxlen);
        // eslint-disable-next-line deprecation/deprecation
        this.spanRecorder.add(this);
    }
    /**
   * Set the context of a transaction event.
   * @deprecated Use either `.setAttribute()`, or set the context on the scope before creating the transaction.
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use top-level `setMeasurement()` instead.
   */ setMeasurement(name, value, unit = '') {
        this._measurements[name] = {
            value: value,
            unit: unit
        };
    }
    /**
   * Store metadata on this transaction.
   * @deprecated Use attributes or store data on the scope instead.
   */ setMetadata(newMetadata) {
        this._metadata = {
            ...this._metadata,
            ...newMetadata
        };
    }
    /**
   * @inheritDoc
   */ end(endTimestamp) {
        const timestampInS = (0, $aYVgD.spanTimeInputToSeconds)(endTimestamp);
        const transaction = this._finishTransaction(timestampInS);
        if (!transaction) return undefined;
        // eslint-disable-next-line deprecation/deprecation
        return this._hub.captureEvent(transaction);
    }
    /**
   * @inheritDoc
   */ toContext() {
        // eslint-disable-next-line deprecation/deprecation
        const spanContext = super.toContext();
        return (0, $aLrZa.dropUndefinedKeys)({
            ...spanContext,
            name: this._name,
            trimEnd: this._trimEnd
        });
    }
    /**
   * @inheritDoc
   */ updateWithContext(transactionContext) {
        // eslint-disable-next-line deprecation/deprecation
        super.updateWithContext(transactionContext);
        this._name = transactionContext.name || '';
        this._trimEnd = transactionContext.trimEnd;
        return this;
    }
    /**
   * @inheritdoc
   *
   * @experimental
   *
   * @deprecated Use top-level `getDynamicSamplingContextFromSpan` instead.
   */ getDynamicSamplingContext() {
        return (0, $7AtVc.getDynamicSamplingContextFromSpan)(this);
    }
    /**
   * Override the current hub with a new one.
   * Used if you want another hub to finish the transaction.
   *
   * @internal
   */ // eslint-disable-next-line deprecation/deprecation
    setHub(hub) {
        this._hub = hub;
    }
    /**
   * Get the profile id of the transaction.
   */ getProfileId() {
        if (this._contexts !== undefined && this._contexts['profile'] !== undefined) return this._contexts['profile'].profile_id;
        return undefined;
    }
    /**
   * Finish the transaction & prepare the event to send to Sentry.
   */ _finishTransaction(endTimestamp) {
        // This transaction is already finished, so we should not flush it again.
        if (this._endTime !== undefined) return undefined;
        if (!this._name) {
            (0, $cQ4mt.DEBUG_BUILD) && (0, $lN8pX.logger).warn('Transaction has no name, falling back to `<unlabeled transaction>`.');
            this._name = '<unlabeled transaction>';
        }
        // just sets the end timestamp
        super.end(endTimestamp);
        // eslint-disable-next-line deprecation/deprecation
        const client = this._hub.getClient();
        if (client && client.emit) client.emit('finishTransaction', this);
        if (this._sampled !== true) {
            // At this point if `sampled !== true` we want to discard the transaction.
            (0, $cQ4mt.DEBUG_BUILD) && (0, $lN8pX.logger).log('[Tracing] Discarding transaction because its trace was not chosen to be sampled.');
            if (client) client.recordDroppedEvent('sample_rate', 'transaction');
            return undefined;
        }
        // eslint-disable-next-line deprecation/deprecation
        const finishedSpans = this.spanRecorder ? this.spanRecorder.spans.filter((span)=>span !== this && (0, $aYVgD.spanToJSON)(span).timestamp) : [];
        if (this._trimEnd && finishedSpans.length > 0) {
            const endTimes = finishedSpans.map((span)=>(0, $aYVgD.spanToJSON)(span).timestamp).filter(Boolean);
            this._endTime = endTimes.reduce((prev, current)=>{
                return prev > current ? prev : current;
            });
        }
        const { scope: capturedSpanScope, isolationScope: capturedSpanIsolationScope } = (0, $9fRGu.getCapturedScopesOnSpan)(this);
        // eslint-disable-next-line deprecation/deprecation
        const { metadata: metadata } = this;
        // eslint-disable-next-line deprecation/deprecation
        const { source: source } = metadata;
        const transaction = {
            contexts: {
                ...this._contexts,
                // We don't want to override trace context
                trace: (0, $aYVgD.spanToTraceContext)(this)
            },
            // TODO: Pass spans serialized via `spanToJSON()` here instead in v8.
            spans: finishedSpans,
            start_timestamp: this._startTime,
            // eslint-disable-next-line deprecation/deprecation
            tags: this.tags,
            timestamp: this._endTime,
            transaction: this._name,
            type: 'transaction',
            sdkProcessingMetadata: {
                ...metadata,
                capturedSpanScope: capturedSpanScope,
                capturedSpanIsolationScope: capturedSpanIsolationScope,
                ...(0, $aLrZa.dropUndefinedKeys)({
                    dynamicSamplingContext: (0, $7AtVc.getDynamicSamplingContextFromSpan)(this)
                })
            },
            _metrics_summary: (0, $5viWL.getMetricSummaryJsonForSpan)(this),
            ...source && {
                transaction_info: {
                    source: source
                }
            }
        };
        const hasMeasurements = Object.keys(this._measurements).length > 0;
        if (hasMeasurements) {
            (0, $cQ4mt.DEBUG_BUILD) && (0, $lN8pX.logger).log('[Measurements] Adding measurements to transaction', JSON.stringify(this._measurements, undefined, 2));
            transaction.measurements = this._measurements;
        }
        // eslint-disable-next-line deprecation/deprecation
        (0, $cQ4mt.DEBUG_BUILD) && (0, $lN8pX.logger).log(`[Tracing] Finishing ${this.op} transaction: ${this._name}.`);
        return transaction;
    }
}

});


parcelRegister("kDNXp", function(module, exports) {

$parcel$export(module.exports, "sampleTransaction", () => $f06e33a2babc23dc$export$b3258c3993bc9b71);
$parcel$export(module.exports, "isValidSampleRate", () => $f06e33a2babc23dc$export$2603c8d332a51c42);

var $dlAFs = parcelRequire("dlAFs");
var $lN8pX = parcelRequire("lN8pX");

var $cQ4mt = parcelRequire("cQ4mt");

var $5ukjY = parcelRequire("5ukjY");

var $bcruQ = parcelRequire("bcruQ");

var $aYVgD = parcelRequire("aYVgD");
/**
 * Makes a sampling decision for the given transaction and stores it on the transaction.
 *
 * Called every time a transaction is created. Only transactions which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 *
 * This method muttes the given `transaction` and will set the `sampled` value on it.
 * It returns the same transaction, for convenience.
 */ function $f06e33a2babc23dc$export$b3258c3993bc9b71(transaction, options, samplingContext) {
    // nothing to do if tracing is not enabled
    if (!(0, $bcruQ.hasTracingEnabled)(options)) {
        // eslint-disable-next-line deprecation/deprecation
        transaction.sampled = false;
        return transaction;
    }
    // if the user has forced a sampling decision by passing a `sampled` value in their transaction context, go with that
    // eslint-disable-next-line deprecation/deprecation
    if (transaction.sampled !== undefined) {
        // eslint-disable-next-line deprecation/deprecation
        transaction.setAttribute((0, $5ukjY.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE), Number(transaction.sampled));
        return transaction;
    }
    // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` nor `enableTracing` were defined, so one of these should
    // work; prefer the hook if so
    let sampleRate;
    if (typeof options.tracesSampler === 'function') {
        sampleRate = options.tracesSampler(samplingContext);
        transaction.setAttribute((0, $5ukjY.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE), Number(sampleRate));
    } else if (samplingContext.parentSampled !== undefined) sampleRate = samplingContext.parentSampled;
    else if (typeof options.tracesSampleRate !== 'undefined') {
        sampleRate = options.tracesSampleRate;
        transaction.setAttribute((0, $5ukjY.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE), Number(sampleRate));
    } else {
        // When `enableTracing === true`, we use a sample rate of 100%
        sampleRate = 1;
        transaction.setAttribute((0, $5ukjY.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE), sampleRate);
    }
    // Since this is coming from the user (or from a function provided by the user), who knows what we might get. (The
    // only valid values are booleans or numbers between 0 and 1.)
    if (!$f06e33a2babc23dc$export$2603c8d332a51c42(sampleRate)) {
        (0, $cQ4mt.DEBUG_BUILD) && (0, $lN8pX.logger).warn('[Tracing] Discarding transaction because of invalid sample rate.');
        // eslint-disable-next-line deprecation/deprecation
        transaction.sampled = false;
        return transaction;
    }
    // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
    if (!sampleRate) {
        (0, $cQ4mt.DEBUG_BUILD) && (0, $lN8pX.logger).log(`[Tracing] Discarding transaction because ${typeof options.tracesSampler === 'function' ? 'tracesSampler returned 0 or false' : 'a negative sampling decision was inherited or tracesSampleRate is set to 0'}`);
        // eslint-disable-next-line deprecation/deprecation
        transaction.sampled = false;
        return transaction;
    }
    // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
    // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
    // eslint-disable-next-line deprecation/deprecation
    transaction.sampled = Math.random() < sampleRate;
    // if we're not going to keep it, we're done
    // eslint-disable-next-line deprecation/deprecation
    if (!transaction.sampled) {
        (0, $cQ4mt.DEBUG_BUILD) && (0, $lN8pX.logger).log(`[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(sampleRate)})`);
        return transaction;
    }
    (0, $cQ4mt.DEBUG_BUILD) && // eslint-disable-next-line deprecation/deprecation
    (0, $lN8pX.logger).log(`[Tracing] starting ${transaction.op} transaction - ${(0, $aYVgD.spanToJSON)(transaction).description}`);
    return transaction;
}
/**
 * Checks the given sample rate to make sure it is valid type and value (a boolean, or a number between 0 and 1).
 */ function $f06e33a2babc23dc$export$2603c8d332a51c42(rate) {
    // we need to check NaN explicitly because it's of type 'number' and therefore wouldn't get caught by this typecheck
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if ((0, $dlAFs.isNaN)(rate) || !(typeof rate === 'number' || typeof rate === 'boolean')) {
        (0, $cQ4mt.DEBUG_BUILD) && (0, $lN8pX.logger).warn(`[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(rate)} of type ${JSON.stringify(typeof rate)}.`);
        return false;
    }
    // in case sampleRate is a boolean, it will get automatically cast to 1 if it's true and 0 if it's false
    if (rate < 0 || rate > 1) {
        (0, $cQ4mt.DEBUG_BUILD) && (0, $lN8pX.logger).warn(`[Tracing] Given sample rate is invalid. Sample rate must be between 0 and 1. Got ${rate}.`);
        return false;
    }
    return true;
}

});


parcelRegister("ldUUe", function(module, exports) {

$parcel$export(module.exports, "createTransport", () => $f736f439687071e0$export$d09f50d9ab7f7b69);

var $cSKRv = parcelRequire("cSKRv");
var $lennZ = parcelRequire("lennZ");
var $lN8pX = parcelRequire("lN8pX");
var $f8O8f = parcelRequire("f8O8f");
var $57iGk = parcelRequire("57iGk");
var $OGB8C = parcelRequire("OGB8C");

var $cQ4mt = parcelRequire("cQ4mt");
const $f736f439687071e0$export$e515cf6dfd2f98b8 = 30;
/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */ function $f736f439687071e0$export$d09f50d9ab7f7b69(options, makeRequest, buffer = (0, $f8O8f.makePromiseBuffer)(options.bufferSize || $f736f439687071e0$export$e515cf6dfd2f98b8)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope) {
        const filteredEnvelopeItems = [];
        // Drop rate limited items from envelope
        (0, $cSKRv.forEachEnvelopeItem)(envelope, (item, type)=>{
            const dataCategory = (0, $cSKRv.envelopeItemTypeToDataCategory)(type);
            if ((0, $lennZ.isRateLimited)(rateLimits, dataCategory)) {
                const event = $f736f439687071e0$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent('ratelimit_backoff', dataCategory, event);
            } else filteredEnvelopeItems.push(item);
        });
        // Skip sending if envelope is empty after filtering out rate limited events
        if (filteredEnvelopeItems.length === 0) return (0, $57iGk.resolvedSyncPromise)();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const filteredEnvelope = (0, $cSKRv.createEnvelope)(envelope[0], filteredEnvelopeItems);
        // Creates client report for each item in an envelope
        const recordEnvelopeLoss = (reason)=>{
            (0, $cSKRv.forEachEnvelopeItem)(filteredEnvelope, (item, type)=>{
                const event = $f736f439687071e0$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent(reason, (0, $cSKRv.envelopeItemTypeToDataCategory)(type), event);
            });
        };
        const requestTask = ()=>makeRequest({
                body: (0, $cSKRv.serializeEnvelope)(filteredEnvelope, options.textEncoder)
            }).then((response)=>{
                // We don't want to throw on NOK responses, but we want to at least log them
                if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) (0, $cQ4mt.DEBUG_BUILD) && (0, $lN8pX.logger).warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = (0, $lennZ.updateRateLimits)(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss('network_error');
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error instanceof (0, $OGB8C.SentryError)) {
                (0, $cQ4mt.DEBUG_BUILD) && (0, $lN8pX.logger).error('Skipped sending event because buffer is full.');
                recordEnvelopeLoss('queue_overflow');
                return (0, $57iGk.resolvedSyncPromise)();
            } else throw error;
        });
    }
    // We use this to identifify if the transport is the base transport
    // TODO (v8): Remove this again as we'll no longer need it
    send.__sentry__baseTransport__ = true;
    return {
        send: send,
        flush: flush
    };
}
function $f736f439687071e0$var$getEventForEnvelopeItem(item, type) {
    if (type !== 'event' && type !== 'transaction') return undefined;
    return Array.isArray(item) ? item[1] : undefined;
}

});
parcelRegister("lennZ", function(module, exports) {

$parcel$export(module.exports, "parseRetryAfterHeader", () => $f74d0bba41d55da6$export$615352e17ed7741);
$parcel$export(module.exports, "isRateLimited", () => $f74d0bba41d55da6$export$6c91fec22056810a);
$parcel$export(module.exports, "updateRateLimits", () => $f74d0bba41d55da6$export$699aff705e0d49d4);
// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend
const $f74d0bba41d55da6$export$b09ce39faaeb1e7c = 60000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */ function $f74d0bba41d55da6$export$615352e17ed7741(header, now = Date.now()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $f74d0bba41d55da6$export$b09ce39faaeb1e7c;
}
/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */ function $f74d0bba41d55da6$export$b89fc7b2e4c799e7(limits, dataCategory) {
    return limits[dataCategory] || limits.all || 0;
}
/**
 * Checks if a category is rate limited
 */ function $f74d0bba41d55da6$export$6c91fec22056810a(limits, dataCategory, now = Date.now()) {
    return $f74d0bba41d55da6$export$b89fc7b2e4c799e7(limits, dataCategory) > now;
}
/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */ function $f74d0bba41d55da6$export$699aff705e0d49d4(limits, { statusCode: statusCode, headers: headers }, now = Date.now()) {
    const updatedRateLimits = {
        ...limits
    };
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    const rateLimitHeader = headers && headers['x-sentry-rate-limits'];
    const retryAfterHeader = headers && headers['retry-after'];
    if (rateLimitHeader) /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>: <namespaces>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     *     <namespaces> Semicolon-separated list of metric namespace identifiers. Defines which namespace(s) will be affected.
     *         Only present if rate limit applies to the metric_bucket data category.
     */ for (const limit of rateLimitHeader.trim().split(',')){
        const [retryAfter, categories, , , namespaces] = limit.split(':', 5);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(';')){
            if (category === 'metric_bucket') // namespaces will be present when category === 'metric_bucket'
            {
                if (!namespaces || namespaces.split(';').includes('custom')) updatedRateLimits[category] = now + delay;
            } else updatedRateLimits[category] = now + delay;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $f74d0bba41d55da6$export$615352e17ed7741(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}

});

parcelRegister("f8O8f", function(module, exports) {

$parcel$export(module.exports, "makePromiseBuffer", () => $b05e7d885bf7d79b$export$85a4f67f852183e6);

var $OGB8C = parcelRequire("OGB8C");

var $57iGk = parcelRequire("57iGk");
/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */ function $b05e7d885bf7d79b$export$85a4f67f852183e6(limit) {
    const buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0];
    }
    /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */ function add(taskProducer) {
        if (!isReady()) return (0, $57iGk.rejectedSyncPromise)(new (0, $OGB8C.SentryError)('Not adding Promise because buffer limit was reached.'));
        // start the task and add its promise to the queue
        const task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(()=>remove(task))// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, ()=>remove(task).then(null, ()=>{
            // We have to add another catch here because `remove()` starts a new promise chain.
            }));
        return task;
    }
    /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */ function drain(timeout) {
        return new (0, $57iGk.SyncPromise)((resolve, reject)=>{
            let counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            const capturedSetTimeout = setTimeout(()=>{
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach((item)=>{
                (0, $57iGk.resolvedSyncPromise)(item).then(()=>{
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}

});


parcelRegister("hJxS5", function(module, exports) {

$parcel$export(module.exports, "functionToStringIntegration", () => $ce90e9c5dba3a2d4$export$7918117e9202e4fb);
$parcel$export(module.exports, "FunctionToString", () => $ce90e9c5dba3a2d4$export$da4704525c20ae79);

var $aLrZa = parcelRequire("aLrZa");

var $fq71H = parcelRequire("fq71H");

var $6emiv = parcelRequire("6emiv");
let $ce90e9c5dba3a2d4$var$originalFunctionToString;
const $ce90e9c5dba3a2d4$var$INTEGRATION_NAME = 'FunctionToString';
const $ce90e9c5dba3a2d4$var$SETUP_CLIENTS = new WeakMap();
const $ce90e9c5dba3a2d4$var$_functionToStringIntegration = ()=>{
    return {
        name: $ce90e9c5dba3a2d4$var$INTEGRATION_NAME,
        setupOnce () {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            $ce90e9c5dba3a2d4$var$originalFunctionToString = Function.prototype.toString;
            // intrinsics (like Function.prototype) might be immutable in some environments
            // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
            try {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                Function.prototype.toString = function(...args) {
                    const originalFunction = (0, $aLrZa.getOriginalFunction)(this);
                    const context = $ce90e9c5dba3a2d4$var$SETUP_CLIENTS.has((0, $fq71H.getClient)()) && originalFunction !== undefined ? originalFunction : this;
                    return $ce90e9c5dba3a2d4$var$originalFunctionToString.apply(context, args);
                };
            } catch (e) {
            // ignore errors here, just don't patch this
            }
        },
        setup (client) {
            $ce90e9c5dba3a2d4$var$SETUP_CLIENTS.set(client, true);
        }
    };
};
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * ```js
 * Sentry.init({
 *   integrations: [
 *     functionToStringIntegration(),
 *   ],
 * });
 * ```
 */ const $ce90e9c5dba3a2d4$export$7918117e9202e4fb = (0, $6emiv.defineIntegration)($ce90e9c5dba3a2d4$var$_functionToStringIntegration);
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * @deprecated Use `functionToStringIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $ce90e9c5dba3a2d4$export$da4704525c20ae79 = (0, $6emiv.convertIntegrationFnToClass)($ce90e9c5dba3a2d4$var$INTEGRATION_NAME, $ce90e9c5dba3a2d4$export$7918117e9202e4fb);

});

parcelRegister("lQehn", function(module, exports) {

$parcel$export(module.exports, "inboundFiltersIntegration", () => $fe6987dfba79d919$export$cb3c5c2ceb9818ba);
$parcel$export(module.exports, "InboundFilters", () => $fe6987dfba79d919$export$2ffbb5359dcc6be4);

var $1y8R2 = parcelRequire("1y8R2");
var $lN8pX = parcelRequire("lN8pX");
var $jmfnM = parcelRequire("jmfnM");

var $cQ4mt = parcelRequire("cQ4mt");

var $6emiv = parcelRequire("6emiv");
// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const $fe6987dfba79d919$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/,
    /^ResizeObserver loop completed with undelivered notifications.$/,
    /^Cannot redefine property: googletag$/
];
const $fe6987dfba79d919$var$DEFAULT_IGNORE_TRANSACTIONS = [
    /^.*\/healthcheck$/,
    /^.*\/healthy$/,
    /^.*\/live$/,
    /^.*\/ready$/,
    /^.*\/heartbeat$/,
    /^.*\/health$/,
    /^.*\/healthz$/
];
/** Options for the InboundFilters integration */ const $fe6987dfba79d919$var$INTEGRATION_NAME = 'InboundFilters';
const $fe6987dfba79d919$var$_inboundFiltersIntegration = (options = {})=>{
    return {
        name: $fe6987dfba79d919$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        processEvent (event, _hint, client) {
            const clientOptions = client.getOptions();
            const mergedOptions = $fe6987dfba79d919$var$_mergeOptions(options, clientOptions);
            return $fe6987dfba79d919$var$_shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
};
const $fe6987dfba79d919$export$cb3c5c2ceb9818ba = (0, $6emiv.defineIntegration)($fe6987dfba79d919$var$_inboundFiltersIntegration);
/**
 * Inbound filters configurable by the user.
 * @deprecated Use `inboundFiltersIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $fe6987dfba79d919$export$2ffbb5359dcc6be4 = (0, $6emiv.convertIntegrationFnToClass)($fe6987dfba79d919$var$INTEGRATION_NAME, $fe6987dfba79d919$export$cb3c5c2ceb9818ba);
function $fe6987dfba79d919$var$_mergeOptions(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...internalOptions.disableErrorDefaults ? [] : $fe6987dfba79d919$var$DEFAULT_IGNORE_ERRORS
        ],
        ignoreTransactions: [
            ...internalOptions.ignoreTransactions || [],
            ...clientOptions.ignoreTransactions || [],
            ...internalOptions.disableTransactionDefaults ? [] : $fe6987dfba79d919$var$DEFAULT_IGNORE_TRANSACTIONS
        ],
        ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true
    };
}
function $fe6987dfba79d919$var$_shouldDropEvent(event, options) {
    if (options.ignoreInternal && $fe6987dfba79d919$var$_isSentryError(event)) {
        (0, $cQ4mt.DEBUG_BUILD) && (0, $lN8pX.logger).warn(`Event dropped due to being internal Sentry Error.\nEvent: ${(0, $1y8R2.getEventDescription)(event)}`);
        return true;
    }
    if ($fe6987dfba79d919$var$_isIgnoredError(event, options.ignoreErrors)) {
        (0, $cQ4mt.DEBUG_BUILD) && (0, $lN8pX.logger).warn(`Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0, $1y8R2.getEventDescription)(event)}`);
        return true;
    }
    if ($fe6987dfba79d919$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
        (0, $cQ4mt.DEBUG_BUILD) && (0, $lN8pX.logger).warn(`Event dropped due to being matched by \`ignoreTransactions\` option.\nEvent: ${(0, $1y8R2.getEventDescription)(event)}`);
        return true;
    }
    if ($fe6987dfba79d919$var$_isDeniedUrl(event, options.denyUrls)) {
        (0, $cQ4mt.DEBUG_BUILD) && (0, $lN8pX.logger).warn(`Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0, $1y8R2.getEventDescription)(event)}.\nUrl: ${$fe6987dfba79d919$var$_getEventFilterUrl(event)}`);
        return true;
    }
    if (!$fe6987dfba79d919$var$_isAllowedUrl(event, options.allowUrls)) {
        (0, $cQ4mt.DEBUG_BUILD) && (0, $lN8pX.logger).warn(`Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0, $1y8R2.getEventDescription)(event)}.\nUrl: ${$fe6987dfba79d919$var$_getEventFilterUrl(event)}`);
        return true;
    }
    return false;
}
function $fe6987dfba79d919$var$_isIgnoredError(event, ignoreErrors) {
    // If event.type, this is not an error
    if (event.type || !ignoreErrors || !ignoreErrors.length) return false;
    return $fe6987dfba79d919$var$_getPossibleEventMessages(event).some((message)=>(0, $jmfnM.stringMatchesSomePattern)(message, ignoreErrors));
}
function $fe6987dfba79d919$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (event.type !== 'transaction' || !ignoreTransactions || !ignoreTransactions.length) return false;
    const name = event.transaction;
    return name ? (0, $jmfnM.stringMatchesSomePattern)(name, ignoreTransactions) : false;
}
function $fe6987dfba79d919$var$_isDeniedUrl(event, denyUrls) {
    // TODO: Use Glob instead?
    if (!denyUrls || !denyUrls.length) return false;
    const url = $fe6987dfba79d919$var$_getEventFilterUrl(event);
    return !url ? false : (0, $jmfnM.stringMatchesSomePattern)(url, denyUrls);
}
function $fe6987dfba79d919$var$_isAllowedUrl(event, allowUrls) {
    // TODO: Use Glob instead?
    if (!allowUrls || !allowUrls.length) return true;
    const url = $fe6987dfba79d919$var$_getEventFilterUrl(event);
    return !url ? true : (0, $jmfnM.stringMatchesSomePattern)(url, allowUrls);
}
function $fe6987dfba79d919$var$_getPossibleEventMessages(event) {
    const possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    let lastException;
    try {
        // @ts-expect-error Try catching to save bundle size
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        lastException = event.exception.values[event.exception.values.length - 1];
    } catch (e) {
    // try catching to save bundle size checking existence of variables
    }
    if (lastException) {
        if (lastException.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push(`${lastException.type}: ${lastException.value}`);
        }
    }
    if ((0, $cQ4mt.DEBUG_BUILD) && possibleMessages.length === 0) (0, $lN8pX.logger).error(`Could not extract message for event ${(0, $1y8R2.getEventDescription)(event)}`);
    return possibleMessages;
}
function $fe6987dfba79d919$var$_isSentryError(event) {
    try {
        // @ts-expect-error can't be a sentry error if undefined
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return event.exception.values[0].type === 'SentryError';
    } catch (e) {
    // ignore
    }
    return false;
}
function $fe6987dfba79d919$var$_getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== '<anonymous>' && frame.filename !== '[native code]') return frame.filename || null;
    }
    return null;
}
function $fe6987dfba79d919$var$_getEventFilterUrl(event) {
    try {
        let frames;
        try {
            // @ts-expect-error we only care about frames if the whole thing here is defined
            frames = event.exception.values[0].stacktrace.frames;
        } catch (e) {
        // ignore
        }
        return frames ? $fe6987dfba79d919$var$_getLastValidUrl(frames) : null;
    } catch (oO) {
        (0, $cQ4mt.DEBUG_BUILD) && (0, $lN8pX.logger).error(`Cannot extract url for event ${(0, $1y8R2.getEventDescription)(event)}`);
        return null;
    }
}

});

parcelRegister("f9ZNq", function(module, exports) {

$parcel$export(module.exports, "Integrations", () => $b097a1b859b5b855$export$99d02219d259eb94);

var $13ShQ = parcelRequire("13ShQ");

var $9XkOL = parcelRequire("9XkOL");

var $bJ5g8 = parcelRequire("bJ5g8");


var $jL5ha = parcelRequire("jL5ha");

var $lBW6h = parcelRequire("lBW6h");

var $9fRGu = parcelRequire("9fRGu");

var $7AtVc = parcelRequire("7AtVc");

var $j1eGv = parcelRequire("j1eGv");

var $kDNXp = parcelRequire("kDNXp");

var $5ukjY = parcelRequire("5ukjY");


var $fq71H = parcelRequire("fq71H");

var $egVmm = parcelRequire("egVmm");



var $XZfNs = parcelRequire("XZfNs");

var $bu7hL = parcelRequire("bu7hL");

var $1UtEE = parcelRequire("1UtEE");

var $diF5W = parcelRequire("diF5W");


var $4tdNk = parcelRequire("4tdNk");

var $ldUUe = parcelRequire("ldUUe");

var $fbHMF = parcelRequire("fbHMF");

var $bdOVf = parcelRequire("bdOVf");

var $itB3p = parcelRequire("itB3p");

var $6emiv = parcelRequire("6emiv");




var $aMWz3 = parcelRequire("aMWz3");

var $bcruQ = parcelRequire("bcruQ");

var $lPCNA = parcelRequire("lPCNA");


var $lRIP3 = parcelRequire("lRIP3");

var $aYVgD = parcelRequire("aYVgD");


var $fOYMT = parcelRequire("fOYMT");

var $b5y9n = parcelRequire("b5y9n");

var $3HnEg = parcelRequire("3HnEg");


var $lQehn = parcelRequire("lQehn");

var $hJxS5 = parcelRequire("hJxS5");


var $8RoEd = parcelRequire("8RoEd");

var $i6lAy = parcelRequire("i6lAy");
/** @deprecated Import the integration function directly, e.g. `inboundFiltersIntegration()` instead of `new Integrations.InboundFilter(). */ const $b097a1b859b5b855$export$99d02219d259eb94 = $8RoEd;

});
parcelRegister("j1eGv", function(module, exports) {

$parcel$export(module.exports, "setMeasurement", () => $dd898063894bc156$export$7cc31b475d33a706);

var $jL5ha = parcelRequire("jL5ha");
/**
 * Adds a measurement to the current active transaction.
 */ function $dd898063894bc156$export$7cc31b475d33a706(name, value, unit) {
    // eslint-disable-next-line deprecation/deprecation
    const transaction = (0, $jL5ha.getActiveTransaction)();
    if (transaction) // eslint-disable-next-line deprecation/deprecation
    transaction.setMeasurement(name, value, unit);
}

});

parcelRegister("4tdNk", function(module, exports) {

$parcel$export(module.exports, "initAndBind", () => $3414922dc0927960$export$5333c3f1c58d9bc1);
$parcel$export(module.exports, "setCurrentClient", () => $3414922dc0927960$export$ecb76f41d43c0e43);

var $lN8pX = parcelRequire("lN8pX");

var $cQ4mt = parcelRequire("cQ4mt");

var $fq71H = parcelRequire("fq71H");

var $egVmm = parcelRequire("egVmm");
/** A class object that can instantiate Client objects. */ /**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */ function $3414922dc0927960$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (0, $cQ4mt.DEBUG_BUILD) (0, $lN8pX.logger).enable();
        else // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
        (0, $lN8pX.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.warn('[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.');
        });
    }
    const scope = (0, $fq71H.getCurrentScope)();
    scope.update(options.initialScope);
    const client = new clientClass(options);
    $3414922dc0927960$export$ecb76f41d43c0e43(client);
    $3414922dc0927960$var$initializeClient(client);
}
/**
 * Make the given client the current client.
 */ function $3414922dc0927960$export$ecb76f41d43c0e43(client) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $egVmm.getCurrentHub)();
    // eslint-disable-next-line deprecation/deprecation
    const top = hub.getStackTop();
    top.client = client;
    top.scope.setClient(client);
}
/**
 * Initialize the client for the current scope.
 * Make sure to call this after `setCurrentClient()`.
 */ function $3414922dc0927960$var$initializeClient(client) {
    if (client.init) client.init();
    else if (client.setupIntegrations) // eslint-disable-next-line deprecation/deprecation
    client.setupIntegrations();
}

});

parcelRegister("fbHMF", function(module, exports) {

$parcel$export(module.exports, "makeOfflineTransport", () => $b0e9d8ac08b0ac40$export$405ec66a0e87547a);

var $cSKRv = parcelRequire("cSKRv");
var $lN8pX = parcelRequire("lN8pX");
var $lennZ = parcelRequire("lennZ");

var $cQ4mt = parcelRequire("cQ4mt");
const $b0e9d8ac08b0ac40$export$638fddefcf0452da = 100; // 100 ms
const $b0e9d8ac08b0ac40$export$998db03eaf5cf3f3 = 5000; // 5 seconds
const $b0e9d8ac08b0ac40$var$MAX_DELAY = 3.6e6; // 1 hour
function $b0e9d8ac08b0ac40$var$log(msg, error) {
    (0, $cQ4mt.DEBUG_BUILD) && (0, $lN8pX.logger).info(`[Offline]: ${msg}`, error);
}
/**
 * Wraps a transport and stores and retries events when they fail to send.
 *
 * @param createTransport The transport to wrap.
 */ function $b0e9d8ac08b0ac40$export$405ec66a0e87547a(createTransport) {
    return (options)=>{
        const transport = createTransport(options);
        const store = options.createStore ? options.createStore(options) : undefined;
        let retryDelay = $b0e9d8ac08b0ac40$export$998db03eaf5cf3f3;
        let flushTimer;
        function shouldQueue(env, error, retryDelay) {
            // We don't queue Session Replay envelopes because they are:
            // - Ordered and Replay relies on the response status to know when they're successfully sent.
            // - Likely to fill the queue quickly and block other events from being sent.
            // We also want to drop client reports because they can be generated when we retry sending events while offline.
            if ((0, $cSKRv.envelopeContainsItemType)(env, [
                'replay_event',
                'replay_recording',
                'client_report'
            ])) return false;
            if (options.shouldStore) return options.shouldStore(env, error, retryDelay);
            return true;
        }
        function flushIn(delay) {
            if (!store) return;
            if (flushTimer) clearTimeout(flushTimer);
            flushTimer = setTimeout(async ()=>{
                flushTimer = undefined;
                const found = await store.pop();
                if (found) {
                    $b0e9d8ac08b0ac40$var$log('Attempting to send previously queued event');
                    send(found).catch((e)=>{
                        $b0e9d8ac08b0ac40$var$log('Failed to retry sending', e);
                    });
                }
            }, delay);
            // We need to unref the timer in node.js, otherwise the node process never exit.
            if (typeof flushTimer !== 'number' && flushTimer.unref) flushTimer.unref();
        }
        function flushWithBackOff() {
            if (flushTimer) return;
            flushIn(retryDelay);
            retryDelay = Math.min(retryDelay * 2, $b0e9d8ac08b0ac40$var$MAX_DELAY);
        }
        async function send(envelope) {
            try {
                const result = await transport.send(envelope);
                let delay = $b0e9d8ac08b0ac40$export$638fddefcf0452da;
                if (result) {
                    // If there's a retry-after header, use that as the next delay.
                    if (result.headers && result.headers['retry-after']) delay = (0, $lennZ.parseRetryAfterHeader)(result.headers['retry-after']);
                    else if ((result.statusCode || 0) >= 400) return result;
                }
                flushIn(delay);
                retryDelay = $b0e9d8ac08b0ac40$export$998db03eaf5cf3f3;
                return result;
            } catch (e) {
                if (store && await shouldQueue(envelope, e, retryDelay)) {
                    await store.insert(envelope);
                    flushWithBackOff();
                    $b0e9d8ac08b0ac40$var$log('Error sending. Event queued', e);
                    return {};
                } else throw e;
            }
        }
        if (options.flushAtStartup) flushWithBackOff();
        return {
            send: send,
            flush: (t)=>transport.flush(t)
        };
    };
}

});

parcelRegister("bdOVf", function(module, exports) {

$parcel$export(module.exports, "makeMultiplexedTransport", () => $82b868b76997ad65$export$53bbcd410607e756);

var $cSKRv = parcelRequire("cSKRv");
var $3w9d5 = parcelRequire("3w9d5");

var $1UtEE = parcelRequire("1UtEE");
/**
 * Gets an event from an envelope.
 *
 * This is only exported for use in the tests
 */ function $82b868b76997ad65$export$b92f55f7516d9100(env, types) {
    let event;
    (0, $cSKRv.forEachEnvelopeItem)(env, (item, type)=>{
        if (types.includes(type)) event = Array.isArray(item) ? item[1] : undefined;
        // bail out if we found an event
        return !!event;
    });
    return event;
}
/**
 * Creates a transport that overrides the release on all events.
 */ function $82b868b76997ad65$var$makeOverrideReleaseTransport(createTransport, release) {
    return (options)=>{
        const transport = createTransport(options);
        return {
            ...transport,
            send: async (envelope)=>{
                const event = $82b868b76997ad65$export$b92f55f7516d9100(envelope, [
                    'event',
                    'transaction',
                    'profile',
                    'replay_event'
                ]);
                if (event) event.release = release;
                return transport.send(envelope);
            }
        };
    };
}
/** Overrides the DSN in the envelope header  */ function $82b868b76997ad65$var$overrideDsn(envelope, dsn) {
    return (0, $cSKRv.createEnvelope)(dsn ? {
        ...envelope[0],
        dsn: dsn
    } : envelope[0], envelope[1]);
}
/**
 * Creates a transport that can send events to different DSNs depending on the envelope contents.
 */ function $82b868b76997ad65$export$53bbcd410607e756(createTransport, matcher) {
    return (options)=>{
        const fallbackTransport = createTransport(options);
        const otherTransports = new Map();
        function getTransport(dsn, release) {
            // We create a transport for every unique dsn/release combination as there may be code from multiple releases in
            // use at the same time
            const key = release ? `${dsn}:${release}` : dsn;
            let transport = otherTransports.get(key);
            if (!transport) {
                const validatedDsn = (0, $3w9d5.dsnFromString)(dsn);
                if (!validatedDsn) return undefined;
                const url = (0, $1UtEE.getEnvelopeEndpointWithUrlEncodedAuth)(validatedDsn, options.tunnel);
                transport = release ? $82b868b76997ad65$var$makeOverrideReleaseTransport(createTransport, release)({
                    ...options,
                    url: url
                }) : createTransport({
                    ...options,
                    url: url
                });
                otherTransports.set(key, transport);
            }
            return [
                dsn,
                transport
            ];
        }
        async function send(envelope) {
            function getEvent(types) {
                const eventTypes = types && types.length ? types : [
                    'event'
                ];
                return $82b868b76997ad65$export$b92f55f7516d9100(envelope, eventTypes);
            }
            const transports = matcher({
                envelope: envelope,
                getEvent: getEvent
            }).map((result)=>{
                if (typeof result === 'string') return getTransport(result, undefined);
                else return getTransport(result.dsn, result.release);
            }).filter((t)=>!!t);
            // If we have no transports to send to, use the fallback transport
            if (transports.length === 0) // Don't override the DSN in the header for the fallback transport. '' is falsy
            transports.push([
                '',
                fallbackTransport
            ]);
            const results = await Promise.all(transports.map(([dsn, transport])=>transport.send($82b868b76997ad65$var$overrideDsn(envelope, dsn))));
            return results[0];
        }
        async function flush(timeout) {
            const promises = [
                await fallbackTransport.flush(timeout)
            ];
            for (const [, transport] of otherTransports)promises.push(await transport.flush(timeout));
            return promises.every((r)=>r);
        }
        return {
            send: send,
            flush: flush
        };
    };
}

});

parcelRegister("aMWz3", function(module, exports) {

$parcel$export(module.exports, "createSpanEnvelope", () => $7dabd0c5342aa6a1$export$19a0081d4b39d77);

var $cSKRv = parcelRequire("cSKRv");
var $3w9d5 = parcelRequire("3w9d5");
/**
 * Create envelope from Span item.
 */ function $7dabd0c5342aa6a1$export$19a0081d4b39d77(spans, dsn) {
    const headers = {
        sent_at: new Date().toISOString()
    };
    if (dsn) headers.dsn = (0, $3w9d5.dsnToString)(dsn);
    const items = spans.map($7dabd0c5342aa6a1$var$createSpanItem);
    return (0, $cSKRv.createEnvelope)(headers, items);
}
function $7dabd0c5342aa6a1$var$createSpanItem(span) {
    const spanHeaders = {
        type: 'span'
    };
    return [
        spanHeaders,
        span
    ];
}

});

parcelRegister("lPCNA", function(module, exports) {

$parcel$export(module.exports, "isSentryRequestUrl", () => $fe4c7509b65b20cb$export$d92e61f5600202af);
/**
 * Checks whether given url points to Sentry server
 * @param url url to verify
 *
 * TODO(v8): Remove Hub fallback type
 */ // eslint-disable-next-line deprecation/deprecation
function $fe4c7509b65b20cb$export$d92e61f5600202af(url, hubOrClient) {
    const client = hubOrClient && $fe4c7509b65b20cb$var$isHub(hubOrClient) ? hubOrClient.getClient() : hubOrClient;
    const dsn = client && client.getDsn();
    const tunnel = client && client.getOptions().tunnel;
    return $fe4c7509b65b20cb$var$checkDsn(url, dsn) || $fe4c7509b65b20cb$var$checkTunnel(url, tunnel);
}
function $fe4c7509b65b20cb$var$checkTunnel(url, tunnel) {
    if (!tunnel) return false;
    return $fe4c7509b65b20cb$var$removeTrailingSlash(url) === $fe4c7509b65b20cb$var$removeTrailingSlash(tunnel);
}
function $fe4c7509b65b20cb$var$checkDsn(url, dsn) {
    return dsn ? url.includes(dsn.host) : false;
}
function $fe4c7509b65b20cb$var$removeTrailingSlash(str) {
    return str[str.length - 1] === '/' ? str.slice(0, -1) : str;
}
// eslint-disable-next-line deprecation/deprecation
function $fe4c7509b65b20cb$var$isHub(hubOrClient) {
    // eslint-disable-next-line deprecation/deprecation
    return hubOrClient.getClient !== undefined;
}

});

parcelRegister("lRIP3", function(module, exports) {

$parcel$export(module.exports, "parameterize", () => $feb150fe2eb20c81$export$4cb5eb704d6ec224);
/**
 * Tagged template function which returns paramaterized representation of the message
 * For example: parameterize`This is a log statement with ${x} and ${y} params`, would return:
 * "__sentry_template_string__": 'This is a log statement with %s and %s params',
 * "__sentry_template_values__": ['first', 'second']
 * @param strings An array of string values splitted between expressions
 * @param values Expressions extracted from template string
 * @returns String with template information in __sentry_template_string__ and __sentry_template_values__ properties
 */ function $feb150fe2eb20c81$export$4cb5eb704d6ec224(strings, ...values) {
    const formatted = new String(String.raw(strings, ...values));
    formatted.__sentry_template_string__ = strings.join('\x00').replace(/%/g, '%%').replace(/\0/g, '%s');
    formatted.__sentry_template_values__ = values;
    return formatted;
}

});

parcelRegister("fOYMT", function(module, exports) {

$parcel$export(module.exports, "applySdkMetadata", () => $b84aadb3e3e1673a$export$b9f95b027256052c);

var $itB3p = parcelRequire("itB3p");
/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 *
 * Note: This function is identical to `buildMetadata` in Remix and NextJS and SvelteKit.
 * We don't extract it for bundle size reasons.
 * @see https://github.com/getsentry/sentry-javascript/pull/7404
 * @see https://github.com/getsentry/sentry-javascript/pull/4196
 *
 * If you make changes to this function consider updating the others as well.
 *
 * @param options SDK options object that gets mutated
 * @param names list of package names
 */ function $b84aadb3e3e1673a$export$b9f95b027256052c(options, name, names = [
    name
], source = 'npm') {
    const metadata = options._metadata || {};
    if (!metadata.sdk) metadata.sdk = {
        name: `sentry.javascript.${name}`,
        packages: names.map((name)=>({
                name: `${source}:@sentry/${name}`,
                version: (0, $itB3p.SDK_VERSION)
            })),
        version: (0, $itB3p.SDK_VERSION)
    };
    options._metadata = metadata;
}

});

parcelRegister("3HnEg", function(module, exports) {

$parcel$export(module.exports, "moduleMetadataIntegration", () => $2b17bb53b8528b4f$export$b3b128c3ae01ded0);
$parcel$export(module.exports, "ModuleMetadata", () => $2b17bb53b8528b4f$export$6cd9b4efeff4101a);

var $cSKRv = parcelRequire("cSKRv");

var $6emiv = parcelRequire("6emiv");

var $h0Fds = parcelRequire("h0Fds");
const $2b17bb53b8528b4f$var$INTEGRATION_NAME = 'ModuleMetadata';
const $2b17bb53b8528b4f$var$_moduleMetadataIntegration = ()=>{
    return {
        name: $2b17bb53b8528b4f$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        setup (client) {
            if (typeof client.on !== 'function') return;
            // We need to strip metadata from stack frames before sending them to Sentry since these are client side only.
            client.on('beforeEnvelope', (envelope)=>{
                (0, $cSKRv.forEachEnvelopeItem)(envelope, (item, type)=>{
                    if (type === 'event') {
                        const event = Array.isArray(item) ? item[1] : undefined;
                        if (event) {
                            (0, $h0Fds.stripMetadataFromStackFrames)(event);
                            item[1] = event;
                        }
                    }
                });
            });
        },
        processEvent (event, _hint, client) {
            const stackParser = client.getOptions().stackParser;
            (0, $h0Fds.addMetadataToStackFrames)(stackParser, event);
            return event;
        }
    };
};
const $2b17bb53b8528b4f$export$b3b128c3ae01ded0 = (0, $6emiv.defineIntegration)($2b17bb53b8528b4f$var$_moduleMetadataIntegration);
/**
 * Adds module metadata to stack frames.
 *
 * Metadata can be injected by the Sentry bundler plugins using the `_experiments.moduleMetadata` config option.
 *
 * When this integration is added, the metadata passed to the bundler plugin is added to the stack frames of all events
 * under the `module_metadata` property. This can be used to help in tagging or routing of events from different teams
 * our sources
 *
 * @deprecated Use `moduleMetadataIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $2b17bb53b8528b4f$export$6cd9b4efeff4101a = (0, $6emiv.convertIntegrationFnToClass)($2b17bb53b8528b4f$var$INTEGRATION_NAME, $2b17bb53b8528b4f$export$b3b128c3ae01ded0);

});
parcelRegister("h0Fds", function(module, exports) {

$parcel$export(module.exports, "addMetadataToStackFrames", () => $c622686393ec91ae$export$94b52ecabddf6844);
$parcel$export(module.exports, "stripMetadataFromStackFrames", () => $c622686393ec91ae$export$5d4932fac9735eed);

var $4mb67 = parcelRequire("4mb67");
/** Keys are source filename/url, values are metadata objects. */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $c622686393ec91ae$var$filenameMetadataMap = new Map();
/** Set of stack strings that have already been parsed. */ const $c622686393ec91ae$var$parsedStacks = new Set();
function $c622686393ec91ae$var$ensureMetadataStacksAreParsed(parser) {
    if (!(0, $4mb67.GLOBAL_OBJ)._sentryModuleMetadata) return;
    for (const stack of Object.keys((0, $4mb67.GLOBAL_OBJ)._sentryModuleMetadata)){
        const metadata = (0, $4mb67.GLOBAL_OBJ)._sentryModuleMetadata[stack];
        if ($c622686393ec91ae$var$parsedStacks.has(stack)) continue;
        // Ensure this stack doesn't get parsed again
        $c622686393ec91ae$var$parsedStacks.add(stack);
        const frames = parser(stack);
        // Go through the frames starting from the top of the stack and find the first one with a filename
        for (const frame of frames.reverse())if (frame.filename) {
            // Save the metadata for this filename
            $c622686393ec91ae$var$filenameMetadataMap.set(frame.filename, metadata);
            break;
        }
    }
}
/**
 * Retrieve metadata for a specific JavaScript file URL.
 *
 * Metadata is injected by the Sentry bundler plugins using the `_experiments.moduleMetadata` config option.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $c622686393ec91ae$export$fb4062399a51f94a(parser, filename) {
    $c622686393ec91ae$var$ensureMetadataStacksAreParsed(parser);
    return $c622686393ec91ae$var$filenameMetadataMap.get(filename);
}
/**
 * Adds metadata to stack frames.
 *
 * Metadata is injected by the Sentry bundler plugins using the `_experiments.moduleMetadata` config option.
 */ function $c622686393ec91ae$export$94b52ecabddf6844(parser, event) {
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            if (!exception.stacktrace) return;
            for (const frame of exception.stacktrace.frames || []){
                if (!frame.filename) continue;
                const metadata = $c622686393ec91ae$export$fb4062399a51f94a(parser, frame.filename);
                if (metadata) frame.module_metadata = metadata;
            }
        });
    } catch (_) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
}
/**
 * Strips metadata from stack frames.
 */ function $c622686393ec91ae$export$5d4932fac9735eed(event) {
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            if (!exception.stacktrace) return;
            for (const frame of exception.stacktrace.frames || [])delete frame.module_metadata;
        });
    } catch (_) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
}

});


parcelRegister("8RoEd", function(module, exports) {

$parcel$export(module.exports, "FunctionToString", () => (parcelRequire("hJxS5")).FunctionToString);
$parcel$export(module.exports, "InboundFilters", () => (parcelRequire("lQehn")).InboundFilters);
$parcel$export(module.exports, "LinkedErrors", () => (parcelRequire("7xKhT")).LinkedErrors);

var $hJxS5 = parcelRequire("hJxS5");

var $lQehn = parcelRequire("lQehn");

var $7xKhT = parcelRequire("7xKhT");
 /* eslint-disable deprecation/deprecation */ 
});
parcelRegister("7xKhT", function(module, exports) {

$parcel$export(module.exports, "LinkedErrors", () => $57df8533febe19d2$export$8d1e60aaf616fb4f);

var $k4DCa = parcelRequire("k4DCa");
var $e9AxB = parcelRequire("e9AxB");

var $6emiv = parcelRequire("6emiv");
const $57df8533febe19d2$var$DEFAULT_KEY = 'cause';
const $57df8533febe19d2$var$DEFAULT_LIMIT = 5;
const $57df8533febe19d2$var$INTEGRATION_NAME = 'LinkedErrors';
const $57df8533febe19d2$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $57df8533febe19d2$var$DEFAULT_LIMIT;
    const key = options.key || $57df8533febe19d2$var$DEFAULT_KEY;
    return {
        name: $57df8533febe19d2$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        preprocessEvent (event, hint, client) {
            const options = client.getOptions();
            (0, $k4DCa.applyAggregateErrorsToEvent)((0, $e9AxB.exceptionFromError), options.stackParser, options.maxValueLength, key, limit, event, hint);
        }
    };
};
const $57df8533febe19d2$export$ebabb00eb7f3a395 = (0, $6emiv.defineIntegration)($57df8533febe19d2$var$_linkedErrorsIntegration);
/**
 * Adds SDK info to an event.
 * @deprecated Use `linkedErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $57df8533febe19d2$export$8d1e60aaf616fb4f = (0, $6emiv.convertIntegrationFnToClass)($57df8533febe19d2$var$INTEGRATION_NAME, $57df8533febe19d2$export$ebabb00eb7f3a395);

});
parcelRegister("k4DCa", function(module, exports) {

$parcel$export(module.exports, "applyAggregateErrorsToEvent", () => $e9d2e903b2a6a10d$export$b91c38ed7d8ae9b2);

var $dlAFs = parcelRequire("dlAFs");

var $jmfnM = parcelRequire("jmfnM");
/**
 * Creates exceptions inside `event.exception.values` for errors that are nested on properties based on the `key` parameter.
 */ function $e9d2e903b2a6a10d$export$b91c38ed7d8ae9b2(exceptionFromErrorImplementation, parser, maxValueLimit = 250, key, limit, event, hint) {
    if (!event.exception || !event.exception.values || !hint || !(0, $dlAFs.isInstanceOf)(hint.originalException, Error)) return;
    // Generally speaking the last item in `event.exception.values` is the exception originating from the original Error
    const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : undefined;
    // We only create exception grouping if there is an exception in the event.
    if (originalException) event.exception.values = $e9d2e903b2a6a10d$var$truncateAggregateExceptions($e9d2e903b2a6a10d$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0), maxValueLimit);
}
function $e9d2e903b2a6a10d$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    let newExceptions = [
        ...prevExceptions
    ];
    // Recursively call this function in order to walk down a chain of errors
    if ((0, $dlAFs.isInstanceOf)(error[key], Error)) {
        $e9d2e903b2a6a10d$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
        const newException = exceptionFromErrorImplementation(parser, error[key]);
        const newExceptionId = newExceptions.length;
        $e9d2e903b2a6a10d$var$applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = $e9d2e903b2a6a10d$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException,
            ...newExceptions
        ], newException, newExceptionId);
    }
    // This will create exception grouping for AggregateErrors
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError
    if (Array.isArray(error.errors)) error.errors.forEach((childError, i)=>{
        if ((0, $dlAFs.isInstanceOf)(childError, Error)) {
            $e9d2e903b2a6a10d$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
            const newException = exceptionFromErrorImplementation(parser, childError);
            const newExceptionId = newExceptions.length;
            $e9d2e903b2a6a10d$var$applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
            newExceptions = $e9d2e903b2a6a10d$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException,
                ...newExceptions
            ], newException, newExceptionId);
        }
    });
    return newExceptions;
}
function $e9d2e903b2a6a10d$var$applyExceptionGroupFieldsForParentException(exception, exceptionId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: 'generic',
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        ...exception.type === 'AggregateError' && {
            is_exception_group: true
        },
        exception_id: exceptionId
    };
}
function $e9d2e903b2a6a10d$var$applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: 'generic',
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        type: 'chained',
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    };
}
/**
 * Truncate the message (exception.value) of all exceptions in the event.
 * Because this event processor is ran after `applyClientOptions`,
 * we need to truncate the message of the added exceptions here.
 */ function $e9d2e903b2a6a10d$var$truncateAggregateExceptions(exceptions, maxValueLength) {
    return exceptions.map((exception)=>{
        if (exception.value) exception.value = (0, $jmfnM.truncate)(exception.value, maxValueLength);
        return exception;
    });
}

});

parcelRegister("e9AxB", function(module, exports) {

$parcel$export(module.exports, "exceptionFromError", () => $a4de403fd318e2bc$export$a6c2d27607295951);

var $dlAFs = parcelRequire("dlAFs");

var $1y8R2 = parcelRequire("1y8R2");

var $j15Q6 = parcelRequire("j15Q6");

var $aLrZa = parcelRequire("aLrZa");
/**
 * Extracts stack frames from the error.stack string
 */ function $a4de403fd318e2bc$export$d478b2c12fbcfdda(stackParser, error) {
    return stackParser(error.stack || '', 1);
}
/**
 * Extracts stack frames from the error and builds a Sentry Exception
 */ function $a4de403fd318e2bc$export$a6c2d27607295951(stackParser, error) {
    const exception = {
        type: error.name || error.constructor.name,
        value: error.message
    };
    const frames = $a4de403fd318e2bc$export$d478b2c12fbcfdda(stackParser, error);
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    return exception;
}
function $a4de403fd318e2bc$var$getMessageForObject(exception) {
    if ('name' in exception && typeof exception.name === 'string') {
        let message = `'${exception.name}' captured as exception`;
        if ('message' in exception && typeof exception.message === 'string') message += ` with message '${exception.message}'`;
        return message;
    } else if ('message' in exception && typeof exception.message === 'string') return exception.message;
    else // This will allow us to group events based on top-level keys
    // which is much better than creating new group when any key/value change
    return `Object captured as exception with keys: ${(0, $aLrZa.extractExceptionKeysForMessage)(exception)}`;
}
/**
 * Builds and Event from a Exception
 *
 * TODO(v8): Remove getHub fallback
 * @hidden
 */ function $a4de403fd318e2bc$export$9dd56ed1ef0c3420(// eslint-disable-next-line deprecation/deprecation
getHubOrClient, stackParser, exception, hint) {
    const client = typeof getHubOrClient === 'function' ? getHubOrClient().getClient() : getHubOrClient;
    let ex = exception;
    const providedMechanism = hint && hint.data && hint.data.mechanism;
    const mechanism = providedMechanism || {
        handled: true,
        type: 'generic'
    };
    let extras;
    if (!(0, $dlAFs.isError)(exception)) {
        if ((0, $dlAFs.isPlainObject)(exception)) {
            const normalizeDepth = client && client.getOptions().normalizeDepth;
            extras = {
                ['__serialized__']: (0, $j15Q6.normalizeToSize)(exception, normalizeDepth)
            };
            const message = $a4de403fd318e2bc$var$getMessageForObject(exception);
            ex = hint && hint.syntheticException || new Error(message);
            ex.message = message;
        } else {
            // This handles when someone does: `throw "something awesome";`
            // We use synthesized Error here so we can extract a (rough) stack trace.
            ex = hint && hint.syntheticException || new Error(exception);
            ex.message = exception;
        }
        mechanism.synthetic = true;
    }
    const event = {
        exception: {
            values: [
                $a4de403fd318e2bc$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
    if (extras) event.extra = extras;
    (0, $1y8R2.addExceptionTypeValue)(event, undefined, undefined);
    (0, $1y8R2.addExceptionMechanism)(event, mechanism);
    return {
        ...event,
        event_id: hint && hint.event_id
    };
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $a4de403fd318e2bc$export$5425b53185d13d6c(stackParser, message, // eslint-disable-next-line deprecation/deprecation
level = 'info', hint, attachStacktrace) {
    const event = {
        event_id: hint && hint.event_id,
        level: level
    };
    if (attachStacktrace && hint && hint.syntheticException) {
        const frames = $a4de403fd318e2bc$export$d478b2c12fbcfdda(stackParser, hint.syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
    }
    if ((0, $dlAFs.isParameterizedString)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}

});



parcelRegister("i6lAy", function(module, exports) {

$parcel$export(module.exports, "metrics", () => $d2d9888e1bb9e29b$export$b0c5c2fac8144e54);

var $lN8pX = parcelRequire("lN8pX");

var $cQ4mt = parcelRequire("cQ4mt");

var $fq71H = parcelRequire("fq71H");

var $aYVgD = parcelRequire("aYVgD");

var $7D0Sp = parcelRequire("7D0Sp");

var $jIxne = parcelRequire("jIxne");
function $d2d9888e1bb9e29b$var$addToMetricsAggregator(metricType, name, value, data = {}) {
    const client = (0, $fq71H.getClient)();
    const scope = (0, $fq71H.getCurrentScope)();
    if (client) {
        if (!client.metricsAggregator) {
            (0, $cQ4mt.DEBUG_BUILD) && (0, $lN8pX.logger).warn('No metrics aggregator enabled. Please add the MetricsAggregator integration to use metrics APIs');
            return;
        }
        const { unit: unit, tags: tags, timestamp: timestamp } = data;
        const { release: release, environment: environment } = client.getOptions();
        // eslint-disable-next-line deprecation/deprecation
        const transaction = scope.getTransaction();
        const metricTags = {};
        if (release) metricTags.release = release;
        if (environment) metricTags.environment = environment;
        if (transaction) metricTags.transaction = (0, $aYVgD.spanToJSON)(transaction).description || '';
        (0, $cQ4mt.DEBUG_BUILD) && (0, $lN8pX.logger).log(`Adding value of ${value} to ${metricType} metric ${name}`);
        client.metricsAggregator.add(metricType, name, value, unit, {
            ...metricTags,
            ...tags
        }, timestamp);
    }
}
/**
 * Adds a value to a counter metric
 *
 * @experimental This API is experimental and might have breaking changes in the future.
 */ function $d2d9888e1bb9e29b$export$a2647aa13413c947(name, value = 1, data) {
    $d2d9888e1bb9e29b$var$addToMetricsAggregator((0, $7D0Sp.COUNTER_METRIC_TYPE), name, value, data);
}
/**
 * Adds a value to a distribution metric
 *
 * @experimental This API is experimental and might have breaking changes in the future.
 */ function $d2d9888e1bb9e29b$export$fd8e353f0040520a(name, value, data) {
    $d2d9888e1bb9e29b$var$addToMetricsAggregator((0, $7D0Sp.DISTRIBUTION_METRIC_TYPE), name, value, data);
}
/**
 * Adds a value to a set metric. Value must be a string or integer.
 *
 * @experimental This API is experimental and might have breaking changes in the future.
 */ function $d2d9888e1bb9e29b$export$adaa4cf7ef1b65be(name, value, data) {
    $d2d9888e1bb9e29b$var$addToMetricsAggregator((0, $7D0Sp.SET_METRIC_TYPE), name, value, data);
}
/**
 * Adds a value to a gauge metric
 *
 * @experimental This API is experimental and might have breaking changes in the future.
 */ function $d2d9888e1bb9e29b$export$b0660673397c6c28(name, value, data) {
    $d2d9888e1bb9e29b$var$addToMetricsAggregator((0, $7D0Sp.GAUGE_METRIC_TYPE), name, value, data);
}
const $d2d9888e1bb9e29b$export$b0c5c2fac8144e54 = {
    increment: $d2d9888e1bb9e29b$export$a2647aa13413c947,
    distribution: $d2d9888e1bb9e29b$export$fd8e353f0040520a,
    set: $d2d9888e1bb9e29b$export$adaa4cf7ef1b65be,
    gauge: $d2d9888e1bb9e29b$export$b0660673397c6c28,
    MetricsAggregator: /** @deprecated Use `metrics.metricsAggregratorIntegration()` instead. */ // eslint-disable-next-line deprecation/deprecation
    $jIxne.MetricsAggregator,
    metricsAggregatorIntegration: $jIxne.metricsAggregatorIntegration
};

});
parcelRegister("7D0Sp", function(module, exports) {

$parcel$export(module.exports, "COUNTER_METRIC_TYPE", () => $58dcdafaf7d1b225$export$ffbd59c90957aeda);
$parcel$export(module.exports, "GAUGE_METRIC_TYPE", () => $58dcdafaf7d1b225$export$41106537ee4dbdd);
$parcel$export(module.exports, "SET_METRIC_TYPE", () => $58dcdafaf7d1b225$export$d2e7506772279f4e);
$parcel$export(module.exports, "DISTRIBUTION_METRIC_TYPE", () => $58dcdafaf7d1b225$export$9818d6472d7991f0);
$parcel$export(module.exports, "DEFAULT_BROWSER_FLUSH_INTERVAL", () => $58dcdafaf7d1b225$export$9fcf9b73aae4b12);
const $58dcdafaf7d1b225$export$ffbd59c90957aeda = 'c';
const $58dcdafaf7d1b225$export$41106537ee4dbdd = 'g';
const $58dcdafaf7d1b225$export$d2e7506772279f4e = 's';
const $58dcdafaf7d1b225$export$9818d6472d7991f0 = 'd';
/**
 * This does not match spec in https://develop.sentry.dev/sdk/metrics
 * but was chosen to optimize for the most common case in browser environments.
 */ const $58dcdafaf7d1b225$export$9fcf9b73aae4b12 = 5000;
/**
 * SDKs are required to bucket into 10 second intervals (rollup in seconds)
 * which is the current lower bound of metric accuracy.
 */ const $58dcdafaf7d1b225$export$8f071e089fcfe0c = 10000;
/**
 * The maximum number of metrics that should be stored in memory.
 */ const $58dcdafaf7d1b225$export$aa41e9d920739c1a = 10000;

});

parcelRegister("jIxne", function(module, exports) {

$parcel$export(module.exports, "metricsAggregatorIntegration", () => $e5ac03b187b1a907$export$4c88deba5759110b);
$parcel$export(module.exports, "MetricsAggregator", () => $e5ac03b187b1a907$export$a2510bffabd4ed26);

var $6emiv = parcelRequire("6emiv");

var $kMEde = parcelRequire("kMEde");
const $e5ac03b187b1a907$var$INTEGRATION_NAME = 'MetricsAggregator';
const $e5ac03b187b1a907$var$_metricsAggregatorIntegration = ()=>{
    return {
        name: $e5ac03b187b1a907$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        setup (client) {
            client.metricsAggregator = new (0, $kMEde.BrowserMetricsAggregator)(client);
        }
    };
};
const $e5ac03b187b1a907$export$4c88deba5759110b = (0, $6emiv.defineIntegration)($e5ac03b187b1a907$var$_metricsAggregatorIntegration);
/**
 * Enables Sentry metrics monitoring.
 *
 * @experimental This API is experimental and might having breaking changes in the future.
 * @deprecated Use `metricsAggegratorIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $e5ac03b187b1a907$export$a2510bffabd4ed26 = (0, $6emiv.convertIntegrationFnToClass)($e5ac03b187b1a907$var$INTEGRATION_NAME, $e5ac03b187b1a907$export$4c88deba5759110b);

});
parcelRegister("kMEde", function(module, exports) {

$parcel$export(module.exports, "BrowserMetricsAggregator", () => $f2177bb3f77cb48f$export$ba883a03ada27e19);

var $leMLP = parcelRequire("leMLP");

var $7D0Sp = parcelRequire("7D0Sp");

var $eKLUT = parcelRequire("eKLUT");

var $5viWL = parcelRequire("5viWL");

var $8umlm = parcelRequire("8umlm");
/**
 * A simple metrics aggregator that aggregates metrics in memory and flushes them periodically.
 * Default flush interval is 5 seconds.
 *
 * @experimental This API is experimental and might change in the future.
 */ class $f2177bb3f77cb48f$export$ba883a03ada27e19 {
    // TODO(@anonrig): Use FinalizationRegistry to have a proper way of flushing the buckets
    // when the aggregator is garbage collected.
    // Ref: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/FinalizationRegistry
    constructor(_client){
        this._client = _client;
        this._buckets = new Map();
        this._interval = setInterval(()=>this.flush(), (0, $7D0Sp.DEFAULT_BROWSER_FLUSH_INTERVAL));
    }
    /**
   * @inheritDoc
   */ add(metricType, unsanitizedName, value, unsanitizedUnit = 'none', unsanitizedTags = {}, maybeFloatTimestamp = (0, $leMLP.timestampInSeconds)()) {
        const timestamp = Math.floor(maybeFloatTimestamp);
        const name = (0, $8umlm.sanitizeMetricKey)(unsanitizedName);
        const tags = (0, $8umlm.sanitizeTags)(unsanitizedTags);
        const unit = (0, $8umlm.sanitizeUnit)(unsanitizedUnit);
        const bucketKey = (0, $8umlm.getBucketKey)(metricType, name, unit, tags);
        let bucketItem = this._buckets.get(bucketKey);
        // If this is a set metric, we need to calculate the delta from the previous weight.
        const previousWeight = bucketItem && metricType === (0, $7D0Sp.SET_METRIC_TYPE) ? bucketItem.metric.weight : 0;
        if (bucketItem) {
            bucketItem.metric.add(value);
            // TODO(abhi): Do we need this check?
            if (bucketItem.timestamp < timestamp) bucketItem.timestamp = timestamp;
        } else {
            bucketItem = {
                // @ts-expect-error we don't need to narrow down the type of value here, saves bundle size.
                metric: new (0, $eKLUT.METRIC_MAP)[metricType](value),
                timestamp: timestamp,
                metricType: metricType,
                name: name,
                unit: unit,
                tags: tags
            };
            this._buckets.set(bucketKey, bucketItem);
        }
        // If value is a string, it's a set metric so calculate the delta from the previous weight.
        const val = typeof value === 'string' ? bucketItem.metric.weight - previousWeight : value;
        (0, $5viWL.updateMetricSummaryOnActiveSpan)(metricType, name, val, unit, unsanitizedTags, bucketKey);
    }
    /**
   * @inheritDoc
   */ flush() {
        // short circuit if buckets are empty.
        if (this._buckets.size === 0) return;
        if (this._client.captureAggregateMetrics) {
            // TODO(@anonrig): Use Object.values() when we support ES6+
            const metricBuckets = Array.from(this._buckets).map(([, bucketItem])=>bucketItem);
            this._client.captureAggregateMetrics(metricBuckets);
        }
        this._buckets.clear();
    }
    /**
   * @inheritDoc
   */ close() {
        clearInterval(this._interval);
        this.flush();
    }
}

});
parcelRegister("eKLUT", function(module, exports) {

$parcel$export(module.exports, "METRIC_MAP", () => $abda87d456d551fb$export$c3e86dbb157e974e);

var $7D0Sp = parcelRequire("7D0Sp");

var $8umlm = parcelRequire("8umlm");
/**
 * A metric instance representing a counter.
 */ class $abda87d456d551fb$export$2598fd6c664a7ae3 {
    constructor(_value){
        this._value = _value;
    }
    /** @inheritDoc */ get weight() {
        return 1;
    }
    /** @inheritdoc */ add(value) {
        this._value += value;
    }
    /** @inheritdoc */ toString() {
        return `${this._value}`;
    }
}
/**
 * A metric instance representing a gauge.
 */ class $abda87d456d551fb$export$56f7b30259c6ff43 {
    constructor(value){
        this._last = value;
        this._min = value;
        this._max = value;
        this._sum = value;
        this._count = 1;
    }
    /** @inheritDoc */ get weight() {
        return 5;
    }
    /** @inheritdoc */ add(value) {
        this._last = value;
        if (value < this._min) this._min = value;
        if (value > this._max) this._max = value;
        this._sum += value;
        this._count++;
    }
    /** @inheritdoc */ toString() {
        return `${this._last}:${this._min}:${this._max}:${this._sum}:${this._count}`;
    }
}
/**
 * A metric instance representing a distribution.
 */ class $abda87d456d551fb$export$94f4651a38b34288 {
    constructor(first){
        this._value = [
            first
        ];
    }
    /** @inheritDoc */ get weight() {
        return this._value.length;
    }
    /** @inheritdoc */ add(value) {
        this._value.push(value);
    }
    /** @inheritdoc */ toString() {
        return this._value.join(':');
    }
}
/**
 * A metric instance representing a set.
 */ class $abda87d456d551fb$export$4d1d31acf43c5a17 {
    constructor(first){
        this.first = first;
        this._value = new Set([
            first
        ]);
    }
    /** @inheritDoc */ get weight() {
        return this._value.size;
    }
    /** @inheritdoc */ add(value) {
        this._value.add(value);
    }
    /** @inheritdoc */ toString() {
        return Array.from(this._value).map((val)=>typeof val === 'string' ? (0, $8umlm.simpleHash)(val) : val).join(':');
    }
}
const $abda87d456d551fb$export$c3e86dbb157e974e = {
    [(0, $7D0Sp.COUNTER_METRIC_TYPE)]: $abda87d456d551fb$export$2598fd6c664a7ae3,
    [(0, $7D0Sp.GAUGE_METRIC_TYPE)]: $abda87d456d551fb$export$56f7b30259c6ff43,
    [(0, $7D0Sp.DISTRIBUTION_METRIC_TYPE)]: $abda87d456d551fb$export$94f4651a38b34288,
    [(0, $7D0Sp.SET_METRIC_TYPE)]: $abda87d456d551fb$export$4d1d31acf43c5a17
};

});





parcelRegister("i8T1U", function(module, exports) {

$parcel$export(module.exports, "WINDOW", () => $d353a91b04ba97ac$export$56d8a8a25bd48b81);
$parcel$export(module.exports, "shouldIgnoreOnError", () => $d353a91b04ba97ac$export$b79738ab10c590b2);
$parcel$export(module.exports, "wrap", () => $d353a91b04ba97ac$export$4997ffc0176396a6);


var $fq71H = parcelRequire("fq71H");

var $1y8R2 = parcelRequire("1y8R2");
var $aLrZa = parcelRequire("aLrZa");
var $4mb67 = parcelRequire("4mb67");
const $d353a91b04ba97ac$export$56d8a8a25bd48b81 = (0, $4mb67.GLOBAL_OBJ);
let $d353a91b04ba97ac$var$ignoreOnError = 0;
/**
 * @hidden
 */ function $d353a91b04ba97ac$export$b79738ab10c590b2() {
    return $d353a91b04ba97ac$var$ignoreOnError > 0;
}
/**
 * @hidden
 */ function $d353a91b04ba97ac$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $d353a91b04ba97ac$var$ignoreOnError++;
    setTimeout(()=>{
        $d353a91b04ba97ac$var$ignoreOnError--;
    });
}
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */ function $d353a91b04ba97ac$export$4997ffc0176396a6(fn, options = {}, before) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    if (typeof fn !== 'function') return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        const wrapper = fn.__sentry_wrapped__;
        if (wrapper) return wrapper;
        // We don't wanna wrap it twice
        if ((0, $aLrZa.getOriginalFunction)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    /* eslint-disable prefer-rest-params */ // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
    const sentryWrapped = function() {
        const args = Array.prototype.slice.call(arguments);
        try {
            if (before && typeof before === 'function') before.apply(this, arguments);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            const wrappedArguments = args.map((arg)=>$d353a91b04ba97ac$export$4997ffc0176396a6(arg, options));
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $d353a91b04ba97ac$export$1265a142ff5ba165();
            (0, $fq71H.withScope)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $1y8R2.addExceptionTypeValue)(event, undefined, undefined);
                        (0, $1y8R2.addExceptionMechanism)(event, options.mechanism);
                    }
                    event.extra = {
                        ...event.extra,
                        arguments: args
                    };
                    return event;
                });
                (0, $fq71H.captureException)(ex);
            });
            throw ex;
        }
    };
    /* eslint-enable prefer-rest-params */ // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch (_oO) {} // eslint-disable-line no-empty
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $aLrZa.markFunctionWrapped)(sentryWrapped, fn);
    (0, $aLrZa.addNonEnumerableProperty)(fn, '__sentry_wrapped__', sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, 'name', {
            get () {
                return fn.name;
            }
        });
    // eslint-disable-next-line no-empty
    } catch (_oO) {}
    return sentryWrapped;
}

});

parcelRegister("cGpn8", function(module, exports) {

$parcel$export(module.exports, "BrowserClient", () => $93bd16aed6270d84$export$1df9218a526d318d);

var $fOYMT = parcelRequire("fOYMT");
var $diF5W = parcelRequire("diF5W");

var $loS2p = parcelRequire("loS2p");
var $3w9d5 = parcelRequire("3w9d5");
var $33mnL = parcelRequire("33mnL");
var $lN8pX = parcelRequire("lN8pX");

var $70zzf = parcelRequire("70zzf");

var $g9ymE = parcelRequire("g9ymE");

var $i8T1U = parcelRequire("i8T1U");

var $fZzwf = parcelRequire("fZzwf");
/**
 * Configuration options for the Sentry Browser SDK.
 * @see @sentry/types Options for more information.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ class $93bd16aed6270d84$export$1df9218a526d318d extends (0, $diF5W.BaseClient) {
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        const sdkSource = (0, $i8T1U.WINDOW).SENTRY_SDK_SOURCE || (0, $33mnL.getSDKSource)();
        (0, $fOYMT.applySdkMetadata)(options, 'browser', [
            'browser'
        ], sdkSource);
        super(options);
        if (options.sendClientReports && (0, $i8T1U.WINDOW).document) (0, $i8T1U.WINDOW).document.addEventListener('visibilitychange', ()=>{
            if ((0, $i8T1U.WINDOW).document.visibilityState === 'hidden') this._flushOutcomes();
        });
    }
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $g9ymE.eventFromException)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, // eslint-disable-next-line deprecation/deprecation
    level = 'info', hint) {
        return (0, $g9ymE.eventFromMessage)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * Sends user feedback to Sentry.
   */ captureUserFeedback(feedback) {
        if (!this._isEnabled()) {
            (0, $70zzf.DEBUG_BUILD) && (0, $lN8pX.logger).warn('SDK not enabled, will not capture user feedback.');
            return;
        }
        const envelope = (0, $fZzwf.createUserFeedbackEnvelope)(feedback, {
            metadata: this.getSdkMetadata(),
            dsn: this.getDsn(),
            tunnel: this.getOptions().tunnel
        });
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(envelope);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, scope) {
        event.platform = event.platform || 'javascript';
        return super._prepareEvent(event, hint, scope);
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            (0, $70zzf.DEBUG_BUILD) && (0, $lN8pX.logger).log('No outcomes to send');
            return;
        }
        // This is really the only place where we want to check for a DSN and only send outcomes then
        if (!this._dsn) {
            (0, $70zzf.DEBUG_BUILD) && (0, $lN8pX.logger).log('No dsn provided, will not send outcomes');
            return;
        }
        (0, $70zzf.DEBUG_BUILD) && (0, $lN8pX.logger).log('Sending outcomes:', outcomes);
        const envelope = (0, $loS2p.createClientReportEnvelope)(outcomes, this._options.tunnel && (0, $3w9d5.dsnToString)(this._dsn));
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(envelope);
    }
}

});
parcelRegister("loS2p", function(module, exports) {

$parcel$export(module.exports, "createClientReportEnvelope", () => $f945c1acee7c3e03$export$f3b9ed77c03eeb00);

var $cSKRv = parcelRequire("cSKRv");

var $leMLP = parcelRequire("leMLP");
/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */ function $f945c1acee7c3e03$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: 'client_report'
        },
        {
            timestamp: timestamp || (0, $leMLP.dateTimestampInSeconds)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $cSKRv.createEnvelope)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}

});

parcelRegister("33mnL", function(module, exports) {

$parcel$export(module.exports, "getSDKSource", () => $23930393ab2b4423$export$8ad33f488b1ab046);
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $23930393ab2b4423$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function $23930393ab2b4423$export$8ad33f488b1ab046() {
    // @ts-expect-error "npm" is injected by rollup during build process
    return "npm";
}

});

parcelRegister("70zzf", function(module, exports) {

$parcel$export(module.exports, "DEBUG_BUILD", () => $51a41f6ed92fcd4c$export$16a28057038b10ef);
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $51a41f6ed92fcd4c$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;

});

parcelRegister("g9ymE", function(module, exports) {

$parcel$export(module.exports, "exceptionFromError", () => $bc28249f857c1fdb$export$a6c2d27607295951);
$parcel$export(module.exports, "eventFromException", () => $bc28249f857c1fdb$export$ea3ec7e569b823fc);
$parcel$export(module.exports, "eventFromUnknownInput", () => $bc28249f857c1fdb$export$9dd56ed1ef0c3420);
$parcel$export(module.exports, "eventFromMessage", () => $bc28249f857c1fdb$export$5425b53185d13d6c);

var $fq71H = parcelRequire("fq71H");

var $1y8R2 = parcelRequire("1y8R2");
var $aLrZa = parcelRequire("aLrZa");
var $dlAFs = parcelRequire("dlAFs");
var $j15Q6 = parcelRequire("j15Q6");
var $57iGk = parcelRequire("57iGk");
/**
 * This function creates an exception from a JavaScript Error
 */ function $bc28249f857c1fdb$export$a6c2d27607295951(stackParser, ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    const frames = $bc28249f857c1fdb$export$d478b2c12fbcfdda(stackParser, ex);
    const exception = {
        type: ex && ex.name,
        value: $bc28249f857c1fdb$var$extractMessage(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === '') exception.value = 'Unrecoverable error caught';
    return exception;
}
/**
 * @hidden
 */ function $bc28249f857c1fdb$export$a6a5dd73e489caf(stackParser, exception, syntheticException, isUnhandledRejection) {
    const client = (0, $fq71H.getClient)();
    const normalizeDepth = client && client.getOptions().normalizeDepth;
    const event = {
        exception: {
            values: [
                {
                    type: (0, $dlAFs.isEvent)(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
                    value: $bc28249f857c1fdb$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: {
            __serialized__: (0, $j15Q6.normalizeToSize)(exception, normalizeDepth)
        }
    };
    if (syntheticException) {
        const frames = $bc28249f857c1fdb$export$d478b2c12fbcfdda(stackParser, syntheticException);
        if (frames.length) // event.exception.values[0] has been set above
        event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
/**
 * @hidden
 */ function $bc28249f857c1fdb$export$73fbea5a0a5234af(stackParser, ex) {
    return {
        exception: {
            values: [
                $bc28249f857c1fdb$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
/** Parses stack frames from an error */ function $bc28249f857c1fdb$export$d478b2c12fbcfdda(stackParser, ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    const stacktrace = ex.stacktrace || ex.stack || '';
    const popSize = $bc28249f857c1fdb$var$getPopSize(ex);
    try {
        return stackParser(stacktrace, popSize);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const $bc28249f857c1fdb$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
function $bc28249f857c1fdb$var$getPopSize(ex) {
    if (ex) {
        if (typeof ex.framesToPop === 'number') return ex.framesToPop;
        if ($bc28249f857c1fdb$var$reactMinifiedRegexp.test(ex.message)) return 1;
    }
    return 0;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $bc28249f857c1fdb$var$extractMessage(ex) {
    const message = ex && ex.message;
    if (!message) return 'No error message';
    if (message.error && typeof message.error.message === 'string') return message.error.message;
    return message;
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */ function $bc28249f857c1fdb$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $bc28249f857c1fdb$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $1y8R2.addExceptionMechanism)(event); // defaults to { type: 'generic', handled: true }
    event.level = 'error';
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $57iGk.resolvedSyncPromise)(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $bc28249f857c1fdb$export$5425b53185d13d6c(stackParser, message, // eslint-disable-next-line deprecation/deprecation
level = 'info', hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $bc28249f857c1fdb$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $57iGk.resolvedSyncPromise)(event);
}
/**
 * @hidden
 */ function $bc28249f857c1fdb$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $dlAFs.isErrorEvent)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        const errorEvent = exception;
        return $bc28249f857c1fdb$export$73fbea5a0a5234af(stackParser, errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $dlAFs.isDOMError)(exception) || (0, $dlAFs.isDOMException)(exception)) {
        const domException = exception;
        if ('stack' in exception) event = $bc28249f857c1fdb$export$73fbea5a0a5234af(stackParser, exception);
        else {
            const name = domException.name || ((0, $dlAFs.isDOMError)(domException) ? 'DOMError' : 'DOMException');
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $bc28249f857c1fdb$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace);
            (0, $1y8R2.addExceptionTypeValue)(event, message);
        }
        if ('code' in domException) // eslint-disable-next-line deprecation/deprecation
        event.tags = {
            ...event.tags,
            'DOMException.code': `${domException.code}`
        };
        return event;
    }
    if ((0, $dlAFs.isError)(exception)) // we have a real Error object, do nothing
    return $bc28249f857c1fdb$export$73fbea5a0a5234af(stackParser, exception);
    if ((0, $dlAFs.isPlainObject)(exception) || (0, $dlAFs.isEvent)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        const objectException = exception;
        event = $bc28249f857c1fdb$export$a6a5dd73e489caf(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $1y8R2.addExceptionMechanism)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $bc28249f857c1fdb$export$47d86ae4b3c9994(stackParser, exception, syntheticException, attachStacktrace);
    (0, $1y8R2.addExceptionTypeValue)(event, `${exception}`, undefined);
    (0, $1y8R2.addExceptionMechanism)(event, {
        synthetic: true
    });
    return event;
}
/**
 * @hidden
 */ function $bc28249f857c1fdb$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace) {
    const event = {};
    if (attachStacktrace && syntheticException) {
        const frames = $bc28249f857c1fdb$export$d478b2c12fbcfdda(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
    }
    if ((0, $dlAFs.isParameterizedString)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function $bc28249f857c1fdb$var$getNonErrorObjectExceptionValue(exception, { isUnhandledRejection: isUnhandledRejection }) {
    const keys = (0, $aLrZa.extractExceptionKeysForMessage)(exception);
    const captureType = isUnhandledRejection ? 'promise rejection' : 'exception';
    // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ((0, $dlAFs.isErrorEvent)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, $dlAFs.isEvent)(exception)) {
        const className = $bc28249f857c1fdb$var$getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function $bc28249f857c1fdb$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch (e) {
    // ignore errors here
    }
}

});

parcelRegister("fZzwf", function(module, exports) {

$parcel$export(module.exports, "createUserFeedbackEnvelope", () => $ba481adf7a726cd6$export$24a4dfcb686ee5bf);

var $cSKRv = parcelRequire("cSKRv");
var $3w9d5 = parcelRequire("3w9d5");
/**
 * Creates an envelope from a user feedback.
 */ function $ba481adf7a726cd6$export$24a4dfcb686ee5bf(feedback, { metadata: metadata, tunnel: tunnel, dsn: dsn }) {
    const headers = {
        event_id: feedback.event_id,
        sent_at: new Date().toISOString(),
        ...metadata && metadata.sdk && {
            sdk: {
                name: metadata.sdk.name,
                version: metadata.sdk.version
            }
        },
        ...!!tunnel && !!dsn && {
            dsn: (0, $3w9d5.dsnToString)(dsn)
        }
    };
    const item = $ba481adf7a726cd6$var$createUserFeedbackEnvelopeItem(feedback);
    return (0, $cSKRv.createEnvelope)(headers, [
        item
    ]);
}
function $ba481adf7a726cd6$var$createUserFeedbackEnvelopeItem(feedback) {
    const feedbackHeaders = {
        type: 'user_report'
    };
    return [
        feedbackHeaders,
        feedback
    ];
}

});


parcelRegister("2pZps", function(module, exports) {

$parcel$export(module.exports, "makeFetchTransport", () => $1c2d8d408f949a1c$export$b2311068c46d7cc8);

var $ldUUe = parcelRequire("ldUUe");

var $57iGk = parcelRequire("57iGk");

var $FE89l = parcelRequire("FE89l");
/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */ function $1c2d8d408f949a1c$export$b2311068c46d7cc8(options, nativeFetch = (0, $FE89l.getNativeFetchImplementation)()) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = {
            body: request.body,
            method: 'POST',
            referrerPolicy: 'origin',
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. whenfinishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 60000 && pendingCount < 15,
            ...options.fetchOptions
        };
        try {
            return nativeFetch(options.url, requestOptions).then((response)=>{
                pendingBodySize -= requestSize;
                pendingCount--;
                return {
                    statusCode: response.status,
                    headers: {
                        'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                        'retry-after': response.headers.get('Retry-After')
                    }
                };
            });
        } catch (e) {
            (0, $FE89l.clearCachedFetchImplementation)();
            pendingBodySize -= requestSize;
            pendingCount--;
            return (0, $57iGk.rejectedSyncPromise)(e);
        }
    }
    return (0, $ldUUe.createTransport)(options, makeRequest);
}

});
parcelRegister("FE89l", function(module, exports) {

$parcel$export(module.exports, "getNativeFetchImplementation", () => $07d2f5855e6ad057$export$8be2119ce08e3379);
$parcel$export(module.exports, "clearCachedFetchImplementation", () => $07d2f5855e6ad057$export$d499686d2dd738c6);

var $4Dtr4 = parcelRequire("4Dtr4");
var $lN8pX = parcelRequire("lN8pX");

var $70zzf = parcelRequire("70zzf");

var $i8T1U = parcelRequire("i8T1U");
let $07d2f5855e6ad057$var$cachedFetchImpl = undefined;
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */ function $07d2f5855e6ad057$export$8be2119ce08e3379() {
    if ($07d2f5855e6ad057$var$cachedFetchImpl) return $07d2f5855e6ad057$var$cachedFetchImpl;
    /* eslint-disable @typescript-eslint/unbound-method */ // Fast path to avoid DOM I/O
    if ((0, $4Dtr4.isNativeFetch)((0, $i8T1U.WINDOW).fetch)) return $07d2f5855e6ad057$var$cachedFetchImpl = (0, $i8T1U.WINDOW).fetch.bind((0, $i8T1U.WINDOW));
    const document = (0, $i8T1U.WINDOW).document;
    let fetchImpl = (0, $i8T1U.WINDOW).fetch;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === 'function') try {
        const sandbox = document.createElement('iframe');
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow.fetch) fetchImpl = contentWindow.fetch;
        document.head.removeChild(sandbox);
    } catch (e) {
        (0, $70zzf.DEBUG_BUILD) && (0, $lN8pX.logger).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', e);
    }
    return $07d2f5855e6ad057$var$cachedFetchImpl = fetchImpl.bind((0, $i8T1U.WINDOW));
/* eslint-enable @typescript-eslint/unbound-method */ }
/** Clears cached fetch impl */ function $07d2f5855e6ad057$export$d499686d2dd738c6() {
    $07d2f5855e6ad057$var$cachedFetchImpl = undefined;
}

});
parcelRegister("4Dtr4", function(module, exports) {

$parcel$export(module.exports, "supportsFetch", () => $3601a33828be5b2f$export$edf3cb81fd7d2a3e);
$parcel$export(module.exports, "isNativeFetch", () => $3601a33828be5b2f$export$18cf36ed71d733e7);
$parcel$export(module.exports, "supportsNativeFetch", () => $3601a33828be5b2f$export$c82d238e23c40b21);
$parcel$export(module.exports, "supportsReportingObserver", () => $3601a33828be5b2f$export$531055a6c684a70a);

var $jK6Z8 = parcelRequire("jK6Z8");

var $lN8pX = parcelRequire("lN8pX");

var $4mb67 = parcelRequire("4mb67");
// eslint-disable-next-line deprecation/deprecation
const $3601a33828be5b2f$var$WINDOW = (0, $4mb67.getGlobalObject)();
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function $3601a33828be5b2f$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function $3601a33828be5b2f$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-expect-error It really needs 1 argument, not 0.
        new DOMError('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function $3601a33828be5b2f$export$ab12a5d056f1d3a() {
    try {
        new DOMException('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */ function $3601a33828be5b2f$export$edf3cb81fd7d2a3e() {
    if (!('fetch' in $3601a33828be5b2f$var$WINDOW)) return false;
    try {
        new Headers();
        new Request('http://www.example.com');
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * isNativeFetch checks if the given function is a native implementation of fetch()
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $3601a33828be5b2f$export$18cf36ed71d733e7(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function $3601a33828be5b2f$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === 'string') return true;
    if (!$3601a33828be5b2f$export$edf3cb81fd7d2a3e()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($3601a33828be5b2f$export$18cf36ed71d733e7($3601a33828be5b2f$var$WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    let result = false;
    const doc = $3601a33828be5b2f$var$WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === 'function') try {
        const sandbox = doc.createElement('iframe');
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow && sandbox.contentWindow.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $3601a33828be5b2f$export$18cf36ed71d733e7(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $jK6Z8.DEBUG_BUILD) && (0, $lN8pX.logger).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function $3601a33828be5b2f$export$531055a6c684a70a() {
    return 'ReportingObserver' in $3601a33828be5b2f$var$WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */ function $3601a33828be5b2f$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$3601a33828be5b2f$export$edf3cb81fd7d2a3e()) return false;
    try {
        new Request('_', {
            referrerPolicy: 'origin'
        });
        return true;
    } catch (e) {
        return false;
    }
}

});



parcelRegister("ecgG4", function(module, exports) {

$parcel$export(module.exports, "makeXHRTransport", () => $a55f1f7a5371345b$export$5e1441cee30d5a39);

var $ldUUe = parcelRequire("ldUUe");

var $57iGk = parcelRequire("57iGk");
/**
 * The DONE ready state for XmlHttpRequest
 *
 * Defining it here as a constant b/c XMLHttpRequest.DONE is not always defined
 * (e.g. during testing, it is `undefined`)
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState}
 */ const $a55f1f7a5371345b$var$XHR_READYSTATE_DONE = 4;
/**
 * Creates a Transport that uses the XMLHttpRequest API to send events to Sentry.
 */ function $a55f1f7a5371345b$export$5e1441cee30d5a39(options) {
    function makeRequest(request) {
        return new (0, $57iGk.SyncPromise)((resolve, reject)=>{
            const xhr = new XMLHttpRequest();
            xhr.onerror = reject;
            xhr.onreadystatechange = ()=>{
                if (xhr.readyState === $a55f1f7a5371345b$var$XHR_READYSTATE_DONE) resolve({
                    statusCode: xhr.status,
                    headers: {
                        'x-sentry-rate-limits': xhr.getResponseHeader('X-Sentry-Rate-Limits'),
                        'retry-after': xhr.getResponseHeader('Retry-After')
                    }
                });
            };
            xhr.open('POST', options.url);
            for(const header in options.headers)if (Object.prototype.hasOwnProperty.call(options.headers, header)) xhr.setRequestHeader(header, options.headers[header]);
            xhr.send(request.body);
        });
    }
    return (0, $ldUUe.createTransport)(options, makeRequest);
}

});

parcelRegister("h8rWQ", function(module, exports) {

$parcel$export(module.exports, "chromeStackLineParser", () => $c798dcf018e7056e$export$263a749fff749872);
$parcel$export(module.exports, "geckoStackLineParser", () => $c798dcf018e7056e$export$cdba47a5dd2804d);
$parcel$export(module.exports, "winjsStackLineParser", () => $c798dcf018e7056e$export$179460296da408e8);
$parcel$export(module.exports, "opera10StackLineParser", () => $c798dcf018e7056e$export$f892b52c880ffc7a);
$parcel$export(module.exports, "opera11StackLineParser", () => $c798dcf018e7056e$export$af11af13f09fb0dc);
$parcel$export(module.exports, "defaultStackLineParsers", () => $c798dcf018e7056e$export$7197c0fe6554c079);
$parcel$export(module.exports, "defaultStackParser", () => $c798dcf018e7056e$export$2b2b997d81bf3907);

var $jVtDJ = parcelRequire("jVtDJ");
// global reference to slice
const $c798dcf018e7056e$var$UNKNOWN_FUNCTION = '?';
const $c798dcf018e7056e$var$OPERA10_PRIORITY = 10;
const $c798dcf018e7056e$var$OPERA11_PRIORITY = 20;
const $c798dcf018e7056e$var$CHROME_PRIORITY = 30;
const $c798dcf018e7056e$var$WINJS_PRIORITY = 40;
const $c798dcf018e7056e$var$GECKO_PRIORITY = 50;
function $c798dcf018e7056e$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func,
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
const $c798dcf018e7056e$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $c798dcf018e7056e$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
// We cannot call this variable `chrome` because it can conflict with global `chrome` variable in certain environments
// See: https://github.com/getsentry/sentry-javascript/issues/6880
const $c798dcf018e7056e$var$chromeStackParserFn = (line)=>{
    const parts = $c798dcf018e7056e$var$chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
        if (isEval) {
            const subMatch = $c798dcf018e7056e$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        const [func, filename] = $c798dcf018e7056e$var$extractSafariExtensionDetails(parts[1] || $c798dcf018e7056e$var$UNKNOWN_FUNCTION, parts[2]);
        return $c798dcf018e7056e$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
const $c798dcf018e7056e$export$263a749fff749872 = [
    $c798dcf018e7056e$var$CHROME_PRIORITY,
    $c798dcf018e7056e$var$chromeStackParserFn
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const $c798dcf018e7056e$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $c798dcf018e7056e$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $c798dcf018e7056e$var$gecko = (line)=>{
    const parts = $c798dcf018e7056e$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval) {
            const subMatch = $c798dcf018e7056e$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || 'eval';
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ''; // no column when eval
            }
        }
        let filename = parts[3];
        let func = parts[1] || $c798dcf018e7056e$var$UNKNOWN_FUNCTION;
        [func, filename] = $c798dcf018e7056e$var$extractSafariExtensionDetails(func, filename);
        return $c798dcf018e7056e$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
const $c798dcf018e7056e$export$cdba47a5dd2804d = [
    $c798dcf018e7056e$var$GECKO_PRIORITY,
    $c798dcf018e7056e$var$gecko
];
const $c798dcf018e7056e$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $c798dcf018e7056e$var$winjs = (line)=>{
    const parts = $c798dcf018e7056e$var$winjsRegex.exec(line);
    return parts ? $c798dcf018e7056e$var$createFrame(parts[2], parts[1] || $c798dcf018e7056e$var$UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
const $c798dcf018e7056e$export$179460296da408e8 = [
    $c798dcf018e7056e$var$WINJS_PRIORITY,
    $c798dcf018e7056e$var$winjs
];
const $c798dcf018e7056e$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $c798dcf018e7056e$var$opera10 = (line)=>{
    const parts = $c798dcf018e7056e$var$opera10Regex.exec(line);
    return parts ? $c798dcf018e7056e$var$createFrame(parts[2], parts[3] || $c798dcf018e7056e$var$UNKNOWN_FUNCTION, +parts[1]) : undefined;
};
const $c798dcf018e7056e$export$f892b52c880ffc7a = [
    $c798dcf018e7056e$var$OPERA10_PRIORITY,
    $c798dcf018e7056e$var$opera10
];
const $c798dcf018e7056e$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $c798dcf018e7056e$var$opera11 = (line)=>{
    const parts = $c798dcf018e7056e$var$opera11Regex.exec(line);
    return parts ? $c798dcf018e7056e$var$createFrame(parts[5], parts[3] || parts[4] || $c798dcf018e7056e$var$UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};
const $c798dcf018e7056e$export$af11af13f09fb0dc = [
    $c798dcf018e7056e$var$OPERA11_PRIORITY,
    $c798dcf018e7056e$var$opera11
];
const $c798dcf018e7056e$export$7197c0fe6554c079 = [
    $c798dcf018e7056e$export$263a749fff749872,
    $c798dcf018e7056e$export$cdba47a5dd2804d,
    $c798dcf018e7056e$export$179460296da408e8
];
const $c798dcf018e7056e$export$2b2b997d81bf3907 = (0, $jVtDJ.createStackParser)(...$c798dcf018e7056e$export$7197c0fe6554c079);
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ const $c798dcf018e7056e$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf('safari-extension') !== -1;
    const isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf('@') !== -1 ? func.split('@')[0] : $c798dcf018e7056e$var$UNKNOWN_FUNCTION,
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};

});

parcelRegister("5kOsg", function(module, exports) {

$parcel$export(module.exports, "defaultIntegrations", () => $3e25f54e4eacbf58$export$5ef831fccfce35e5);
$parcel$export(module.exports, "getDefaultIntegrations", () => $3e25f54e4eacbf58$export$5783b2920b1d62b9);
$parcel$export(module.exports, "init", () => $3e25f54e4eacbf58$export$2cd8252107eb640b);
$parcel$export(module.exports, "showReportDialog", () => $3e25f54e4eacbf58$export$3a8fd680da42627b);
$parcel$export(module.exports, "forceLoad", () => $3e25f54e4eacbf58$export$a3f323d81eede727);
$parcel$export(module.exports, "onLoad", () => $3e25f54e4eacbf58$export$4e4d8b287d028b6b);
$parcel$export(module.exports, "wrap", () => $3e25f54e4eacbf58$export$4997ffc0176396a6);
$parcel$export(module.exports, "captureUserFeedback", () => $3e25f54e4eacbf58$export$88cefaf72d1e58a3);

var $fq71H = parcelRequire("fq71H");
var $hJxS5 = parcelRequire("hJxS5");
var $egVmm = parcelRequire("egVmm");
var $6emiv = parcelRequire("6emiv");
var $1UtEE = parcelRequire("1UtEE");
var $lQehn = parcelRequire("lQehn");
var $4tdNk = parcelRequire("4tdNk");

var $bCTfk = parcelRequire("bCTfk");
var $lN8pX = parcelRequire("lN8pX");
var $jVtDJ = parcelRequire("jVtDJ");
var $4Dtr4 = parcelRequire("4Dtr4");

var $cGpn8 = parcelRequire("cGpn8");

var $70zzf = parcelRequire("70zzf");

var $i8T1U = parcelRequire("i8T1U");

var $7abYO = parcelRequire("7abYO");

var $AU319 = parcelRequire("AU319");

var $aan6Q = parcelRequire("aan6Q");

var $fRQU9 = parcelRequire("fRQU9");

var $5nexQ = parcelRequire("5nexQ");

var $bDzZk = parcelRequire("bDzZk");

var $h8rWQ = parcelRequire("h8rWQ");

var $2pZps = parcelRequire("2pZps");

var $ecgG4 = parcelRequire("ecgG4");
/** @deprecated Use `getDefaultIntegrations(options)` instead. */ const $3e25f54e4eacbf58$export$5ef831fccfce35e5 = [
    (0, $lQehn.inboundFiltersIntegration)(),
    (0, $hJxS5.functionToStringIntegration)(),
    (0, $bDzZk.browserApiErrorsIntegration)(),
    (0, $7abYO.breadcrumbsIntegration)(),
    (0, $aan6Q.globalHandlersIntegration)(),
    (0, $5nexQ.linkedErrorsIntegration)(),
    (0, $AU319.dedupeIntegration)(),
    (0, $fRQU9.httpContextIntegration)()
];
/** Get the default integrations for the browser SDK. */ function $3e25f54e4eacbf58$export$5783b2920b1d62b9(_options) {
    // We return a copy of the defaultIntegrations here to avoid mutating this
    return [
        // eslint-disable-next-line deprecation/deprecation
        ...$3e25f54e4eacbf58$export$5ef831fccfce35e5
    ];
}
/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { configureScope } from '@sentry/browser';
 * configureScope((scope: Scope) => {
 *   scope.setExtra({ battery: 0.7 });
 *   scope.setTag({ user_mode: 'admin' });
 *   scope.setUser({ id: '4711' });
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */ function $3e25f54e4eacbf58$export$2cd8252107eb640b(options = {}) {
    if (options.defaultIntegrations === undefined) options.defaultIntegrations = $3e25f54e4eacbf58$export$5783b2920b1d62b9();
    if (options.release === undefined) {
        // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
        if (typeof __SENTRY_RELEASE__ === 'string') options.release = __SENTRY_RELEASE__;
        // This supports the variable that sentry-webpack-plugin injects
        if ((0, $i8T1U.WINDOW).SENTRY_RELEASE && (0, $i8T1U.WINDOW).SENTRY_RELEASE.id) options.release = (0, $i8T1U.WINDOW).SENTRY_RELEASE.id;
    }
    if (options.autoSessionTracking === undefined) options.autoSessionTracking = true;
    if (options.sendClientReports === undefined) options.sendClientReports = true;
    const clientOptions = {
        ...options,
        stackParser: (0, $jVtDJ.stackParserFromStackParserOptions)(options.stackParser || (0, $h8rWQ.defaultStackParser)),
        integrations: (0, $6emiv.getIntegrationsToSetup)(options),
        transport: options.transport || ((0, $4Dtr4.supportsFetch)() ? (0, $2pZps.makeFetchTransport) : (0, $ecgG4.makeXHRTransport))
    };
    (0, $4tdNk.initAndBind)((0, $cGpn8.BrowserClient), clientOptions);
    if (options.autoSessionTracking) $3e25f54e4eacbf58$var$startSessionTracking();
}
const $3e25f54e4eacbf58$export$3a8fd680da42627b = (// eslint-disable-next-line deprecation/deprecation
options = {}, // eslint-disable-next-line deprecation/deprecation
hub = (0, $egVmm.getCurrentHub)())=>{
    // doesn't work without a document (React Native)
    if (!(0, $i8T1U.WINDOW).document) {
        (0, $70zzf.DEBUG_BUILD) && (0, $lN8pX.logger).error('Global document not defined in showReportDialog call');
        return;
    }
    // eslint-disable-next-line deprecation/deprecation
    const { client: client, scope: scope } = hub.getStackTop();
    const dsn = options.dsn || client && client.getDsn();
    if (!dsn) {
        (0, $70zzf.DEBUG_BUILD) && (0, $lN8pX.logger).error('DSN not configured for showReportDialog call');
        return;
    }
    if (scope) options.user = {
        ...scope.getUser(),
        ...options.user
    };
    if (!options.eventId) // eslint-disable-next-line deprecation/deprecation
    options.eventId = hub.lastEventId();
    const script = (0, $i8T1U.WINDOW).document.createElement('script');
    script.async = true;
    script.crossOrigin = 'anonymous';
    script.src = (0, $1UtEE.getReportDialogEndpoint)(dsn, options);
    if (options.onLoad) script.onload = options.onLoad;
    const { onClose: onClose } = options;
    if (onClose) {
        const reportDialogClosedMessageHandler = (event)=>{
            if (event.data === '__sentry_reportdialog_closed__') try {
                onClose();
            } finally{
                (0, $i8T1U.WINDOW).removeEventListener('message', reportDialogClosedMessageHandler);
            }
        };
        (0, $i8T1U.WINDOW).addEventListener('message', reportDialogClosedMessageHandler);
    }
    const injectionPoint = (0, $i8T1U.WINDOW).document.head || (0, $i8T1U.WINDOW).document.body;
    if (injectionPoint) injectionPoint.appendChild(script);
    else (0, $70zzf.DEBUG_BUILD) && (0, $lN8pX.logger).error('Not injecting report dialog. No injection point found in HTML');
};
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $3e25f54e4eacbf58$export$a3f323d81eede727() {
// Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $3e25f54e4eacbf58$export$4e4d8b287d028b6b(callback) {
    callback();
}
/**
 * Wrap code within a try/catch block so the SDK is able to capture errors.
 *
 * @deprecated This function will be removed in v8.
 * It is not part of Sentry's official API and it's easily replaceable by using a try/catch block
 * and calling Sentry.captureException.
 *
 * @param fn A function to wrap.
 *
 * @returns The result of wrapped function call.
 */ // TODO(v8): Remove this function
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $3e25f54e4eacbf58$export$4997ffc0176396a6(fn) {
    return (0, $i8T1U.wrap)(fn)();
}
/**
 * Enable automatic Session Tracking for the initial page load.
 */ function $3e25f54e4eacbf58$var$startSessionTracking() {
    if (typeof (0, $i8T1U.WINDOW).document === 'undefined') {
        (0, $70zzf.DEBUG_BUILD) && (0, $lN8pX.logger).warn('Session tracking in non-browser environment with @sentry/browser is not supported.');
        return;
    }
    // The session duration for browser sessions does not track a meaningful
    // concept that can be used as a metric.
    // Automatically captured sessions are akin to page views, and thus we
    // discard their duration.
    (0, $fq71H.startSession)({
        ignoreDuration: true
    });
    (0, $fq71H.captureSession)();
    // We want to create a session for every navigation as well
    (0, $bCTfk.addHistoryInstrumentationHandler)(({ from: from, to: to })=>{
        // Don't create an additional session for the initial route or if the location did not change
        if (from !== undefined && from !== to) {
            (0, $fq71H.startSession)({
                ignoreDuration: true
            });
            (0, $fq71H.captureSession)();
        }
    });
}
/**
 * Captures user feedback and sends it to Sentry.
 */ function $3e25f54e4eacbf58$export$88cefaf72d1e58a3(feedback) {
    const client = (0, $fq71H.getClient)();
    if (client) client.captureUserFeedback(feedback);
}

});
parcelRegister("bCTfk", function(module, exports) {

$parcel$export(module.exports, "addHistoryInstrumentationHandler", () => $876e19115cc4f5c8$export$3f18c56c58114e75);

var $aLrZa = parcelRequire("aLrZa");



var $4mb67 = parcelRequire("4mb67");

var $j8c9t = parcelRequire("j8c9t");

var $bjmDL = parcelRequire("bjmDL");
const $876e19115cc4f5c8$var$WINDOW = (0, $4mb67.GLOBAL_OBJ);
let $876e19115cc4f5c8$var$lastHref;
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $876e19115cc4f5c8$export$3f18c56c58114e75(handler) {
    const type = 'history';
    (0, $bjmDL.addHandler)(type, handler);
    (0, $bjmDL.maybeInstrument)(type, $876e19115cc4f5c8$var$instrumentHistory);
}
function $876e19115cc4f5c8$var$instrumentHistory() {
    if (!(0, $j8c9t.supportsHistory)()) return;
    const oldOnPopState = $876e19115cc4f5c8$var$WINDOW.onpopstate;
    $876e19115cc4f5c8$var$WINDOW.onpopstate = function(...args) {
        const to = $876e19115cc4f5c8$var$WINDOW.location.href;
        // keep track of the current URL state, as we always receive only the updated state
        const from = $876e19115cc4f5c8$var$lastHref;
        $876e19115cc4f5c8$var$lastHref = to;
        const handlerData = {
            from: from,
            to: to
        };
        (0, $bjmDL.triggerHandlers)('history', handlerData);
        if (oldOnPopState) // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
        // https://github.com/getsentry/sentry-javascript/issues/3344
        // https://github.com/bugsnag/bugsnag-js/issues/469
        try {
            return oldOnPopState.apply(this, args);
        } catch (_oO) {
        // no-empty
        }
    };
    function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                const from = $876e19115cc4f5c8$var$lastHref;
                const to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                $876e19115cc4f5c8$var$lastHref = to;
                const handlerData = {
                    from: from,
                    to: to
                };
                (0, $bjmDL.triggerHandlers)('history', handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $aLrZa.fill)($876e19115cc4f5c8$var$WINDOW.history, 'pushState', historyReplacementFunction);
    (0, $aLrZa.fill)($876e19115cc4f5c8$var$WINDOW.history, 'replaceState', historyReplacementFunction);
}

});
parcelRegister("j8c9t", function(module, exports) {

$parcel$export(module.exports, "supportsHistory", () => $ded830c688dce90d$export$67fc34576016d6ec);

var $4mb67 = parcelRequire("4mb67");
// Based on https://github.com/angular/angular.js/pull/13945/files
// eslint-disable-next-line deprecation/deprecation
const $ded830c688dce90d$var$WINDOW = (0, $4mb67.getGlobalObject)();
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function $ded830c688dce90d$export$67fc34576016d6ec() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const chromeVar = $ded830c688dce90d$var$WINDOW.chrome;
    const isChromePackagedApp = chromeVar && chromeVar.app && chromeVar.app.runtime;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */ const hasHistoryApi = 'history' in $ded830c688dce90d$var$WINDOW && !!$ded830c688dce90d$var$WINDOW.history.pushState && !!$ded830c688dce90d$var$WINDOW.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}

});


parcelRegister("7abYO", function(module, exports) {

$parcel$export(module.exports, "breadcrumbsIntegration", () => $5372c2839a8cf63e$export$c079d904b326663a);
$parcel$export(module.exports, "Breadcrumbs", () => $5372c2839a8cf63e$export$2dc68d50d56fbbd);

var $fq71H = parcelRequire("fq71H");
var $6emiv = parcelRequire("6emiv");

var $e1u3d = parcelRequire("e1u3d");
var $amBmj = parcelRequire("amBmj");
var $8YW3h = parcelRequire("8YW3h");
var $bCTfk = parcelRequire("bCTfk");
var $8UJMm = parcelRequire("8UJMm");
var $3oSFd = parcelRequire("3oSFd");
var $1y8R2 = parcelRequire("1y8R2");
var $lN8pX = parcelRequire("lN8pX");
var $23mcX = parcelRequire("23mcX");
var $jmfnM = parcelRequire("jmfnM");
var $cIgWs = parcelRequire("cIgWs");

var $70zzf = parcelRequire("70zzf");

var $i8T1U = parcelRequire("i8T1U");
/* eslint-disable max-lines */ /** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */ const $5372c2839a8cf63e$var$MAX_ALLOWED_STRING_LENGTH = 1024;
const $5372c2839a8cf63e$var$INTEGRATION_NAME = 'Breadcrumbs';
const $5372c2839a8cf63e$var$_breadcrumbsIntegration = (options = {})=>{
    const _options = {
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true,
        ...options
    };
    return {
        name: $5372c2839a8cf63e$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        setup (client) {
            if (_options.console) (0, $amBmj.addConsoleInstrumentationHandler)($5372c2839a8cf63e$var$_getConsoleBreadcrumbHandler(client));
            if (_options.dom) (0, $e1u3d.addClickKeypressInstrumentationHandler)($5372c2839a8cf63e$var$_getDomBreadcrumbHandler(client, _options.dom));
            if (_options.xhr) (0, $8UJMm.addXhrInstrumentationHandler)($5372c2839a8cf63e$var$_getXhrBreadcrumbHandler(client));
            if (_options.fetch) (0, $8YW3h.addFetchInstrumentationHandler)($5372c2839a8cf63e$var$_getFetchBreadcrumbHandler(client));
            if (_options.history) (0, $bCTfk.addHistoryInstrumentationHandler)($5372c2839a8cf63e$var$_getHistoryBreadcrumbHandler(client));
            if (_options.sentry && client.on) client.on('beforeSendEvent', $5372c2839a8cf63e$var$_getSentryBreadcrumbHandler(client));
        }
    };
};
const $5372c2839a8cf63e$export$c079d904b326663a = (0, $6emiv.defineIntegration)($5372c2839a8cf63e$var$_breadcrumbsIntegration);
/**
 * Default Breadcrumbs instrumentations
 *
 * @deprecated Use `breadcrumbsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $5372c2839a8cf63e$export$2dc68d50d56fbbd = (0, $6emiv.convertIntegrationFnToClass)($5372c2839a8cf63e$var$INTEGRATION_NAME, $5372c2839a8cf63e$export$c079d904b326663a);
/**
 * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
 */ function $5372c2839a8cf63e$var$_getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0, $fq71H.getClient)() !== client) return;
        (0, $fq71H.addBreadcrumb)({
            category: `sentry.${event.type === 'transaction' ? 'transaction' : 'event'}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, $1y8R2.getEventDescription)(event)
        }, {
            event: event
        });
    };
}
/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ function $5372c2839a8cf63e$var$_getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0, $fq71H.getClient)() !== client) return;
        let target;
        let componentName;
        let keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;
        let maxStringLength = typeof dom === 'object' && typeof dom.maxStringLength === 'number' ? dom.maxStringLength : undefined;
        if (maxStringLength && maxStringLength > $5372c2839a8cf63e$var$MAX_ALLOWED_STRING_LENGTH) {
            (0, $70zzf.DEBUG_BUILD) && (0, $lN8pX.logger).warn(`\`dom.maxStringLength\` cannot exceed ${$5372c2839a8cf63e$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$5372c2839a8cf63e$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $5372c2839a8cf63e$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === 'string') keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            const event = handlerData.event;
            const element = $5372c2839a8cf63e$var$_isEvent(event) ? event.target : event;
            target = (0, $3oSFd.htmlTreeAsString)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0, $3oSFd.getComponentName)(element);
        } catch (e) {
            target = '<unknown>';
        }
        if (target.length === 0) return;
        const breadcrumb = {
            category: `ui.${handlerData.name}`,
            message: target
        };
        if (componentName) breadcrumb.data = {
            'ui.component_name': componentName
        };
        (0, $fq71H.addBreadcrumb)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
/**
 * Creates breadcrumbs from console API calls
 */ function $5372c2839a8cf63e$var$_getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0, $fq71H.getClient)() !== client) return;
        const breadcrumb = {
            category: 'console',
            data: {
                arguments: handlerData.args,
                logger: 'console'
            },
            level: (0, $cIgWs.severityLevelFromString)(handlerData.level),
            message: (0, $jmfnM.safeJoin)(handlerData.args, ' ')
        };
        if (handlerData.level === 'assert') {
            if (handlerData.args[0] === false) {
                breadcrumb.message = `Assertion failed: ${(0, $jmfnM.safeJoin)(handlerData.args.slice(1), ' ') || 'console.assert'}`;
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else // Don't capture a breadcrumb for passed assertions
            return;
        }
        (0, $fq71H.addBreadcrumb)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
/**
 * Creates breadcrumbs from XHR API calls
 */ function $5372c2839a8cf63e$var$_getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0, $fq71H.getClient)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        const sentryXhrData = handlerData.xhr[0, $8UJMm.SENTRY_XHR_DATA_KEY];
        // We only capture complete, non-sentry requests
        if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
        const { method: method, url: url, status_code: status_code, body: body } = sentryXhrData;
        const data = {
            method: method,
            url: url,
            status_code: status_code
        };
        const hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        (0, $fq71H.addBreadcrumb)({
            category: 'xhr',
            data: data,
            type: 'http'
        }, hint);
    };
}
/**
 * Creates breadcrumbs from fetch API calls
 */ function $5372c2839a8cf63e$var$_getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0, $fq71H.getClient)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        // We only capture complete fetch requests
        if (!endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
        return;
        if (handlerData.error) {
            const data = handlerData.fetchData;
            const hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0, $fq71H.addBreadcrumb)({
                category: 'fetch',
                data: data,
                level: 'error',
                type: 'http'
            }, hint);
        } else {
            const response = handlerData.response;
            const data = {
                ...handlerData.fetchData,
                status_code: response && response.status
            };
            const hint = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0, $fq71H.addBreadcrumb)({
                category: 'fetch',
                data: data,
                type: 'http'
            }, hint);
        }
    };
}
/**
 * Creates breadcrumbs from history API calls
 */ function $5372c2839a8cf63e$var$_getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0, $fq71H.getClient)() !== client) return;
        let from = handlerData.from;
        let to = handlerData.to;
        const parsedLoc = (0, $23mcX.parseUrl)((0, $i8T1U.WINDOW).location.href);
        let parsedFrom = from ? (0, $23mcX.parseUrl)(from) : undefined;
        const parsedTo = (0, $23mcX.parseUrl)(to);
        // Initial pushState doesn't provide `from` information
        if (!parsedFrom || !parsedFrom.path) parsedFrom = parsedLoc;
        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, $fq71H.addBreadcrumb)({
            category: 'navigation',
            data: {
                from: from,
                to: to
            }
        });
    };
}
function $5372c2839a8cf63e$var$_isEvent(event) {
    return !!event && !!event.target;
}

});
parcelRegister("e1u3d", function(module, exports) {

$parcel$export(module.exports, "addClickKeypressInstrumentationHandler", () => $a3587827b7ffd6e6$export$5aeffd3db2cf9df7);

var $1y8R2 = parcelRequire("1y8R2");

var $aLrZa = parcelRequire("aLrZa");

var $4mb67 = parcelRequire("4mb67");

var $bjmDL = parcelRequire("bjmDL");
const $a3587827b7ffd6e6$var$WINDOW = (0, $4mb67.GLOBAL_OBJ);
const $a3587827b7ffd6e6$var$DEBOUNCE_DURATION = 1000;
let $a3587827b7ffd6e6$var$debounceTimerID;
let $a3587827b7ffd6e6$var$lastCapturedEventType;
let $a3587827b7ffd6e6$var$lastCapturedEventTargetId;
/**
 * Add an instrumentation handler for when a click or a keypress happens.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $a3587827b7ffd6e6$export$5aeffd3db2cf9df7(handler) {
    const type = 'dom';
    (0, $bjmDL.addHandler)(type, handler);
    (0, $bjmDL.maybeInstrument)(type, $a3587827b7ffd6e6$export$3014bbf0af0e1d4a);
}
/** Exported for tests only. */ function $a3587827b7ffd6e6$export$3014bbf0af0e1d4a() {
    if (!$a3587827b7ffd6e6$var$WINDOW.document) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    const triggerDOMHandler = (0, $bjmDL.triggerHandlers).bind(null, 'dom');
    const globalDOMEventHandler = $a3587827b7ffd6e6$var$makeDOMEventHandler(triggerDOMHandler, true);
    $a3587827b7ffd6e6$var$WINDOW.document.addEventListener('click', globalDOMEventHandler, false);
    $a3587827b7ffd6e6$var$WINDOW.document.addEventListener('keypress', globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        'EventTarget',
        'Node'
    ].forEach((target)=>{
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        const proto = $a3587827b7ffd6e6$var$WINDOW[target] && $a3587827b7ffd6e6$var$WINDOW[target].prototype;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) return;
        (0, $aLrZa.fill)(proto, 'addEventListener', function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $a3587827b7ffd6e6$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $aLrZa.fill)(proto, 'removeEventListener', function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers).length === 0) delete el.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
/**
 * Check whether the event is similar to the last captured one. For example, two click events on the same button.
 */ function $a3587827b7ffd6e6$var$isSimilarToLastCapturedEvent(event) {
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (event.type !== $a3587827b7ffd6e6$var$lastCapturedEventType) return false;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (!event.target || event.target._sentryId !== $a3587827b7ffd6e6$var$lastCapturedEventTargetId) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return true;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $a3587827b7ffd6e6$var$shouldSkipDOMEvent(eventType, target) {
    // We are only interested in filtering `keypress` events for now.
    if (eventType !== 'keypress') return false;
    if (!target || !target.tagName) return true;
    // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
    // e.g.tabbing through elements, hotkeys, etc.
    if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) return false;
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 */ function $a3587827b7ffd6e6$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || event['_sentryCaptured']) return;
        const target = $a3587827b7ffd6e6$var$getEventTarget(event);
        // We always want to skip _some_ events.
        if ($a3587827b7ffd6e6$var$shouldSkipDOMEvent(event.type, target)) return;
        // Mark event as "seen"
        (0, $aLrZa.addNonEnumerableProperty)(event, '_sentryCaptured', true);
        if (target && !target._sentryId) // Add UUID to event target so we can identify if
        (0, $aLrZa.addNonEnumerableProperty)(target, '_sentryId', (0, $1y8R2.uuid4)());
        const name = event.type === 'keypress' ? 'input' : event.type;
        // If there is no last captured event, it means that we can safely capture the new event and store it for future comparisons.
        // If there is a last captured event, see if the new event is different enough to treat it as a unique one.
        // If that's the case, emit the previous event and store locally the newly-captured DOM event.
        if (!$a3587827b7ffd6e6$var$isSimilarToLastCapturedEvent(event)) {
            const handlerData = {
                event: event,
                name: name,
                global: globalListener
            };
            handler(handlerData);
            $a3587827b7ffd6e6$var$lastCapturedEventType = event.type;
            $a3587827b7ffd6e6$var$lastCapturedEventTargetId = target ? target._sentryId : undefined;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($a3587827b7ffd6e6$var$debounceTimerID);
        $a3587827b7ffd6e6$var$debounceTimerID = $a3587827b7ffd6e6$var$WINDOW.setTimeout(()=>{
            $a3587827b7ffd6e6$var$lastCapturedEventTargetId = undefined;
            $a3587827b7ffd6e6$var$lastCapturedEventType = undefined;
        }, $a3587827b7ffd6e6$var$DEBOUNCE_DURATION);
    };
}
function $a3587827b7ffd6e6$var$getEventTarget(event) {
    try {
        return event.target;
    } catch (e) {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
        return null;
    }
}

});

parcelRegister("amBmj", function(module, exports) {

$parcel$export(module.exports, "addConsoleInstrumentationHandler", () => $78b8f0255e60ba4f$export$1d6e0d073f9e6723);

var $lN8pX = parcelRequire("lN8pX");

var $aLrZa = parcelRequire("aLrZa");

var $4mb67 = parcelRequire("4mb67");

var $bjmDL = parcelRequire("bjmDL");
/**
 * Add an instrumentation handler for when a console.xxx method is called.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $78b8f0255e60ba4f$export$1d6e0d073f9e6723(handler) {
    const type = 'console';
    (0, $bjmDL.addHandler)(type, handler);
    (0, $bjmDL.maybeInstrument)(type, $78b8f0255e60ba4f$var$instrumentConsole);
}
function $78b8f0255e60ba4f$var$instrumentConsole() {
    if (!('console' in (0, $4mb67.GLOBAL_OBJ))) return;
    (0, $lN8pX.CONSOLE_LEVELS).forEach(function(level) {
        if (!(level in (0, $4mb67.GLOBAL_OBJ).console)) return;
        (0, $aLrZa.fill)((0, $4mb67.GLOBAL_OBJ).console, level, function(originalConsoleMethod) {
            (0, $lN8pX.originalConsoleMethods)[level] = originalConsoleMethod;
            return function(...args) {
                const handlerData = {
                    args: args,
                    level: level
                };
                (0, $bjmDL.triggerHandlers)('console', handlerData);
                const log = (0, $lN8pX.originalConsoleMethods)[level];
                log && log.apply((0, $4mb67.GLOBAL_OBJ).console, args);
            };
        });
    });
}

});

parcelRegister("8YW3h", function(module, exports) {

$parcel$export(module.exports, "addFetchInstrumentationHandler", () => $68a0f537a6b313d4$export$f75d3c772c923df0);

var $aLrZa = parcelRequire("aLrZa");

var $4Dtr4 = parcelRequire("4Dtr4");

var $4mb67 = parcelRequire("4mb67");

var $bjmDL = parcelRequire("bjmDL");
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $68a0f537a6b313d4$export$f75d3c772c923df0(handler) {
    const type = 'fetch';
    (0, $bjmDL.addHandler)(type, handler);
    (0, $bjmDL.maybeInstrument)(type, $68a0f537a6b313d4$var$instrumentFetch);
}
function $68a0f537a6b313d4$var$instrumentFetch() {
    if (!(0, $4Dtr4.supportsNativeFetch)()) return;
    (0, $aLrZa.fill)((0, $4mb67.GLOBAL_OBJ), 'fetch', function(originalFetch) {
        return function(...args) {
            const { method: method, url: url } = $68a0f537a6b313d4$export$f7a71163cc309d9a(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: Date.now()
            };
            (0, $bjmDL.triggerHandlers)('fetch', {
                ...handlerData
            });
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply((0, $4mb67.GLOBAL_OBJ), args).then((response)=>{
                const finishedHandlerData = {
                    ...handlerData,
                    endTimestamp: Date.now(),
                    response: response
                };
                (0, $bjmDL.triggerHandlers)('fetch', finishedHandlerData);
                return response;
            }, (error)=>{
                const erroredHandlerData = {
                    ...handlerData,
                    endTimestamp: Date.now(),
                    error: error
                };
                (0, $bjmDL.triggerHandlers)('fetch', erroredHandlerData);
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
function $68a0f537a6b313d4$var$hasProp(obj, prop) {
    return !!obj && typeof obj === 'object' && !!obj[prop];
}
function $68a0f537a6b313d4$var$getUrlFromResource(resource) {
    if (typeof resource === 'string') return resource;
    if (!resource) return '';
    if ($68a0f537a6b313d4$var$hasProp(resource, 'url')) return resource.url;
    if (resource.toString) return resource.toString();
    return '';
}
/**
 * Parses the fetch arguments to find the used Http method and the url of the request.
 * Exported for tests only.
 */ function $68a0f537a6b313d4$export$f7a71163cc309d9a(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: 'GET',
        url: ''
    };
    if (fetchArgs.length === 2) {
        const [url, options] = fetchArgs;
        return {
            url: $68a0f537a6b313d4$var$getUrlFromResource(url),
            method: $68a0f537a6b313d4$var$hasProp(options, 'method') ? String(options.method).toUpperCase() : 'GET'
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $68a0f537a6b313d4$var$getUrlFromResource(arg),
        method: $68a0f537a6b313d4$var$hasProp(arg, 'method') ? String(arg.method).toUpperCase() : 'GET'
    };
}

});

parcelRegister("8UJMm", function(module, exports) {

$parcel$export(module.exports, "SENTRY_XHR_DATA_KEY", () => $67d7106dab0b5446$export$55b6bb1e45c6cf59);
$parcel$export(module.exports, "addXhrInstrumentationHandler", () => $67d7106dab0b5446$export$26ace48dd54c9aea);

var $dlAFs = parcelRequire("dlAFs");

var $aLrZa = parcelRequire("aLrZa");

var $4mb67 = parcelRequire("4mb67");

var $bjmDL = parcelRequire("bjmDL");
const $67d7106dab0b5446$var$WINDOW = (0, $4mb67.GLOBAL_OBJ);
const $67d7106dab0b5446$export$55b6bb1e45c6cf59 = '__sentry_xhr_v3__';
/**
 * Add an instrumentation handler for when an XHR request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $67d7106dab0b5446$export$26ace48dd54c9aea(handler) {
    const type = 'xhr';
    (0, $bjmDL.addHandler)(type, handler);
    (0, $bjmDL.maybeInstrument)(type, $67d7106dab0b5446$export$c67d533bf77cbf54);
}
/** Exported only for tests. */ function $67d7106dab0b5446$export$c67d533bf77cbf54() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (!$67d7106dab0b5446$var$WINDOW.XMLHttpRequest) return;
    const xhrproto = XMLHttpRequest.prototype;
    (0, $aLrZa.fill)(xhrproto, 'open', function(originalOpen) {
        return function(...args) {
            const startTimestamp = Date.now();
            // open() should always be called with two or more arguments
            // But to be on the safe side, we actually validate this and bail out if we don't have a method & url
            const method = (0, $dlAFs.isString)(args[0]) ? args[0].toUpperCase() : undefined;
            const url = $67d7106dab0b5446$var$parseUrl(args[1]);
            if (!method || !url) return originalOpen.apply(this, args);
            this[$67d7106dab0b5446$export$55b6bb1e45c6cf59] = {
                method: method,
                url: url,
                request_headers: {}
            };
            // if Sentry key appears in URL, don't capture it as a request
            if (method === 'POST' && url.match(/sentry_key/)) this.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                // For whatever reason, this is not the same instance here as from the outer method
                const xhrInfo = this[$67d7106dab0b5446$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (this.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = this.status;
                    } catch (e) {
                    /* do nothing */ }
                    const handlerData = {
                        args: [
                            method,
                            url
                        ],
                        endTimestamp: Date.now(),
                        startTimestamp: startTimestamp,
                        xhr: this
                    };
                    (0, $bjmDL.triggerHandlers)('xhr', handlerData);
                }
            };
            if ('onreadystatechange' in this && typeof this.onreadystatechange === 'function') (0, $aLrZa.fill)(this, 'onreadystatechange', function(original) {
                return function(...readyStateArgs) {
                    onreadystatechangeHandler();
                    return original.apply(this, readyStateArgs);
                };
            });
            else this.addEventListener('readystatechange', onreadystatechangeHandler);
            // Intercepting `setRequestHeader` to access the request headers of XHR instance.
            // This will only work for user/library defined headers, not for the default/browser-assigned headers.
            // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
            (0, $aLrZa.fill)(this, 'setRequestHeader', function(original) {
                return function(...setRequestHeaderArgs) {
                    const [header, value] = setRequestHeaderArgs;
                    const xhrInfo = this[$67d7106dab0b5446$export$55b6bb1e45c6cf59];
                    if (xhrInfo && (0, $dlAFs.isString)(header) && (0, $dlAFs.isString)(value)) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return original.apply(this, setRequestHeaderArgs);
                };
            });
            return originalOpen.apply(this, args);
        };
    });
    (0, $aLrZa.fill)(xhrproto, 'send', function(originalSend) {
        return function(...args) {
            const sentryXhrData = this[$67d7106dab0b5446$export$55b6bb1e45c6cf59];
            if (!sentryXhrData) return originalSend.apply(this, args);
            if (args[0] !== undefined) sentryXhrData.body = args[0];
            const handlerData = {
                args: [
                    sentryXhrData.method,
                    sentryXhrData.url
                ],
                startTimestamp: Date.now(),
                xhr: this
            };
            (0, $bjmDL.triggerHandlers)('xhr', handlerData);
            return originalSend.apply(this, args);
        };
    });
}
function $67d7106dab0b5446$var$parseUrl(url) {
    if ((0, $dlAFs.isString)(url)) return url;
    try {
        // url can be a string or URL
        // but since URL is not available in IE11, we do not check for it,
        // but simply assume it is an URL and return `toString()` from it (which returns the full URL)
        // If that fails, we just return undefined
        return url.toString();
    } catch (e2) {} // eslint-disable-line no-empty
    return undefined;
}

});

parcelRegister("23mcX", function(module, exports) {

$parcel$export(module.exports, "parseUrl", () => $17ed16a5b1af16fa$export$7a5253c0f62e0150);
$parcel$export(module.exports, "stripUrlQueryAndFragment", () => $17ed16a5b1af16fa$export$ce084c78234bd35);
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function $17ed16a5b1af16fa$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    const query = match[6] || '';
    const fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function $17ed16a5b1af16fa$export$ce084c78234bd35(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
/**
 * Returns number of URL segments of a passed string URL.
 */ function $17ed16a5b1af16fa$export$69dd85280a8d374c(url) {
    // split at '/' or at '\/' to split regex urls correctly
    return url.split(/\\?\//).filter((s)=>s.length > 0 && s !== ',').length;
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span description
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $17ed16a5b1af16fa$export$e0ba26c9e23e1fe0(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host && host// Always filter out authority
    .replace(/^.*@/, '[filtered]:[filtered]@')// Don't show standard :80 (http) and :443 (https) ports to reduce the noise
    // TODO: Use new URL global if it exists
    .replace(/(:80)$/, '').replace(/(:443)$/, '') || '';
    return `${protocol ? `${protocol}://` : ''}${filteredHost}${path}`;
}

});

parcelRegister("cIgWs", function(module, exports) {

$parcel$export(module.exports, "severityLevelFromString", () => $9416bc60c73369a1$export$d771ef054122c30a);
// Note: Ideally the `SeverityLevel` type would be derived from `validSeverityLevels`, but that would mean either
//
// a) moving `validSeverityLevels` to `@sentry/types`,
// b) moving the`SeverityLevel` type here, or
// c) importing `validSeverityLevels` from here into `@sentry/types`.
//
// Option A would make `@sentry/types` a runtime dependency of `@sentry/utils` (not good), and options B and C would
// create a circular dependency between `@sentry/types` and `@sentry/utils` (also not good). So a TODO accompanying the
// type, reminding anyone who changes it to change this list also, will have to do.
const $9416bc60c73369a1$export$411d0ffdba845b6c = [
    'fatal',
    'error',
    'warning',
    'log',
    'info',
    'debug'
];
/**
 * Converts a string-based level into a member of the deprecated {@link Severity} enum.
 *
 * @deprecated `severityFromString` is deprecated. Please use `severityLevelFromString` instead.
 *
 * @param level String representation of Severity
 * @returns Severity
 */ function $9416bc60c73369a1$export$e01cef29b4327697(level) {
    return $9416bc60c73369a1$export$d771ef054122c30a(level);
}
/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */ function $9416bc60c73369a1$export$d771ef054122c30a(level) {
    return level === 'warn' ? 'warning' : $9416bc60c73369a1$export$411d0ffdba845b6c.includes(level) ? level : 'log';
}

});


parcelRegister("AU319", function(module, exports) {

$parcel$export(module.exports, "dedupeIntegration", () => $06eed6cebae65797$export$6d39aa44cd0c7567);
$parcel$export(module.exports, "Dedupe", () => $06eed6cebae65797$export$688d98c249d31ad3);

var $6emiv = parcelRequire("6emiv");

var $lN8pX = parcelRequire("lN8pX");

var $70zzf = parcelRequire("70zzf");
const $06eed6cebae65797$var$INTEGRATION_NAME = 'Dedupe';
const $06eed6cebae65797$var$_dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: $06eed6cebae65797$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        processEvent (currentEvent) {
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) return currentEvent;
            // Juuust in case something goes wrong
            try {
                if ($06eed6cebae65797$var$_shouldDropEvent(currentEvent, previousEvent)) {
                    (0, $70zzf.DEBUG_BUILD) && (0, $lN8pX.logger).warn('Event dropped due to being a duplicate of previously captured event.');
                    return null;
                }
            } catch (_oO) {} // eslint-disable-line no-empty
            return previousEvent = currentEvent;
        }
    };
};
const $06eed6cebae65797$export$6d39aa44cd0c7567 = (0, $6emiv.defineIntegration)($06eed6cebae65797$var$_dedupeIntegration);
/**
 * Deduplication filter.
 * @deprecated Use `dedupeIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $06eed6cebae65797$export$688d98c249d31ad3 = (0, $6emiv.convertIntegrationFnToClass)($06eed6cebae65797$var$INTEGRATION_NAME, $06eed6cebae65797$export$6d39aa44cd0c7567);
function $06eed6cebae65797$var$_shouldDropEvent(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($06eed6cebae65797$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($06eed6cebae65797$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $06eed6cebae65797$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$06eed6cebae65797$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$06eed6cebae65797$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $06eed6cebae65797$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $06eed6cebae65797$var$_getExceptionFromEvent(previousEvent);
    const currentException = $06eed6cebae65797$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$06eed6cebae65797$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$06eed6cebae65797$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $06eed6cebae65797$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = $06eed6cebae65797$var$_getFramesFromEvent(currentEvent);
    let previousFrames = $06eed6cebae65797$var$_getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(let i = 0; i < previousFrames.length; i++){
        const frameA = previousFrames[i];
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $06eed6cebae65797$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    } catch (_oO) {
        return false;
    }
}
function $06eed6cebae65797$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
function $06eed6cebae65797$var$_getFramesFromEvent(event) {
    const exception = event.exception;
    if (exception) try {
        // @ts-expect-error Object could be undefined
        return exception.values[0].stacktrace.frames;
    } catch (_oO) {
        return undefined;
    }
    return undefined;
}

});

parcelRegister("aan6Q", function(module, exports) {

$parcel$export(module.exports, "globalHandlersIntegration", () => $766cc3938e192305$export$66acc70e8cf2b71a);
$parcel$export(module.exports, "GlobalHandlers", () => $766cc3938e192305$export$204155decbc90e5a);

var $fq71H = parcelRequire("fq71H");
var $6emiv = parcelRequire("6emiv");

var $7hreB = parcelRequire("7hreB");
var $aeUoj = parcelRequire("aeUoj");
var $3oSFd = parcelRequire("3oSFd");
var $dlAFs = parcelRequire("dlAFs");
var $lN8pX = parcelRequire("lN8pX");

var $70zzf = parcelRequire("70zzf");

var $g9ymE = parcelRequire("g9ymE");

var $i8T1U = parcelRequire("i8T1U");
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ const $766cc3938e192305$var$INTEGRATION_NAME = 'GlobalHandlers';
const $766cc3938e192305$var$_globalHandlersIntegration = (options = {})=>{
    const _options = {
        onerror: true,
        onunhandledrejection: true,
        ...options
    };
    return {
        name: $766cc3938e192305$var$INTEGRATION_NAME,
        setupOnce () {
            Error.stackTraceLimit = 50;
        },
        setup (client) {
            if (_options.onerror) {
                $766cc3938e192305$var$_installGlobalOnErrorHandler(client);
                $766cc3938e192305$var$globalHandlerLog('onerror');
            }
            if (_options.onunhandledrejection) {
                $766cc3938e192305$var$_installGlobalOnUnhandledRejectionHandler(client);
                $766cc3938e192305$var$globalHandlerLog('onunhandledrejection');
            }
        }
    };
};
const $766cc3938e192305$export$66acc70e8cf2b71a = (0, $6emiv.defineIntegration)($766cc3938e192305$var$_globalHandlersIntegration);
/**
 * Global handlers.
 * @deprecated Use `globalHandlersIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $766cc3938e192305$export$204155decbc90e5a = (0, $6emiv.convertIntegrationFnToClass)($766cc3938e192305$var$INTEGRATION_NAME, $766cc3938e192305$export$66acc70e8cf2b71a);
function $766cc3938e192305$var$_installGlobalOnErrorHandler(client) {
    (0, $7hreB.addGlobalErrorInstrumentationHandler)((data)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $766cc3938e192305$var$getOptions();
        if ((0, $fq71H.getClient)() !== client || (0, $i8T1U.shouldIgnoreOnError)()) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        const event = error === undefined && (0, $dlAFs.isString)(msg) ? $766cc3938e192305$var$_eventFromIncompleteOnError(msg, url, line, column) : $766cc3938e192305$var$_enhanceEventWithInitialFrame((0, $g9ymE.eventFromUnknownInput)(stackParser, error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = 'error';
        (0, $fq71H.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'onerror'
            }
        });
    });
}
function $766cc3938e192305$var$_installGlobalOnUnhandledRejectionHandler(client) {
    (0, $aeUoj.addGlobalUnhandledRejectionInstrumentationHandler)((e)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $766cc3938e192305$var$getOptions();
        if ((0, $fq71H.getClient)() !== client || (0, $i8T1U.shouldIgnoreOnError)()) return;
        const error = $766cc3938e192305$var$_getUnhandledRejectionError(e);
        const event = (0, $dlAFs.isPrimitive)(error) ? $766cc3938e192305$var$_eventFromRejectionWithPrimitive(error) : (0, $g9ymE.eventFromUnknownInput)(stackParser, error, undefined, attachStacktrace, true);
        event.level = 'error';
        (0, $fq71H.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'onunhandledrejection'
            }
        });
    });
}
function $766cc3938e192305$var$_getUnhandledRejectionError(error) {
    if ((0, $dlAFs.isPrimitive)(error)) return error;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const e = error;
    // dig the object of the rejection out of known event types
    try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ('reason' in e) return e.reason;
        else if ('detail' in e && 'reason' in e.detail) return e.detail.reason;
    } catch (e2) {} // eslint-disable-line no-empty
    return error;
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $766cc3938e192305$var$_eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: 'UnhandledRejection',
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
/**
 * This function creates a stack from an old, error-less onerror handler.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $766cc3938e192305$var$_eventFromIncompleteOnError(msg, url, line, column) {
    const ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
    // If 'message' is ErrorEvent, get real message from inside
    let message = (0, $dlAFs.isErrorEvent)(msg) ? msg.message : msg;
    let name = 'Error';
    const groups = message.match(ERROR_TYPES_RE);
    if (groups) {
        name = groups[1];
        message = groups[2];
    }
    const event = {
        exception: {
            values: [
                {
                    type: name,
                    value: message
                }
            ]
        }
    };
    return $766cc3938e192305$var$_enhanceEventWithInitialFrame(event, url, line, column);
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $766cc3938e192305$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    const e = event.exception = event.exception || {};
    // event.exception.values
    const ev = e.values = e.values || [];
    // event.exception.values[0]
    const ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    const ev0sf = ev0s.frames = ev0s.frames || [];
    const colno = isNaN(parseInt(column, 10)) ? undefined : column;
    const lineno = isNaN(parseInt(line, 10)) ? undefined : line;
    const filename = (0, $dlAFs.isString)(url) && url.length > 0 ? url : (0, $3oSFd.getLocationHref)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: '?',
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $766cc3938e192305$var$globalHandlerLog(type) {
    (0, $70zzf.DEBUG_BUILD) && (0, $lN8pX.logger).log(`Global Handler attached: ${type}`);
}
function $766cc3938e192305$var$getOptions() {
    const client = (0, $fq71H.getClient)();
    const options = client && client.getOptions() || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return options;
}

});

parcelRegister("fRQU9", function(module, exports) {

$parcel$export(module.exports, "httpContextIntegration", () => $b8d4d8080299bc0a$export$1378794447170364);
$parcel$export(module.exports, "HttpContext", () => $b8d4d8080299bc0a$export$5d2ee9a544b09a94);

var $6emiv = parcelRequire("6emiv");

var $i8T1U = parcelRequire("i8T1U");
const $b8d4d8080299bc0a$var$INTEGRATION_NAME = 'HttpContext';
const $b8d4d8080299bc0a$var$_httpContextIntegration = ()=>{
    return {
        name: $b8d4d8080299bc0a$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        preprocessEvent (event) {
            // if none of the information we want exists, don't bother
            if (!(0, $i8T1U.WINDOW).navigator && !(0, $i8T1U.WINDOW).location && !(0, $i8T1U.WINDOW).document) return;
            // grab as much info as exists and add it to the event
            const url = event.request && event.request.url || (0, $i8T1U.WINDOW).location && (0, $i8T1U.WINDOW).location.href;
            const { referrer: referrer } = (0, $i8T1U.WINDOW).document || {};
            const { userAgent: userAgent } = (0, $i8T1U.WINDOW).navigator || {};
            const headers = {
                ...event.request && event.request.headers,
                ...referrer && {
                    Referer: referrer
                },
                ...userAgent && {
                    'User-Agent': userAgent
                }
            };
            const request = {
                ...event.request,
                ...url && {
                    url: url
                },
                headers: headers
            };
            event.request = request;
        }
    };
};
const $b8d4d8080299bc0a$export$1378794447170364 = (0, $6emiv.defineIntegration)($b8d4d8080299bc0a$var$_httpContextIntegration);
/**
 * HttpContext integration collects information about HTTP request headers.
 * @deprecated Use `httpContextIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $b8d4d8080299bc0a$export$5d2ee9a544b09a94 = (0, $6emiv.convertIntegrationFnToClass)($b8d4d8080299bc0a$var$INTEGRATION_NAME, $b8d4d8080299bc0a$export$1378794447170364);

});

parcelRegister("5nexQ", function(module, exports) {

$parcel$export(module.exports, "linkedErrorsIntegration", () => $3e9a620c84ba112f$export$ebabb00eb7f3a395);
$parcel$export(module.exports, "LinkedErrors", () => $3e9a620c84ba112f$export$8d1e60aaf616fb4f);

var $6emiv = parcelRequire("6emiv");

var $k4DCa = parcelRequire("k4DCa");

var $g9ymE = parcelRequire("g9ymE");
const $3e9a620c84ba112f$var$DEFAULT_KEY = 'cause';
const $3e9a620c84ba112f$var$DEFAULT_LIMIT = 5;
const $3e9a620c84ba112f$var$INTEGRATION_NAME = 'LinkedErrors';
const $3e9a620c84ba112f$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $3e9a620c84ba112f$var$DEFAULT_LIMIT;
    const key = options.key || $3e9a620c84ba112f$var$DEFAULT_KEY;
    return {
        name: $3e9a620c84ba112f$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        preprocessEvent (event, hint, client) {
            const options = client.getOptions();
            (0, $k4DCa.applyAggregateErrorsToEvent)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            (0, $g9ymE.exceptionFromError), options.stackParser, options.maxValueLength, key, limit, event, hint);
        }
    };
};
const $3e9a620c84ba112f$export$ebabb00eb7f3a395 = (0, $6emiv.defineIntegration)($3e9a620c84ba112f$var$_linkedErrorsIntegration);
/**
 * Aggregrate linked errors in an event.
 * @deprecated Use `linkedErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $3e9a620c84ba112f$export$8d1e60aaf616fb4f = (0, $6emiv.convertIntegrationFnToClass)($3e9a620c84ba112f$var$INTEGRATION_NAME, $3e9a620c84ba112f$export$ebabb00eb7f3a395);

});

parcelRegister("bDzZk", function(module, exports) {

$parcel$export(module.exports, "browserApiErrorsIntegration", () => $878f40b66b1498b6$export$59bfe9f1c76150e);
$parcel$export(module.exports, "TryCatch", () => $878f40b66b1498b6$export$f1a018517668e6d3);

var $6emiv = parcelRequire("6emiv");

var $aLrZa = parcelRequire("aLrZa");
var $jVtDJ = parcelRequire("jVtDJ");

var $i8T1U = parcelRequire("i8T1U");
const $878f40b66b1498b6$var$DEFAULT_EVENT_TARGET = [
    'EventTarget',
    'Window',
    'Node',
    'ApplicationCache',
    'AudioTrackList',
    'BroadcastChannel',
    'ChannelMergerNode',
    'CryptoOperation',
    'EventSource',
    'FileReader',
    'HTMLUnknownElement',
    'IDBDatabase',
    'IDBRequest',
    'IDBTransaction',
    'KeyOperation',
    'MediaController',
    'MessagePort',
    'ModalWindow',
    'Notification',
    'SVGElementInstance',
    'Screen',
    'SharedWorker',
    'TextTrack',
    'TextTrackCue',
    'TextTrackList',
    'WebSocket',
    'WebSocketWorker',
    'Worker',
    'XMLHttpRequest',
    'XMLHttpRequestEventTarget',
    'XMLHttpRequestUpload'
];
const $878f40b66b1498b6$var$INTEGRATION_NAME = 'TryCatch';
const $878f40b66b1498b6$var$_browserApiErrorsIntegration = (options = {})=>{
    const _options = {
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true,
        ...options
    };
    return {
        name: $878f40b66b1498b6$var$INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce () {
            if (_options.setTimeout) (0, $aLrZa.fill)((0, $i8T1U.WINDOW), 'setTimeout', $878f40b66b1498b6$var$_wrapTimeFunction);
            if (_options.setInterval) (0, $aLrZa.fill)((0, $i8T1U.WINDOW), 'setInterval', $878f40b66b1498b6$var$_wrapTimeFunction);
            if (_options.requestAnimationFrame) (0, $aLrZa.fill)((0, $i8T1U.WINDOW), 'requestAnimationFrame', $878f40b66b1498b6$var$_wrapRAF);
            if (_options.XMLHttpRequest && 'XMLHttpRequest' in (0, $i8T1U.WINDOW)) (0, $aLrZa.fill)(XMLHttpRequest.prototype, 'send', $878f40b66b1498b6$var$_wrapXHR);
            const eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $878f40b66b1498b6$var$DEFAULT_EVENT_TARGET;
                eventTarget.forEach($878f40b66b1498b6$var$_wrapEventTarget);
            }
        }
    };
};
const $878f40b66b1498b6$export$59bfe9f1c76150e = (0, $6emiv.defineIntegration)($878f40b66b1498b6$var$_browserApiErrorsIntegration);
/**
 * Wrap timer functions and event targets to catch errors and provide better meta data.
 * @deprecated Use `browserApiErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $878f40b66b1498b6$export$f1a018517668e6d3 = (0, $6emiv.convertIntegrationFnToClass)($878f40b66b1498b6$var$INTEGRATION_NAME, $878f40b66b1498b6$export$59bfe9f1c76150e);
function $878f40b66b1498b6$var$_wrapTimeFunction(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $i8T1U.wrap)(originalCallback, {
            mechanism: {
                data: {
                    function: (0, $jVtDJ.getFunctionName)(original)
                },
                handled: false,
                type: 'instrument'
            }
        });
        return original.apply(this, args);
    };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $878f40b66b1498b6$var$_wrapRAF(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(callback) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return original.apply(this, [
            (0, $i8T1U.wrap)(callback, {
                mechanism: {
                    data: {
                        function: 'requestAnimationFrame',
                        handler: (0, $jVtDJ.getFunctionName)(original)
                    },
                    handled: false,
                    type: 'instrument'
                }
            })
        ]);
    };
}
function $878f40b66b1498b6$var$_wrapXHR(originalSend) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const xhr = this;
        const xmlHttpRequestProps = [
            'onload',
            'onerror',
            'onprogress',
            'onreadystatechange'
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === 'function') // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $aLrZa.fill)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            function: prop,
                            handler: (0, $jVtDJ.getFunctionName)(original)
                        },
                        handled: false,
                        type: 'instrument'
                    }
                };
                // If Instrument integration has been called before TryCatch, get the name of original function
                const originalFunction = (0, $aLrZa.getOriginalFunction)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $jVtDJ.getFunctionName)(originalFunction);
                // Otherwise wrap directly
                return (0, $i8T1U.wrap)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
function $878f40b66b1498b6$var$_wrapEventTarget(target) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const globalObject = (0, $i8T1U.WINDOW);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const proto = globalObject[target] && globalObject[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) return;
    (0, $aLrZa.fill)(proto, 'addEventListener', function(original) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            try {
                if (typeof fn.handleEvent === 'function') // ESlint disable explanation:
                //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
                //  introduce a bug here, because bind returns a new function that doesn't have our
                //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
                //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
                // eslint-disable-next-line @typescript-eslint/unbound-method
                fn.handleEvent = (0, $i8T1U.wrap)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            function: 'handleEvent',
                            handler: (0, $jVtDJ.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'instrument'
                    }
                });
            } catch (err) {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.apply(this, [
                eventName,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (0, $i8T1U.wrap)(fn, {
                    mechanism: {
                        data: {
                            function: 'addEventListener',
                            handler: (0, $jVtDJ.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'instrument'
                    }
                }),
                options
            ]);
        };
    });
    (0, $aLrZa.fill)(proto, 'removeEventListener', function(originalRemoveEventListener) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            /**
         * There are 2 possible scenarios here:
         *
         * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
         * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
         * as a pass-through, and call original `removeEventListener` with it.
         *
         * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
         * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
         * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
         * in order for us to make a distinction between wrapped/non-wrapped functions possible.
         * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
         *
         * When someone adds a handler prior to initialization, and then do it again, but after,
         * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
         * to get rid of the initial handler and it'd stick there forever.
         */ const wrappedEventHandler = fn;
            try {
                const originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
        };
    });
}

});


parcelRegister("1UG7K", function(module, exports) {

$parcel$export(module.exports, "GlobalHandlers", () => (parcelRequire("aan6Q")).GlobalHandlers);
$parcel$export(module.exports, "TryCatch", () => (parcelRequire("bDzZk")).TryCatch);
$parcel$export(module.exports, "Breadcrumbs", () => (parcelRequire("7abYO")).Breadcrumbs);
$parcel$export(module.exports, "LinkedErrors", () => (parcelRequire("5nexQ")).LinkedErrors);
$parcel$export(module.exports, "HttpContext", () => (parcelRequire("fRQU9")).HttpContext);
$parcel$export(module.exports, "Dedupe", () => (parcelRequire("AU319")).Dedupe);

var $aan6Q = parcelRequire("aan6Q");

var $bDzZk = parcelRequire("bDzZk");

var $7abYO = parcelRequire("7abYO");

var $5nexQ = parcelRequire("5nexQ");

var $fRQU9 = parcelRequire("fRQU9");

var $AU319 = parcelRequire("AU319");
 /* eslint-disable deprecation/deprecation */ 
});

parcelRegister("7xQsu", function(module, exports) {

$parcel$export(module.exports, "replayCanvasIntegration", () => $57e44ea3447f964e$export$71ba62165d5c834d);
$parcel$export(module.exports, "ReplayCanvas", () => $57e44ea3447f964e$export$5f05966c3e8baf2f);

var $dgG6n = parcelRequire("dgG6n");

var $6emiv = parcelRequire("6emiv");
var $57e44ea3447f964e$var$NodeType;
(function(NodeType) {
    NodeType[NodeType["Document"] = 0] = "Document";
    NodeType[NodeType["DocumentType"] = 1] = "DocumentType";
    NodeType[NodeType["Element"] = 2] = "Element";
    NodeType[NodeType["Text"] = 3] = "Text";
    NodeType[NodeType["CDATA"] = 4] = "CDATA";
    NodeType[NodeType["Comment"] = 5] = "Comment";
})($57e44ea3447f964e$var$NodeType || ($57e44ea3447f964e$var$NodeType = {}));
function $57e44ea3447f964e$var$elementClassMatchesRegex(el, regex) {
    for(let eIndex = el.classList.length; eIndex--;){
        const className = el.classList[eIndex];
        if (regex.test(className)) return true;
    }
    return false;
}
function $57e44ea3447f964e$var$distanceToMatch(node, matchPredicate, limit = Infinity, distance = 0) {
    if (!node) return -1;
    if (node.nodeType !== node.ELEMENT_NODE) return -1;
    if (distance > limit) return -1;
    if (matchPredicate(node)) return distance;
    return $57e44ea3447f964e$var$distanceToMatch(node.parentNode, matchPredicate, limit, distance + 1);
}
function $57e44ea3447f964e$var$createMatchPredicate(className, selector) {
    return (node)=>{
        const el = node;
        if (el === null) return false;
        try {
            if (className) {
                if (typeof className === 'string') {
                    if (el.matches(`.${className}`)) return true;
                } else if ($57e44ea3447f964e$var$elementClassMatchesRegex(el, className)) return true;
            }
            if (selector && el.matches(selector)) return true;
            return false;
        } catch (e2) {
            return false;
        }
    };
}
const $57e44ea3447f964e$var$DEPARTED_MIRROR_ACCESS_WARNING = "Please stop import mirror directly. Instead of that,\r\nnow you can use replayer.getMirror() to access the mirror instance of a replayer,\r\nor you can use record.mirror to access the mirror instance during recording.";
let $57e44ea3447f964e$var$_mirror = {
    map: {},
    getId () {
        console.error($57e44ea3447f964e$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return -1;
    },
    getNode () {
        console.error($57e44ea3447f964e$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return null;
    },
    removeNodeFromMap () {
        console.error($57e44ea3447f964e$var$DEPARTED_MIRROR_ACCESS_WARNING);
    },
    has () {
        console.error($57e44ea3447f964e$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return false;
    },
    reset () {
        console.error($57e44ea3447f964e$var$DEPARTED_MIRROR_ACCESS_WARNING);
    }
};
if (typeof window !== 'undefined' && window.Proxy && window.Reflect) $57e44ea3447f964e$var$_mirror = new Proxy($57e44ea3447f964e$var$_mirror, {
    get (target, prop, receiver) {
        if (prop === 'map') console.error($57e44ea3447f964e$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return Reflect.get(target, prop, receiver);
    }
});
function $57e44ea3447f964e$var$hookSetter(target, key, d, isRevoked, win = window) {
    const original = win.Object.getOwnPropertyDescriptor(target, key);
    win.Object.defineProperty(target, key, isRevoked ? d : {
        set (value) {
            $57e44ea3447f964e$var$setTimeout(()=>{
                d.set.call(this, value);
            }, 0);
            if (original && original.set) original.set.call(this, value);
        }
    });
    return ()=>$57e44ea3447f964e$var$hookSetter(target, key, original || {}, true);
}
function $57e44ea3447f964e$var$patch(source, name, replacement) {
    try {
        if (!(name in source)) return ()=>{};
        const original = source[name];
        const wrapped = replacement(original);
        if (typeof wrapped === 'function') {
            wrapped.prototype = wrapped.prototype || {};
            Object.defineProperties(wrapped, {
                __rrweb_original__: {
                    enumerable: false,
                    value: original
                }
            });
        }
        source[name] = wrapped;
        return ()=>{
            source[name] = original;
        };
    } catch (e2) {
        return ()=>{};
    }
}
/[1-9][0-9]{12}/.test(Date.now().toString());
function $57e44ea3447f964e$var$closestElementOfNode(node) {
    if (!node) return null;
    const el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
    return el;
}
function $57e44ea3447f964e$var$isBlocked(node, blockClass, blockSelector, unblockSelector, checkAncestors) {
    if (!node) return false;
    const el = $57e44ea3447f964e$var$closestElementOfNode(node);
    if (!el) return false;
    const blockedPredicate = $57e44ea3447f964e$var$createMatchPredicate(blockClass, blockSelector);
    if (!checkAncestors) {
        const isUnblocked = unblockSelector && el.matches(unblockSelector);
        return blockedPredicate(el) && !isUnblocked;
    }
    const blockDistance = $57e44ea3447f964e$var$distanceToMatch(el, blockedPredicate);
    let unblockDistance = -1;
    if (blockDistance < 0) return false;
    if (unblockSelector) unblockDistance = $57e44ea3447f964e$var$distanceToMatch(el, $57e44ea3447f964e$var$createMatchPredicate(null, unblockSelector));
    if (blockDistance > -1 && unblockDistance < 0) return true;
    return blockDistance < unblockDistance;
}
const $57e44ea3447f964e$var$cachedImplementations = {};
function $57e44ea3447f964e$var$getImplementation(name) {
    const cached = $57e44ea3447f964e$var$cachedImplementations[name];
    if (cached) return cached;
    const document = window.document;
    let impl = window[name];
    if (document && typeof document.createElement === 'function') try {
        const sandbox = document.createElement('iframe');
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow[name]) impl = contentWindow[name];
        document.head.removeChild(sandbox);
    } catch (e) {}
    return $57e44ea3447f964e$var$cachedImplementations[name] = impl.bind(window);
}
function $57e44ea3447f964e$var$onRequestAnimationFrame(...rest) {
    return $57e44ea3447f964e$var$getImplementation('requestAnimationFrame')(...rest);
}
function $57e44ea3447f964e$var$setTimeout(...rest) {
    return $57e44ea3447f964e$var$getImplementation('setTimeout')(...rest);
}
var $57e44ea3447f964e$var$CanvasContext = /* @__PURE__ */ ((CanvasContext2)=>{
    CanvasContext2[CanvasContext2["2D"] = 0] = "2D";
    CanvasContext2[CanvasContext2["WebGL"] = 1] = "WebGL";
    CanvasContext2[CanvasContext2["WebGL2"] = 2] = "WebGL2";
    return CanvasContext2;
})($57e44ea3447f964e$var$CanvasContext || {});
let $57e44ea3447f964e$var$errorHandler;
function $57e44ea3447f964e$var$registerErrorHandler(handler) {
    $57e44ea3447f964e$var$errorHandler = handler;
}
const $57e44ea3447f964e$var$callbackWrapper = (cb)=>{
    if (!$57e44ea3447f964e$var$errorHandler) return cb;
    const rrwebWrapped = (...rest)=>{
        try {
            return cb(...rest);
        } catch (error) {
            if ($57e44ea3447f964e$var$errorHandler && $57e44ea3447f964e$var$errorHandler(error) === true) return ()=>{};
            throw error;
        }
    };
    return rrwebWrapped;
};
/*
 * base64-arraybuffer 1.0.1 <https://github.com/niklasvh/base64-arraybuffer>
 * Copyright (c) 2021 Niklas von Hertzen <https://hertzen.com>
 * Released under MIT License
 */ var $57e44ea3447f964e$var$chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
// Use a lookup table to find the index.
var $57e44ea3447f964e$var$lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
for(var $57e44ea3447f964e$var$i = 0; $57e44ea3447f964e$var$i < $57e44ea3447f964e$var$chars.length; $57e44ea3447f964e$var$i++)$57e44ea3447f964e$var$lookup[$57e44ea3447f964e$var$chars.charCodeAt($57e44ea3447f964e$var$i)] = $57e44ea3447f964e$var$i;
var $57e44ea3447f964e$var$encode = function(arraybuffer) {
    var bytes = new Uint8Array(arraybuffer), i, len = bytes.length, base64 = '';
    for(i = 0; i < len; i += 3){
        base64 += $57e44ea3447f964e$var$chars[bytes[i] >> 2];
        base64 += $57e44ea3447f964e$var$chars[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
        base64 += $57e44ea3447f964e$var$chars[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
        base64 += $57e44ea3447f964e$var$chars[bytes[i + 2] & 63];
    }
    if (len % 3 === 2) base64 = base64.substring(0, base64.length - 1) + '=';
    else if (len % 3 === 1) base64 = base64.substring(0, base64.length - 2) + '==';
    return base64;
};
const $57e44ea3447f964e$var$canvasVarMap = new Map();
function $57e44ea3447f964e$var$variableListFor(ctx, ctor) {
    let contextMap = $57e44ea3447f964e$var$canvasVarMap.get(ctx);
    if (!contextMap) {
        contextMap = new Map();
        $57e44ea3447f964e$var$canvasVarMap.set(ctx, contextMap);
    }
    if (!contextMap.has(ctor)) contextMap.set(ctor, []);
    return contextMap.get(ctor);
}
const $57e44ea3447f964e$var$saveWebGLVar = (value, win, ctx)=>{
    if (!value || !($57e44ea3447f964e$var$isInstanceOfWebGLObject(value, win) || typeof value === 'object')) return;
    const name = value.constructor.name;
    const list = $57e44ea3447f964e$var$variableListFor(ctx, name);
    let index = list.indexOf(value);
    if (index === -1) {
        index = list.length;
        list.push(value);
    }
    return index;
};
function $57e44ea3447f964e$var$serializeArg(value, win, ctx) {
    if (value instanceof Array) return value.map((arg)=>$57e44ea3447f964e$var$serializeArg(arg, win, ctx));
    else if (value === null) return value;
    else if (value instanceof Float32Array || value instanceof Float64Array || value instanceof Int32Array || value instanceof Uint32Array || value instanceof Uint8Array || value instanceof Uint16Array || value instanceof Int16Array || value instanceof Int8Array || value instanceof Uint8ClampedArray) {
        const name = value.constructor.name;
        return {
            rr_type: name,
            args: [
                Object.values(value)
            ]
        };
    } else if (value instanceof ArrayBuffer) {
        const name = value.constructor.name;
        const base64 = $57e44ea3447f964e$var$encode(value);
        return {
            rr_type: name,
            base64: base64
        };
    } else if (value instanceof DataView) {
        const name = value.constructor.name;
        return {
            rr_type: name,
            args: [
                $57e44ea3447f964e$var$serializeArg(value.buffer, win, ctx),
                value.byteOffset,
                value.byteLength
            ]
        };
    } else if (value instanceof HTMLImageElement) {
        const name = value.constructor.name;
        const { src: src } = value;
        return {
            rr_type: name,
            src: src
        };
    } else if (value instanceof HTMLCanvasElement) {
        const name = 'HTMLImageElement';
        const src = value.toDataURL();
        return {
            rr_type: name,
            src: src
        };
    } else if (value instanceof ImageData) {
        const name = value.constructor.name;
        return {
            rr_type: name,
            args: [
                $57e44ea3447f964e$var$serializeArg(value.data, win, ctx),
                value.width,
                value.height
            ]
        };
    } else if ($57e44ea3447f964e$var$isInstanceOfWebGLObject(value, win) || typeof value === 'object') {
        const name = value.constructor.name;
        const index = $57e44ea3447f964e$var$saveWebGLVar(value, win, ctx);
        return {
            rr_type: name,
            index: index
        };
    }
    return value;
}
const $57e44ea3447f964e$var$serializeArgs = (args, win, ctx)=>{
    return args.map((arg)=>$57e44ea3447f964e$var$serializeArg(arg, win, ctx));
};
const $57e44ea3447f964e$var$isInstanceOfWebGLObject = (value, win)=>{
    const webGLConstructorNames = [
        'WebGLActiveInfo',
        'WebGLBuffer',
        'WebGLFramebuffer',
        'WebGLProgram',
        'WebGLRenderbuffer',
        'WebGLShader',
        'WebGLShaderPrecisionFormat',
        'WebGLTexture',
        'WebGLUniformLocation',
        'WebGLVertexArrayObject',
        'WebGLVertexArrayObjectOES'
    ];
    const supportedWebGLConstructorNames = webGLConstructorNames.filter((name)=>typeof win[name] === 'function');
    return Boolean(supportedWebGLConstructorNames.find((name)=>value instanceof win[name]));
};
function $57e44ea3447f964e$var$initCanvas2DMutationObserver(cb, win, blockClass, blockSelector, unblockSelector) {
    const handlers = [];
    const props2D = Object.getOwnPropertyNames(win.CanvasRenderingContext2D.prototype);
    for (const prop of props2D)try {
        if (typeof win.CanvasRenderingContext2D.prototype[prop] !== 'function') continue;
        const restoreHandler = $57e44ea3447f964e$var$patch(win.CanvasRenderingContext2D.prototype, prop, function(original) {
            return function(...args) {
                if (!$57e44ea3447f964e$var$isBlocked(this.canvas, blockClass, blockSelector, unblockSelector, true)) $57e44ea3447f964e$var$setTimeout(()=>{
                    const recordArgs = $57e44ea3447f964e$var$serializeArgs(args, win, this);
                    cb(this.canvas, {
                        type: $57e44ea3447f964e$var$CanvasContext['2D'],
                        property: prop,
                        args: recordArgs
                    });
                }, 0);
                return original.apply(this, args);
            };
        });
        handlers.push(restoreHandler);
    } catch (e) {
        const hookHandler = $57e44ea3447f964e$var$hookSetter(win.CanvasRenderingContext2D.prototype, prop, {
            set (v) {
                cb(this.canvas, {
                    type: $57e44ea3447f964e$var$CanvasContext['2D'],
                    property: prop,
                    args: [
                        v
                    ],
                    setter: true
                });
            }
        });
        handlers.push(hookHandler);
    }
    return ()=>{
        handlers.forEach((h)=>h());
    };
}
function $57e44ea3447f964e$var$getNormalizedContextName(contextType) {
    return contextType === 'experimental-webgl' ? 'webgl' : contextType;
}
function $57e44ea3447f964e$var$initCanvasContextObserver(win, blockClass, blockSelector, unblockSelector, setPreserveDrawingBufferToTrue) {
    const handlers = [];
    try {
        const restoreHandler = $57e44ea3447f964e$var$patch(win.HTMLCanvasElement.prototype, 'getContext', function(original) {
            return function(contextType, ...args) {
                if (!$57e44ea3447f964e$var$isBlocked(this, blockClass, blockSelector, unblockSelector, true)) {
                    const ctxName = $57e44ea3447f964e$var$getNormalizedContextName(contextType);
                    if (!('__context' in this)) this.__context = ctxName;
                    if (setPreserveDrawingBufferToTrue && [
                        'webgl',
                        'webgl2'
                    ].includes(ctxName)) {
                        if (args[0] && typeof args[0] === 'object') {
                            const contextAttributes = args[0];
                            if (!contextAttributes.preserveDrawingBuffer) contextAttributes.preserveDrawingBuffer = true;
                        } else args.splice(0, 1, {
                            preserveDrawingBuffer: true
                        });
                    }
                }
                return original.apply(this, [
                    contextType,
                    ...args
                ]);
            };
        });
        handlers.push(restoreHandler);
    } catch (e) {
        console.error('failed to patch HTMLCanvasElement.prototype.getContext');
    }
    return ()=>{
        handlers.forEach((h)=>h());
    };
}
function $57e44ea3447f964e$var$patchGLPrototype(prototype, type, cb, blockClass, blockSelector, unblockSelector, mirror, win) {
    const handlers = [];
    const props = Object.getOwnPropertyNames(prototype);
    for (const prop of props){
        if ([
            'isContextLost',
            'canvas',
            'drawingBufferWidth',
            'drawingBufferHeight'
        ].includes(prop)) continue;
        try {
            if (typeof prototype[prop] !== 'function') continue;
            const restoreHandler = $57e44ea3447f964e$var$patch(prototype, prop, function(original) {
                return function(...args) {
                    const result = original.apply(this, args);
                    $57e44ea3447f964e$var$saveWebGLVar(result, win, this);
                    if ('tagName' in this.canvas && !$57e44ea3447f964e$var$isBlocked(this.canvas, blockClass, blockSelector, unblockSelector, true)) {
                        const recordArgs = $57e44ea3447f964e$var$serializeArgs(args, win, this);
                        const mutation = {
                            type: type,
                            property: prop,
                            args: recordArgs
                        };
                        cb(this.canvas, mutation);
                    }
                    return result;
                };
            });
            handlers.push(restoreHandler);
        } catch (e) {
            const hookHandler = $57e44ea3447f964e$var$hookSetter(prototype, prop, {
                set (v) {
                    cb(this.canvas, {
                        type: type,
                        property: prop,
                        args: [
                            v
                        ],
                        setter: true
                    });
                }
            });
            handlers.push(hookHandler);
        }
    }
    return handlers;
}
function $57e44ea3447f964e$var$initCanvasWebGLMutationObserver(cb, win, blockClass, blockSelector, unblockSelector, mirror) {
    const handlers = [];
    handlers.push(...$57e44ea3447f964e$var$patchGLPrototype(win.WebGLRenderingContext.prototype, $57e44ea3447f964e$var$CanvasContext.WebGL, cb, blockClass, blockSelector, unblockSelector, mirror, win));
    if (typeof win.WebGL2RenderingContext !== 'undefined') handlers.push(...$57e44ea3447f964e$var$patchGLPrototype(win.WebGL2RenderingContext.prototype, $57e44ea3447f964e$var$CanvasContext.WebGL2, cb, blockClass, blockSelector, unblockSelector, mirror, win));
    return ()=>{
        handlers.forEach((h)=>h());
    };
}
var $57e44ea3447f964e$var$r = `for(var e="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",t="undefined"==typeof Uint8Array?[]:new Uint8Array(256),a=0;a<64;a++)t[e.charCodeAt(a)]=a;var n=function(t){var a,n=new Uint8Array(t),r=n.length,s="";for(a=0;a<r;a+=3)s+=e[n[a]>>2],s+=e[(3&n[a])<<4|n[a+1]>>4],s+=e[(15&n[a+1])<<2|n[a+2]>>6],s+=e[63&n[a+2]];return r%3==2?s=s.substring(0,s.length-1)+"=":r%3==1&&(s=s.substring(0,s.length-2)+"=="),s};const r=new Map,s=new Map;const i=self;i.onmessage=async function(e){if(!("OffscreenCanvas"in globalThis))return i.postMessage({id:e.data.id});{const{id:t,bitmap:a,width:o,height:f,maxCanvasSize:c,dataURLOptions:g}=e.data,u=async function(e,t,a){const r=e+"-"+t;if("OffscreenCanvas"in globalThis){if(s.has(r))return s.get(r);const i=new OffscreenCanvas(e,t);i.getContext("2d");const o=await i.convertToBlob(a),f=await o.arrayBuffer(),c=n(f);return s.set(r,c),c}return""}(o,f,g),[h,d]=function(e,t,a){if(!a)return[e,t];const[n,r]=a;if(e<=n&&t<=r)return[e,t];let s=e,i=t;return s>n&&(i=Math.floor(n*t/e),s=n),i>r&&(s=Math.floor(r*e/t),i=r),[s,i]}(o,f,c),l=new OffscreenCanvas(h,d),w=l.getContext("bitmaprenderer"),p=h===o&&d===f?a:await createImageBitmap(a,{resizeWidth:h,resizeHeight:d,resizeQuality:"low"});w.transferFromImageBitmap(p),a.close();const y=await l.convertToBlob(g),v=y.type,b=await y.arrayBuffer(),m=n(b);if(p.close(),!r.has(t)&&await u===m)return r.set(t,m),i.postMessage({id:t});if(r.get(t)===m)return i.postMessage({id:t});i.postMessage({id:t,type:v,base64:m,width:o,height:f}),r.set(t,m)}};`;
function $57e44ea3447f964e$var$t() {
    const t = new Blob([
        $57e44ea3447f964e$var$r
    ]);
    return URL.createObjectURL(t);
}
class $57e44ea3447f964e$var$CanvasManager {
    reset() {
        this.pendingCanvasMutations.clear();
        this.resetObservers && this.resetObservers();
    }
    freeze() {
        this.frozen = true;
    }
    unfreeze() {
        this.frozen = false;
    }
    lock() {
        this.locked = true;
    }
    unlock() {
        this.locked = false;
    }
    constructor(options){
        this.pendingCanvasMutations = new Map();
        this.rafStamps = {
            latestId: 0,
            invokeId: null
        };
        this.frozen = false;
        this.locked = false;
        this.processMutation = (target, mutation)=>{
            const newFrame = this.rafStamps.invokeId && this.rafStamps.latestId !== this.rafStamps.invokeId;
            if (newFrame || !this.rafStamps.invokeId) this.rafStamps.invokeId = this.rafStamps.latestId;
            if (!this.pendingCanvasMutations.has(target)) this.pendingCanvasMutations.set(target, []);
            this.pendingCanvasMutations.get(target).push(mutation);
        };
        const { sampling: sampling = 'all', win: win, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, maxCanvasSize: maxCanvasSize, recordCanvas: recordCanvas, dataURLOptions: dataURLOptions, errorHandler: errorHandler } = options;
        this.mutationCb = options.mutationCb;
        this.mirror = options.mirror;
        this.options = options;
        if (errorHandler) $57e44ea3447f964e$var$registerErrorHandler(errorHandler);
        if (options.enableManualSnapshot) return;
        $57e44ea3447f964e$var$callbackWrapper(()=>{
            if (recordCanvas && sampling === 'all') this.initCanvasMutationObserver(win, blockClass, blockSelector, unblockSelector);
            if (recordCanvas && typeof sampling === 'number') this.initCanvasFPSObserver(sampling, win, blockClass, blockSelector, unblockSelector, maxCanvasSize, {
                dataURLOptions: dataURLOptions
            });
        })();
    }
    initCanvasFPSObserver(fps, win, blockClass, blockSelector, unblockSelector, maxCanvasSize, options) {
        const canvasContextReset = $57e44ea3447f964e$var$initCanvasContextObserver(win, blockClass, blockSelector, unblockSelector, true);
        const rafId = this.takeSnapshot(false, fps, win, blockClass, blockSelector, unblockSelector, maxCanvasSize, options.dataURLOptions);
        this.resetObservers = ()=>{
            canvasContextReset();
            cancelAnimationFrame(rafId);
        };
    }
    initCanvasMutationObserver(win, blockClass, blockSelector, unblockSelector) {
        this.startRAFTimestamping();
        this.startPendingCanvasMutationFlusher();
        const canvasContextReset = $57e44ea3447f964e$var$initCanvasContextObserver(win, blockClass, blockSelector, unblockSelector, false);
        const canvas2DReset = $57e44ea3447f964e$var$initCanvas2DMutationObserver(this.processMutation.bind(this), win, blockClass, blockSelector, unblockSelector);
        const canvasWebGL1and2Reset = $57e44ea3447f964e$var$initCanvasWebGLMutationObserver(this.processMutation.bind(this), win, blockClass, blockSelector, unblockSelector, this.mirror);
        this.resetObservers = ()=>{
            canvasContextReset();
            canvas2DReset();
            canvasWebGL1and2Reset();
        };
    }
    snapshot(canvasElement) {
        const { options: options } = this;
        const rafId = this.takeSnapshot(true, options.sampling === 'all' ? 2 : options.sampling || 2, options.win, options.blockClass, options.blockSelector, options.unblockSelector, options.maxCanvasSize, options.dataURLOptions, canvasElement);
        this.resetObservers = ()=>{
            cancelAnimationFrame(rafId);
        };
    }
    takeSnapshot(isManualSnapshot, fps, win, blockClass, blockSelector, unblockSelector, maxCanvasSize, dataURLOptions, canvasElement) {
        const snapshotInProgressMap = new Map();
        const worker = new Worker($57e44ea3447f964e$var$t());
        worker.onmessage = (e)=>{
            const data = e.data;
            const { id: id } = data;
            snapshotInProgressMap.set(id, false);
            if (!('base64' in data)) return;
            const { base64: base64, type: type, width: width, height: height } = data;
            this.mutationCb({
                id: id,
                type: $57e44ea3447f964e$var$CanvasContext['2D'],
                commands: [
                    {
                        property: 'clearRect',
                        args: [
                            0,
                            0,
                            width,
                            height
                        ]
                    },
                    {
                        property: 'drawImage',
                        args: [
                            {
                                rr_type: 'ImageBitmap',
                                args: [
                                    {
                                        rr_type: 'Blob',
                                        data: [
                                            {
                                                rr_type: 'ArrayBuffer',
                                                base64: base64
                                            }
                                        ],
                                        type: type
                                    }
                                ]
                            },
                            0,
                            0,
                            width,
                            height
                        ]
                    }
                ]
            });
        };
        const timeBetweenSnapshots = 1000 / fps;
        let lastSnapshotTime = 0;
        let rafId;
        const getCanvas = (canvasElement)=>{
            if (canvasElement) return [
                canvasElement
            ];
            const matchedCanvas = [];
            win.document.querySelectorAll('canvas').forEach((canvas)=>{
                if (!$57e44ea3447f964e$var$isBlocked(canvas, blockClass, blockSelector, unblockSelector, true)) matchedCanvas.push(canvas);
            });
            return matchedCanvas;
        };
        const takeCanvasSnapshots = (timestamp)=>{
            if (lastSnapshotTime && timestamp - lastSnapshotTime < timeBetweenSnapshots) {
                rafId = $57e44ea3447f964e$var$onRequestAnimationFrame(takeCanvasSnapshots);
                return;
            }
            lastSnapshotTime = timestamp;
            getCanvas(canvasElement).forEach((canvas)=>{
                const id = this.mirror.getId(canvas);
                if (snapshotInProgressMap.get(id)) return;
                if (!canvas.width || !canvas.height) return;
                snapshotInProgressMap.set(id, true);
                if (!isManualSnapshot && [
                    'webgl',
                    'webgl2'
                ].includes(canvas.__context)) {
                    const context = canvas.getContext(canvas.__context);
                    if ((0, $dgG6n._optionalChain)([
                        context,
                        'optionalAccess',
                        (_)=>_.getContextAttributes,
                        'call',
                        (_2)=>_2(),
                        'optionalAccess',
                        (_3)=>_3.preserveDrawingBuffer
                    ]) === false) context.clear(context.COLOR_BUFFER_BIT);
                }
                createImageBitmap(canvas).then((bitmap)=>{
                    worker.postMessage({
                        id: id,
                        bitmap: bitmap,
                        width: canvas.width,
                        height: canvas.height,
                        dataURLOptions: dataURLOptions,
                        maxCanvasSize: maxCanvasSize
                    }, [
                        bitmap
                    ]);
                }).catch((error)=>{
                    $57e44ea3447f964e$var$callbackWrapper(()=>{
                        throw error;
                    })();
                });
            });
            rafId = $57e44ea3447f964e$var$onRequestAnimationFrame(takeCanvasSnapshots);
        };
        rafId = $57e44ea3447f964e$var$onRequestAnimationFrame(takeCanvasSnapshots);
        return rafId;
    }
    startPendingCanvasMutationFlusher() {
        $57e44ea3447f964e$var$onRequestAnimationFrame(()=>this.flushPendingCanvasMutations());
    }
    startRAFTimestamping() {
        const setLatestRAFTimestamp = (timestamp)=>{
            this.rafStamps.latestId = timestamp;
            $57e44ea3447f964e$var$onRequestAnimationFrame(setLatestRAFTimestamp);
        };
        $57e44ea3447f964e$var$onRequestAnimationFrame(setLatestRAFTimestamp);
    }
    flushPendingCanvasMutations() {
        this.pendingCanvasMutations.forEach((values, canvas)=>{
            const id = this.mirror.getId(canvas);
            this.flushPendingCanvasMutationFor(canvas, id);
        });
        $57e44ea3447f964e$var$onRequestAnimationFrame(()=>this.flushPendingCanvasMutations());
    }
    flushPendingCanvasMutationFor(canvas, id) {
        if (this.frozen || this.locked) return;
        const valuesWithType = this.pendingCanvasMutations.get(canvas);
        if (!valuesWithType || id === -1) return;
        const values = valuesWithType.map((value)=>{
            const { type: type, ...rest } = value;
            return rest;
        });
        const { type: type } = valuesWithType[0];
        this.mutationCb({
            id: id,
            type: type,
            commands: values
        });
        this.pendingCanvasMutations.delete(canvas);
    }
}
const $57e44ea3447f964e$var$CANVAS_QUALITY = {
    low: {
        sampling: {
            canvas: 1
        },
        dataURLOptions: {
            type: 'image/webp',
            quality: 0.25
        }
    },
    medium: {
        sampling: {
            canvas: 2
        },
        dataURLOptions: {
            type: 'image/webp',
            quality: 0.4
        }
    },
    high: {
        sampling: {
            canvas: 4
        },
        dataURLOptions: {
            type: 'image/webp',
            quality: 0.5
        }
    }
};
const $57e44ea3447f964e$var$INTEGRATION_NAME = 'ReplayCanvas';
const $57e44ea3447f964e$var$DEFAULT_MAX_CANVAS_SIZE = 1280;
/** Exported only for type safe tests. */ const $57e44ea3447f964e$var$_replayCanvasIntegration = (options = {})=>{
    const [maxCanvasWidth, maxCanvasHeight] = options.maxCanvasSize || [];
    const _canvasOptions = {
        quality: options.quality || 'medium',
        enableManualSnapshot: options.enableManualSnapshot,
        maxCanvasSize: [
            maxCanvasWidth ? Math.min(maxCanvasWidth, $57e44ea3447f964e$var$DEFAULT_MAX_CANVAS_SIZE) : $57e44ea3447f964e$var$DEFAULT_MAX_CANVAS_SIZE,
            maxCanvasHeight ? Math.min(maxCanvasHeight, $57e44ea3447f964e$var$DEFAULT_MAX_CANVAS_SIZE) : $57e44ea3447f964e$var$DEFAULT_MAX_CANVAS_SIZE
        ]
    };
    let canvasManagerResolve;
    const _canvasManager = new Promise((resolve)=>canvasManagerResolve = resolve);
    return {
        name: $57e44ea3447f964e$var$INTEGRATION_NAME,
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        setupOnce () {},
        getOptions () {
            const { quality: quality, enableManualSnapshot: enableManualSnapshot, maxCanvasSize: maxCanvasSize } = _canvasOptions;
            return {
                enableManualSnapshot: enableManualSnapshot,
                recordCanvas: true,
                getCanvasManager: (getCanvasManagerOptions)=>{
                    const manager = new $57e44ea3447f964e$var$CanvasManager({
                        ...getCanvasManagerOptions,
                        enableManualSnapshot: enableManualSnapshot,
                        maxCanvasSize: maxCanvasSize,
                        errorHandler: (err)=>{
                            try {
                                if (typeof err === 'object') err.__rrweb__ = true;
                            } catch (error) {
                            // ignore errors here
                            // this can happen if the error is frozen or does not allow mutation for other reasons
                            }
                        }
                    });
                    canvasManagerResolve(manager);
                    return manager;
                },
                ...$57e44ea3447f964e$var$CANVAS_QUALITY[quality || 'medium'] || $57e44ea3447f964e$var$CANVAS_QUALITY.medium
            };
        },
        async snapshot (canvasElement) {
            const canvasManager = await _canvasManager;
            canvasManager.snapshot(canvasElement);
        }
    };
};
/**
 * Add this in addition to `replayIntegration()` to enable canvas recording.
 */ const $57e44ea3447f964e$export$71ba62165d5c834d = (0, $6emiv.defineIntegration)($57e44ea3447f964e$var$_replayCanvasIntegration);
/**
 * @deprecated Use `replayCanvasIntegration()` instead
 */ // eslint-disable-next-line deprecation/deprecation
const $57e44ea3447f964e$export$5f05966c3e8baf2f = (0, $6emiv.convertIntegrationFnToClass)($57e44ea3447f964e$var$INTEGRATION_NAME, $57e44ea3447f964e$export$71ba62165d5c834d);

});
parcelRegister("dgG6n", function(module, exports) {

$parcel$export(module.exports, "_optionalChain", () => $027e26eda627e97d$export$3cc482e6b02f32f7);
/**
 * Polyfill for the optional chain operator, `?.`, given previous conversion of the expression into an array of values,
 * descriptors, and functions.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase)
 * See https://github.com/alangpierce/sucrase/blob/265887868966917f3b924ce38dfad01fbab1329f/src/transformers/OptionalChainingNullishTransformer.ts#L15
 *
 * @param ops Array result of expression conversion
 * @returns The value of the expression
 */ function $027e26eda627e97d$export$3cc482e6b02f32f7(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        // by checking for loose equality to `null`, we catch both `null` and `undefined`
        if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) // really we're meaning to return `undefined` as an actual value here, but it saves bytes not to write it
        return;
        if (op === 'access' || op === 'optionalAccess') {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === 'call' || op === 'optionalCall') {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}

});


parcelRegister("13Shy", function(module, exports) {

$parcel$export(module.exports, "captureConsoleIntegration", () => $0c602d92b435e3e8$export$caa9b6c4a4144db4);
$parcel$export(module.exports, "CaptureConsole", () => $0c602d92b435e3e8$export$25a43cb5b5c58c08);

var $fq71H = parcelRequire("fq71H");
var $6emiv = parcelRequire("6emiv");

var $amBmj = parcelRequire("amBmj");
var $1y8R2 = parcelRequire("1y8R2");
var $lN8pX = parcelRequire("lN8pX");
var $4mb67 = parcelRequire("4mb67");
var $jmfnM = parcelRequire("jmfnM");
var $cIgWs = parcelRequire("cIgWs");
const $0c602d92b435e3e8$var$INTEGRATION_NAME = 'CaptureConsole';
const $0c602d92b435e3e8$var$_captureConsoleIntegration = (options = {})=>{
    const levels = options.levels || (0, $lN8pX.CONSOLE_LEVELS);
    return {
        name: $0c602d92b435e3e8$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        setup (client) {
            if (!('console' in (0, $4mb67.GLOBAL_OBJ))) return;
            (0, $amBmj.addConsoleInstrumentationHandler)(({ args: args, level: level })=>{
                if ((0, $fq71H.getClient)() !== client || !levels.includes(level)) return;
                $0c602d92b435e3e8$var$consoleHandler(args, level);
            });
        }
    };
};
const $0c602d92b435e3e8$export$caa9b6c4a4144db4 = (0, $6emiv.defineIntegration)($0c602d92b435e3e8$var$_captureConsoleIntegration);
/**
 * Send Console API calls as Sentry Events.
 * @deprecated Use `captureConsoleIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $0c602d92b435e3e8$export$25a43cb5b5c58c08 = (0, $6emiv.convertIntegrationFnToClass)($0c602d92b435e3e8$var$INTEGRATION_NAME, $0c602d92b435e3e8$export$caa9b6c4a4144db4);
function $0c602d92b435e3e8$var$consoleHandler(args, level) {
    const captureContext = {
        level: (0, $cIgWs.severityLevelFromString)(level),
        extra: {
            arguments: args
        }
    };
    (0, $fq71H.withScope)((scope)=>{
        scope.addEventProcessor((event)=>{
            event.logger = 'console';
            (0, $1y8R2.addExceptionMechanism)(event, {
                handled: false,
                type: 'console'
            });
            return event;
        });
        if (level === 'assert' && args[0] === false) {
            const message = `Assertion failed: ${(0, $jmfnM.safeJoin)(args.slice(1), ' ') || 'console.assert'}`;
            scope.setExtra('arguments', args.slice(1));
            (0, $fq71H.captureMessage)(message, captureContext);
            return;
        }
        const error = args.find((arg)=>arg instanceof Error);
        if (level === 'error' && error) {
            (0, $fq71H.captureException)(error, captureContext);
            return;
        }
        const message = (0, $jmfnM.safeJoin)(args, ' ');
        (0, $fq71H.captureMessage)(message, captureContext);
    });
}

});

parcelRegister("ahC8I", function(module, exports) {

$parcel$export(module.exports, "contextLinesIntegration", () => $77c913a094d06039$export$74173d114ed4f354);

var $6emiv = parcelRequire("6emiv");

var $1y8R2 = parcelRequire("1y8R2");
var $4mb67 = parcelRequire("4mb67");
var $23mcX = parcelRequire("23mcX");
const $77c913a094d06039$var$WINDOW = (0, $4mb67.GLOBAL_OBJ);
const $77c913a094d06039$var$DEFAULT_LINES_OF_CONTEXT = 7;
const $77c913a094d06039$var$INTEGRATION_NAME = 'ContextLines';
const $77c913a094d06039$var$_contextLinesIntegration = (options = {})=>{
    const contextLines = options.frameContextLines != null ? options.frameContextLines : $77c913a094d06039$var$DEFAULT_LINES_OF_CONTEXT;
    return {
        name: $77c913a094d06039$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        processEvent (event) {
            return $77c913a094d06039$var$addSourceContext(event, contextLines);
        }
    };
};
const $77c913a094d06039$export$74173d114ed4f354 = (0, $6emiv.defineIntegration)($77c913a094d06039$var$_contextLinesIntegration);
/**
 * Collects source context lines around the lines of stackframes pointing to JS embedded in
 * the current page's HTML.
 *
 * This integration DOES NOT work for stack frames pointing to JS files that are loaded by the browser.
 * For frames pointing to files, context lines are added during ingestion and symbolication
 * by attempting to download the JS files to the Sentry backend.
 *
 * Use this integration if you have inline JS code in HTML pages that can't be accessed
 * by our backend (e.g. due to a login-protected page).
 *
 * @deprecated Use `contextLinesIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $77c913a094d06039$export$a1f484ece213940c = (0, $6emiv.convertIntegrationFnToClass)($77c913a094d06039$var$INTEGRATION_NAME, $77c913a094d06039$export$74173d114ed4f354);
/**
 * Processes an event and adds context lines.
 */ function $77c913a094d06039$var$addSourceContext(event, contextLines) {
    const doc = $77c913a094d06039$var$WINDOW.document;
    const htmlFilename = $77c913a094d06039$var$WINDOW.location && (0, $23mcX.stripUrlQueryAndFragment)($77c913a094d06039$var$WINDOW.location.href);
    if (!doc || !htmlFilename) return event;
    const exceptions = event.exception && event.exception.values;
    if (!exceptions || !exceptions.length) return event;
    const html = doc.documentElement.innerHTML;
    if (!html) return event;
    const htmlLines = [
        '<!DOCTYPE html>',
        '<html>',
        ...html.split('\n'),
        '</html>'
    ];
    exceptions.forEach((exception)=>{
        const stacktrace = exception.stacktrace;
        if (stacktrace && stacktrace.frames) stacktrace.frames = stacktrace.frames.map((frame)=>$77c913a094d06039$export$cf59ef3dc46bd2e1(frame, htmlLines, htmlFilename, contextLines));
    });
    return event;
}
/**
 * Only exported for testing
 */ function $77c913a094d06039$export$cf59ef3dc46bd2e1(frame, htmlLines, htmlFilename, linesOfContext) {
    if (frame.filename !== htmlFilename || !frame.lineno || !htmlLines.length) return frame;
    (0, $1y8R2.addContextToFrame)(htmlLines, frame, linesOfContext);
    return frame;
}

});

parcelRegister("aRfWy", function(module, exports) {

$parcel$export(module.exports, "debugIntegration", () => $7e7b38a394632cc2$export$6c044612ac549e3);

var $6emiv = parcelRequire("6emiv");

var $lN8pX = parcelRequire("lN8pX");
const $7e7b38a394632cc2$var$INTEGRATION_NAME = 'Debug';
const $7e7b38a394632cc2$var$_debugIntegration = (options = {})=>{
    const _options = {
        debugger: false,
        stringify: false,
        ...options
    };
    return {
        name: $7e7b38a394632cc2$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        setup (client) {
            if (!client.on) return;
            client.on('beforeSendEvent', (event, hint)=>{
                if (_options.debugger) // eslint-disable-next-line no-debugger
                debugger;
                /* eslint-disable no-console */ (0, $lN8pX.consoleSandbox)(()=>{
                    if (_options.stringify) {
                        console.log(JSON.stringify(event, null, 2));
                        if (hint && Object.keys(hint).length) console.log(JSON.stringify(hint, null, 2));
                    } else {
                        console.log(event);
                        if (hint && Object.keys(hint).length) console.log(hint);
                    }
                });
            /* eslint-enable no-console */ });
        }
    };
};
const $7e7b38a394632cc2$export$6c044612ac549e3 = (0, $6emiv.defineIntegration)($7e7b38a394632cc2$var$_debugIntegration);
/**
 * Integration to debug sent Sentry events.
 * This integration should not be used in production.
 *
 * @deprecated Use `debugIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $7e7b38a394632cc2$export$153e5dc2c098b35c = (0, $6emiv.convertIntegrationFnToClass)($7e7b38a394632cc2$var$INTEGRATION_NAME, $7e7b38a394632cc2$export$6c044612ac549e3);

});

parcelRegister("cDASn", function(module, exports) {

$parcel$export(module.exports, "dedupeIntegration", () => $9335bb6370553b31$export$6d39aa44cd0c7567);
$parcel$export(module.exports, "Dedupe", () => $9335bb6370553b31$export$688d98c249d31ad3);

var $6emiv = parcelRequire("6emiv");

var $lN8pX = parcelRequire("lN8pX");

var $d3T3V = parcelRequire("d3T3V");
const $9335bb6370553b31$var$INTEGRATION_NAME = 'Dedupe';
const $9335bb6370553b31$var$_dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: $9335bb6370553b31$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        processEvent (currentEvent) {
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) return currentEvent;
            // Juuust in case something goes wrong
            try {
                if ($9335bb6370553b31$export$3c6361fddf6cd929(currentEvent, previousEvent)) {
                    (0, $d3T3V.DEBUG_BUILD) && (0, $lN8pX.logger).warn('Event dropped due to being a duplicate of previously captured event.');
                    return null;
                }
            } catch (_oO) {} // eslint-disable-line no-empty
            return previousEvent = currentEvent;
        }
    };
};
const $9335bb6370553b31$export$6d39aa44cd0c7567 = (0, $6emiv.defineIntegration)($9335bb6370553b31$var$_dedupeIntegration);
/**
 * Deduplication filter.
 * @deprecated Use `dedupeIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $9335bb6370553b31$export$688d98c249d31ad3 = (0, $6emiv.convertIntegrationFnToClass)($9335bb6370553b31$var$INTEGRATION_NAME, $9335bb6370553b31$export$6d39aa44cd0c7567);
/** only exported for tests. */ function $9335bb6370553b31$export$3c6361fddf6cd929(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($9335bb6370553b31$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($9335bb6370553b31$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $9335bb6370553b31$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$9335bb6370553b31$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$9335bb6370553b31$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $9335bb6370553b31$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $9335bb6370553b31$var$_getExceptionFromEvent(previousEvent);
    const currentException = $9335bb6370553b31$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$9335bb6370553b31$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$9335bb6370553b31$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $9335bb6370553b31$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = $9335bb6370553b31$var$_getFramesFromEvent(currentEvent);
    let previousFrames = $9335bb6370553b31$var$_getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(let i = 0; i < previousFrames.length; i++){
        const frameA = previousFrames[i];
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $9335bb6370553b31$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    } catch (_oO) {
        return false;
    }
}
function $9335bb6370553b31$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
function $9335bb6370553b31$var$_getFramesFromEvent(event) {
    const exception = event.exception;
    if (exception) try {
        // @ts-expect-error Object could be undefined
        return exception.values[0].stacktrace.frames;
    } catch (_oO) {
        return undefined;
    }
    return undefined;
}

});
parcelRegister("d3T3V", function(module, exports) {

$parcel$export(module.exports, "DEBUG_BUILD", () => $982644631ff986cd$export$16a28057038b10ef);
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $982644631ff986cd$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;

});


parcelRegister("24Tbz", function(module, exports) {

$parcel$export(module.exports, "extraErrorDataIntegration", () => $1836c3370f9fd195$export$6e0872131894301d);
$parcel$export(module.exports, "ExtraErrorData", () => $1836c3370f9fd195$export$56d961ef3a52a072);

var $6emiv = parcelRequire("6emiv");

var $aLrZa = parcelRequire("aLrZa");
var $dlAFs = parcelRequire("dlAFs");
var $lN8pX = parcelRequire("lN8pX");
var $j15Q6 = parcelRequire("j15Q6");

var $d3T3V = parcelRequire("d3T3V");
const $1836c3370f9fd195$var$INTEGRATION_NAME = 'ExtraErrorData';
const $1836c3370f9fd195$var$_extraErrorDataIntegration = (options = {})=>{
    const depth = options.depth || 3;
    // TODO(v8): Flip the default for this option to true
    const captureErrorCause = options.captureErrorCause || false;
    return {
        name: $1836c3370f9fd195$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        processEvent (event, hint) {
            return $1836c3370f9fd195$var$_enhanceEventWithErrorData(event, hint, depth, captureErrorCause);
        }
    };
};
const $1836c3370f9fd195$export$6e0872131894301d = (0, $6emiv.defineIntegration)($1836c3370f9fd195$var$_extraErrorDataIntegration);
/**
 * Extract additional data for from original exceptions.
 * @deprecated Use `extraErrorDataIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $1836c3370f9fd195$export$56d961ef3a52a072 = (0, $6emiv.convertIntegrationFnToClass)($1836c3370f9fd195$var$INTEGRATION_NAME, $1836c3370f9fd195$export$6e0872131894301d);
function $1836c3370f9fd195$var$_enhanceEventWithErrorData(event, hint = {}, depth, captureErrorCause) {
    if (!hint.originalException || !(0, $dlAFs.isError)(hint.originalException)) return event;
    const exceptionName = hint.originalException.name || hint.originalException.constructor.name;
    const errorData = $1836c3370f9fd195$var$_extractErrorData(hint.originalException, captureErrorCause);
    if (errorData) {
        const contexts = {
            ...event.contexts
        };
        const normalizedErrorData = (0, $j15Q6.normalize)(errorData, depth);
        if ((0, $dlAFs.isPlainObject)(normalizedErrorData)) {
            // We mark the error data as "already normalized" here, because we don't want other normalization procedures to
            // potentially truncate the data we just already normalized, with a certain depth setting.
            (0, $aLrZa.addNonEnumerableProperty)(normalizedErrorData, '__sentry_skip_normalization__', true);
            contexts[exceptionName] = normalizedErrorData;
        }
        return {
            ...event,
            contexts: contexts
        };
    }
    return event;
}
/**
 * Extract extra information from the Error object
 */ function $1836c3370f9fd195$var$_extractErrorData(error, captureErrorCause) {
    // We are trying to enhance already existing event, so no harm done if it won't succeed
    try {
        const nativeKeys = [
            'name',
            'message',
            'stack',
            'line',
            'column',
            'fileName',
            'lineNumber',
            'columnNumber',
            'toJSON'
        ];
        const extraErrorInfo = {};
        // We want only enumerable properties, thus `getOwnPropertyNames` is redundant here, as we filter keys anyway.
        for (const key of Object.keys(error)){
            if (nativeKeys.indexOf(key) !== -1) continue;
            const value = error[key];
            extraErrorInfo[key] = (0, $dlAFs.isError)(value) ? value.toString() : value;
        }
        // Error.cause is a standard property that is non enumerable, we therefore need to access it separately.
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error/cause
        if (captureErrorCause && error.cause !== undefined) extraErrorInfo.cause = (0, $dlAFs.isError)(error.cause) ? error.cause.toString() : error.cause;
        // Check if someone attached `toJSON` method to grab even more properties (eg. axios is doing that)
        if (typeof error.toJSON === 'function') {
            const serializedError = error.toJSON();
            for (const key of Object.keys(serializedError)){
                const value = serializedError[key];
                extraErrorInfo[key] = (0, $dlAFs.isError)(value) ? value.toString() : value;
            }
        }
        return extraErrorInfo;
    } catch (oO) {
        (0, $d3T3V.DEBUG_BUILD) && (0, $lN8pX.logger).error('Unable to extract extra data from the Error object:', oO);
    }
    return null;
}

});

parcelRegister("co6wL", function(module, exports) {

$parcel$export(module.exports, "httpClientIntegration", () => $904cca1f6fd5e6ac$export$8a3b7aeb379b3907);

var $fq71H = parcelRequire("fq71H");
var $6emiv = parcelRequire("6emiv");
var $lPCNA = parcelRequire("lPCNA");

var $1y8R2 = parcelRequire("1y8R2");
var $8YW3h = parcelRequire("8YW3h");
var $8UJMm = parcelRequire("8UJMm");
var $4mb67 = parcelRequire("4mb67");
var $lN8pX = parcelRequire("lN8pX");
var $4Dtr4 = parcelRequire("4Dtr4");

var $d3T3V = parcelRequire("d3T3V");
const $904cca1f6fd5e6ac$var$INTEGRATION_NAME = 'HttpClient';
const $904cca1f6fd5e6ac$var$_httpClientIntegration = (options = {})=>{
    const _options = {
        failedRequestStatusCodes: [
            [
                500,
                599
            ]
        ],
        failedRequestTargets: [
            /.*/
        ],
        ...options
    };
    return {
        name: $904cca1f6fd5e6ac$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        setup (client) {
            $904cca1f6fd5e6ac$var$_wrapFetch(client, _options);
            $904cca1f6fd5e6ac$var$_wrapXHR(client, _options);
        }
    };
};
const $904cca1f6fd5e6ac$export$8a3b7aeb379b3907 = (0, $6emiv.defineIntegration)($904cca1f6fd5e6ac$var$_httpClientIntegration);
/**
 * Create events for failed client side HTTP requests.
 * @deprecated Use `httpClientIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $904cca1f6fd5e6ac$export$8c6ee871e681f0f4 = (0, $6emiv.convertIntegrationFnToClass)($904cca1f6fd5e6ac$var$INTEGRATION_NAME, $904cca1f6fd5e6ac$export$8a3b7aeb379b3907);
/**
 * Interceptor function for fetch requests
 *
 * @param requestInfo The Fetch API request info
 * @param response The Fetch API response
 * @param requestInit The request init object
 */ function $904cca1f6fd5e6ac$var$_fetchResponseHandler(options, requestInfo, response, requestInit) {
    if ($904cca1f6fd5e6ac$var$_shouldCaptureResponse(options, response.status, response.url)) {
        const request = $904cca1f6fd5e6ac$var$_getRequest(requestInfo, requestInit);
        let requestHeaders, responseHeaders, requestCookies, responseCookies;
        if ($904cca1f6fd5e6ac$var$_shouldSendDefaultPii()) [{ headers: requestHeaders, cookies: requestCookies }, { headers: responseHeaders, cookies: responseCookies }] = [
            {
                cookieHeader: 'Cookie',
                obj: request
            },
            {
                cookieHeader: 'Set-Cookie',
                obj: response
            }
        ].map(({ cookieHeader: cookieHeader, obj: obj })=>{
            const headers = $904cca1f6fd5e6ac$var$_extractFetchHeaders(obj.headers);
            let cookies;
            try {
                const cookieString = headers[cookieHeader] || headers[cookieHeader.toLowerCase()] || undefined;
                if (cookieString) cookies = $904cca1f6fd5e6ac$var$_parseCookieString(cookieString);
            } catch (e) {
                (0, $d3T3V.DEBUG_BUILD) && (0, $lN8pX.logger).log(`Could not extract cookies from header ${cookieHeader}`);
            }
            return {
                headers: headers,
                cookies: cookies
            };
        });
        const event = $904cca1f6fd5e6ac$var$_createEvent({
            url: request.url,
            method: request.method,
            status: response.status,
            requestHeaders: requestHeaders,
            responseHeaders: responseHeaders,
            requestCookies: requestCookies,
            responseCookies: responseCookies
        });
        (0, $fq71H.captureEvent)(event);
    }
}
/**
 * Interceptor function for XHR requests
 *
 * @param xhr The XHR request
 * @param method The HTTP method
 * @param headers The HTTP headers
 */ function $904cca1f6fd5e6ac$var$_xhrResponseHandler(options, xhr, method, headers) {
    if ($904cca1f6fd5e6ac$var$_shouldCaptureResponse(options, xhr.status, xhr.responseURL)) {
        let requestHeaders, responseCookies, responseHeaders;
        if ($904cca1f6fd5e6ac$var$_shouldSendDefaultPii()) {
            try {
                const cookieString = xhr.getResponseHeader('Set-Cookie') || xhr.getResponseHeader('set-cookie') || undefined;
                if (cookieString) responseCookies = $904cca1f6fd5e6ac$var$_parseCookieString(cookieString);
            } catch (e) {
                (0, $d3T3V.DEBUG_BUILD) && (0, $lN8pX.logger).log('Could not extract cookies from response headers');
            }
            try {
                responseHeaders = $904cca1f6fd5e6ac$var$_getXHRResponseHeaders(xhr);
            } catch (e) {
                (0, $d3T3V.DEBUG_BUILD) && (0, $lN8pX.logger).log('Could not extract headers from response');
            }
            requestHeaders = headers;
        }
        const event = $904cca1f6fd5e6ac$var$_createEvent({
            url: xhr.responseURL,
            method: method,
            status: xhr.status,
            requestHeaders: requestHeaders,
            responseHeaders: // Can't access request cookies from XHR
            responseHeaders,
            responseCookies: responseCookies
        });
        (0, $fq71H.captureEvent)(event);
    }
}
/**
 * Extracts response size from `Content-Length` header when possible
 *
 * @param headers
 * @returns The response size in bytes or undefined
 */ function $904cca1f6fd5e6ac$var$_getResponseSizeFromHeaders(headers) {
    if (headers) {
        const contentLength = headers['Content-Length'] || headers['content-length'];
        if (contentLength) return parseInt(contentLength, 10);
    }
    return undefined;
}
/**
 * Creates an object containing cookies from the given cookie string
 *
 * @param cookieString The cookie string to parse
 * @returns The parsed cookies
 */ function $904cca1f6fd5e6ac$var$_parseCookieString(cookieString) {
    return cookieString.split('; ').reduce((acc, cookie)=>{
        const [key, value] = cookie.split('=');
        acc[key] = value;
        return acc;
    }, {});
}
/**
 * Extracts the headers as an object from the given Fetch API request or response object
 *
 * @param headers The headers to extract
 * @returns The extracted headers as an object
 */ function $904cca1f6fd5e6ac$var$_extractFetchHeaders(headers) {
    const result = {};
    headers.forEach((value, key)=>{
        result[key] = value;
    });
    return result;
}
/**
 * Extracts the response headers as an object from the given XHR object
 *
 * @param xhr The XHR object to extract the response headers from
 * @returns The response headers as an object
 */ function $904cca1f6fd5e6ac$var$_getXHRResponseHeaders(xhr) {
    const headers = xhr.getAllResponseHeaders();
    if (!headers) return {};
    return headers.split('\r\n').reduce((acc, line)=>{
        const [key, value] = line.split(': ');
        acc[key] = value;
        return acc;
    }, {});
}
/**
 * Checks if the given target url is in the given list of targets
 *
 * @param target The target url to check
 * @returns true if the target url is in the given list of targets, false otherwise
 */ function $904cca1f6fd5e6ac$var$_isInGivenRequestTargets(failedRequestTargets, target) {
    return failedRequestTargets.some((givenRequestTarget)=>{
        if (typeof givenRequestTarget === 'string') return target.includes(givenRequestTarget);
        return givenRequestTarget.test(target);
    });
}
/**
 * Checks if the given status code is in the given range
 *
 * @param status The status code to check
 * @returns true if the status code is in the given range, false otherwise
 */ function $904cca1f6fd5e6ac$var$_isInGivenStatusRanges(failedRequestStatusCodes, status) {
    return failedRequestStatusCodes.some((range)=>{
        if (typeof range === 'number') return range === status;
        return status >= range[0] && status <= range[1];
    });
}
/**
 * Wraps `fetch` function to capture request and response data
 */ function $904cca1f6fd5e6ac$var$_wrapFetch(client, options) {
    if (!(0, $4Dtr4.supportsNativeFetch)()) return;
    (0, $8YW3h.addFetchInstrumentationHandler)((handlerData)=>{
        if ((0, $fq71H.getClient)() !== client) return;
        const { response: response, args: args } = handlerData;
        const [requestInfo, requestInit] = args;
        if (!response) return;
        $904cca1f6fd5e6ac$var$_fetchResponseHandler(options, requestInfo, response, requestInit);
    });
}
/**
 * Wraps XMLHttpRequest to capture request and response data
 */ function $904cca1f6fd5e6ac$var$_wrapXHR(client, options) {
    if (!('XMLHttpRequest' in (0, $4mb67.GLOBAL_OBJ))) return;
    (0, $8UJMm.addXhrInstrumentationHandler)((handlerData)=>{
        if ((0, $fq71H.getClient)() !== client) return;
        const xhr = handlerData.xhr;
        const sentryXhrData = xhr[0, $8UJMm.SENTRY_XHR_DATA_KEY];
        if (!sentryXhrData) return;
        const { method: method, request_headers: headers } = sentryXhrData;
        try {
            $904cca1f6fd5e6ac$var$_xhrResponseHandler(options, xhr, method, headers);
        } catch (e) {
            (0, $d3T3V.DEBUG_BUILD) && (0, $lN8pX.logger).warn('Error while extracting response event form XHR response', e);
        }
    });
}
/**
 * Checks whether to capture given response as an event
 *
 * @param status response status code
 * @param url response url
 */ function $904cca1f6fd5e6ac$var$_shouldCaptureResponse(options, status, url) {
    return $904cca1f6fd5e6ac$var$_isInGivenStatusRanges(options.failedRequestStatusCodes, status) && $904cca1f6fd5e6ac$var$_isInGivenRequestTargets(options.failedRequestTargets, url) && !(0, $lPCNA.isSentryRequestUrl)(url, (0, $fq71H.getClient)());
}
/**
 * Creates a synthetic Sentry event from given response data
 *
 * @param data response data
 * @returns event
 */ function $904cca1f6fd5e6ac$var$_createEvent(data) {
    const message = `HTTP Client Error with status code: ${data.status}`;
    const event = {
        message: message,
        exception: {
            values: [
                {
                    type: 'Error',
                    value: message
                }
            ]
        },
        request: {
            url: data.url,
            method: data.method,
            headers: data.requestHeaders,
            cookies: data.requestCookies
        },
        contexts: {
            response: {
                status_code: data.status,
                headers: data.responseHeaders,
                cookies: data.responseCookies,
                body_size: $904cca1f6fd5e6ac$var$_getResponseSizeFromHeaders(data.responseHeaders)
            }
        }
    };
    (0, $1y8R2.addExceptionMechanism)(event, {
        type: 'http.client',
        handled: false
    });
    return event;
}
function $904cca1f6fd5e6ac$var$_getRequest(requestInfo, requestInit) {
    if (!requestInit && requestInfo instanceof Request) return requestInfo;
    // If both are set, we try to construct a new Request with the given arguments
    // However, if e.g. the original request has a `body`, this will throw an error because it was already accessed
    // In this case, as a fallback, we just use the original request - using both is rather an edge case
    if (requestInfo instanceof Request && requestInfo.bodyUsed) return requestInfo;
    return new Request(requestInfo, requestInit);
}
function $904cca1f6fd5e6ac$var$_shouldSendDefaultPii() {
    const client = (0, $fq71H.getClient)();
    return client ? Boolean(client.getOptions().sendDefaultPii) : false;
}

});

parcelRegister("iXVbD", function(module, exports) {

$parcel$export(module.exports, "reportingObserverIntegration", () => $dcea18c049e4a5b3$export$609cccfa9f328cc5);

var $fq71H = parcelRequire("fq71H");
var $6emiv = parcelRequire("6emiv");

var $4mb67 = parcelRequire("4mb67");
var $4Dtr4 = parcelRequire("4Dtr4");
const $dcea18c049e4a5b3$var$WINDOW = (0, $4mb67.GLOBAL_OBJ);
const $dcea18c049e4a5b3$var$INTEGRATION_NAME = 'ReportingObserver';
const $dcea18c049e4a5b3$var$SETUP_CLIENTS = new WeakMap();
const $dcea18c049e4a5b3$var$_reportingObserverIntegration = (options = {})=>{
    const types = options.types || [
        'crash',
        'deprecation',
        'intervention'
    ];
    /** Handler for the reporting observer. */ function handler(reports) {
        if (!$dcea18c049e4a5b3$var$SETUP_CLIENTS.has((0, $fq71H.getClient)())) return;
        for (const report of reports)(0, $fq71H.withScope)((scope)=>{
            scope.setExtra('url', report.url);
            const label = `ReportingObserver [${report.type}]`;
            let details = 'No details available';
            if (report.body) {
                // Object.keys doesn't work on ReportBody, as all properties are inheirted
                const plainBody = {};
                // eslint-disable-next-line guard-for-in
                for(const prop in report.body)plainBody[prop] = report.body[prop];
                scope.setExtra('body', plainBody);
                if (report.type === 'crash') {
                    const body = report.body;
                    // A fancy way to create a message out of crashId OR reason OR both OR fallback
                    details = [
                        body.crashId || '',
                        body.reason || ''
                    ].join(' ').trim() || details;
                } else {
                    const body = report.body;
                    details = body.message || details;
                }
            }
            (0, $fq71H.captureMessage)(`${label}: ${details}`);
        });
    }
    return {
        name: $dcea18c049e4a5b3$var$INTEGRATION_NAME,
        setupOnce () {
            if (!(0, $4Dtr4.supportsReportingObserver)()) return;
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
            const observer = new $dcea18c049e4a5b3$var$WINDOW.ReportingObserver(handler, {
                buffered: true,
                types: types
            });
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            observer.observe();
        },
        setup (client) {
            $dcea18c049e4a5b3$var$SETUP_CLIENTS.set(client, true);
        }
    };
};
const $dcea18c049e4a5b3$export$609cccfa9f328cc5 = (0, $6emiv.defineIntegration)($dcea18c049e4a5b3$var$_reportingObserverIntegration);
/**
 * Reporting API integration - https://w3c.github.io/reporting/
 * @deprecated Use `reportingObserverIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $dcea18c049e4a5b3$export$922d48d1e32daf68 = (0, $6emiv.convertIntegrationFnToClass)($dcea18c049e4a5b3$var$INTEGRATION_NAME, $dcea18c049e4a5b3$export$609cccfa9f328cc5);

});

parcelRegister("8jpeT", function(module, exports) {

$parcel$export(module.exports, "rewriteFramesIntegration", () => $60d3ad12d0a884e4$export$5ed0db6416cb6ea2);
$parcel$export(module.exports, "RewriteFrames", () => $60d3ad12d0a884e4$export$af39fa91d1acf248);

var $6emiv = parcelRequire("6emiv");

var $d1CZ9 = parcelRequire("d1CZ9");
const $60d3ad12d0a884e4$var$INTEGRATION_NAME = 'RewriteFrames';
const $60d3ad12d0a884e4$var$_rewriteFramesIntegration = (options = {})=>{
    const root = options.root;
    const prefix = options.prefix || 'app:///';
    const iteratee = options.iteratee || ((frame)=>{
        if (!frame.filename) return frame;
        // Determine if this is a Windows frame by checking for a Windows-style prefix such as `C:\`
        const isWindowsFrame = /^[a-zA-Z]:\\/.test(frame.filename) || // or the presence of a backslash without a forward slash (which are not allowed on Windows)
        frame.filename.includes('\\') && !frame.filename.includes('/');
        // Check if the frame filename begins with `/`
        const startsWithSlash = /^\//.test(frame.filename);
        if (isWindowsFrame || startsWithSlash) {
            const filename = isWindowsFrame ? frame.filename.replace(/^[a-zA-Z]:/, '') // remove Windows-style prefix
            .replace(/\\/g, '/') // replace all `\\` instances with `/`
             : frame.filename;
            const base = root ? (0, $d1CZ9.relative)(root, filename) : (0, $d1CZ9.basename)(filename);
            frame.filename = `${prefix}${base}`;
        }
        return frame;
    });
    /** Process an exception event. */ function _processExceptionsEvent(event) {
        try {
            return {
                ...event,
                exception: {
                    ...event.exception,
                    // The check for this is performed inside `process` call itself, safe to skip here
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    values: event.exception.values.map((value)=>({
                            ...value,
                            ...value.stacktrace && {
                                stacktrace: _processStacktrace(value.stacktrace)
                            }
                        }))
                }
            };
        } catch (_oO) {
            return event;
        }
    }
    /** Process a stack trace. */ function _processStacktrace(stacktrace) {
        return {
            ...stacktrace,
            frames: stacktrace && stacktrace.frames && stacktrace.frames.map((f)=>iteratee(f))
        };
    }
    return {
        name: $60d3ad12d0a884e4$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        processEvent (originalEvent) {
            let processedEvent = originalEvent;
            if (originalEvent.exception && Array.isArray(originalEvent.exception.values)) processedEvent = _processExceptionsEvent(processedEvent);
            return processedEvent;
        }
    };
};
const $60d3ad12d0a884e4$export$5ed0db6416cb6ea2 = (0, $6emiv.defineIntegration)($60d3ad12d0a884e4$var$_rewriteFramesIntegration);
/**
 * Rewrite event frames paths.
 * @deprecated Use `rewriteFramesIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $60d3ad12d0a884e4$export$af39fa91d1acf248 = (0, $6emiv.convertIntegrationFnToClass)($60d3ad12d0a884e4$var$INTEGRATION_NAME, $60d3ad12d0a884e4$export$5ed0db6416cb6ea2);

});
parcelRegister("d1CZ9", function(module, exports) {

$parcel$export(module.exports, "relative", () => $97b99c02563cbc4f$export$f0e7d1106eeabbe6);
$parcel$export(module.exports, "basename", () => $97b99c02563cbc4f$export$9bf319d8f74f51d1);
// Slightly modified (no IE8 support, ES6) and transcribed to TypeScript
// https://github.com/calvinmetcalf/rollup-plugin-node-builtins/blob/63ab8aacd013767445ca299e468d9a60a95328d7/src/es6/path.js
//
// Copyright Joyent, Inc.and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
/** JSDoc */ function $97b99c02563cbc4f$var$normalizeArray(parts, allowAboveRoot) {
    // if the path tries to go above the root, `up` ends up > 0
    let up = 0;
    for(let i = parts.length - 1; i >= 0; i--){
        const last = parts[i];
        if (last === '.') parts.splice(i, 1);
        else if (last === '..') {
            parts.splice(i, 1);
            up++;
        } else if (up) {
            parts.splice(i, 1);
            up--;
        }
    }
    // if the path is allowed to go above the root, restore leading ..s
    if (allowAboveRoot) for(; up--; up)parts.unshift('..');
    return parts;
}
// Split a filename into [root, dir, basename, ext], unix version
// 'root' is just a slash, or nothing.
const $97b99c02563cbc4f$var$splitPathRe = /^(\S+:\\|\/?)([\s\S]*?)((?:\.{1,2}|[^/\\]+?|)(\.[^./\\]*|))(?:[/\\]*)$/;
/** JSDoc */ function $97b99c02563cbc4f$var$splitPath(filename) {
    // Truncate files names greater than 1024 characters to avoid regex dos
    // https://github.com/getsentry/sentry-javascript/pull/8737#discussion_r1285719172
    const truncated = filename.length > 1024 ? `<truncated>${filename.slice(-1024)}` : filename;
    const parts = $97b99c02563cbc4f$var$splitPathRe.exec(truncated);
    return parts ? parts.slice(1) : [];
}
// path.resolve([from ...], to)
// posix version
/** JSDoc */ function $97b99c02563cbc4f$export$f7ad0328861e2f03(...args) {
    let resolvedPath = '';
    let resolvedAbsolute = false;
    for(let i = args.length - 1; i >= -1 && !resolvedAbsolute; i--){
        const path = i >= 0 ? args[i] : '/';
        // Skip empty entries
        if (!path) continue;
        resolvedPath = `${path}/${resolvedPath}`;
        resolvedAbsolute = path.charAt(0) === '/';
    }
    // At this point the path should be resolved to a full absolute path, but
    // handle relative paths to be safe (might happen when process.cwd() fails)
    // Normalize the path
    resolvedPath = $97b99c02563cbc4f$var$normalizeArray(resolvedPath.split('/').filter((p)=>!!p), !resolvedAbsolute).join('/');
    return (resolvedAbsolute ? '/' : '') + resolvedPath || '.';
}
/** JSDoc */ function $97b99c02563cbc4f$var$trim(arr) {
    let start = 0;
    for(; start < arr.length; start++){
        if (arr[start] !== '') break;
    }
    let end = arr.length - 1;
    for(; end >= 0; end--){
        if (arr[end] !== '') break;
    }
    if (start > end) return [];
    return arr.slice(start, end - start + 1);
}
// path.relative(from, to)
// posix version
/** JSDoc */ function $97b99c02563cbc4f$export$f0e7d1106eeabbe6(from, to) {
    /* eslint-disable no-param-reassign */ from = $97b99c02563cbc4f$export$f7ad0328861e2f03(from).slice(1);
    to = $97b99c02563cbc4f$export$f7ad0328861e2f03(to).slice(1);
    /* eslint-enable no-param-reassign */ const fromParts = $97b99c02563cbc4f$var$trim(from.split('/'));
    const toParts = $97b99c02563cbc4f$var$trim(to.split('/'));
    const length = Math.min(fromParts.length, toParts.length);
    let samePartsLength = length;
    for(let i = 0; i < length; i++)if (fromParts[i] !== toParts[i]) {
        samePartsLength = i;
        break;
    }
    let outputParts = [];
    for(let i = samePartsLength; i < fromParts.length; i++)outputParts.push('..');
    outputParts = outputParts.concat(toParts.slice(samePartsLength));
    return outputParts.join('/');
}
// path.normalize(path)
// posix version
/** JSDoc */ function $97b99c02563cbc4f$export$6af368f973c74c5(path) {
    const isPathAbsolute = $97b99c02563cbc4f$export$e434c7255acda994(path);
    const trailingSlash = path.slice(-1) === '/';
    // Normalize the path
    let normalizedPath = $97b99c02563cbc4f$var$normalizeArray(path.split('/').filter((p)=>!!p), !isPathAbsolute).join('/');
    if (!normalizedPath && !isPathAbsolute) normalizedPath = '.';
    if (normalizedPath && trailingSlash) normalizedPath += '/';
    return (isPathAbsolute ? '/' : '') + normalizedPath;
}
// posix version
/** JSDoc */ function $97b99c02563cbc4f$export$e434c7255acda994(path) {
    return path.charAt(0) === '/';
}
// posix version
/** JSDoc */ function $97b99c02563cbc4f$export$f7e2c8231c57a8bd(...args) {
    return $97b99c02563cbc4f$export$6af368f973c74c5(args.join('/'));
}
/** JSDoc */ function $97b99c02563cbc4f$export$7f7b8152cc673abe(path) {
    const result = $97b99c02563cbc4f$var$splitPath(path);
    const root = result[0];
    let dir = result[1];
    if (!root && !dir) // No dirname whatsoever
    return '.';
    if (dir) // It has a dirname, strip trailing slash
    dir = dir.slice(0, dir.length - 1);
    return root + dir;
}
/** JSDoc */ function $97b99c02563cbc4f$export$9bf319d8f74f51d1(path, ext) {
    let f = $97b99c02563cbc4f$var$splitPath(path)[2];
    if (ext && f.slice(ext.length * -1) === ext) f = f.slice(0, f.length - ext.length);
    return f;
}

});


parcelRegister("3wp2s", function(module, exports) {

$parcel$export(module.exports, "sessionTimingIntegration", () => $2907c864a27c9bb3$export$5787162663950c6d);

var $6emiv = parcelRequire("6emiv");
const $2907c864a27c9bb3$var$INTEGRATION_NAME = 'SessionTiming';
const $2907c864a27c9bb3$var$_sessionTimingIntegration = ()=>{
    const startTime = Date.now();
    return {
        name: $2907c864a27c9bb3$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        processEvent (event) {
            const now = Date.now();
            return {
                ...event,
                extra: {
                    ...event.extra,
                    ['session:start']: startTime,
                    ['session:duration']: now - startTime,
                    ['session:end']: now
                }
            };
        }
    };
};
const $2907c864a27c9bb3$export$5787162663950c6d = (0, $6emiv.defineIntegration)($2907c864a27c9bb3$var$_sessionTimingIntegration);
/**
 * This function adds duration since Sentry was initialized till the time event was sent.
 * @deprecated Use `sessionTimingIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $2907c864a27c9bb3$export$43065883b38218d8 = (0, $6emiv.convertIntegrationFnToClass)($2907c864a27c9bb3$var$INTEGRATION_NAME, $2907c864a27c9bb3$export$5787162663950c6d);

});

parcelRegister("2G2rZ", function(module, exports) {

$parcel$export(module.exports, "BrowserTracing", () => $1f31679a9dbab8ac$export$46d3bbd0375f5fa4);

var $13ShQ = parcelRequire("13ShQ");
var $jL5ha = parcelRequire("jL5ha");
var $fq71H = parcelRequire("fq71H");
var $5ukjY = parcelRequire("5ukjY");
var $9XkOL = parcelRequire("9XkOL");

var $3oSFd = parcelRequire("3oSFd");
var $lN8pX = parcelRequire("lN8pX");
var $27K1p = parcelRequire("27K1p");

var $iDP9B = parcelRequire("iDP9B");

var $d8B5C = parcelRequire("d8B5C");

var $7ytqC = parcelRequire("7ytqC");

var $jVgAA = parcelRequire("jVgAA");

var $dwq5q = parcelRequire("dwq5q");

var $lbCcz = parcelRequire("lbCcz");

var $7bfNR = parcelRequire("7bfNR");
const $1f31679a9dbab8ac$export$bbd2089f30bd3708 = 'BrowserTracing';
/** Options for Browser Tracing integration */ const $1f31679a9dbab8ac$var$DEFAULT_BROWSER_TRACING_OPTIONS = {
    ...(0, $9XkOL.TRACING_DEFAULTS),
    markBackgroundTransactions: true,
    routingInstrumentation: (0, $lbCcz.instrumentRoutingWithDefaults),
    startTransactionOnLocationChange: true,
    startTransactionOnPageLoad: true,
    enableLongTask: true,
    enableInp: false,
    interactionsSampleRate: 1,
    _experiments: {},
    ...(0, $dwq5q.defaultRequestInstrumentationOptions)
};
/** We store up to 10 interaction candidates max to cap memory usage. This is the same cap as getINP from web-vitals */ const $1f31679a9dbab8ac$var$MAX_INTERACTIONS = 10;
/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library. This integration uses {@see IdleTransaction} to create transactions.
 *
 * @deprecated Use `browserTracingIntegration()` instead.
 */ class $1f31679a9dbab8ac$export$46d3bbd0375f5fa4 {
    // This class currently doesn't have a static `id` field like the other integration classes, because it prevented
    // @sentry/tracing from being treeshaken. Tree shakers do not like static fields, because they behave like side effects.
    // TODO: Come up with a better plan, than using static fields on integration classes, and use that plan on all
    // integrations.
    /** Browser Tracing integration options */ /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    constructor(_options){
        this.name = $1f31679a9dbab8ac$export$bbd2089f30bd3708;
        this._hasSetTracePropagationTargets = false;
        (0, $13ShQ.addTracingExtensions)();
        if (0, $iDP9B.DEBUG_BUILD) this._hasSetTracePropagationTargets = !!(_options && // eslint-disable-next-line deprecation/deprecation
        (_options.tracePropagationTargets || _options.tracingOrigins));
        this.options = {
            ...$1f31679a9dbab8ac$var$DEFAULT_BROWSER_TRACING_OPTIONS,
            ..._options
        };
        // Special case: enableLongTask can be set in _experiments
        // TODO (v8): Remove this in v8
        if (this.options._experiments.enableLongTask !== undefined) this.options.enableLongTask = this.options._experiments.enableLongTask;
        // TODO (v8): remove this block after tracingOrigins is removed
        // Set tracePropagationTargets to tracingOrigins if specified by the user
        // In case both are specified, tracePropagationTargets takes precedence
        // eslint-disable-next-line deprecation/deprecation
        if (_options && !_options.tracePropagationTargets && _options.tracingOrigins) // eslint-disable-next-line deprecation/deprecation
        this.options.tracePropagationTargets = _options.tracingOrigins;
        this._collectWebVitals = (0, $jVgAA.startTrackingWebVitals)();
        /** Stores a mapping of interactionIds from PerformanceEventTimings to the origin interaction path */ this._interactionIdToRouteNameMapping = {};
        if (this.options.enableInp) (0, $jVgAA.startTrackingINP)(this._interactionIdToRouteNameMapping, this.options.interactionsSampleRate);
        if (this.options.enableLongTask) (0, $jVgAA.startTrackingLongTasks)();
        if (this.options._experiments.enableInteractions) (0, $jVgAA.startTrackingInteractions)();
        this._latestRoute = {
            name: undefined,
            context: undefined
        };
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    setupOnce(_, getCurrentHub) {
        this._getCurrentHub = getCurrentHub;
        const hub = getCurrentHub();
        // eslint-disable-next-line deprecation/deprecation
        const client = hub.getClient();
        const clientOptions = client && client.getOptions();
        const { routingInstrumentation: instrumentRouting, startTransactionOnLocationChange: startTransactionOnLocationChange, startTransactionOnPageLoad: startTransactionOnPageLoad, markBackgroundTransactions: markBackgroundTransactions, traceFetch: traceFetch, traceXHR: traceXHR, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings, _experiments: _experiments } = this.options;
        const clientOptionsTracePropagationTargets = clientOptions && clientOptions.tracePropagationTargets;
        // There are three ways to configure tracePropagationTargets:
        // 1. via top level client option `tracePropagationTargets`
        // 2. via BrowserTracing option `tracePropagationTargets`
        // 3. via BrowserTracing option `tracingOrigins` (deprecated)
        //
        // To avoid confusion, favour top level client option `tracePropagationTargets`, and fallback to
        // BrowserTracing option `tracePropagationTargets` and then `tracingOrigins` (deprecated).
        // This is done as it minimizes bundle size (we don't have to have undefined checks).
        //
        // If both 1 and either one of 2 or 3 are set (from above), we log out a warning.
        // eslint-disable-next-line deprecation/deprecation
        const tracePropagationTargets = clientOptionsTracePropagationTargets || this.options.tracePropagationTargets;
        if ((0, $iDP9B.DEBUG_BUILD) && this._hasSetTracePropagationTargets && clientOptionsTracePropagationTargets) (0, $lN8pX.logger).warn('[Tracing] The `tracePropagationTargets` option was set in the BrowserTracing integration and top level `Sentry.init`. The top level `Sentry.init` value is being used.');
        instrumentRouting((context)=>{
            const transaction = this._createRouteTransaction(context);
            this.options._experiments.onStartRouteTransaction && this.options._experiments.onStartRouteTransaction(transaction, context, getCurrentHub);
            return transaction;
        }, startTransactionOnPageLoad, startTransactionOnLocationChange);
        if (markBackgroundTransactions) (0, $d8B5C.registerBackgroundTabDetection)();
        if (_experiments.enableInteractions) this._registerInteractionListener();
        if (this.options.enableInp) this._registerInpInteractionListener();
        (0, $dwq5q.instrumentOutgoingRequests)({
            traceFetch: traceFetch,
            traceXHR: traceXHR,
            tracePropagationTargets: tracePropagationTargets,
            shouldCreateSpanForRequest: shouldCreateSpanForRequest,
            enableHTTPTimings: enableHTTPTimings
        });
    }
    /** Create routing idle transaction. */ _createRouteTransaction(context) {
        if (!this._getCurrentHub) {
            (0, $iDP9B.DEBUG_BUILD) && (0, $lN8pX.logger).warn(`[Tracing] Did not create ${context.op} transaction because _getCurrentHub is invalid.`);
            return undefined;
        }
        const hub = this._getCurrentHub();
        const { beforeNavigate: beforeNavigate, idleTimeout: idleTimeout, finalTimeout: finalTimeout, heartbeatInterval: heartbeatInterval } = this.options;
        const isPageloadTransaction = context.op === 'pageload';
        let expandedContext;
        if (isPageloadTransaction) {
            const sentryTrace = isPageloadTransaction ? $1f31679a9dbab8ac$export$f147b32b03c9cf11('sentry-trace') : '';
            const baggage = isPageloadTransaction ? $1f31679a9dbab8ac$export$f147b32b03c9cf11('baggage') : undefined;
            const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: sampled } = (0, $27K1p.propagationContextFromHeaders)(sentryTrace, baggage);
            expandedContext = {
                traceId: traceId,
                parentSpanId: parentSpanId,
                parentSampled: sampled,
                ...context,
                metadata: {
                    // eslint-disable-next-line deprecation/deprecation
                    ...context.metadata,
                    dynamicSamplingContext: dsc
                },
                trimEnd: true
            };
        } else expandedContext = {
            trimEnd: true,
            ...context
        };
        const modifiedContext = typeof beforeNavigate === 'function' ? beforeNavigate(expandedContext) : expandedContext;
        // For backwards compatibility reasons, beforeNavigate can return undefined to "drop" the transaction (prevent it
        // from being sent to Sentry).
        const finalContext = modifiedContext === undefined ? {
            ...expandedContext,
            sampled: false
        } : modifiedContext;
        // If `beforeNavigate` set a custom name, record that fact
        // eslint-disable-next-line deprecation/deprecation
        finalContext.metadata = finalContext.name !== expandedContext.name ? {
            ...finalContext.metadata,
            source: 'custom'
        } : finalContext.metadata;
        this._latestRoute.name = finalContext.name;
        this._latestRoute.context = finalContext;
        // eslint-disable-next-line deprecation/deprecation
        if (finalContext.sampled === false) (0, $iDP9B.DEBUG_BUILD) && (0, $lN8pX.logger).log(`[Tracing] Will not send ${finalContext.op} transaction because of beforeNavigate.`);
        (0, $iDP9B.DEBUG_BUILD) && (0, $lN8pX.logger).log(`[Tracing] Starting ${finalContext.op} transaction on scope`);
        const { location: location } = (0, $7bfNR.WINDOW);
        const idleTransaction = (0, $13ShQ.startIdleTransaction)(hub, finalContext, idleTimeout, finalTimeout, true, {
            location: location
        }, heartbeatInterval, isPageloadTransaction);
        if (isPageloadTransaction) {
            if ((0, $7bfNR.WINDOW).document) {
                (0, $7bfNR.WINDOW).document.addEventListener('readystatechange', ()=>{
                    if ([
                        'interactive',
                        'complete'
                    ].includes((0, $7bfNR.WINDOW).document.readyState)) idleTransaction.sendAutoFinishSignal();
                });
                if ([
                    'interactive',
                    'complete'
                ].includes((0, $7bfNR.WINDOW).document.readyState)) idleTransaction.sendAutoFinishSignal();
            }
        }
        idleTransaction.registerBeforeFinishCallback((transaction)=>{
            this._collectWebVitals();
            (0, $jVgAA.addPerformanceEntries)(transaction);
        });
        return idleTransaction;
    }
    /** Start listener for interaction transactions */ _registerInteractionListener() {
        let inflightInteractionTransaction;
        const registerInteractionTransaction = ()=>{
            const { idleTimeout: idleTimeout, finalTimeout: finalTimeout, heartbeatInterval: heartbeatInterval } = this.options;
            const op = 'ui.action.click';
            // eslint-disable-next-line deprecation/deprecation
            const currentTransaction = (0, $jL5ha.getActiveTransaction)();
            if (currentTransaction && currentTransaction.op && [
                'navigation',
                'pageload'
            ].includes(currentTransaction.op)) {
                (0, $iDP9B.DEBUG_BUILD) && (0, $lN8pX.logger).warn(`[Tracing] Did not create ${op} transaction because a pageload or navigation transaction is in progress.`);
                return undefined;
            }
            if (inflightInteractionTransaction) {
                inflightInteractionTransaction.setFinishReason('interactionInterrupted');
                inflightInteractionTransaction.end();
                inflightInteractionTransaction = undefined;
            }
            if (!this._getCurrentHub) {
                (0, $iDP9B.DEBUG_BUILD) && (0, $lN8pX.logger).warn(`[Tracing] Did not create ${op} transaction because _getCurrentHub is invalid.`);
                return undefined;
            }
            if (!this._latestRoute.name) {
                (0, $iDP9B.DEBUG_BUILD) && (0, $lN8pX.logger).warn(`[Tracing] Did not create ${op} transaction because _latestRouteName is missing.`);
                return undefined;
            }
            const hub = this._getCurrentHub();
            const { location: location } = (0, $7bfNR.WINDOW);
            const context = {
                name: this._latestRoute.name,
                op: op,
                trimEnd: true,
                data: {
                    [(0, $5ukjY.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: this._latestRoute.context ? $1f31679a9dbab8ac$var$getSource(this._latestRoute.context) : 'url'
                }
            };
            inflightInteractionTransaction = (0, $13ShQ.startIdleTransaction)(hub, context, idleTimeout, finalTimeout, true, {
                location: location
            }, heartbeatInterval);
        };
        [
            'click'
        ].forEach((type)=>{
            if ((0, $7bfNR.WINDOW).document) addEventListener(type, registerInteractionTransaction, {
                once: false,
                capture: true
            });
        });
    }
    /** Creates a listener on interaction entries, and maps interactionIds to the origin path of the interaction */ _registerInpInteractionListener() {
        const handleEntries = ({ entries: entries })=>{
            const client = (0, $fq71H.getClient)();
            // We need to get the replay, user, and activeTransaction from the current scope
            // so that we can associate replay id, profile id, and a user display to the span
            const replay = client !== undefined && client.getIntegrationByName !== undefined ? client.getIntegrationByName('Replay') : undefined;
            const replayId = replay !== undefined ? replay.getReplayId() : undefined;
            // eslint-disable-next-line deprecation/deprecation
            const activeTransaction = (0, $jL5ha.getActiveTransaction)();
            const currentScope = (0, $fq71H.getCurrentScope)();
            const user = currentScope !== undefined ? currentScope.getUser() : undefined;
            entries.forEach((entry)=>{
                if ($1f31679a9dbab8ac$var$isPerformanceEventTiming(entry)) {
                    const interactionId = entry.interactionId;
                    if (interactionId === undefined) return;
                    const existingInteraction = this._interactionIdToRouteNameMapping[interactionId];
                    const duration = entry.duration;
                    const startTime = entry.startTime;
                    const keys = Object.keys(this._interactionIdToRouteNameMapping);
                    const minInteractionId = keys.length > 0 ? keys.reduce((a, b)=>{
                        return this._interactionIdToRouteNameMapping[a].duration < this._interactionIdToRouteNameMapping[b].duration ? a : b;
                    }) : undefined;
                    // For a first input event to be considered, we must check that an interaction event does not already exist with the same duration and start time.
                    // This is also checked in the web-vitals library.
                    if (entry.entryType === 'first-input') {
                        const matchingEntry = keys.map((key)=>this._interactionIdToRouteNameMapping[key]).some((interaction)=>{
                            return interaction.duration === duration && interaction.startTime === startTime;
                        });
                        if (matchingEntry) return;
                    }
                    // Interactions with an id of 0 and are not first-input are not valid.
                    if (!interactionId) return;
                    // If the interaction already exists, we want to use the duration of the longest entry, since that is what the INP metric uses.
                    if (existingInteraction) existingInteraction.duration = Math.max(existingInteraction.duration, duration);
                    else if (keys.length < $1f31679a9dbab8ac$var$MAX_INTERACTIONS || minInteractionId === undefined || duration > this._interactionIdToRouteNameMapping[minInteractionId].duration) {
                        // If the interaction does not exist, we want to add it to the mapping if there is space, or if the duration is longer than the shortest entry.
                        const routeName = this._latestRoute.name;
                        const parentContext = this._latestRoute.context;
                        if (routeName && parentContext) {
                            if (minInteractionId && Object.keys(this._interactionIdToRouteNameMapping).length >= $1f31679a9dbab8ac$var$MAX_INTERACTIONS) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
                            delete this._interactionIdToRouteNameMapping[minInteractionId];
                            this._interactionIdToRouteNameMapping[interactionId] = {
                                routeName: routeName,
                                duration: duration,
                                parentContext: parentContext,
                                user: user,
                                activeTransaction: activeTransaction,
                                replayId: replayId,
                                startTime: startTime
                            };
                        }
                    }
                }
            });
        };
        (0, $7ytqC.addPerformanceInstrumentationHandler)('event', handleEntries);
        (0, $7ytqC.addPerformanceInstrumentationHandler)('first-input', handleEntries);
    }
}
/** Returns the value of a meta tag */ function $1f31679a9dbab8ac$export$f147b32b03c9cf11(metaName) {
    // Can't specify generic to `getDomElement` because tracing can be used
    // in a variety of environments, have to disable `no-unsafe-member-access`
    // as a result.
    const metaTag = (0, $3oSFd.getDomElement)(`meta[name=${metaName}]`);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return metaTag ? metaTag.getAttribute('content') : undefined;
}
function $1f31679a9dbab8ac$var$getSource(context) {
    const sourceFromAttributes = context.attributes && context.attributes[0, $5ukjY.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
    // eslint-disable-next-line deprecation/deprecation
    const sourceFromData = context.data && context.data[0, $5ukjY.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
    // eslint-disable-next-line deprecation/deprecation
    const sourceFromMetadata = context.metadata && context.metadata.source;
    return sourceFromAttributes || sourceFromData || sourceFromMetadata;
}
function $1f31679a9dbab8ac$var$isPerformanceEventTiming(entry) {
    return 'duration' in entry;
}

});
parcelRegister("iDP9B", function(module, exports) {

$parcel$export(module.exports, "DEBUG_BUILD", () => $d9238c9bcf613a5f$export$16a28057038b10ef);
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $d9238c9bcf613a5f$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;

});

parcelRegister("d8B5C", function(module, exports) {

$parcel$export(module.exports, "registerBackgroundTabDetection", () => $9908caf226a091e1$export$6f18f55521af71a1);

var $jL5ha = parcelRequire("jL5ha");
var $aYVgD = parcelRequire("aYVgD");

var $lN8pX = parcelRequire("lN8pX");

var $iDP9B = parcelRequire("iDP9B");

var $7bfNR = parcelRequire("7bfNR");
/**
 * Add a listener that cancels and finishes a transaction when the global
 * document is hidden.
 */ function $9908caf226a091e1$export$6f18f55521af71a1() {
    if ((0, $7bfNR.WINDOW).document) (0, $7bfNR.WINDOW).document.addEventListener('visibilitychange', ()=>{
        // eslint-disable-next-line deprecation/deprecation
        const activeTransaction = (0, $jL5ha.getActiveTransaction)();
        if ((0, $7bfNR.WINDOW).document.hidden && activeTransaction) {
            const statusType = 'cancelled';
            const { op: op, status: status } = (0, $aYVgD.spanToJSON)(activeTransaction);
            (0, $iDP9B.DEBUG_BUILD) && (0, $lN8pX.logger).log(`[Tracing] Transaction: ${statusType} -> since tab moved to the background, op: ${op}`);
            // We should not set status if it is already set, this prevent important statuses like
            // error or data loss from being overwritten on transaction.
            if (!status) activeTransaction.setStatus(statusType);
            // TODO: Can we rewrite this to an attribute?
            // eslint-disable-next-line deprecation/deprecation
            activeTransaction.setTag('visibilitychange', 'document.hidden');
            activeTransaction.end();
        }
    });
    else (0, $iDP9B.DEBUG_BUILD) && (0, $lN8pX.logger).warn('[Tracing] Could not set up background tab detection due to lack of global document');
}

});
parcelRegister("7bfNR", function(module, exports) {

$parcel$export(module.exports, "WINDOW", () => $53a5d1ae1b90c615$export$56d8a8a25bd48b81);

var $4mb67 = parcelRequire("4mb67");
const $53a5d1ae1b90c615$export$56d8a8a25bd48b81 = (0, $4mb67.GLOBAL_OBJ);

});


parcelRegister("7ytqC", function(module, exports) {

$parcel$export(module.exports, "addClsInstrumentationHandler", () => $5802894253379e42$export$861b82818b37ba5b);
$parcel$export(module.exports, "addLcpInstrumentationHandler", () => $5802894253379e42$export$3fd4b53331200102);
$parcel$export(module.exports, "addTtfbInstrumentationHandler", () => $5802894253379e42$export$699d9529c099a797);
$parcel$export(module.exports, "addFidInstrumentationHandler", () => $5802894253379e42$export$2707d7471c0b918f);
$parcel$export(module.exports, "addInpInstrumentationHandler", () => $5802894253379e42$export$da3b76aa2022cbd7);
$parcel$export(module.exports, "addPerformanceInstrumentationHandler", () => $5802894253379e42$export$69816c1a049f8db6);

var $jVtDJ = parcelRequire("jVtDJ");
var $lN8pX = parcelRequire("lN8pX");

var $iDP9B = parcelRequire("iDP9B");

var $9QLL2 = parcelRequire("9QLL2");

var $5g6c0 = parcelRequire("5g6c0");

var $h4MJS = parcelRequire("h4MJS");

var $8Xcsd = parcelRequire("8Xcsd");

var $kAzJr = parcelRequire("kAzJr");

var $kdQUF = parcelRequire("kdQUF");
const $5802894253379e42$var$handlers = {};
const $5802894253379e42$var$instrumented = {};
let $5802894253379e42$var$_previousCls;
let $5802894253379e42$var$_previousFid;
let $5802894253379e42$var$_previousLcp;
let $5802894253379e42$var$_previousTtfb;
let $5802894253379e42$var$_previousInp;
/**
 * Add a callback that will be triggered when a CLS metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for CLS when the cleanup callback is called.
 * This will lead to the CLS being finalized and frozen.
 */ function $5802894253379e42$export$861b82818b37ba5b(callback, stopOnCallback = false) {
    return $5802894253379e42$var$addMetricObserver('cls', callback, $5802894253379e42$var$instrumentCls, $5802894253379e42$var$_previousCls, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a LCP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for LCP when the cleanup callback is called.
 * This will lead to the LCP being finalized and frozen.
 */ function $5802894253379e42$export$3fd4b53331200102(callback, stopOnCallback = false) {
    return $5802894253379e42$var$addMetricObserver('lcp', callback, $5802894253379e42$var$instrumentLcp, $5802894253379e42$var$_previousLcp, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a FID metric is available.
 */ function $5802894253379e42$export$699d9529c099a797(callback) {
    return $5802894253379e42$var$addMetricObserver('ttfb', callback, $5802894253379e42$var$instrumentTtfb, $5802894253379e42$var$_previousTtfb);
}
/**
 * Add a callback that will be triggered when a FID metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $5802894253379e42$export$2707d7471c0b918f(callback) {
    return $5802894253379e42$var$addMetricObserver('fid', callback, $5802894253379e42$var$instrumentFid, $5802894253379e42$var$_previousFid);
}
/**
 * Add a callback that will be triggered when a INP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $5802894253379e42$export$da3b76aa2022cbd7(callback) {
    return $5802894253379e42$var$addMetricObserver('inp', callback, $5802894253379e42$var$instrumentInp, $5802894253379e42$var$_previousInp);
}
/**
 * Add a callback that will be triggered when a performance observer is triggered,
 * and receives the entries of the observer.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $5802894253379e42$export$69816c1a049f8db6(type, callback) {
    $5802894253379e42$var$addHandler(type, callback);
    if (!$5802894253379e42$var$instrumented[type]) {
        $5802894253379e42$var$instrumentPerformanceObserver(type);
        $5802894253379e42$var$instrumented[type] = true;
    }
    return $5802894253379e42$var$getCleanupCallback(type, callback);
}
/** Trigger all handlers of a given type. */ function $5802894253379e42$var$triggerHandlers(type, data) {
    const typeHandlers = $5802894253379e42$var$handlers[type];
    if (!typeHandlers || !typeHandlers.length) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $iDP9B.DEBUG_BUILD) && (0, $lN8pX.logger).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $jVtDJ.getFunctionName)(handler)}\nError:`, e);
    }
}
function $5802894253379e42$var$instrumentCls() {
    return (0, $9QLL2.onCLS)((metric)=>{
        $5802894253379e42$var$triggerHandlers('cls', {
            metric: metric
        });
        $5802894253379e42$var$_previousCls = metric;
    }, {
        reportAllChanges: true
    });
}
function $5802894253379e42$var$instrumentFid() {
    return (0, $5g6c0.onFID)((metric)=>{
        $5802894253379e42$var$triggerHandlers('fid', {
            metric: metric
        });
        $5802894253379e42$var$_previousFid = metric;
    });
}
function $5802894253379e42$var$instrumentLcp() {
    return (0, $8Xcsd.onLCP)((metric)=>{
        $5802894253379e42$var$triggerHandlers('lcp', {
            metric: metric
        });
        $5802894253379e42$var$_previousLcp = metric;
    });
}
function $5802894253379e42$var$instrumentTtfb() {
    return (0, $kdQUF.onTTFB)((metric)=>{
        $5802894253379e42$var$triggerHandlers('ttfb', {
            metric: metric
        });
        $5802894253379e42$var$_previousTtfb = metric;
    });
}
function $5802894253379e42$var$instrumentInp() {
    return (0, $h4MJS.onINP)((metric)=>{
        $5802894253379e42$var$triggerHandlers('inp', {
            metric: metric
        });
        $5802894253379e42$var$_previousInp = metric;
    });
}
function $5802894253379e42$var$addMetricObserver(type, callback, instrumentFn, previousValue, stopOnCallback = false) {
    $5802894253379e42$var$addHandler(type, callback);
    let stopListening;
    if (!$5802894253379e42$var$instrumented[type]) {
        stopListening = instrumentFn();
        $5802894253379e42$var$instrumented[type] = true;
    }
    if (previousValue) callback({
        metric: previousValue
    });
    return $5802894253379e42$var$getCleanupCallback(type, callback, stopOnCallback ? stopListening : undefined);
}
function $5802894253379e42$var$instrumentPerformanceObserver(type) {
    const options = {};
    // Special per-type options we want to use
    if (type === 'event') options.durationThreshold = 0;
    (0, $kAzJr.observe)(type, (entries)=>{
        $5802894253379e42$var$triggerHandlers(type, {
            entries: entries
        });
    }, options);
}
function $5802894253379e42$var$addHandler(type, handler) {
    $5802894253379e42$var$handlers[type] = $5802894253379e42$var$handlers[type] || [];
    $5802894253379e42$var$handlers[type].push(handler);
}
// Get a callback which can be called to remove the instrumentation handler
function $5802894253379e42$var$getCleanupCallback(type, callback, stopListening) {
    return ()=>{
        if (stopListening) stopListening();
        const typeHandlers = $5802894253379e42$var$handlers[type];
        if (!typeHandlers) return;
        const index = typeHandlers.indexOf(callback);
        if (index !== -1) typeHandlers.splice(index, 1);
    };
}

});
parcelRegister("9QLL2", function(module, exports) {

$parcel$export(module.exports, "onCLS", () => $72be040feef41485$export$a7873055838e5ad8);

var $6JGBk = parcelRequire("6JGBk");

var $fUHPw = parcelRequire("fUHPw");

var $kAzJr = parcelRequire("kAzJr");

var $kjgfl = parcelRequire("kjgfl");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Calculates the [CLS](https://web.dev/cls/) value for the current page and
 * calls the `callback` function once the value is ready to be reported, along
 * with all `layout-shift` performance entries that were used in the metric
 * value calculation. The reported value is a `double` (corresponding to a
 * [layout shift score](https://web.dev/cls/#layout-shift-score)).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** CLS should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ const $72be040feef41485$export$a7873055838e5ad8 = (onReport, options = {})=>{
    const metric = (0, $fUHPw.initMetric)('CLS', 0);
    let report;
    let sessionValue = 0;
    let sessionEntries = [];
    // const handleEntries = (entries: Metric['entries']) => {
    const handleEntries = (entries)=>{
        entries.forEach((entry)=>{
            // Only count layout shifts without recent user input.
            if (!entry.hadRecentInput) {
                const firstSessionEntry = sessionEntries[0];
                const lastSessionEntry = sessionEntries[sessionEntries.length - 1];
                // If the entry occurred less than 1 second after the previous entry and
                // less than 5 seconds after the first entry in the session, include the
                // entry in the current session. Otherwise, start a new session.
                if (sessionValue && sessionEntries.length !== 0 && entry.startTime - lastSessionEntry.startTime < 1000 && entry.startTime - firstSessionEntry.startTime < 5000) {
                    sessionValue += entry.value;
                    sessionEntries.push(entry);
                } else {
                    sessionValue = entry.value;
                    sessionEntries = [
                        entry
                    ];
                }
                // If the current session value is larger than the current CLS value,
                // update CLS and the entries contributing to it.
                if (sessionValue > metric.value) {
                    metric.value = sessionValue;
                    metric.entries = sessionEntries;
                    if (report) report();
                }
            }
        });
    };
    const po = (0, $kAzJr.observe)('layout-shift', handleEntries);
    if (po) {
        report = (0, $6JGBk.bindReporter)(onReport, metric, options.reportAllChanges);
        const stopListening = ()=>{
            handleEntries(po.takeRecords());
            report(true);
        };
        (0, $kjgfl.onHidden)(stopListening);
        return stopListening;
    }
    return;
};

});
parcelRegister("6JGBk", function(module, exports) {

$parcel$export(module.exports, "bindReporter", () => $4e77fdb4feb7fc4b$export$17679dccdd551979);
const $4e77fdb4feb7fc4b$export$17679dccdd551979 = (callback, metric, reportAllChanges)=>{
    let prevValue;
    let delta;
    return (forceReport)=>{
        if (metric.value >= 0) {
            if (forceReport || reportAllChanges) {
                delta = metric.value - (prevValue || 0);
                // Report the metric if there's a non-zero delta or if no previous
                // value exists (which can happen in the case of the document becoming
                // hidden when the metric value is 0).
                // See: https://github.com/GoogleChrome/web-vitals/issues/14
                if (delta || prevValue === undefined) {
                    prevValue = metric.value;
                    metric.delta = delta;
                    callback(metric);
                }
            }
        }
    };
};

});

parcelRegister("fUHPw", function(module, exports) {

$parcel$export(module.exports, "initMetric", () => $b95e15b06f6ddaa9$export$3c29b44508a0612b);

var $7bfNR = parcelRequire("7bfNR");

var $2n3X1 = parcelRequire("2n3X1");

var $lN4MW = parcelRequire("lN4MW");

var $ev7Gb = parcelRequire("ev7Gb");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $b95e15b06f6ddaa9$export$3c29b44508a0612b = (name, value)=>{
    const navEntry = (0, $ev7Gb.getNavigationEntry)();
    let navigationType = 'navigate';
    if (navEntry) {
        if ((0, $7bfNR.WINDOW).document && (0, $7bfNR.WINDOW).document.prerendering || (0, $lN4MW.getActivationStart)() > 0) navigationType = 'prerender';
        else navigationType = navEntry.type.replace(/_/g, '-');
    }
    return {
        name: name,
        value: typeof value === 'undefined' ? -1 : value,
        rating: 'good',
        delta: 0,
        entries: [],
        id: (0, $2n3X1.generateUniqueID)(),
        navigationType: navigationType
    };
};

});
parcelRegister("2n3X1", function(module, exports) {

$parcel$export(module.exports, "generateUniqueID", () => $1ba0cb5a850f88d1$export$407ea409d1f3b539);
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Performantly generate a unique, 30-char string by combining a version
 * number, the current timestamp with a 13-digit number integer.
 * @return {string}
 */ const $1ba0cb5a850f88d1$export$407ea409d1f3b539 = ()=>{
    return `v3-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`;
};

});

parcelRegister("lN4MW", function(module, exports) {

$parcel$export(module.exports, "getActivationStart", () => $fdd1e378db65dc07$export$d3e828b3c7b5b845);

var $ev7Gb = parcelRequire("ev7Gb");
/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $fdd1e378db65dc07$export$d3e828b3c7b5b845 = ()=>{
    const navEntry = (0, $ev7Gb.getNavigationEntry)();
    return navEntry && navEntry.activationStart || 0;
};

});
parcelRegister("ev7Gb", function(module, exports) {

$parcel$export(module.exports, "getNavigationEntry", () => $a8e9eae41b997e16$export$6431553786c94949);

var $7bfNR = parcelRequire("7bfNR");
/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $a8e9eae41b997e16$var$getNavigationEntryFromPerformanceTiming = ()=>{
    // eslint-disable-next-line deprecation/deprecation
    const timing = (0, $7bfNR.WINDOW).performance.timing;
    // eslint-disable-next-line deprecation/deprecation
    const type = (0, $7bfNR.WINDOW).performance.navigation.type;
    const navigationEntry = {
        entryType: 'navigation',
        startTime: 0,
        type: type == 2 ? 'back_forward' : type === 1 ? 'reload' : 'navigate'
    };
    for(const key in timing)if (key !== 'navigationStart' && key !== 'toJSON') // eslint-disable-next-line deprecation/deprecation
    navigationEntry[key] = Math.max(timing[key] - timing.navigationStart, 0);
    return navigationEntry;
};
const $a8e9eae41b997e16$export$6431553786c94949 = ()=>{
    if ((0, $7bfNR.WINDOW).__WEB_VITALS_POLYFILL__) return (0, $7bfNR.WINDOW).performance && (performance.getEntriesByType && performance.getEntriesByType('navigation')[0] || $a8e9eae41b997e16$var$getNavigationEntryFromPerformanceTiming());
    else return (0, $7bfNR.WINDOW).performance && performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
};

});



parcelRegister("kAzJr", function(module, exports) {

$parcel$export(module.exports, "observe", () => $efd2e30cbee7e1eb$export$d1203567a167490e);
/**
 * Takes a performance entry type and a callback function, and creates a
 * `PerformanceObserver` instance that will observe the specified entry type
 * with buffering enabled and call the callback _for each entry_.
 *
 * This function also feature-detects entry support and wraps the logic in a
 * try/catch to avoid errors in unsupporting browsers.
 */ const $efd2e30cbee7e1eb$export$d1203567a167490e = (type, callback, opts)=>{
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(type)) {
            const po = new PerformanceObserver((list)=>{
                callback(list.getEntries());
            });
            po.observe(Object.assign({
                type: type,
                buffered: true
            }, opts || {}));
            return po;
        }
    } catch (e) {
    // Do nothing.
    }
    return;
};

});

parcelRegister("kjgfl", function(module, exports) {

$parcel$export(module.exports, "onHidden", () => $ec922f3a15bbf282$export$91ec2be6fdd8f1b4);

var $7bfNR = parcelRequire("7bfNR");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $ec922f3a15bbf282$export$91ec2be6fdd8f1b4 = (cb, once)=>{
    const onHiddenOrPageHide = (event)=>{
        if (event.type === 'pagehide' || (0, $7bfNR.WINDOW).document.visibilityState === 'hidden') {
            cb(event);
            if (once) {
                removeEventListener('visibilitychange', onHiddenOrPageHide, true);
                removeEventListener('pagehide', onHiddenOrPageHide, true);
            }
        }
    };
    if ((0, $7bfNR.WINDOW).document) {
        addEventListener('visibilitychange', onHiddenOrPageHide, true);
        // Some browsers have buggy implementations of visibilitychange,
        // so we use pagehide in addition, just to be safe.
        addEventListener('pagehide', onHiddenOrPageHide, true);
    }
};

});


parcelRegister("5g6c0", function(module, exports) {

$parcel$export(module.exports, "onFID", () => $3d43401c7850a31e$export$39705a25c49af873);

var $6JGBk = parcelRequire("6JGBk");

var $dnMKP = parcelRequire("dnMKP");

var $fUHPw = parcelRequire("fUHPw");

var $kAzJr = parcelRequire("kAzJr");

var $kjgfl = parcelRequire("kjgfl");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Calculates the [FID](https://web.dev/fid/) value for the current page and
 * calls the `callback` function once the value is ready, along with the
 * relevant `first-input` performance entry used to determine the value. The
 * reported value is a `DOMHighResTimeStamp`.
 *
 * _**Important:** since FID is only reported after the user interacts with the
 * page, it's possible that it will not be reported for some page loads._
 */ const $3d43401c7850a31e$export$39705a25c49af873 = (onReport)=>{
    const visibilityWatcher = (0, $dnMKP.getVisibilityWatcher)();
    const metric = (0, $fUHPw.initMetric)('FID');
    // eslint-disable-next-line prefer-const
    let report;
    const handleEntry = (entry)=>{
        // Only report if the page wasn't hidden prior to the first input.
        if (entry.startTime < visibilityWatcher.firstHiddenTime) {
            metric.value = entry.processingStart - entry.startTime;
            metric.entries.push(entry);
            report(true);
        }
    };
    const handleEntries = (entries)=>{
        entries.forEach(handleEntry);
    };
    const po = (0, $kAzJr.observe)('first-input', handleEntries);
    report = (0, $6JGBk.bindReporter)(onReport, metric);
    if (po) (0, $kjgfl.onHidden)(()=>{
        handleEntries(po.takeRecords());
        po.disconnect();
    }, true);
};

});
parcelRegister("dnMKP", function(module, exports) {

$parcel$export(module.exports, "getVisibilityWatcher", () => $9be33deaa9008fb0$export$443f86b2c77012c4);

var $7bfNR = parcelRequire("7bfNR");

var $kjgfl = parcelRequire("kjgfl");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $9be33deaa9008fb0$var$firstHiddenTime = -1;
const $9be33deaa9008fb0$var$initHiddenTime = ()=>{
    // If the document is hidden and not prerendering, assume it was always
    // hidden and the page was loaded in the background.
    if ((0, $7bfNR.WINDOW).document && (0, $7bfNR.WINDOW).document.visibilityState) $9be33deaa9008fb0$var$firstHiddenTime = (0, $7bfNR.WINDOW).document.visibilityState === 'hidden' && !(0, $7bfNR.WINDOW).document.prerendering ? 0 : Infinity;
};
const $9be33deaa9008fb0$var$trackChanges = ()=>{
    // Update the time if/when the document becomes hidden.
    (0, $kjgfl.onHidden)(({ timeStamp: timeStamp })=>{
        $9be33deaa9008fb0$var$firstHiddenTime = timeStamp;
    }, true);
};
const $9be33deaa9008fb0$export$443f86b2c77012c4 = ()=>{
    if ($9be33deaa9008fb0$var$firstHiddenTime < 0) {
        // If the document is hidden when this code runs, assume it was hidden
        // since navigation start. This isn't a perfect heuristic, but it's the
        // best we can do until an API is available to support querying past
        // visibilityState.
        $9be33deaa9008fb0$var$initHiddenTime();
        $9be33deaa9008fb0$var$trackChanges();
    }
    return {
        get firstHiddenTime () {
            return $9be33deaa9008fb0$var$firstHiddenTime;
        }
    };
};

});


parcelRegister("h4MJS", function(module, exports) {

$parcel$export(module.exports, "onINP", () => $c6e89de77a3334b9$export$7df4b36ecaed99e1);

var $6JGBk = parcelRequire("6JGBk");

var $fUHPw = parcelRequire("fUHPw");

var $kAzJr = parcelRequire("kAzJr");

var $kjgfl = parcelRequire("kjgfl");

var $bueP0 = parcelRequire("bueP0");
/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns the interaction count since the last bfcache restore (or for the
 * full page lifecycle if there were no bfcache restores).
 */ const $c6e89de77a3334b9$var$getInteractionCountForNavigation = ()=>{
    return (0, $bueP0.getInteractionCount)();
};
// To prevent unnecessary memory usage on pages with lots of interactions,
// store at most 10 of the longest interactions to consider as INP candidates.
const $c6e89de77a3334b9$var$MAX_INTERACTIONS_TO_CONSIDER = 10;
// A list of longest interactions on the page (by latency) sorted so the
// longest one is first. The list is as most MAX_INTERACTIONS_TO_CONSIDER long.
const $c6e89de77a3334b9$var$longestInteractionList = [];
// A mapping of longest interactions by their interaction ID.
// This is used for faster lookup.
const $c6e89de77a3334b9$var$longestInteractionMap = {};
/**
 * Takes a performance entry and adds it to the list of worst interactions
 * if its duration is long enough to make it among the worst. If the
 * entry is part of an existing interaction, it is merged and the latency
 * and entries list is updated as needed.
 */ const $c6e89de77a3334b9$var$processEntry = (entry)=>{
    // The least-long of the 10 longest interactions.
    const minLongestInteraction = $c6e89de77a3334b9$var$longestInteractionList[$c6e89de77a3334b9$var$longestInteractionList.length - 1];
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const existingInteraction = $c6e89de77a3334b9$var$longestInteractionMap[entry.interactionId];
    // Only process the entry if it's possibly one of the ten longest,
    // or if it's part of an existing interaction.
    if (existingInteraction || $c6e89de77a3334b9$var$longestInteractionList.length < $c6e89de77a3334b9$var$MAX_INTERACTIONS_TO_CONSIDER || entry.duration > minLongestInteraction.latency) {
        // If the interaction already exists, update it. Otherwise create one.
        if (existingInteraction) {
            existingInteraction.entries.push(entry);
            existingInteraction.latency = Math.max(existingInteraction.latency, entry.duration);
        } else {
            const interaction = {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                id: entry.interactionId,
                latency: entry.duration,
                entries: [
                    entry
                ]
            };
            $c6e89de77a3334b9$var$longestInteractionMap[interaction.id] = interaction;
            $c6e89de77a3334b9$var$longestInteractionList.push(interaction);
        }
        // Sort the entries by latency (descending) and keep only the top ten.
        $c6e89de77a3334b9$var$longestInteractionList.sort((a, b)=>b.latency - a.latency);
        $c6e89de77a3334b9$var$longestInteractionList.splice($c6e89de77a3334b9$var$MAX_INTERACTIONS_TO_CONSIDER).forEach((i)=>{
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete $c6e89de77a3334b9$var$longestInteractionMap[i.id];
        });
    }
};
/**
 * Returns the estimated p98 longest interaction based on the stored
 * interaction candidates and the interaction count for the current page.
 */ const $c6e89de77a3334b9$var$estimateP98LongestInteraction = ()=>{
    const candidateInteractionIndex = Math.min($c6e89de77a3334b9$var$longestInteractionList.length - 1, Math.floor($c6e89de77a3334b9$var$getInteractionCountForNavigation() / 50));
    return $c6e89de77a3334b9$var$longestInteractionList[candidateInteractionIndex];
};
/**
 * Calculates the [INP](https://web.dev/responsiveness/) value for the current
 * page and calls the `callback` function once the value is ready, along with
 * the `event` performance entries reported for that interaction. The reported
 * value is a `DOMHighResTimeStamp`.
 *
 * A custom `durationThreshold` configuration option can optionally be passed to
 * control what `event-timing` entries are considered for INP reporting. The
 * default threshold is `40`, which means INP scores of less than 40 are
 * reported as 0. Note that this will not affect your 75th percentile INP value
 * unless that value is also less than 40 (well below the recommended
 * [good](https://web.dev/inp/#what-is-a-good-inp-score) threshold).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** INP should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ const $c6e89de77a3334b9$export$7df4b36ecaed99e1 = (onReport, opts)=>{
    // Set defaults
    // eslint-disable-next-line no-param-reassign
    opts = opts || {};
    // https://web.dev/inp/#what's-a-%22good%22-inp-value
    // const thresholds = [200, 500];
    // TODO(philipwalton): remove once the polyfill is no longer needed.
    (0, $bueP0.initInteractionCountPolyfill)();
    const metric = (0, $fUHPw.initMetric)('INP');
    // eslint-disable-next-line prefer-const
    let report;
    const handleEntries = (entries)=>{
        entries.forEach((entry)=>{
            if (entry.interactionId) $c6e89de77a3334b9$var$processEntry(entry);
            // Entries of type `first-input` don't currently have an `interactionId`,
            // so to consider them in INP we have to first check that an existing
            // entry doesn't match the `duration` and `startTime`.
            // Note that this logic assumes that `event` entries are dispatched
            // before `first-input` entries. This is true in Chrome but it is not
            // true in Firefox; however, Firefox doesn't support interactionId, so
            // it's not an issue at the moment.
            // TODO(philipwalton): remove once crbug.com/1325826 is fixed.
            if (entry.entryType === 'first-input') {
                const noMatchingEntry = !$c6e89de77a3334b9$var$longestInteractionList.some((interaction)=>{
                    return interaction.entries.some((prevEntry)=>{
                        return entry.duration === prevEntry.duration && entry.startTime === prevEntry.startTime;
                    });
                });
                if (noMatchingEntry) $c6e89de77a3334b9$var$processEntry(entry);
            }
        });
        const inp = $c6e89de77a3334b9$var$estimateP98LongestInteraction();
        if (inp && inp.latency !== metric.value) {
            metric.value = inp.latency;
            metric.entries = inp.entries;
            report();
        }
    };
    const po = (0, $kAzJr.observe)('event', handleEntries, {
        // Event Timing entries have their durations rounded to the nearest 8ms,
        // so a duration of 40ms would be any event that spans 2.5 or more frames
        // at 60Hz. This threshold is chosen to strike a balance between usefulness
        // and performance. Running this callback for any interaction that spans
        // just one or two frames is likely not worth the insight that could be
        // gained.
        durationThreshold: opts.durationThreshold || 40
    });
    report = (0, $6JGBk.bindReporter)(onReport, metric, opts.reportAllChanges);
    if (po) {
        // Also observe entries of type `first-input`. This is useful in cases
        // where the first interaction is less than the `durationThreshold`.
        po.observe({
            type: 'first-input',
            buffered: true
        });
        (0, $kjgfl.onHidden)(()=>{
            handleEntries(po.takeRecords());
            // If the interaction count shows that there were interactions but
            // none were captured by the PerformanceObserver, report a latency of 0.
            if (metric.value < 0 && $c6e89de77a3334b9$var$getInteractionCountForNavigation() > 0) {
                metric.value = 0;
                metric.entries = [];
            }
            report(true);
        });
    }
};

});
parcelRegister("bueP0", function(module, exports) {

$parcel$export(module.exports, "getInteractionCount", () => $85cdfe52efa5b0f6$export$8a962f2683a476d1);
$parcel$export(module.exports, "initInteractionCountPolyfill", () => $85cdfe52efa5b0f6$export$67d90cda6b78a2eb);

var $kAzJr = parcelRequire("kAzJr");
let $85cdfe52efa5b0f6$var$interactionCountEstimate = 0;
let $85cdfe52efa5b0f6$var$minKnownInteractionId = Infinity;
let $85cdfe52efa5b0f6$var$maxKnownInteractionId = 0;
const $85cdfe52efa5b0f6$var$updateEstimate = (entries)=>{
    entries.forEach((e)=>{
        if (e.interactionId) {
            $85cdfe52efa5b0f6$var$minKnownInteractionId = Math.min($85cdfe52efa5b0f6$var$minKnownInteractionId, e.interactionId);
            $85cdfe52efa5b0f6$var$maxKnownInteractionId = Math.max($85cdfe52efa5b0f6$var$maxKnownInteractionId, e.interactionId);
            $85cdfe52efa5b0f6$var$interactionCountEstimate = $85cdfe52efa5b0f6$var$maxKnownInteractionId ? ($85cdfe52efa5b0f6$var$maxKnownInteractionId - $85cdfe52efa5b0f6$var$minKnownInteractionId) / 7 + 1 : 0;
        }
    });
};
let $85cdfe52efa5b0f6$var$po;
/**
 * Returns the `interactionCount` value using the native API (if available)
 * or the polyfill estimate in this module.
 */ const $85cdfe52efa5b0f6$export$8a962f2683a476d1 = ()=>{
    return $85cdfe52efa5b0f6$var$po ? $85cdfe52efa5b0f6$var$interactionCountEstimate : performance.interactionCount || 0;
};
/**
 * Feature detects native support or initializes the polyfill if needed.
 */ const $85cdfe52efa5b0f6$export$67d90cda6b78a2eb = ()=>{
    if ('interactionCount' in performance || $85cdfe52efa5b0f6$var$po) return;
    $85cdfe52efa5b0f6$var$po = (0, $kAzJr.observe)('event', $85cdfe52efa5b0f6$var$updateEstimate, {
        type: 'event',
        buffered: true,
        durationThreshold: 0
    });
};

});


parcelRegister("8Xcsd", function(module, exports) {

$parcel$export(module.exports, "onLCP", () => $684d7e901312048b$export$947b1626ab8d5632);

var $7bfNR = parcelRequire("7bfNR");

var $6JGBk = parcelRequire("6JGBk");

var $lN4MW = parcelRequire("lN4MW");

var $dnMKP = parcelRequire("dnMKP");

var $fUHPw = parcelRequire("fUHPw");

var $kAzJr = parcelRequire("kAzJr");

var $kjgfl = parcelRequire("kjgfl");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $684d7e901312048b$var$reportedMetricIDs = {};
/**
 * Calculates the [LCP](https://web.dev/lcp/) value for the current page and
 * calls the `callback` function once the value is ready (along with the
 * relevant `largest-contentful-paint` performance entry used to determine the
 * value). The reported value is a `DOMHighResTimeStamp`.
 */ const $684d7e901312048b$export$947b1626ab8d5632 = (onReport)=>{
    const visibilityWatcher = (0, $dnMKP.getVisibilityWatcher)();
    const metric = (0, $fUHPw.initMetric)('LCP');
    let report;
    const handleEntries = (entries)=>{
        const lastEntry = entries[entries.length - 1];
        if (lastEntry) {
            // The startTime attribute returns the value of the renderTime if it is
            // not 0, and the value of the loadTime otherwise. The activationStart
            // reference is used because LCP should be relative to page activation
            // rather than navigation start if the page was prerendered.
            const value = Math.max(lastEntry.startTime - (0, $lN4MW.getActivationStart)(), 0);
            // Only report if the page wasn't hidden prior to LCP.
            if (value < visibilityWatcher.firstHiddenTime) {
                metric.value = value;
                metric.entries = [
                    lastEntry
                ];
                report();
            }
        }
    };
    const po = (0, $kAzJr.observe)('largest-contentful-paint', handleEntries);
    if (po) {
        report = (0, $6JGBk.bindReporter)(onReport, metric);
        const stopListening = ()=>{
            if (!$684d7e901312048b$var$reportedMetricIDs[metric.id]) {
                handleEntries(po.takeRecords());
                po.disconnect();
                $684d7e901312048b$var$reportedMetricIDs[metric.id] = true;
                report(true);
            }
        };
        // Stop listening after input. Note: while scrolling is an input that
        // stop LCP observation, it's unreliable since it can be programmatically
        // generated. See: https://github.com/GoogleChrome/web-vitals/issues/75
        [
            'keydown',
            'click'
        ].forEach((type)=>{
            if ((0, $7bfNR.WINDOW).document) addEventListener(type, stopListening, {
                once: true,
                capture: true
            });
        });
        (0, $kjgfl.onHidden)(stopListening, true);
        return stopListening;
    }
    return;
};

});

parcelRegister("kdQUF", function(module, exports) {

$parcel$export(module.exports, "onTTFB", () => $eb8e10f1ad3ebcea$export$33a01e6c5f2c7e33);

var $7bfNR = parcelRequire("7bfNR");

var $6JGBk = parcelRequire("6JGBk");

var $lN4MW = parcelRequire("lN4MW");

var $ev7Gb = parcelRequire("ev7Gb");

var $fUHPw = parcelRequire("fUHPw");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Runs in the next task after the page is done loading and/or prerendering.
 * @param callback
 */ const $eb8e10f1ad3ebcea$var$whenReady = (callback)=>{
    if (!(0, $7bfNR.WINDOW).document) return;
    if ((0, $7bfNR.WINDOW).document.prerendering) addEventListener('prerenderingchange', ()=>$eb8e10f1ad3ebcea$var$whenReady(callback), true);
    else if ((0, $7bfNR.WINDOW).document.readyState !== 'complete') addEventListener('load', ()=>$eb8e10f1ad3ebcea$var$whenReady(callback), true);
    else // Queue a task so the callback runs after `loadEventEnd`.
    setTimeout(callback, 0);
};
/**
 * Calculates the [TTFB](https://web.dev/time-to-first-byte/) value for the
 * current page and calls the `callback` function once the page has loaded,
 * along with the relevant `navigation` performance entry used to determine the
 * value. The reported value is a `DOMHighResTimeStamp`.
 *
 * Note, this function waits until after the page is loaded to call `callback`
 * in order to ensure all properties of the `navigation` entry are populated.
 * This is useful if you want to report on other metrics exposed by the
 * [Navigation Timing API](https://w3c.github.io/navigation-timing/). For
 * example, the TTFB metric starts from the page's [time
 * origin](https://www.w3.org/TR/hr-time-2/#sec-time-origin), which means it
 * includes time spent on DNS lookup, connection negotiation, network latency,
 * and server processing time.
 */ const $eb8e10f1ad3ebcea$export$33a01e6c5f2c7e33 = (onReport, opts)=>{
    // Set defaults
    // eslint-disable-next-line no-param-reassign
    opts = opts || {};
    // https://web.dev/ttfb/#what-is-a-good-ttfb-score
    // const thresholds = [800, 1800];
    const metric = (0, $fUHPw.initMetric)('TTFB');
    const report = (0, $6JGBk.bindReporter)(onReport, metric, opts.reportAllChanges);
    $eb8e10f1ad3ebcea$var$whenReady(()=>{
        const navEntry = (0, $ev7Gb.getNavigationEntry)();
        if (navEntry) {
            // The activationStart reference is used because TTFB should be
            // relative to page activation rather than navigation start if the
            // page was prerendered. But in cases where `activationStart` occurs
            // after the first byte is received, this time should be clamped at 0.
            metric.value = Math.max(navEntry.responseStart - (0, $lN4MW.getActivationStart)(), 0);
            // In some cases the value reported is negative or is larger
            // than the current page time. Ignore these cases:
            // https://github.com/GoogleChrome/web-vitals/issues/137
            // https://github.com/GoogleChrome/web-vitals/issues/162
            if (metric.value < 0 || metric.value > performance.now()) return;
            metric.entries = [
                navEntry
            ];
            report(true);
        }
    });
};

});


parcelRegister("jVgAA", function(module, exports) {

$parcel$export(module.exports, "startTrackingWebVitals", () => $e810356dc06f0246$export$7c69f0412d101b88);
$parcel$export(module.exports, "startTrackingLongTasks", () => $e810356dc06f0246$export$f396d19077034ad2);
$parcel$export(module.exports, "startTrackingInteractions", () => $e810356dc06f0246$export$e27543e0976315e4);
$parcel$export(module.exports, "startTrackingINP", () => $e810356dc06f0246$export$f17d06681a4744a3);
$parcel$export(module.exports, "addPerformanceEntries", () => $e810356dc06f0246$export$5f8fa6b3467a7443);

var $aMWz3 = parcelRequire("aMWz3");
var $jL5ha = parcelRequire("jL5ha");
var $fq71H = parcelRequire("fq71H");
var $bcruQ = parcelRequire("bcruQ");
var $kDNXp = parcelRequire("kDNXp");
var $j1eGv = parcelRequire("j1eGv");
var $bJ5g8 = parcelRequire("bJ5g8");
var $aYVgD = parcelRequire("aYVgD");

var $leMLP = parcelRequire("leMLP");
var $3oSFd = parcelRequire("3oSFd");
var $lN8pX = parcelRequire("lN8pX");
var $23mcX = parcelRequire("23mcX");

var $iDP9B = parcelRequire("iDP9B");

var $7ytqC = parcelRequire("7ytqC");

var $7bfNR = parcelRequire("7bfNR");

var $dnMKP = parcelRequire("dnMKP");

var $fggqD = parcelRequire("fggqD");

var $ev7Gb = parcelRequire("ev7Gb");
const $e810356dc06f0246$var$MAX_INT_AS_BYTES = 2147483647;
/**
 * Converts from milliseconds to seconds
 * @param time time in ms
 */ function $e810356dc06f0246$var$msToSec(time) {
    return time / 1000;
}
function $e810356dc06f0246$var$getBrowserPerformanceAPI() {
    // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
    return (0, $7bfNR.WINDOW) && (0, $7bfNR.WINDOW).addEventListener && (0, $7bfNR.WINDOW).performance;
}
let $e810356dc06f0246$var$_performanceCursor = 0;
let $e810356dc06f0246$var$_measurements = {};
let $e810356dc06f0246$var$_lcpEntry;
let $e810356dc06f0246$var$_clsEntry;
/**
 * Start tracking web vitals.
 * The callback returned by this function can be used to stop tracking & ensure all measurements are final & captured.
 *
 * @returns A function that forces web vitals collection
 */ function $e810356dc06f0246$export$7c69f0412d101b88() {
    const performance = $e810356dc06f0246$var$getBrowserPerformanceAPI();
    if (performance && (0, $leMLP.browserPerformanceTimeOrigin)) {
        // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
        if (performance.mark) (0, $7bfNR.WINDOW).performance.mark('sentry-tracing-init');
        const fidCallback = $e810356dc06f0246$var$_trackFID();
        const clsCallback = $e810356dc06f0246$var$_trackCLS();
        const lcpCallback = $e810356dc06f0246$var$_trackLCP();
        const ttfbCallback = $e810356dc06f0246$var$_trackTtfb();
        return ()=>{
            fidCallback();
            clsCallback();
            lcpCallback();
            ttfbCallback();
        };
    }
    return ()=>undefined;
}
/**
 * Start tracking long tasks.
 */ function $e810356dc06f0246$export$f396d19077034ad2() {
    (0, $7ytqC.addPerformanceInstrumentationHandler)('longtask', ({ entries: entries })=>{
        for (const entry of entries){
            // eslint-disable-next-line deprecation/deprecation
            const transaction = (0, $jL5ha.getActiveTransaction)();
            if (!transaction) return;
            const startTime = $e810356dc06f0246$var$msToSec((0, $leMLP.browserPerformanceTimeOrigin) + entry.startTime);
            const duration = $e810356dc06f0246$var$msToSec(entry.duration);
            // eslint-disable-next-line deprecation/deprecation
            transaction.startChild({
                description: 'Main UI thread blocked',
                op: 'ui.long-task',
                origin: 'auto.ui.browser.metrics',
                startTimestamp: startTime,
                endTimestamp: startTime + duration
            });
        }
    });
}
/**
 * Start tracking interaction events.
 */ function $e810356dc06f0246$export$e27543e0976315e4() {
    (0, $7ytqC.addPerformanceInstrumentationHandler)('event', ({ entries: entries })=>{
        for (const entry of entries){
            // eslint-disable-next-line deprecation/deprecation
            const transaction = (0, $jL5ha.getActiveTransaction)();
            if (!transaction) return;
            if (entry.name === 'click') {
                const startTime = $e810356dc06f0246$var$msToSec((0, $leMLP.browserPerformanceTimeOrigin) + entry.startTime);
                const duration = $e810356dc06f0246$var$msToSec(entry.duration);
                const span = {
                    description: (0, $3oSFd.htmlTreeAsString)(entry.target),
                    op: `ui.interaction.${entry.name}`,
                    origin: 'auto.ui.browser.metrics',
                    startTimestamp: startTime,
                    endTimestamp: startTime + duration
                };
                const componentName = (0, $3oSFd.getComponentName)(entry.target);
                if (componentName) span.attributes = {
                    'ui.component_name': componentName
                };
                // eslint-disable-next-line deprecation/deprecation
                transaction.startChild(span);
            }
        }
    });
}
/**
 * Start tracking INP webvital events.
 */ function $e810356dc06f0246$export$f17d06681a4744a3(interactionIdtoRouteNameMapping, interactionsSampleRate) {
    const performance = $e810356dc06f0246$var$getBrowserPerformanceAPI();
    if (performance && (0, $leMLP.browserPerformanceTimeOrigin)) {
        const inpCallback = $e810356dc06f0246$var$_trackINP(interactionIdtoRouteNameMapping, interactionsSampleRate);
        return ()=>{
            inpCallback();
        };
    }
    return ()=>undefined;
}
/** Starts tracking the Cumulative Layout Shift on the current page. */ function $e810356dc06f0246$var$_trackCLS() {
    return (0, $7ytqC.addClsInstrumentationHandler)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        (0, $iDP9B.DEBUG_BUILD) && (0, $lN8pX.logger).log('[Measurements] Adding CLS');
        $e810356dc06f0246$var$_measurements['cls'] = {
            value: metric.value,
            unit: ''
        };
        $e810356dc06f0246$var$_clsEntry = entry;
    }, true);
}
/** Starts tracking the Largest Contentful Paint on the current page. */ function $e810356dc06f0246$var$_trackLCP() {
    return (0, $7ytqC.addLcpInstrumentationHandler)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        (0, $iDP9B.DEBUG_BUILD) && (0, $lN8pX.logger).log('[Measurements] Adding LCP');
        $e810356dc06f0246$var$_measurements['lcp'] = {
            value: metric.value,
            unit: 'millisecond'
        };
        $e810356dc06f0246$var$_lcpEntry = entry;
    }, true);
}
/** Starts tracking the First Input Delay on the current page. */ function $e810356dc06f0246$var$_trackFID() {
    return (0, $7ytqC.addFidInstrumentationHandler)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        const timeOrigin = $e810356dc06f0246$var$msToSec((0, $leMLP.browserPerformanceTimeOrigin));
        const startTime = $e810356dc06f0246$var$msToSec(entry.startTime);
        (0, $iDP9B.DEBUG_BUILD) && (0, $lN8pX.logger).log('[Measurements] Adding FID');
        $e810356dc06f0246$var$_measurements['fid'] = {
            value: metric.value,
            unit: 'millisecond'
        };
        $e810356dc06f0246$var$_measurements['mark.fid'] = {
            value: timeOrigin + startTime,
            unit: 'second'
        };
    });
}
function $e810356dc06f0246$var$_trackTtfb() {
    return (0, $7ytqC.addTtfbInstrumentationHandler)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        (0, $iDP9B.DEBUG_BUILD) && (0, $lN8pX.logger).log('[Measurements] Adding TTFB');
        $e810356dc06f0246$var$_measurements['ttfb'] = {
            value: metric.value,
            unit: 'millisecond'
        };
    });
}
const $e810356dc06f0246$var$INP_ENTRY_MAP = {
    click: 'click',
    pointerdown: 'click',
    pointerup: 'click',
    mousedown: 'click',
    mouseup: 'click',
    touchstart: 'click',
    touchend: 'click',
    mouseover: 'hover',
    mouseout: 'hover',
    mouseenter: 'hover',
    mouseleave: 'hover',
    pointerover: 'hover',
    pointerout: 'hover',
    pointerenter: 'hover',
    pointerleave: 'hover',
    dragstart: 'drag',
    dragend: 'drag',
    drag: 'drag',
    dragenter: 'drag',
    dragleave: 'drag',
    dragover: 'drag',
    drop: 'drag',
    keydown: 'press',
    keyup: 'press',
    keypress: 'press',
    input: 'press'
};
/** Starts tracking the Interaction to Next Paint on the current page. */ function $e810356dc06f0246$var$_trackINP(interactionIdToRouteNameMapping, interactionsSampleRate) {
    return (0, $7ytqC.addInpInstrumentationHandler)(({ metric: metric })=>{
        if (metric.value === undefined) return;
        const entry = metric.entries.find((entry)=>entry.duration === metric.value && $e810356dc06f0246$var$INP_ENTRY_MAP[entry.name] !== undefined);
        const client = (0, $fq71H.getClient)();
        if (!entry || !client) return;
        const interactionType = $e810356dc06f0246$var$INP_ENTRY_MAP[entry.name];
        const options = client.getOptions();
        /** Build the INP span, create an envelope from the span, and then send the envelope */ const startTime = $e810356dc06f0246$var$msToSec((0, $leMLP.browserPerformanceTimeOrigin) + entry.startTime);
        const duration = $e810356dc06f0246$var$msToSec(metric.value);
        const interaction = entry.interactionId !== undefined ? interactionIdToRouteNameMapping[entry.interactionId] : undefined;
        if (interaction === undefined) return;
        const { routeName: routeName, parentContext: parentContext, activeTransaction: activeTransaction, user: user, replayId: replayId } = interaction;
        const userDisplay = user !== undefined ? user.email || user.id || user.ip_address : undefined;
        // eslint-disable-next-line deprecation/deprecation
        const profileId = activeTransaction !== undefined ? activeTransaction.getProfileId() : undefined;
        const span = new (0, $bJ5g8.Span)({
            startTimestamp: startTime,
            endTimestamp: startTime + duration,
            op: `ui.interaction.${interactionType}`,
            name: (0, $3oSFd.htmlTreeAsString)(entry.target),
            attributes: {
                release: options.release,
                environment: options.environment,
                transaction: routeName,
                ...userDisplay !== undefined && userDisplay !== '' ? {
                    user: userDisplay
                } : {},
                ...profileId !== undefined ? {
                    profile_id: profileId
                } : {},
                ...replayId !== undefined ? {
                    replay_id: replayId
                } : {}
            },
            exclusiveTime: metric.value,
            measurements: {
                inp: {
                    value: metric.value,
                    unit: 'millisecond'
                }
            }
        });
        /** Check to see if the span should be sampled */ const sampleRate = $e810356dc06f0246$var$getSampleRate(parentContext, options, interactionsSampleRate);
        if (!sampleRate) return;
        if (Math.random() < sampleRate) {
            const envelope = span ? (0, $aMWz3.createSpanEnvelope)([
                span
            ], client.getDsn()) : undefined;
            const transport = client && client.getTransport();
            if (transport && envelope) transport.send(envelope).then(null, (reason)=>{
                (0, $iDP9B.DEBUG_BUILD) && (0, $lN8pX.logger).error('Error while sending interaction:', reason);
            });
            return;
        }
    });
}
/** Add performance related spans to a transaction */ function $e810356dc06f0246$export$5f8fa6b3467a7443(transaction) {
    const performance = $e810356dc06f0246$var$getBrowserPerformanceAPI();
    if (!performance || !(0, $7bfNR.WINDOW).performance.getEntries || !(0, $leMLP.browserPerformanceTimeOrigin)) // Gatekeeper if performance API not available
    return;
    (0, $iDP9B.DEBUG_BUILD) && (0, $lN8pX.logger).log('[Tracing] Adding & adjusting spans using Performance API');
    const timeOrigin = $e810356dc06f0246$var$msToSec((0, $leMLP.browserPerformanceTimeOrigin));
    const performanceEntries = performance.getEntries();
    const { op: op, start_timestamp: transactionStartTime } = (0, $aYVgD.spanToJSON)(transaction);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    performanceEntries.slice($e810356dc06f0246$var$_performanceCursor).forEach((entry)=>{
        const startTime = $e810356dc06f0246$var$msToSec(entry.startTime);
        const duration = $e810356dc06f0246$var$msToSec(entry.duration);
        // eslint-disable-next-line deprecation/deprecation
        if (transaction.op === 'navigation' && transactionStartTime && timeOrigin + startTime < transactionStartTime) return;
        switch(entry.entryType){
            case 'navigation':
                $e810356dc06f0246$var$_addNavigationSpans(transaction, entry, timeOrigin);
                break;
            case 'mark':
            case 'paint':
            case 'measure':
                {
                    $e810356dc06f0246$export$bc93b84e4d45912d(transaction, entry, startTime, duration, timeOrigin);
                    // capture web vitals
                    const firstHidden = (0, $dnMKP.getVisibilityWatcher)();
                    // Only report if the page wasn't hidden prior to the web vital.
                    const shouldRecord = entry.startTime < firstHidden.firstHiddenTime;
                    if (entry.name === 'first-paint' && shouldRecord) {
                        (0, $iDP9B.DEBUG_BUILD) && (0, $lN8pX.logger).log('[Measurements] Adding FP');
                        $e810356dc06f0246$var$_measurements['fp'] = {
                            value: entry.startTime,
                            unit: 'millisecond'
                        };
                    }
                    if (entry.name === 'first-contentful-paint' && shouldRecord) {
                        (0, $iDP9B.DEBUG_BUILD) && (0, $lN8pX.logger).log('[Measurements] Adding FCP');
                        $e810356dc06f0246$var$_measurements['fcp'] = {
                            value: entry.startTime,
                            unit: 'millisecond'
                        };
                    }
                    break;
                }
            case 'resource':
                $e810356dc06f0246$export$c82fe1a70634f317(transaction, entry, entry.name, startTime, duration, timeOrigin);
                break;
        }
    });
    $e810356dc06f0246$var$_performanceCursor = Math.max(performanceEntries.length - 1, 0);
    $e810356dc06f0246$var$_trackNavigator(transaction);
    // Measurements are only available for pageload transactions
    if (op === 'pageload') {
        $e810356dc06f0246$var$_addTtfbRequestTimeToMeasurements($e810356dc06f0246$var$_measurements);
        [
            'fcp',
            'fp',
            'lcp'
        ].forEach((name)=>{
            if (!$e810356dc06f0246$var$_measurements[name] || !transactionStartTime || timeOrigin >= transactionStartTime) return;
            // The web vitals, fcp, fp, lcp, and ttfb, all measure relative to timeOrigin.
            // Unfortunately, timeOrigin is not captured within the transaction span data, so these web vitals will need
            // to be adjusted to be relative to transaction.startTimestamp.
            const oldValue = $e810356dc06f0246$var$_measurements[name].value;
            const measurementTimestamp = timeOrigin + $e810356dc06f0246$var$msToSec(oldValue);
            // normalizedValue should be in milliseconds
            const normalizedValue = Math.abs((measurementTimestamp - transactionStartTime) * 1000);
            const delta = normalizedValue - oldValue;
            (0, $iDP9B.DEBUG_BUILD) && (0, $lN8pX.logger).log(`[Measurements] Normalized ${name} from ${oldValue} to ${normalizedValue} (${delta})`);
            $e810356dc06f0246$var$_measurements[name].value = normalizedValue;
        });
        const fidMark = $e810356dc06f0246$var$_measurements['mark.fid'];
        if (fidMark && $e810356dc06f0246$var$_measurements['fid']) {
            // create span for FID
            (0, $fggqD._startChild)(transaction, {
                description: 'first input delay',
                endTimestamp: fidMark.value + $e810356dc06f0246$var$msToSec($e810356dc06f0246$var$_measurements['fid'].value),
                op: 'ui.action',
                origin: 'auto.ui.browser.metrics',
                startTimestamp: fidMark.value
            });
            // Delete mark.fid as we don't want it to be part of final payload
            delete $e810356dc06f0246$var$_measurements['mark.fid'];
        }
        // If FCP is not recorded we should not record the cls value
        // according to the new definition of CLS.
        if (!('fcp' in $e810356dc06f0246$var$_measurements)) delete $e810356dc06f0246$var$_measurements.cls;
        Object.keys($e810356dc06f0246$var$_measurements).forEach((measurementName)=>{
            (0, $j1eGv.setMeasurement)(measurementName, $e810356dc06f0246$var$_measurements[measurementName].value, $e810356dc06f0246$var$_measurements[measurementName].unit);
        });
        $e810356dc06f0246$var$_tagMetricInfo(transaction);
    }
    $e810356dc06f0246$var$_lcpEntry = undefined;
    $e810356dc06f0246$var$_clsEntry = undefined;
    $e810356dc06f0246$var$_measurements = {};
}
/** Create measure related spans */ function $e810356dc06f0246$export$bc93b84e4d45912d(transaction, // eslint-disable-next-line @typescript-eslint/no-explicit-any
entry, startTime, duration, timeOrigin) {
    const measureStartTimestamp = timeOrigin + startTime;
    const measureEndTimestamp = measureStartTimestamp + duration;
    (0, $fggqD._startChild)(transaction, {
        description: entry.name,
        endTimestamp: measureEndTimestamp,
        op: entry.entryType,
        origin: 'auto.resource.browser.metrics',
        startTimestamp: measureStartTimestamp
    });
    return measureStartTimestamp;
}
/** Instrument navigation entries */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $e810356dc06f0246$var$_addNavigationSpans(transaction, entry, timeOrigin) {
    [
        'unloadEvent',
        'redirect',
        'domContentLoadedEvent',
        'loadEvent',
        'connect'
    ].forEach((event)=>{
        $e810356dc06f0246$var$_addPerformanceNavigationTiming(transaction, entry, event, timeOrigin);
    });
    $e810356dc06f0246$var$_addPerformanceNavigationTiming(transaction, entry, 'secureConnection', timeOrigin, 'TLS/SSL', 'connectEnd');
    $e810356dc06f0246$var$_addPerformanceNavigationTiming(transaction, entry, 'fetch', timeOrigin, 'cache', 'domainLookupStart');
    $e810356dc06f0246$var$_addPerformanceNavigationTiming(transaction, entry, 'domainLookup', timeOrigin, 'DNS');
    $e810356dc06f0246$var$_addRequest(transaction, entry, timeOrigin);
}
/** Create performance navigation related spans */ function $e810356dc06f0246$var$_addPerformanceNavigationTiming(transaction, // eslint-disable-next-line @typescript-eslint/no-explicit-any
entry, event, timeOrigin, description, eventEnd) {
    const end = eventEnd ? entry[eventEnd] : entry[`${event}End`];
    const start = entry[`${event}Start`];
    if (!start || !end) return;
    (0, $fggqD._startChild)(transaction, {
        op: 'browser',
        origin: 'auto.browser.browser.metrics',
        description: description || event,
        startTimestamp: timeOrigin + $e810356dc06f0246$var$msToSec(start),
        endTimestamp: timeOrigin + $e810356dc06f0246$var$msToSec(end)
    });
}
/** Create request and response related spans */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $e810356dc06f0246$var$_addRequest(transaction, entry, timeOrigin) {
    if (entry.responseEnd) {
        // It is possible that we are collecting these metrics when the page hasn't finished loading yet, for example when the HTML slowly streams in.
        // In this case, ie. when the document request hasn't finished yet, `entry.responseEnd` will be 0.
        // In order not to produce faulty spans, where the end timestamp is before the start timestamp, we will only collect
        // these spans when the responseEnd value is available. The backend (Relay) would drop the entire transaction if it contained faulty spans.
        (0, $fggqD._startChild)(transaction, {
            op: 'browser',
            origin: 'auto.browser.browser.metrics',
            description: 'request',
            startTimestamp: timeOrigin + $e810356dc06f0246$var$msToSec(entry.requestStart),
            endTimestamp: timeOrigin + $e810356dc06f0246$var$msToSec(entry.responseEnd)
        });
        (0, $fggqD._startChild)(transaction, {
            op: 'browser',
            origin: 'auto.browser.browser.metrics',
            description: 'response',
            startTimestamp: timeOrigin + $e810356dc06f0246$var$msToSec(entry.responseStart),
            endTimestamp: timeOrigin + $e810356dc06f0246$var$msToSec(entry.responseEnd)
        });
    }
}
/** Create resource-related spans */ function $e810356dc06f0246$export$c82fe1a70634f317(transaction, entry, resourceUrl, startTime, duration, timeOrigin) {
    // we already instrument based on fetch and xhr, so we don't need to
    // duplicate spans here.
    if (entry.initiatorType === 'xmlhttprequest' || entry.initiatorType === 'fetch') return;
    const parsedUrl = (0, $23mcX.parseUrl)(resourceUrl);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const data = {};
    $e810356dc06f0246$var$setResourceEntrySizeData(data, entry, 'transferSize', 'http.response_transfer_size');
    $e810356dc06f0246$var$setResourceEntrySizeData(data, entry, 'encodedBodySize', 'http.response_content_length');
    $e810356dc06f0246$var$setResourceEntrySizeData(data, entry, 'decodedBodySize', 'http.decoded_response_content_length');
    if ('renderBlockingStatus' in entry) data['resource.render_blocking_status'] = entry.renderBlockingStatus;
    if (parsedUrl.protocol) data['url.scheme'] = parsedUrl.protocol.split(':').pop(); // the protocol returned by parseUrl includes a :, but OTEL spec does not, so we remove it.
    if (parsedUrl.host) data['server.address'] = parsedUrl.host;
    data['url.same_origin'] = resourceUrl.includes((0, $7bfNR.WINDOW).location.origin);
    const startTimestamp = timeOrigin + startTime;
    const endTimestamp = startTimestamp + duration;
    (0, $fggqD._startChild)(transaction, {
        description: resourceUrl.replace((0, $7bfNR.WINDOW).location.origin, ''),
        endTimestamp: endTimestamp,
        op: entry.initiatorType ? `resource.${entry.initiatorType}` : 'resource.other',
        origin: 'auto.resource.browser.metrics',
        startTimestamp: startTimestamp,
        data: data
    });
}
/**
 * Capture the information of the user agent.
 */ function $e810356dc06f0246$var$_trackNavigator(transaction) {
    const navigator = (0, $7bfNR.WINDOW).navigator;
    if (!navigator) return;
    // track network connectivity
    const connection = navigator.connection;
    if (connection) {
        if (connection.effectiveType) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag('effectiveConnectionType', connection.effectiveType);
        if (connection.type) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag('connectionType', connection.type);
        if ((0, $fggqD.isMeasurementValue)(connection.rtt)) $e810356dc06f0246$var$_measurements['connection.rtt'] = {
            value: connection.rtt,
            unit: 'millisecond'
        };
    }
    if ((0, $fggqD.isMeasurementValue)(navigator.deviceMemory)) // TODO: Can we rewrite this to an attribute?
    // eslint-disable-next-line deprecation/deprecation
    transaction.setTag('deviceMemory', `${navigator.deviceMemory} GB`);
    if ((0, $fggqD.isMeasurementValue)(navigator.hardwareConcurrency)) // TODO: Can we rewrite this to an attribute?
    // eslint-disable-next-line deprecation/deprecation
    transaction.setTag('hardwareConcurrency', String(navigator.hardwareConcurrency));
}
/** Add LCP / CLS data to transaction to allow debugging */ function $e810356dc06f0246$var$_tagMetricInfo(transaction) {
    if ($e810356dc06f0246$var$_lcpEntry) {
        (0, $iDP9B.DEBUG_BUILD) && (0, $lN8pX.logger).log('[Measurements] Adding LCP Data');
        // Capture Properties of the LCP element that contributes to the LCP.
        if ($e810356dc06f0246$var$_lcpEntry.element) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag('lcp.element', (0, $3oSFd.htmlTreeAsString)($e810356dc06f0246$var$_lcpEntry.element));
        if ($e810356dc06f0246$var$_lcpEntry.id) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag('lcp.id', $e810356dc06f0246$var$_lcpEntry.id);
        if ($e810356dc06f0246$var$_lcpEntry.url) // Trim URL to the first 200 characters.
        // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag('lcp.url', $e810356dc06f0246$var$_lcpEntry.url.trim().slice(0, 200));
        // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag('lcp.size', $e810356dc06f0246$var$_lcpEntry.size);
    }
    // See: https://developer.mozilla.org/en-US/docs/Web/API/LayoutShift
    if ($e810356dc06f0246$var$_clsEntry && $e810356dc06f0246$var$_clsEntry.sources) {
        (0, $iDP9B.DEBUG_BUILD) && (0, $lN8pX.logger).log('[Measurements] Adding CLS Data');
        $e810356dc06f0246$var$_clsEntry.sources.forEach((source, index)=>// TODO: Can we rewrite this to an attribute?
            // eslint-disable-next-line deprecation/deprecation
            transaction.setTag(`cls.source.${index + 1}`, (0, $3oSFd.htmlTreeAsString)(source.node)));
    }
}
function $e810356dc06f0246$var$setResourceEntrySizeData(data, entry, key, dataKey) {
    const entryVal = entry[key];
    if (entryVal != null && entryVal < $e810356dc06f0246$var$MAX_INT_AS_BYTES) data[dataKey] = entryVal;
}
/**
 * Add ttfb request time information to measurements.
 *
 * ttfb information is added via vendored web vitals library.
 */ function $e810356dc06f0246$var$_addTtfbRequestTimeToMeasurements(_measurements) {
    const navEntry = (0, $ev7Gb.getNavigationEntry)();
    if (!navEntry) return;
    const { responseStart: responseStart, requestStart: requestStart } = navEntry;
    if (requestStart <= responseStart) {
        (0, $iDP9B.DEBUG_BUILD) && (0, $lN8pX.logger).log('[Measurements] Adding TTFB Request Time');
        _measurements['ttfb.requestTime'] = {
            value: responseStart - requestStart,
            unit: 'millisecond'
        };
    }
}
/** Taken from @sentry/core sampling.ts */ function $e810356dc06f0246$var$getSampleRate(transactionContext, options, interactionsSampleRate) {
    if (!(0, $bcruQ.hasTracingEnabled)(options)) return false;
    let sampleRate;
    if (transactionContext !== undefined && typeof options.tracesSampler === 'function') sampleRate = options.tracesSampler({
        transactionContext: transactionContext,
        name: transactionContext.name,
        parentSampled: transactionContext.parentSampled,
        attributes: {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.data,
            ...transactionContext.attributes
        },
        location: (0, $7bfNR.WINDOW).location
    });
    else if (transactionContext !== undefined && transactionContext.sampled !== undefined) sampleRate = transactionContext.sampled;
    else if (typeof options.tracesSampleRate !== 'undefined') sampleRate = options.tracesSampleRate;
    else sampleRate = 1;
    if (!(0, $kDNXp.isValidSampleRate)(sampleRate)) {
        (0, $iDP9B.DEBUG_BUILD) && (0, $lN8pX.logger).warn('[Tracing] Discarding interaction span because of invalid sample rate.');
        return false;
    }
    if (sampleRate === true) return interactionsSampleRate;
    else if (sampleRate === false) return 0;
    return sampleRate * interactionsSampleRate;
}

});
parcelRegister("fggqD", function(module, exports) {

$parcel$export(module.exports, "isMeasurementValue", () => $b1c51809dc29c004$export$27169ccae1b439e3);
$parcel$export(module.exports, "_startChild", () => $b1c51809dc29c004$export$8bd469e1f37aa721);
/**
 * Checks if a given value is a valid measurement value.
 */ function $b1c51809dc29c004$export$27169ccae1b439e3(value) {
    return typeof value === 'number' && isFinite(value);
}
/**
 * Helper function to start child on transactions. This function will make sure that the transaction will
 * use the start timestamp of the created child span if it is earlier than the transactions actual
 * start timestamp.
 *
 * Note: this will not be possible anymore in v8,
 * unless we do some special handling for browser here...
 */ function $b1c51809dc29c004$export$8bd469e1f37aa721(transaction, { startTimestamp: startTimestamp, ...ctx }) {
    // eslint-disable-next-line deprecation/deprecation
    if (startTimestamp && transaction.startTimestamp > startTimestamp) // eslint-disable-next-line deprecation/deprecation
    transaction.startTimestamp = startTimestamp;
    // eslint-disable-next-line deprecation/deprecation
    return transaction.startChild({
        startTimestamp: startTimestamp,
        ...ctx
    });
}

});


parcelRegister("dwq5q", function(module, exports) {

$parcel$export(module.exports, "defaultRequestInstrumentationOptions", () => $9d827fbec7c2ec07$export$cc17fb3c0bc95cd7);
$parcel$export(module.exports, "instrumentOutgoingRequests", () => $9d827fbec7c2ec07$export$864489cb3478db3e);

var $fq71H = parcelRequire("fq71H");
var $7AtVc = parcelRequire("7AtVc");
var $egVmm = parcelRequire("egVmm");
var $bcruQ = parcelRequire("bcruQ");
var $5ukjY = parcelRequire("5ukjY");
var $lBW6h = parcelRequire("lBW6h");
var $aYVgD = parcelRequire("aYVgD");
var $9fRGu = parcelRequire("9fRGu");

var $8YW3h = parcelRequire("8YW3h");
var $8UJMm = parcelRequire("8UJMm");
var $1QelU = parcelRequire("1QelU");
var $leMLP = parcelRequire("leMLP");
var $27K1p = parcelRequire("27K1p");
var $23mcX = parcelRequire("23mcX");
var $jmfnM = parcelRequire("jmfnM");

var $4bw3t = parcelRequire("4bw3t");

var $7ytqC = parcelRequire("7ytqC");

var $7bfNR = parcelRequire("7bfNR");
/* eslint-disable max-lines */ const $9d827fbec7c2ec07$export$15bd0305d05ad07b = [
    'localhost',
    /^\/(?!\/)/
];
/** Options for Request Instrumentation */ const $9d827fbec7c2ec07$export$cc17fb3c0bc95cd7 = {
    traceFetch: true,
    traceXHR: true,
    enableHTTPTimings: true,
    // TODO (v8): Remove this property
    tracingOrigins: $9d827fbec7c2ec07$export$15bd0305d05ad07b,
    tracePropagationTargets: $9d827fbec7c2ec07$export$15bd0305d05ad07b
};
/** Registers span creators for xhr and fetch requests  */ function $9d827fbec7c2ec07$export$864489cb3478db3e(_options) {
    const { traceFetch: traceFetch, traceXHR: traceXHR, tracePropagationTargets: // eslint-disable-next-line deprecation/deprecation
    tracePropagationTargets, tracingOrigins: // eslint-disable-next-line deprecation/deprecation
    tracingOrigins, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings } = {
        traceFetch: $9d827fbec7c2ec07$export$cc17fb3c0bc95cd7.traceFetch,
        traceXHR: $9d827fbec7c2ec07$export$cc17fb3c0bc95cd7.traceXHR,
        ..._options
    };
    const shouldCreateSpan = typeof shouldCreateSpanForRequest === 'function' ? shouldCreateSpanForRequest : (_)=>true;
    // TODO(v8) Remove tracingOrigins here
    // The only reason we're passing it in here is because this instrumentOutgoingRequests function is publicly exported
    // and we don't want to break the API. We can remove it in v8.
    const shouldAttachHeadersWithTargets = (url)=>$9d827fbec7c2ec07$export$c260386ab3f0b3dd(url, tracePropagationTargets || tracingOrigins);
    const spans = {};
    if (traceFetch) (0, $8YW3h.addFetchInstrumentationHandler)((handlerData)=>{
        const createdSpan = (0, $4bw3t.instrumentFetchRequest)(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
        // We cannot use `window.location` in the generic fetch instrumentation,
        // but we need it for reliable `server.address` attribute.
        // so we extend this in here
        if (createdSpan) {
            const fullUrl = $9d827fbec7c2ec07$var$getFullURL(handlerData.fetchData.url);
            const host = fullUrl ? (0, $23mcX.parseUrl)(fullUrl).host : undefined;
            createdSpan.setAttributes({
                'http.url': fullUrl,
                'server.address': host
            });
        }
        if (enableHTTPTimings && createdSpan) $9d827fbec7c2ec07$var$addHTTPTimings(createdSpan);
    });
    if (traceXHR) (0, $8UJMm.addXhrInstrumentationHandler)((handlerData)=>{
        const createdSpan = $9d827fbec7c2ec07$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
        if (enableHTTPTimings && createdSpan) $9d827fbec7c2ec07$var$addHTTPTimings(createdSpan);
    });
}
function $9d827fbec7c2ec07$var$isPerformanceResourceTiming(entry) {
    return entry.entryType === 'resource' && 'initiatorType' in entry && typeof entry.nextHopProtocol === 'string' && (entry.initiatorType === 'fetch' || entry.initiatorType === 'xmlhttprequest');
}
/**
 * Creates a temporary observer to listen to the next fetch/xhr resourcing timings,
 * so that when timings hit their per-browser limit they don't need to be removed.
 *
 * @param span A span that has yet to be finished, must contain `url` on data.
 */ function $9d827fbec7c2ec07$var$addHTTPTimings(span) {
    const { url: url } = (0, $aYVgD.spanToJSON)(span).data || {};
    if (!url || typeof url !== 'string') return;
    const cleanup = (0, $7ytqC.addPerformanceInstrumentationHandler)('resource', ({ entries: entries })=>{
        entries.forEach((entry)=>{
            if ($9d827fbec7c2ec07$var$isPerformanceResourceTiming(entry) && entry.name.endsWith(url)) {
                const spanData = $9d827fbec7c2ec07$var$resourceTimingEntryToSpanData(entry);
                spanData.forEach((data)=>span.setAttribute(...data));
                // In the next tick, clean this handler up
                // We have to wait here because otherwise this cleans itself up before it is fully done
                setTimeout(cleanup);
            }
        });
    });
}
/**
 * Converts ALPN protocol ids to name and version.
 *
 * (https://www.iana.org/assignments/tls-extensiontype-values/tls-extensiontype-values.xhtml#alpn-protocol-ids)
 * @param nextHopProtocol PerformanceResourceTiming.nextHopProtocol
 */ function $9d827fbec7c2ec07$export$57c6f824442f9fe1(nextHopProtocol) {
    let name = 'unknown';
    let version = 'unknown';
    let _name = '';
    for (const char of nextHopProtocol){
        // http/1.1 etc.
        if (char === '/') {
            [name, version] = nextHopProtocol.split('/');
            break;
        }
        // h2, h3 etc.
        if (!isNaN(Number(char))) {
            name = _name === 'h' ? 'http' : _name;
            version = nextHopProtocol.split(_name)[1];
            break;
        }
        _name += char;
    }
    if (_name === nextHopProtocol) // webrtc, ftp, etc.
    name = _name;
    return {
        name: name,
        version: version
    };
}
function $9d827fbec7c2ec07$var$getAbsoluteTime(time = 0) {
    return (((0, $leMLP.browserPerformanceTimeOrigin) || performance.timeOrigin) + time) / 1000;
}
function $9d827fbec7c2ec07$var$resourceTimingEntryToSpanData(resourceTiming) {
    const { name: name, version: version } = $9d827fbec7c2ec07$export$57c6f824442f9fe1(resourceTiming.nextHopProtocol);
    const timingSpanData = [];
    timingSpanData.push([
        'network.protocol.version',
        version
    ], [
        'network.protocol.name',
        name
    ]);
    if (!(0, $leMLP.browserPerformanceTimeOrigin)) return timingSpanData;
    return [
        ...timingSpanData,
        [
            'http.request.redirect_start',
            $9d827fbec7c2ec07$var$getAbsoluteTime(resourceTiming.redirectStart)
        ],
        [
            'http.request.fetch_start',
            $9d827fbec7c2ec07$var$getAbsoluteTime(resourceTiming.fetchStart)
        ],
        [
            'http.request.domain_lookup_start',
            $9d827fbec7c2ec07$var$getAbsoluteTime(resourceTiming.domainLookupStart)
        ],
        [
            'http.request.domain_lookup_end',
            $9d827fbec7c2ec07$var$getAbsoluteTime(resourceTiming.domainLookupEnd)
        ],
        [
            'http.request.connect_start',
            $9d827fbec7c2ec07$var$getAbsoluteTime(resourceTiming.connectStart)
        ],
        [
            'http.request.secure_connection_start',
            $9d827fbec7c2ec07$var$getAbsoluteTime(resourceTiming.secureConnectionStart)
        ],
        [
            'http.request.connection_end',
            $9d827fbec7c2ec07$var$getAbsoluteTime(resourceTiming.connectEnd)
        ],
        [
            'http.request.request_start',
            $9d827fbec7c2ec07$var$getAbsoluteTime(resourceTiming.requestStart)
        ],
        [
            'http.request.response_start',
            $9d827fbec7c2ec07$var$getAbsoluteTime(resourceTiming.responseStart)
        ],
        [
            'http.request.response_end',
            $9d827fbec7c2ec07$var$getAbsoluteTime(resourceTiming.responseEnd)
        ]
    ];
}
/**
 * A function that determines whether to attach tracing headers to a request.
 * This was extracted from `instrumentOutgoingRequests` to make it easier to test shouldAttachHeaders.
 * We only export this fuction for testing purposes.
 */ function $9d827fbec7c2ec07$export$c260386ab3f0b3dd(url, tracePropagationTargets) {
    return (0, $jmfnM.stringMatchesSomePattern)(url, tracePropagationTargets || $9d827fbec7c2ec07$export$15bd0305d05ad07b);
}
/**
 * Create and track xhr request spans
 *
 * @returns Span if a span was created, otherwise void.
 */ // eslint-disable-next-line complexity
function $9d827fbec7c2ec07$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeaders, spans) {
    const xhr = handlerData.xhr;
    const sentryXhrData = xhr && xhr[0, $8UJMm.SENTRY_XHR_DATA_KEY];
    if (!(0, $bcruQ.hasTracingEnabled)() || !xhr || xhr.__sentry_own_request__ || !sentryXhrData) return undefined;
    const shouldCreateSpanResult = shouldCreateSpan(sentryXhrData.url);
    // check first if the request has finished and is tracked by an existing span which should now end
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        const spanId = xhr.__sentry_xhr_span_id__;
        if (!spanId) return;
        const span = spans[spanId];
        if (span && sentryXhrData.status_code !== undefined) {
            (0, $lBW6h.setHttpStatus)(span, sentryXhrData.status_code);
            span.end();
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    const scope = (0, $fq71H.getCurrentScope)();
    const isolationScope = (0, $egVmm.getIsolationScope)();
    const fullUrl = $9d827fbec7c2ec07$var$getFullURL(sentryXhrData.url);
    const host = fullUrl ? (0, $23mcX.parseUrl)(fullUrl).host : undefined;
    const span = shouldCreateSpanResult ? (0, $9fRGu.startInactiveSpan)({
        name: `${sentryXhrData.method} ${sentryXhrData.url}`,
        onlyIfParent: true,
        attributes: {
            type: 'xhr',
            'http.method': sentryXhrData.method,
            'http.url': fullUrl,
            url: sentryXhrData.url,
            'server.address': host,
            [(0, $5ukjY.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: 'auto.http.browser'
        },
        op: 'http.client'
    }) : undefined;
    if (span) {
        xhr.__sentry_xhr_span_id__ = span.spanContext().spanId;
        spans[xhr.__sentry_xhr_span_id__] = span;
    }
    const client = (0, $fq71H.getClient)();
    if (xhr.setRequestHeader && shouldAttachHeaders(sentryXhrData.url) && client) {
        const { traceId: traceId, spanId: spanId, sampled: sampled, dsc: dsc } = {
            ...isolationScope.getPropagationContext(),
            ...scope.getPropagationContext()
        };
        const sentryTraceHeader = span ? (0, $aYVgD.spanToTraceHeader)(span) : (0, $27K1p.generateSentryTraceHeader)(traceId, spanId, sampled);
        const sentryBaggageHeader = (0, $1QelU.dynamicSamplingContextToSentryBaggageHeader)(dsc || (span ? (0, $7AtVc.getDynamicSamplingContextFromSpan)(span) : (0, $7AtVc.getDynamicSamplingContextFromClient)(traceId, client, scope)));
        $9d827fbec7c2ec07$var$setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader);
    }
    return span;
}
function $9d827fbec7c2ec07$var$setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader) {
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        xhr.setRequestHeader('sentry-trace', sentryTraceHeader);
        if (sentryBaggageHeader) // From MDN: "If this method is called several times with the same header, the values are merged into one single request header."
        // We can therefore simply set a baggage header without checking what was there before
        // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/setRequestHeader
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        xhr.setRequestHeader((0, $1QelU.BAGGAGE_HEADER_NAME), sentryBaggageHeader);
    } catch (_) {
    // Error: InvalidStateError: Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.
    }
}
function $9d827fbec7c2ec07$var$getFullURL(url) {
    try {
        // By adding a base URL to new URL(), this will also work for relative urls
        // If `url` is a full URL, the base URL is ignored anyhow
        const parsed = new URL(url, (0, $7bfNR.WINDOW).location.origin);
        return parsed.href;
    } catch (e) {
        return undefined;
    }
}

});
parcelRegister("4bw3t", function(module, exports) {

$parcel$export(module.exports, "instrumentFetchRequest", () => $30c10df508acb84a$export$6d73c62358c655be);

var $fq71H = parcelRequire("fq71H");
var $7AtVc = parcelRequire("7AtVc");
var $egVmm = parcelRequire("egVmm");
var $bcruQ = parcelRequire("bcruQ");
var $5ukjY = parcelRequire("5ukjY");
var $lBW6h = parcelRequire("lBW6h");
var $aYVgD = parcelRequire("aYVgD");
var $9fRGu = parcelRequire("9fRGu");

var $1QelU = parcelRequire("1QelU");
var $27K1p = parcelRequire("27K1p");
var $dlAFs = parcelRequire("dlAFs");
var $23mcX = parcelRequire("23mcX");
/**
 * Create and track fetch request spans for usage in combination with `addInstrumentationHandler`.
 *
 * @returns Span if a span was created, otherwise void.
 */ function $30c10df508acb84a$export$6d73c62358c655be(handlerData, shouldCreateSpan, shouldAttachHeaders, spans, spanOrigin = 'auto.http.browser') {
    if (!(0, $bcruQ.hasTracingEnabled)() || !handlerData.fetchData) return undefined;
    const shouldCreateSpanResult = shouldCreateSpan(handlerData.fetchData.url);
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        const spanId = handlerData.fetchData.__span;
        if (!spanId) return;
        const span = spans[spanId];
        if (span) {
            $30c10df508acb84a$var$endSpan(span, handlerData);
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    const scope = (0, $fq71H.getCurrentScope)();
    const client = (0, $fq71H.getClient)();
    const { method: method, url: url } = handlerData.fetchData;
    const fullUrl = $30c10df508acb84a$var$getFullURL(url);
    const host = fullUrl ? (0, $23mcX.parseUrl)(fullUrl).host : undefined;
    const span = shouldCreateSpanResult ? (0, $9fRGu.startInactiveSpan)({
        name: `${method} ${url}`,
        onlyIfParent: true,
        attributes: {
            url: url,
            type: 'fetch',
            'http.method': method,
            'http.url': fullUrl,
            'server.address': host,
            [(0, $5ukjY.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: spanOrigin
        },
        op: 'http.client'
    }) : undefined;
    if (span) {
        handlerData.fetchData.__span = span.spanContext().spanId;
        spans[span.spanContext().spanId] = span;
    }
    if (shouldAttachHeaders(handlerData.fetchData.url) && client) {
        const request = handlerData.args[0];
        // In case the user hasn't set the second argument of a fetch call we default it to `{}`.
        handlerData.args[1] = handlerData.args[1] || {};
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const options = handlerData.args[1];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
        options.headers = $30c10df508acb84a$export$6717acf674206871(request, client, scope, options, span);
    }
    return span;
}
/**
 * Adds sentry-trace and baggage headers to the various forms of fetch headers
 */ function $30c10df508acb84a$export$6717acf674206871(request, client, scope, options, requestSpan) {
    // eslint-disable-next-line deprecation/deprecation
    const span = requestSpan || scope.getSpan();
    const isolationScope = (0, $egVmm.getIsolationScope)();
    const { traceId: traceId, spanId: spanId, sampled: sampled, dsc: dsc } = {
        ...isolationScope.getPropagationContext(),
        ...scope.getPropagationContext()
    };
    const sentryTraceHeader = span ? (0, $aYVgD.spanToTraceHeader)(span) : (0, $27K1p.generateSentryTraceHeader)(traceId, spanId, sampled);
    const sentryBaggageHeader = (0, $1QelU.dynamicSamplingContextToSentryBaggageHeader)(dsc || (span ? (0, $7AtVc.getDynamicSamplingContextFromSpan)(span) : (0, $7AtVc.getDynamicSamplingContextFromClient)(traceId, client, scope)));
    const headers = options.headers || (typeof Request !== 'undefined' && (0, $dlAFs.isInstanceOf)(request, Request) ? request.headers : undefined);
    if (!headers) return {
        'sentry-trace': sentryTraceHeader,
        baggage: sentryBaggageHeader
    };
    else if (typeof Headers !== 'undefined' && (0, $dlAFs.isInstanceOf)(headers, Headers)) {
        const newHeaders = new Headers(headers);
        newHeaders.append('sentry-trace', sentryTraceHeader);
        if (sentryBaggageHeader) // If the same header is appended multiple times the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders.append((0, $1QelU.BAGGAGE_HEADER_NAME), sentryBaggageHeader);
        return newHeaders;
    } else if (Array.isArray(headers)) {
        const newHeaders = [
            ...headers,
            [
                'sentry-trace',
                sentryTraceHeader
            ]
        ];
        if (sentryBaggageHeader) // If there are multiple entries with the same key, the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders.push([
            (0, $1QelU.BAGGAGE_HEADER_NAME),
            sentryBaggageHeader
        ]);
        return newHeaders;
    } else {
        const existingBaggageHeader = 'baggage' in headers ? headers.baggage : undefined;
        const newBaggageHeaders = [];
        if (Array.isArray(existingBaggageHeader)) newBaggageHeaders.push(...existingBaggageHeader);
        else if (existingBaggageHeader) newBaggageHeaders.push(existingBaggageHeader);
        if (sentryBaggageHeader) newBaggageHeaders.push(sentryBaggageHeader);
        return {
            ...headers,
            'sentry-trace': sentryTraceHeader,
            baggage: newBaggageHeaders.length > 0 ? newBaggageHeaders.join(',') : undefined
        };
    }
}
function $30c10df508acb84a$var$getFullURL(url) {
    try {
        const parsed = new URL(url);
        return parsed.href;
    } catch (e) {
        return undefined;
    }
}
function $30c10df508acb84a$var$endSpan(span, handlerData) {
    if (handlerData.response) {
        (0, $lBW6h.setHttpStatus)(span, handlerData.response.status);
        const contentLength = handlerData.response && handlerData.response.headers && handlerData.response.headers.get('content-length');
        if (contentLength) {
            const contentLengthNum = parseInt(contentLength);
            if (contentLengthNum > 0) span.setAttribute('http.response_content_length', contentLengthNum);
        }
    } else if (handlerData.error) span.setStatus('internal_error');
    span.end();
}

});


parcelRegister("lbCcz", function(module, exports) {

$parcel$export(module.exports, "instrumentRoutingWithDefaults", () => $f6c8421ccff27ce7$export$86649cc09fe75143);

var $bCTfk = parcelRequire("bCTfk");
var $leMLP = parcelRequire("leMLP");
var $lN8pX = parcelRequire("lN8pX");

var $iDP9B = parcelRequire("iDP9B");

var $7bfNR = parcelRequire("7bfNR");
/**
 * Default function implementing pageload and navigation transactions
 */ function $f6c8421ccff27ce7$export$86649cc09fe75143(customStartTransaction, startTransactionOnPageLoad = true, startTransactionOnLocationChange = true) {
    if (!(0, $7bfNR.WINDOW) || !(0, $7bfNR.WINDOW).location) {
        (0, $iDP9B.DEBUG_BUILD) && (0, $lN8pX.logger).warn('Could not initialize routing instrumentation due to invalid location');
        return;
    }
    let startingUrl = (0, $7bfNR.WINDOW).location.href;
    let activeTransaction;
    if (startTransactionOnPageLoad) activeTransaction = customStartTransaction({
        name: (0, $7bfNR.WINDOW).location.pathname,
        // pageload should always start at timeOrigin (and needs to be in s, not ms)
        startTimestamp: (0, $leMLP.browserPerformanceTimeOrigin) ? (0, $leMLP.browserPerformanceTimeOrigin) / 1000 : undefined,
        op: 'pageload',
        origin: 'auto.pageload.browser',
        metadata: {
            source: 'url'
        }
    });
    if (startTransactionOnLocationChange) (0, $bCTfk.addHistoryInstrumentationHandler)(({ to: to, from: from })=>{
        /**
       * This early return is there to account for some cases where a navigation transaction starts right after
       * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
       * create an uneccessary navigation transaction.
       *
       * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
       * only be caused in certain development environments where the usage of a hot module reloader is causing
       * errors.
       */ if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
            startingUrl = undefined;
            return;
        }
        if (from !== to) {
            startingUrl = undefined;
            if (activeTransaction) {
                (0, $iDP9B.DEBUG_BUILD) && (0, $lN8pX.logger).log(`[Tracing] Finishing current transaction with op: ${activeTransaction.op}`);
                // If there's an open transaction on the scope, we need to finish it before creating an new one.
                activeTransaction.end();
            }
            activeTransaction = customStartTransaction({
                name: (0, $7bfNR.WINDOW).location.pathname,
                op: 'navigation',
                origin: 'auto.navigation.browser',
                metadata: {
                    source: 'url'
                }
            });
        }
    });
}

});


parcelRegister("fnUdv", function(module, exports) {

$parcel$export(module.exports, "browserTracingIntegration", () => $b3349c8175dec20e$export$b4109253475213e9);
$parcel$export(module.exports, "startBrowserTracingPageLoadSpan", () => $b3349c8175dec20e$export$aa44a07f82af519f);
$parcel$export(module.exports, "startBrowserTracingNavigationSpan", () => $b3349c8175dec20e$export$7d159749bd9969ad);

var $13ShQ = parcelRequire("13ShQ");
var $9fRGu = parcelRequire("9fRGu");
var $jL5ha = parcelRequire("jL5ha");
var $fq71H = parcelRequire("fq71H");
var $egVmm = parcelRequire("egVmm");
var $5ukjY = parcelRequire("5ukjY");
var $aYVgD = parcelRequire("aYVgD");
var $9XkOL = parcelRequire("9XkOL");

var $bCTfk = parcelRequire("bCTfk");
var $leMLP = parcelRequire("leMLP");
var $3oSFd = parcelRequire("3oSFd");
var $lN8pX = parcelRequire("lN8pX");
var $27K1p = parcelRequire("27K1p");

var $iDP9B = parcelRequire("iDP9B");

var $d8B5C = parcelRequire("d8B5C");

var $7ytqC = parcelRequire("7ytqC");

var $jVgAA = parcelRequire("jVgAA");

var $dwq5q = parcelRequire("dwq5q");

var $7bfNR = parcelRequire("7bfNR");
const $b3349c8175dec20e$export$bbd2089f30bd3708 = 'BrowserTracing';
/** Options for Browser Tracing integration */ const $b3349c8175dec20e$var$DEFAULT_BROWSER_TRACING_OPTIONS = {
    ...(0, $9XkOL.TRACING_DEFAULTS),
    instrumentNavigation: true,
    instrumentPageLoad: true,
    markBackgroundSpan: true,
    enableLongTask: true,
    enableInp: false,
    interactionsSampleRate: 1,
    _experiments: {},
    ...(0, $dwq5q.defaultRequestInstrumentationOptions)
};
/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library. This integration uses {@see IdleTransaction} to create transactions.
 *
 * We explicitly export the proper type here, as this has to be extended in some cases.
 */ const $b3349c8175dec20e$export$b4109253475213e9 = (_options = {})=>{
    const _hasSetTracePropagationTargets = (0, $iDP9B.DEBUG_BUILD) ? !!// eslint-disable-next-line deprecation/deprecation
    (_options.tracePropagationTargets || _options.tracingOrigins) : false;
    (0, $13ShQ.addTracingExtensions)();
    // TODO (v8): remove this block after tracingOrigins is removed
    // Set tracePropagationTargets to tracingOrigins if specified by the user
    // In case both are specified, tracePropagationTargets takes precedence
    // eslint-disable-next-line deprecation/deprecation
    if (!_options.tracePropagationTargets && _options.tracingOrigins) // eslint-disable-next-line deprecation/deprecation
    _options.tracePropagationTargets = _options.tracingOrigins;
    const options = {
        ...$b3349c8175dec20e$var$DEFAULT_BROWSER_TRACING_OPTIONS,
        ..._options
    };
    const _collectWebVitals = (0, $jVgAA.startTrackingWebVitals)();
    /** Stores a mapping of interactionIds from PerformanceEventTimings to the origin interaction path */ const interactionIdToRouteNameMapping = {};
    if (options.enableInp) (0, $jVgAA.startTrackingINP)(interactionIdToRouteNameMapping, options.interactionsSampleRate);
    if (options.enableLongTask) (0, $jVgAA.startTrackingLongTasks)();
    if (options._experiments.enableInteractions) (0, $jVgAA.startTrackingInteractions)();
    const latestRoute = {
        name: undefined,
        context: undefined
    };
    /** Create routing idle transaction. */ function _createRouteTransaction(context) {
        // eslint-disable-next-line deprecation/deprecation
        const hub = (0, $egVmm.getCurrentHub)();
        const { beforeStartSpan: beforeStartSpan, idleTimeout: idleTimeout, finalTimeout: finalTimeout, heartbeatInterval: heartbeatInterval } = options;
        const isPageloadTransaction = context.op === 'pageload';
        let expandedContext;
        if (isPageloadTransaction) {
            const sentryTrace = isPageloadTransaction ? $b3349c8175dec20e$export$f147b32b03c9cf11('sentry-trace') : '';
            const baggage = isPageloadTransaction ? $b3349c8175dec20e$export$f147b32b03c9cf11('baggage') : undefined;
            const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: sampled } = (0, $27K1p.propagationContextFromHeaders)(sentryTrace, baggage);
            expandedContext = {
                traceId: traceId,
                parentSpanId: parentSpanId,
                parentSampled: sampled,
                ...context,
                metadata: {
                    // eslint-disable-next-line deprecation/deprecation
                    ...context.metadata,
                    dynamicSamplingContext: dsc
                },
                trimEnd: true
            };
        } else expandedContext = {
            trimEnd: true,
            ...context
        };
        const finalContext = beforeStartSpan ? beforeStartSpan(expandedContext) : expandedContext;
        // If `beforeStartSpan` set a custom name, record that fact
        // eslint-disable-next-line deprecation/deprecation
        finalContext.metadata = finalContext.name !== expandedContext.name ? {
            ...finalContext.metadata,
            source: 'custom'
        } : finalContext.metadata;
        latestRoute.name = finalContext.name;
        latestRoute.context = finalContext;
        if (finalContext.sampled === false) (0, $iDP9B.DEBUG_BUILD) && (0, $lN8pX.logger).log(`[Tracing] Will not send ${finalContext.op} transaction because of beforeNavigate.`);
        (0, $iDP9B.DEBUG_BUILD) && (0, $lN8pX.logger).log(`[Tracing] Starting ${finalContext.op} transaction on scope`);
        const { location: location } = (0, $7bfNR.WINDOW);
        const idleTransaction = (0, $13ShQ.startIdleTransaction)(hub, finalContext, idleTimeout, finalTimeout, true, {
            location: location
        }, heartbeatInterval, isPageloadTransaction);
        if (isPageloadTransaction && (0, $7bfNR.WINDOW).document) {
            (0, $7bfNR.WINDOW).document.addEventListener('readystatechange', ()=>{
                if ([
                    'interactive',
                    'complete'
                ].includes((0, $7bfNR.WINDOW).document.readyState)) idleTransaction.sendAutoFinishSignal();
            });
            if ([
                'interactive',
                'complete'
            ].includes((0, $7bfNR.WINDOW).document.readyState)) idleTransaction.sendAutoFinishSignal();
        }
        idleTransaction.registerBeforeFinishCallback((transaction)=>{
            _collectWebVitals();
            (0, $jVgAA.addPerformanceEntries)(transaction);
        });
        return idleTransaction;
    }
    return {
        name: $b3349c8175dec20e$export$bbd2089f30bd3708,
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        setupOnce: ()=>{},
        afterAllSetup (client) {
            const clientOptions = client.getOptions();
            const { markBackgroundSpan: markBackgroundSpan, traceFetch: traceFetch, traceXHR: traceXHR, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings, _experiments: _experiments } = options;
            const clientOptionsTracePropagationTargets = clientOptions && clientOptions.tracePropagationTargets;
            // There are three ways to configure tracePropagationTargets:
            // 1. via top level client option `tracePropagationTargets`
            // 2. via BrowserTracing option `tracePropagationTargets`
            // 3. via BrowserTracing option `tracingOrigins` (deprecated)
            //
            // To avoid confusion, favour top level client option `tracePropagationTargets`, and fallback to
            // BrowserTracing option `tracePropagationTargets` and then `tracingOrigins` (deprecated).
            // This is done as it minimizes bundle size (we don't have to have undefined checks).
            //
            // If both 1 and either one of 2 or 3 are set (from above), we log out a warning.
            // eslint-disable-next-line deprecation/deprecation
            const tracePropagationTargets = clientOptionsTracePropagationTargets || options.tracePropagationTargets;
            if ((0, $iDP9B.DEBUG_BUILD) && _hasSetTracePropagationTargets && clientOptionsTracePropagationTargets) (0, $lN8pX.logger).warn('[Tracing] The `tracePropagationTargets` option was set in the BrowserTracing integration and top level `Sentry.init`. The top level `Sentry.init` value is being used.');
            let activeSpan;
            let startingUrl = (0, $7bfNR.WINDOW).location && (0, $7bfNR.WINDOW).location.href;
            if (client.on) {
                client.on('startNavigationSpan', (context)=>{
                    if (activeSpan) {
                        (0, $iDP9B.DEBUG_BUILD) && (0, $lN8pX.logger).log(`[Tracing] Finishing current transaction with op: ${(0, $aYVgD.spanToJSON)(activeSpan).op}`);
                        // If there's an open transaction on the scope, we need to finish it before creating an new one.
                        activeSpan.end();
                    }
                    activeSpan = _createRouteTransaction({
                        op: 'navigation',
                        ...context
                    });
                });
                client.on('startPageLoadSpan', (context)=>{
                    if (activeSpan) {
                        (0, $iDP9B.DEBUG_BUILD) && (0, $lN8pX.logger).log(`[Tracing] Finishing current transaction with op: ${(0, $aYVgD.spanToJSON)(activeSpan).op}`);
                        // If there's an open transaction on the scope, we need to finish it before creating an new one.
                        activeSpan.end();
                    }
                    activeSpan = _createRouteTransaction({
                        op: 'pageload',
                        ...context
                    });
                });
            }
            if (options.instrumentPageLoad && client.emit && (0, $7bfNR.WINDOW).location) {
                const context = {
                    name: (0, $7bfNR.WINDOW).location.pathname,
                    // pageload should always start at timeOrigin (and needs to be in s, not ms)
                    startTimestamp: (0, $leMLP.browserPerformanceTimeOrigin) ? (0, $leMLP.browserPerformanceTimeOrigin) / 1000 : undefined,
                    origin: 'auto.pageload.browser',
                    attributes: {
                        [(0, $5ukjY.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: 'url'
                    }
                };
                $b3349c8175dec20e$export$aa44a07f82af519f(client, context);
            }
            if (options.instrumentNavigation && client.emit && (0, $7bfNR.WINDOW).location) (0, $bCTfk.addHistoryInstrumentationHandler)(({ to: to, from: from })=>{
                /**
           * This early return is there to account for some cases where a navigation transaction starts right after
           * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
           * create an uneccessary navigation transaction.
           *
           * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
           * only be caused in certain development environments where the usage of a hot module reloader is causing
           * errors.
           */ if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
                    startingUrl = undefined;
                    return;
                }
                if (from !== to) {
                    startingUrl = undefined;
                    const context = {
                        name: (0, $7bfNR.WINDOW).location.pathname,
                        origin: 'auto.navigation.browser',
                        attributes: {
                            [(0, $5ukjY.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: 'url'
                        }
                    };
                    $b3349c8175dec20e$export$7d159749bd9969ad(client, context);
                }
            });
            if (markBackgroundSpan) (0, $d8B5C.registerBackgroundTabDetection)();
            if (_experiments.enableInteractions) $b3349c8175dec20e$var$registerInteractionListener(options, latestRoute);
            if (options.enableInp) $b3349c8175dec20e$var$registerInpInteractionListener(interactionIdToRouteNameMapping, latestRoute);
            (0, $dwq5q.instrumentOutgoingRequests)({
                traceFetch: traceFetch,
                traceXHR: traceXHR,
                tracePropagationTargets: tracePropagationTargets,
                shouldCreateSpanForRequest: shouldCreateSpanForRequest,
                enableHTTPTimings: enableHTTPTimings
            });
        },
        options: // TODO v8: Remove this again
        // This is private API that we use to fix converted BrowserTracing integrations in Next.js & SvelteKit
        options
    };
};
/**
 * Manually start a page load span.
 * This will only do something if the BrowserTracing integration has been setup.
 */ function $b3349c8175dec20e$export$aa44a07f82af519f(client, spanOptions) {
    if (!client.emit) return;
    client.emit('startPageLoadSpan', spanOptions);
    const span = (0, $9fRGu.getActiveSpan)();
    const op = span && (0, $aYVgD.spanToJSON)(span).op;
    return op === 'pageload' ? span : undefined;
}
/**
 * Manually start a navigation span.
 * This will only do something if the BrowserTracing integration has been setup.
 */ function $b3349c8175dec20e$export$7d159749bd9969ad(client, spanOptions) {
    if (!client.emit) return;
    client.emit('startNavigationSpan', spanOptions);
    const span = (0, $9fRGu.getActiveSpan)();
    const op = span && (0, $aYVgD.spanToJSON)(span).op;
    return op === 'navigation' ? span : undefined;
}
/** Returns the value of a meta tag */ function $b3349c8175dec20e$export$f147b32b03c9cf11(metaName) {
    // Can't specify generic to `getDomElement` because tracing can be used
    // in a variety of environments, have to disable `no-unsafe-member-access`
    // as a result.
    const metaTag = (0, $3oSFd.getDomElement)(`meta[name=${metaName}]`);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return metaTag ? metaTag.getAttribute('content') : undefined;
}
/** Start listener for interaction transactions */ function $b3349c8175dec20e$var$registerInteractionListener(options, latestRoute) {
    let inflightInteractionTransaction;
    const registerInteractionTransaction = ()=>{
        const { idleTimeout: idleTimeout, finalTimeout: finalTimeout, heartbeatInterval: heartbeatInterval } = options;
        const op = 'ui.action.click';
        // eslint-disable-next-line deprecation/deprecation
        const currentTransaction = (0, $jL5ha.getActiveTransaction)();
        if (currentTransaction && currentTransaction.op && [
            'navigation',
            'pageload'
        ].includes(currentTransaction.op)) {
            (0, $iDP9B.DEBUG_BUILD) && (0, $lN8pX.logger).warn(`[Tracing] Did not create ${op} transaction because a pageload or navigation transaction is in progress.`);
            return undefined;
        }
        if (inflightInteractionTransaction) {
            inflightInteractionTransaction.setFinishReason('interactionInterrupted');
            inflightInteractionTransaction.end();
            inflightInteractionTransaction = undefined;
        }
        if (!latestRoute.name) {
            (0, $iDP9B.DEBUG_BUILD) && (0, $lN8pX.logger).warn(`[Tracing] Did not create ${op} transaction because _latestRouteName is missing.`);
            return undefined;
        }
        const { location: location } = (0, $7bfNR.WINDOW);
        const context = {
            name: latestRoute.name,
            op: op,
            trimEnd: true,
            data: {
                [(0, $5ukjY.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: latestRoute.context ? $b3349c8175dec20e$var$getSource(latestRoute.context) : 'url'
            }
        };
        inflightInteractionTransaction = (0, $13ShQ.startIdleTransaction)(// eslint-disable-next-line deprecation/deprecation
        (0, $egVmm.getCurrentHub)(), context, idleTimeout, finalTimeout, true, {
            location: location
        }, heartbeatInterval);
    };
    [
        'click'
    ].forEach((type)=>{
        if ((0, $7bfNR.WINDOW).document) addEventListener(type, registerInteractionTransaction, {
            once: false,
            capture: true
        });
    });
}
function $b3349c8175dec20e$var$isPerformanceEventTiming(entry) {
    return 'duration' in entry;
}
/** We store up to 10 interaction candidates max to cap memory usage. This is the same cap as getINP from web-vitals */ const $b3349c8175dec20e$var$MAX_INTERACTIONS = 10;
/** Creates a listener on interaction entries, and maps interactionIds to the origin path of the interaction */ function $b3349c8175dec20e$var$registerInpInteractionListener(interactionIdToRouteNameMapping, latestRoute) {
    const handleEntries = ({ entries: entries })=>{
        const client = (0, $fq71H.getClient)();
        // We need to get the replay, user, and activeTransaction from the current scope
        // so that we can associate replay id, profile id, and a user display to the span
        const replay = client !== undefined && client.getIntegrationByName !== undefined ? client.getIntegrationByName('Replay') : undefined;
        const replayId = replay !== undefined ? replay.getReplayId() : undefined;
        // eslint-disable-next-line deprecation/deprecation
        const activeTransaction = (0, $jL5ha.getActiveTransaction)();
        const currentScope = (0, $fq71H.getCurrentScope)();
        const user = currentScope !== undefined ? currentScope.getUser() : undefined;
        entries.forEach((entry)=>{
            if ($b3349c8175dec20e$var$isPerformanceEventTiming(entry)) {
                const interactionId = entry.interactionId;
                if (interactionId === undefined) return;
                const existingInteraction = interactionIdToRouteNameMapping[interactionId];
                const duration = entry.duration;
                const startTime = entry.startTime;
                const keys = Object.keys(interactionIdToRouteNameMapping);
                const minInteractionId = keys.length > 0 ? keys.reduce((a, b)=>{
                    return interactionIdToRouteNameMapping[a].duration < interactionIdToRouteNameMapping[b].duration ? a : b;
                }) : undefined;
                // For a first input event to be considered, we must check that an interaction event does not already exist with the same duration and start time.
                // This is also checked in the web-vitals library.
                if (entry.entryType === 'first-input') {
                    const matchingEntry = keys.map((key)=>interactionIdToRouteNameMapping[key]).some((interaction)=>{
                        return interaction.duration === duration && interaction.startTime === startTime;
                    });
                    if (matchingEntry) return;
                }
                // Interactions with an id of 0 and are not first-input are not valid.
                if (!interactionId) return;
                // If the interaction already exists, we want to use the duration of the longest entry, since that is what the INP metric uses.
                if (existingInteraction) existingInteraction.duration = Math.max(existingInteraction.duration, duration);
                else if (keys.length < $b3349c8175dec20e$var$MAX_INTERACTIONS || minInteractionId === undefined || duration > interactionIdToRouteNameMapping[minInteractionId].duration) {
                    // If the interaction does not exist, we want to add it to the mapping if there is space, or if the duration is longer than the shortest entry.
                    const routeName = latestRoute.name;
                    const parentContext = latestRoute.context;
                    if (routeName && parentContext) {
                        if (minInteractionId && Object.keys(interactionIdToRouteNameMapping).length >= $b3349c8175dec20e$var$MAX_INTERACTIONS) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
                        delete interactionIdToRouteNameMapping[minInteractionId];
                        interactionIdToRouteNameMapping[interactionId] = {
                            routeName: routeName,
                            duration: duration,
                            parentContext: parentContext,
                            user: user,
                            activeTransaction: activeTransaction,
                            replayId: replayId,
                            startTime: startTime
                        };
                    }
                }
            }
        });
    };
    (0, $7ytqC.addPerformanceInstrumentationHandler)('event', handleEntries);
    (0, $7ytqC.addPerformanceInstrumentationHandler)('first-input', handleEntries);
}
function $b3349c8175dec20e$var$getSource(context) {
    const sourceFromAttributes = context.attributes && context.attributes[0, $5ukjY.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
    // eslint-disable-next-line deprecation/deprecation
    const sourceFromData = context.data && context.data[0, $5ukjY.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
    // eslint-disable-next-line deprecation/deprecation
    const sourceFromMetadata = context.metadata && context.metadata.source;
    return sourceFromAttributes || sourceFromData || sourceFromMetadata;
}

});

parcelRegister("6umDS", function(module, exports) {

$parcel$export(module.exports, "makeBrowserOfflineTransport", () => $4b971baedf52518a$export$79c8882827636cf2);

var $fbHMF = parcelRequire("fbHMF");

var $cSKRv = parcelRequire("cSKRv");
// 'Store', 'promisifyRequest' and 'createStore' were originally copied from the 'idb-keyval' package before being
// modified and simplified: https://github.com/jakearchibald/idb-keyval
//
// At commit: 0420a704fd6cbb4225429c536b1f61112d012fca
// Original licence:
// Copyright 2016, Jake Archibald
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
function $4b971baedf52518a$var$promisifyRequest(request) {
    return new Promise((resolve, reject)=>{
        // @ts-expect-error - file size hacks
        request.oncomplete = request.onsuccess = ()=>resolve(request.result);
        // @ts-expect-error - file size hacks
        request.onabort = request.onerror = ()=>reject(request.error);
    });
}
/** Create or open an IndexedDb store */ function $4b971baedf52518a$export$f51a9068ac82ea43(dbName, storeName) {
    const request = indexedDB.open(dbName);
    request.onupgradeneeded = ()=>request.result.createObjectStore(storeName);
    const dbp = $4b971baedf52518a$var$promisifyRequest(request);
    return (callback)=>dbp.then((db)=>callback(db.transaction(storeName, 'readwrite').objectStore(storeName)));
}
function $4b971baedf52518a$var$keys(store) {
    return $4b971baedf52518a$var$promisifyRequest(store.getAllKeys());
}
/** Insert into the store */ function $4b971baedf52518a$export$21a5ca8aa77d35ff(store, value, maxQueueSize) {
    return store((store)=>{
        return $4b971baedf52518a$var$keys(store).then((keys)=>{
            if (keys.length >= maxQueueSize) return;
            // We insert with an incremented key so that the entries are popped in order
            store.put(value, Math.max(...keys, 0) + 1);
            return $4b971baedf52518a$var$promisifyRequest(store.transaction);
        });
    });
}
/** Pop the oldest value from the store */ function $4b971baedf52518a$export$3e41007ebfff0e64(store) {
    return store((store)=>{
        return $4b971baedf52518a$var$keys(store).then((keys)=>{
            if (keys.length === 0) return undefined;
            return $4b971baedf52518a$var$promisifyRequest(store.get(keys[0])).then((value)=>{
                store.delete(keys[0]);
                return $4b971baedf52518a$var$promisifyRequest(store.transaction).then(()=>value);
            });
        });
    });
}
function $4b971baedf52518a$var$createIndexedDbStore(options) {
    let store;
    // Lazily create the store only when it's needed
    function getStore() {
        if (store == undefined) store = $4b971baedf52518a$export$f51a9068ac82ea43(options.dbName || 'sentry-offline', options.storeName || 'queue');
        return store;
    }
    return {
        insert: async (env)=>{
            try {
                const serialized = await (0, $cSKRv.serializeEnvelope)(env, options.textEncoder);
                await $4b971baedf52518a$export$21a5ca8aa77d35ff(getStore(), serialized, options.maxQueueSize || 30);
            } catch (_) {
            //
            }
        },
        pop: async ()=>{
            try {
                const deserialized = await $4b971baedf52518a$export$3e41007ebfff0e64(getStore());
                if (deserialized) return (0, $cSKRv.parseEnvelope)(deserialized, options.textEncoder || new TextEncoder(), options.textDecoder || new TextDecoder());
            } catch (_) {
            //
            }
            return undefined;
        }
    };
}
function $4b971baedf52518a$var$makeIndexedDbOfflineTransport(createTransport) {
    return (options)=>createTransport({
            ...options,
            createStore: $4b971baedf52518a$var$createIndexedDbStore
        });
}
/**
 * Creates a transport that uses IndexedDb to store events when offline.
 */ function $4b971baedf52518a$export$79c8882827636cf2(createTransport) {
    return $4b971baedf52518a$var$makeIndexedDbOfflineTransport((0, $fbHMF.makeOfflineTransport)(createTransport));
}

});

parcelRegister("6cDJJ", function(module, exports) {

$parcel$export(module.exports, "onProfilingStartRouteTransaction", () => $4842afedcd3d0ad5$export$410ca53b300571c6);
$parcel$export(module.exports, "startProfileForTransaction", () => $4842afedcd3d0ad5$export$a5c90b2530e76e64);

var $aYVgD = parcelRequire("aYVgD");

var $lN8pX = parcelRequire("lN8pX");
var $leMLP = parcelRequire("leMLP");
var $1y8R2 = parcelRequire("1y8R2");

var $70zzf = parcelRequire("70zzf");

var $i8T1U = parcelRequire("i8T1U");

var $izYtH = parcelRequire("izYtH");
/* eslint-disable complexity */ /**
 * Safety wrapper for startTransaction for the unlikely case that transaction starts before tracing is imported -
 * if that happens we want to avoid throwing an error from profiling code.
 * see https://github.com/getsentry/sentry-javascript/issues/4731.
 *
 * @experimental
 */ function $4842afedcd3d0ad5$export$410ca53b300571c6(transaction) {
    if (!transaction) {
        if (0, $70zzf.DEBUG_BUILD) (0, $lN8pX.logger).log('[Profiling] Transaction is undefined, skipping profiling');
        return transaction;
    }
    if ((0, $izYtH.shouldProfileTransaction)(transaction)) return $4842afedcd3d0ad5$export$a5c90b2530e76e64(transaction);
    return transaction;
}
/**
 * Wraps startTransaction and stopTransaction with profiling related logic.
 * startProfileForTransaction is called after the call to startTransaction in order to avoid our own code from
 * being profiled. Because of that same reason, stopProfiling is called before the call to stopTransaction.
 */ function $4842afedcd3d0ad5$export$a5c90b2530e76e64(transaction) {
    // Start the profiler and get the profiler instance.
    let startTimestamp;
    if ((0, $izYtH.isAutomatedPageLoadTransaction)(transaction)) startTimestamp = (0, $leMLP.timestampInSeconds)() * 1000;
    const profiler = (0, $izYtH.startJSSelfProfile)();
    // We failed to construct the profiler, fallback to original transaction.
    // No need to log anything as this has already been logged in startProfile.
    if (!profiler) return transaction;
    if (0, $70zzf.DEBUG_BUILD) (0, $lN8pX.logger).log(`[Profiling] started profiling transaction: ${(0, $aYVgD.spanToJSON)(transaction).description}`);
    // We create "unique" transaction names to avoid concurrent transactions with same names
    // from being ignored by the profiler. From here on, only this transaction name should be used when
    // calling the profiler methods. Note: we log the original name to the user to avoid confusion.
    const profileId = (0, $1y8R2.uuid4)();
    /**
   * Idempotent handler for profile stop
   */ async function onProfileHandler() {
        // Check if the profile exists and return it the behavior has to be idempotent as users may call transaction.finish multiple times.
        if (!transaction) return null;
        // Satisfy the type checker, but profiler will always be defined here.
        if (!profiler) return null;
        return profiler.stop().then((profile)=>{
            if (maxDurationTimeoutID) {
                (0, $i8T1U.WINDOW).clearTimeout(maxDurationTimeoutID);
                maxDurationTimeoutID = undefined;
            }
            if (0, $70zzf.DEBUG_BUILD) (0, $lN8pX.logger).log(`[Profiling] stopped profiling of transaction: ${(0, $aYVgD.spanToJSON)(transaction).description}`);
            // In case of an overlapping transaction, stopProfiling may return null and silently ignore the overlapping profile.
            if (!profile) {
                if (0, $70zzf.DEBUG_BUILD) (0, $lN8pX.logger).log(`[Profiling] profiler returned null profile for: ${(0, $aYVgD.spanToJSON)(transaction).description}`, 'this may indicate an overlapping transaction or a call to stopProfiling with a profile title that was never started');
                return null;
            }
            (0, $izYtH.addProfileToGlobalCache)(profileId, profile);
            return null;
        }).catch((error)=>{
            if (0, $70zzf.DEBUG_BUILD) (0, $lN8pX.logger).log('[Profiling] error while stopping profiler:', error);
            return null;
        });
    }
    // Enqueue a timeout to prevent profiles from running over max duration.
    let maxDurationTimeoutID = (0, $i8T1U.WINDOW).setTimeout(()=>{
        if (0, $70zzf.DEBUG_BUILD) (0, $lN8pX.logger).log('[Profiling] max profile duration elapsed, stopping profiling for:', (0, $aYVgD.spanToJSON)(transaction).description);
        // If the timeout exceeds, we want to stop profiling, but not finish the transaction
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        onProfileHandler();
    }, (0, $izYtH.MAX_PROFILE_DURATION_MS));
    // We need to reference the original end call to avoid creating an infinite loop
    const originalEnd = transaction.end.bind(transaction);
    /**
   * Wraps startTransaction and stopTransaction with profiling related logic.
   * startProfiling is called after the call to startTransaction in order to avoid our own code from
   * being profiled. Because of that same reason, stopProfiling is called before the call to stopTransaction.
   */ function profilingWrappedTransactionEnd() {
        if (!transaction) return originalEnd();
        // onProfileHandler should always return the same profile even if this is called multiple times.
        // Always call onProfileHandler to ensure stopProfiling is called and the timeout is cleared.
        onProfileHandler().then(()=>{
            // TODO: Can we rewrite this to use attributes?
            // eslint-disable-next-line deprecation/deprecation
            transaction.setContext('profile', {
                profile_id: profileId,
                start_timestamp: startTimestamp
            });
            originalEnd();
        }, ()=>{
            // If onProfileHandler fails, we still want to call the original finish method.
            originalEnd();
        });
        return transaction;
    }
    transaction.end = profilingWrappedTransactionEnd;
    return transaction;
}

});
parcelRegister("izYtH", function(module, exports) {

$parcel$export(module.exports, "isAutomatedPageLoadTransaction", () => $d86a688f978d4434$export$7c501dd6adb8177c);
$parcel$export(module.exports, "addProfilesToEnvelope", () => $d86a688f978d4434$export$4df36760a75f76bc);
$parcel$export(module.exports, "findProfiledTransactionsFromEnvelope", () => $d86a688f978d4434$export$df9bb0fc214ff8cd);
$parcel$export(module.exports, "MAX_PROFILE_DURATION_MS", () => $d86a688f978d4434$export$8640c0b5c7d98a81);
$parcel$export(module.exports, "startJSSelfProfile", () => $d86a688f978d4434$export$9f4f648547a4284f);
$parcel$export(module.exports, "shouldProfileTransaction", () => $d86a688f978d4434$export$ea6683c0c72c1201);
$parcel$export(module.exports, "createProfilingEvent", () => $d86a688f978d4434$export$5c2c5e805edd874f);
$parcel$export(module.exports, "getActiveProfilesCount", () => $d86a688f978d4434$export$9d723f414195854a);
$parcel$export(module.exports, "takeProfileFromGlobalCache", () => $d86a688f978d4434$export$6285310796363de1);
$parcel$export(module.exports, "addProfileToGlobalCache", () => $d86a688f978d4434$export$7ddae68097f7e530);

var $b5y9n = parcelRequire("b5y9n");
var $fq71H = parcelRequire("fq71H");

var $leMLP = parcelRequire("leMLP");
var $cSKRv = parcelRequire("cSKRv");
var $4mb67 = parcelRequire("4mb67");
var $lN8pX = parcelRequire("lN8pX");
var $1y8R2 = parcelRequire("1y8R2");

var $70zzf = parcelRequire("70zzf");

var $i8T1U = parcelRequire("i8T1U");
/* eslint-disable max-lines */ const $d86a688f978d4434$var$MS_TO_NS = 1e6;
// Use 0 as main thread id which is identical to threadId in node:worker_threads
// where main logs 0 and workers seem to log in increments of 1
const $d86a688f978d4434$var$THREAD_ID_STRING = String(0);
const $d86a688f978d4434$var$THREAD_NAME = 'main';
// Machine properties (eval only once)
let $d86a688f978d4434$var$OS_PLATFORM = '';
let $d86a688f978d4434$var$OS_PLATFORM_VERSION = '';
let $d86a688f978d4434$var$OS_ARCH = '';
let $d86a688f978d4434$var$OS_BROWSER = (0, $i8T1U.WINDOW).navigator && (0, $i8T1U.WINDOW).navigator.userAgent || '';
let $d86a688f978d4434$var$OS_MODEL = '';
const $d86a688f978d4434$var$OS_LOCALE = (0, $i8T1U.WINDOW).navigator && (0, $i8T1U.WINDOW).navigator.language || (0, $i8T1U.WINDOW).navigator && (0, $i8T1U.WINDOW).navigator.languages && (0, $i8T1U.WINDOW).navigator.languages[0] || '';
function $d86a688f978d4434$var$isUserAgentData(data) {
    return typeof data === 'object' && data !== null && 'getHighEntropyValues' in data;
}
// @ts-expect-error userAgentData is not part of the navigator interface yet
const $d86a688f978d4434$var$userAgentData = (0, $i8T1U.WINDOW).navigator && (0, $i8T1U.WINDOW).navigator.userAgentData;
if ($d86a688f978d4434$var$isUserAgentData($d86a688f978d4434$var$userAgentData)) $d86a688f978d4434$var$userAgentData.getHighEntropyValues([
    'architecture',
    'model',
    'platform',
    'platformVersion',
    'fullVersionList'
]).then((ua)=>{
    $d86a688f978d4434$var$OS_PLATFORM = ua.platform || '';
    $d86a688f978d4434$var$OS_ARCH = ua.architecture || '';
    $d86a688f978d4434$var$OS_MODEL = ua.model || '';
    $d86a688f978d4434$var$OS_PLATFORM_VERSION = ua.platformVersion || '';
    if (ua.fullVersionList && ua.fullVersionList.length > 0) {
        const firstUa = ua.fullVersionList[ua.fullVersionList.length - 1];
        $d86a688f978d4434$var$OS_BROWSER = `${firstUa.brand} ${firstUa.version}`;
    }
}).catch((e)=>void 0);
function $d86a688f978d4434$var$isProcessedJSSelfProfile(profile) {
    return !('thread_metadata' in profile);
}
// Enriches the profile with threadId of the current thread.
// This is done in node as we seem to not be able to get the info from C native code.
/**
 *
 */ function $d86a688f978d4434$export$7cbe6c4f12ea8325(profile) {
    if (!$d86a688f978d4434$var$isProcessedJSSelfProfile(profile)) return profile;
    return $d86a688f978d4434$export$f4122c775dfac1c2(profile);
}
// Profile is marked as optional because it is deleted from the metadata
// by the integration before the event is processed by other integrations.
function $d86a688f978d4434$var$getTraceId(event) {
    const traceId = event && event.contexts && event.contexts['trace'] && event.contexts['trace']['trace_id'];
    // Log a warning if the profile has an invalid traceId (should be uuidv4).
    // All profiles and transactions are rejected if this is the case and we want to
    // warn users that this is happening if they enable debug flag
    if (typeof traceId === 'string' && traceId.length !== 32) {
        if (0, $70zzf.DEBUG_BUILD) (0, $lN8pX.logger).log(`[Profiling] Invalid traceId: ${traceId} on profiled event`);
    }
    if (typeof traceId !== 'string') return '';
    return traceId;
}
/**
 * Creates a profiling event envelope from a Sentry event. If profile does not pass
 * validation, returns null.
 * @param event
 * @param dsn
 * @param metadata
 * @param tunnel
 * @returns {EventEnvelope | null}
 */ /**
 * Creates a profiling event envelope from a Sentry event.
 */ function $d86a688f978d4434$export$5c9f6e262288b7db(profile_id, start_timestamp, processed_profile, event) {
    if (event.type !== 'transaction') // createProfilingEventEnvelope should only be called for transactions,
    // we type guard this behavior with isProfiledTransactionEvent.
    throw new TypeError('Profiling events may only be attached to transactions, this should never occur.');
    if (processed_profile === undefined || processed_profile === null) throw new TypeError(`Cannot construct profiling event envelope without a valid profile. Got ${processed_profile} instead.`);
    const traceId = $d86a688f978d4434$var$getTraceId(event);
    const enrichedThreadProfile = $d86a688f978d4434$export$7cbe6c4f12ea8325(processed_profile);
    const transactionStartMs = start_timestamp ? start_timestamp : typeof event.start_timestamp === 'number' ? event.start_timestamp * 1000 : Date.now();
    const transactionEndMs = typeof event.timestamp === 'number' ? event.timestamp * 1000 : Date.now();
    const profile = {
        event_id: profile_id,
        timestamp: new Date(transactionStartMs).toISOString(),
        platform: 'javascript',
        version: '1',
        release: event.release || '',
        environment: event.environment || (0, $b5y9n.DEFAULT_ENVIRONMENT),
        runtime: {
            name: 'javascript',
            version: (0, $i8T1U.WINDOW).navigator.userAgent
        },
        os: {
            name: $d86a688f978d4434$var$OS_PLATFORM,
            version: $d86a688f978d4434$var$OS_PLATFORM_VERSION,
            build_number: $d86a688f978d4434$var$OS_BROWSER
        },
        device: {
            locale: $d86a688f978d4434$var$OS_LOCALE,
            model: $d86a688f978d4434$var$OS_MODEL,
            manufacturer: $d86a688f978d4434$var$OS_BROWSER,
            architecture: $d86a688f978d4434$var$OS_ARCH,
            is_emulator: false
        },
        debug_meta: {
            images: $d86a688f978d4434$export$4c0b0d8ee0d018b5(processed_profile.resources)
        },
        profile: enrichedThreadProfile,
        transactions: [
            {
                name: event.transaction || '',
                id: event.event_id || (0, $1y8R2.uuid4)(),
                trace_id: traceId,
                active_thread_id: $d86a688f978d4434$var$THREAD_ID_STRING,
                relative_start_ns: '0',
                relative_end_ns: ((transactionEndMs - transactionStartMs) * 1e6).toFixed(0)
            }
        ]
    };
    return profile;
}
/*
  See packages/tracing-internal/src/browser/router.ts
*/ /**
 *
 */ function $d86a688f978d4434$export$7c501dd6adb8177c(transaction) {
    return transaction.op === 'pageload';
}
/**
 * Converts a JSSelfProfile to a our sampled format.
 * Does not currently perform stack indexing.
 */ function $d86a688f978d4434$export$f4122c775dfac1c2(input) {
    let EMPTY_STACK_ID = undefined;
    let STACK_ID = 0;
    // Initialize the profile that we will fill with data
    const profile = {
        samples: [],
        stacks: [],
        frames: [],
        thread_metadata: {
            [$d86a688f978d4434$var$THREAD_ID_STRING]: {
                name: $d86a688f978d4434$var$THREAD_NAME
            }
        }
    };
    if (!input.samples.length) return profile;
    // We assert samples.length > 0 above and timestamp should always be present
    const start = input.samples[0].timestamp;
    // The JS SDK might change it's time origin based on some heuristic (see See packages/utils/src/time.ts)
    // when that happens, we need to ensure we are correcting the profile timings so the two timelines stay in sync.
    // Since JS self profiling time origin is always initialized to performance.timeOrigin, we need to adjust for
    // the drift between the SDK selected value and our profile time origin.
    const origin = typeof performance.timeOrigin === 'number' ? performance.timeOrigin : (0, $leMLP.browserPerformanceTimeOrigin) || 0;
    const adjustForOriginChange = origin - ((0, $leMLP.browserPerformanceTimeOrigin) || origin);
    for(let i = 0; i < input.samples.length; i++){
        const jsSample = input.samples[i];
        // If sample has no stack, add an empty sample
        if (jsSample.stackId === undefined) {
            if (EMPTY_STACK_ID === undefined) {
                EMPTY_STACK_ID = STACK_ID;
                profile.stacks[EMPTY_STACK_ID] = [];
                STACK_ID++;
            }
            profile['samples'][i] = {
                // convert ms timestamp to ns
                elapsed_since_start_ns: ((jsSample.timestamp + adjustForOriginChange - start) * $d86a688f978d4434$var$MS_TO_NS).toFixed(0),
                stack_id: EMPTY_STACK_ID,
                thread_id: $d86a688f978d4434$var$THREAD_ID_STRING
            };
            continue;
        }
        let stackTop = input.stacks[jsSample.stackId];
        // Functions in top->down order (root is last)
        // We follow the stackTop.parentId trail and collect each visited frameId
        const stack = [];
        while(stackTop){
            stack.push(stackTop.frameId);
            const frame = input.frames[stackTop.frameId];
            // If our frame has not been indexed yet, index it
            if (profile.frames[stackTop.frameId] === undefined) profile.frames[stackTop.frameId] = {
                function: frame.name,
                abs_path: typeof frame.resourceId === 'number' ? input.resources[frame.resourceId] : undefined,
                lineno: frame.line,
                colno: frame.column
            };
            stackTop = stackTop.parentId === undefined ? undefined : input.stacks[stackTop.parentId];
        }
        const sample = {
            // convert ms timestamp to ns
            elapsed_since_start_ns: ((jsSample.timestamp + adjustForOriginChange - start) * $d86a688f978d4434$var$MS_TO_NS).toFixed(0),
            stack_id: STACK_ID,
            thread_id: $d86a688f978d4434$var$THREAD_ID_STRING
        };
        profile['stacks'][STACK_ID] = stack;
        profile['samples'][i] = sample;
        STACK_ID++;
    }
    return profile;
}
/**
 * Adds items to envelope if they are not already present - mutates the envelope.
 * @param envelope
 */ function $d86a688f978d4434$export$4df36760a75f76bc(envelope, profiles) {
    if (!profiles.length) return envelope;
    for (const profile of profiles)envelope[1].push([
        {
            type: 'profile'
        },
        profile
    ]);
    return envelope;
}
/**
 * Finds transactions with profile_id context in the envelope
 * @param envelope
 * @returns
 */ function $d86a688f978d4434$export$df9bb0fc214ff8cd(envelope) {
    const events = [];
    (0, $cSKRv.forEachEnvelopeItem)(envelope, (item, type)=>{
        if (type !== 'transaction') return;
        for(let j = 1; j < item.length; j++){
            const event = item[j];
            if (event && event.contexts && event.contexts['profile'] && event.contexts['profile']['profile_id']) events.push(item[j]);
        }
    });
    return events;
}
const $d86a688f978d4434$var$debugIdStackParserCache = new WeakMap();
/**
 * Applies debug meta data to an event from a list of paths to resources (sourcemaps)
 */ function $d86a688f978d4434$export$4c0b0d8ee0d018b5(resource_paths) {
    const debugIdMap = (0, $4mb67.GLOBAL_OBJ)._sentryDebugIds;
    if (!debugIdMap) return [];
    const client = (0, $fq71H.getClient)();
    const options = client && client.getOptions();
    const stackParser = options && options.stackParser;
    if (!stackParser) return [];
    let debugIdStackFramesCache;
    const cachedDebugIdStackFrameCache = $d86a688f978d4434$var$debugIdStackParserCache.get(stackParser);
    if (cachedDebugIdStackFrameCache) debugIdStackFramesCache = cachedDebugIdStackFrameCache;
    else {
        debugIdStackFramesCache = new Map();
        $d86a688f978d4434$var$debugIdStackParserCache.set(stackParser, debugIdStackFramesCache);
    }
    // Build a map of filename -> debug_id
    const filenameDebugIdMap = Object.keys(debugIdMap).reduce((acc, debugIdStackTrace)=>{
        let parsedStack;
        const cachedParsedStack = debugIdStackFramesCache.get(debugIdStackTrace);
        if (cachedParsedStack) parsedStack = cachedParsedStack;
        else {
            parsedStack = stackParser(debugIdStackTrace);
            debugIdStackFramesCache.set(debugIdStackTrace, parsedStack);
        }
        for(let i = parsedStack.length - 1; i >= 0; i--){
            const stackFrame = parsedStack[i];
            const file = stackFrame && stackFrame.filename;
            if (stackFrame && file) {
                acc[file] = debugIdMap[debugIdStackTrace];
                break;
            }
        }
        return acc;
    }, {});
    const images = [];
    for (const path of resource_paths)if (path && filenameDebugIdMap[path]) images.push({
        type: 'sourcemap',
        code_file: path,
        debug_id: filenameDebugIdMap[path]
    });
    return images;
}
/**
 * Checks the given sample rate to make sure it is valid type and value (a boolean, or a number between 0 and 1).
 */ function $d86a688f978d4434$export$2603c8d332a51c42(rate) {
    // we need to check NaN explicitly because it's of type 'number' and therefore wouldn't get caught by this typecheck
    if (typeof rate !== 'number' && typeof rate !== 'boolean' || typeof rate === 'number' && isNaN(rate)) {
        (0, $70zzf.DEBUG_BUILD) && (0, $lN8pX.logger).warn(`[Profiling] Invalid sample rate. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(rate)} of type ${JSON.stringify(typeof rate)}.`);
        return false;
    }
    // Boolean sample rates are always valid
    if (rate === true || rate === false) return true;
    // in case sampleRate is a boolean, it will get automatically cast to 1 if it's true and 0 if it's false
    if (rate < 0 || rate > 1) {
        (0, $70zzf.DEBUG_BUILD) && (0, $lN8pX.logger).warn(`[Profiling] Invalid sample rate. Sample rate must be between 0 and 1. Got ${rate}.`);
        return false;
    }
    return true;
}
function $d86a688f978d4434$var$isValidProfile(profile) {
    if (profile.samples.length < 2) {
        if (0, $70zzf.DEBUG_BUILD) // Log a warning if the profile has less than 2 samples so users can know why
        // they are not seeing any profiling data and we cant avoid the back and forth
        // of asking them to provide us with a dump of the profile data.
        (0, $lN8pX.logger).log('[Profiling] Discarding profile because it contains less than 2 samples');
        return false;
    }
    if (!profile.frames.length) {
        if (0, $70zzf.DEBUG_BUILD) (0, $lN8pX.logger).log('[Profiling] Discarding profile because it contains no frames');
        return false;
    }
    return true;
}
// Keep a flag value to avoid re-initializing the profiler constructor. If it fails
// once, it will always fail and this allows us to early return.
let $d86a688f978d4434$var$PROFILING_CONSTRUCTOR_FAILED = false;
const $d86a688f978d4434$export$8640c0b5c7d98a81 = 30000;
/**
 * Check if profiler constructor is available.
 * @param maybeProfiler
 */ function $d86a688f978d4434$var$isJSProfilerSupported(maybeProfiler) {
    return typeof maybeProfiler === 'function';
}
/**
 * Starts the profiler and returns the profiler instance.
 */ function $d86a688f978d4434$export$9f4f648547a4284f() {
    // Feature support check first
    const JSProfilerConstructor = (0, $i8T1U.WINDOW).Profiler;
    if (!$d86a688f978d4434$var$isJSProfilerSupported(JSProfilerConstructor)) {
        if (0, $70zzf.DEBUG_BUILD) (0, $lN8pX.logger).log('[Profiling] Profiling is not supported by this browser, Profiler interface missing on window object.');
        return;
    }
    // From initial testing, it seems that the minimum value for sampleInterval is 10ms.
    const samplingIntervalMS = 10;
    // Start the profiler
    const maxSamples = Math.floor($d86a688f978d4434$export$8640c0b5c7d98a81 / samplingIntervalMS);
    // Attempt to initialize the profiler constructor, if it fails, we disable profiling for the current user session.
    // This is likely due to a missing 'Document-Policy': 'js-profiling' header. We do not want to throw an error if this happens
    // as we risk breaking the user's application, so just disable profiling and log an error.
    try {
        return new JSProfilerConstructor({
            sampleInterval: samplingIntervalMS,
            maxBufferSize: maxSamples
        });
    } catch (e) {
        if (0, $70zzf.DEBUG_BUILD) {
            (0, $lN8pX.logger).log("[Profiling] Failed to initialize the Profiling constructor, this is likely due to a missing 'Document-Policy': 'js-profiling' header.");
            (0, $lN8pX.logger).log('[Profiling] Disabling profiling for current user session.');
        }
        $d86a688f978d4434$var$PROFILING_CONSTRUCTOR_FAILED = true;
    }
    return;
}
/**
 * Determine if a profile should be profiled.
 */ function $d86a688f978d4434$export$ea6683c0c72c1201(transaction) {
    // If constructor failed once, it will always fail, so we can early return.
    if ($d86a688f978d4434$var$PROFILING_CONSTRUCTOR_FAILED) {
        if (0, $70zzf.DEBUG_BUILD) (0, $lN8pX.logger).log('[Profiling] Profiling has been disabled for the duration of the current user session.');
        return false;
    }
    if (!transaction.isRecording()) {
        if (0, $70zzf.DEBUG_BUILD) (0, $lN8pX.logger).log('[Profiling] Discarding profile because transaction was not sampled.');
        return false;
    }
    const client = (0, $fq71H.getClient)();
    const options = client && client.getOptions();
    if (!options) {
        (0, $70zzf.DEBUG_BUILD) && (0, $lN8pX.logger).log('[Profiling] Profiling disabled, no options found.');
        return false;
    }
    // @ts-expect-error profilesSampleRate is not part of the browser options yet
    const profilesSampleRate = options.profilesSampleRate;
    // Since this is coming from the user (or from a function provided by the user), who knows what we might get. (The
    // only valid values are booleans or numbers between 0 and 1.)
    if (!$d86a688f978d4434$export$2603c8d332a51c42(profilesSampleRate)) {
        (0, $70zzf.DEBUG_BUILD) && (0, $lN8pX.logger).warn('[Profiling] Discarding profile because of invalid sample rate.');
        return false;
    }
    // if the function returned 0 (or false), or if `profileSampleRate` is 0, it's a sign the profile should be dropped
    if (!profilesSampleRate) {
        (0, $70zzf.DEBUG_BUILD) && (0, $lN8pX.logger).log('[Profiling] Discarding profile because a negative sampling decision was inherited or profileSampleRate is set to 0');
        return false;
    }
    // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
    // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
    const sampled = profilesSampleRate === true ? true : Math.random() < profilesSampleRate;
    // Check if we should sample this profile
    if (!sampled) {
        (0, $70zzf.DEBUG_BUILD) && (0, $lN8pX.logger).log(`[Profiling] Discarding profile because it's not included in the random sample (sampling rate = ${Number(profilesSampleRate)})`);
        return false;
    }
    return true;
}
/**
 * Creates a profiling envelope item, if the profile does not pass validation, returns null.
 * @param event
 * @returns {Profile | null}
 */ function $d86a688f978d4434$export$5c2c5e805edd874f(profile_id, start_timestamp, profile, event) {
    if (!$d86a688f978d4434$var$isValidProfile(profile)) return null;
    return $d86a688f978d4434$export$5c9f6e262288b7db(profile_id, start_timestamp, profile, event);
}
// TODO (v8): We need to obtain profile ids in @sentry-internal/tracing,
// but we don't have access to this map because importing this map would
// cause a circular dependancy. We need to resolve this in v8.
const $d86a688f978d4434$var$PROFILE_MAP = new Map();
/**
 *
 */ function $d86a688f978d4434$export$9d723f414195854a() {
    return $d86a688f978d4434$var$PROFILE_MAP.size;
}
/**
 * Retrieves profile from global cache and removes it.
 */ function $d86a688f978d4434$export$6285310796363de1(profile_id) {
    const profile = $d86a688f978d4434$var$PROFILE_MAP.get(profile_id);
    if (profile) $d86a688f978d4434$var$PROFILE_MAP.delete(profile_id);
    return profile;
}
/**
 * Adds profile to global cache and evicts the oldest profile if the cache is full.
 */ function $d86a688f978d4434$export$7ddae68097f7e530(profile_id, profile) {
    $d86a688f978d4434$var$PROFILE_MAP.set(profile_id, profile);
    if ($d86a688f978d4434$var$PROFILE_MAP.size > 30) {
        const last = $d86a688f978d4434$var$PROFILE_MAP.keys().next().value;
        $d86a688f978d4434$var$PROFILE_MAP.delete(last);
    }
}

});


parcelRegister("4Ux1y", function(module, exports) {

$parcel$export(module.exports, "browserProfilingIntegration", () => $3936024573a3a9af$export$2c7b5d6dd5622f23);
$parcel$export(module.exports, "BrowserProfilingIntegration", () => $3936024573a3a9af$export$b0fe88803ed435e0);

var $6emiv = parcelRequire("6emiv");
var $fq71H = parcelRequire("fq71H");

var $lN8pX = parcelRequire("lN8pX");

var $70zzf = parcelRequire("70zzf");

var $6cDJJ = parcelRequire("6cDJJ");

var $izYtH = parcelRequire("izYtH");
const $3936024573a3a9af$var$INTEGRATION_NAME = 'BrowserProfiling';
const $3936024573a3a9af$var$_browserProfilingIntegration = ()=>{
    return {
        name: $3936024573a3a9af$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        setup (client) {
            const scope = (0, $fq71H.getCurrentScope)();
            // eslint-disable-next-line deprecation/deprecation
            const transaction = scope.getTransaction();
            if (transaction && (0, $izYtH.isAutomatedPageLoadTransaction)(transaction)) {
                if ((0, $izYtH.shouldProfileTransaction)(transaction)) (0, $6cDJJ.startProfileForTransaction)(transaction);
            }
            if (typeof client.on !== 'function') {
                (0, $lN8pX.logger).warn('[Profiling] Client does not support hooks, profiling will be disabled');
                return;
            }
            client.on('startTransaction', (transaction)=>{
                if ((0, $izYtH.shouldProfileTransaction)(transaction)) (0, $6cDJJ.startProfileForTransaction)(transaction);
            });
            client.on('beforeEnvelope', (envelope)=>{
                // if not profiles are in queue, there is nothing to add to the envelope.
                if (!(0, $izYtH.getActiveProfilesCount)()) return;
                const profiledTransactionEvents = (0, $izYtH.findProfiledTransactionsFromEnvelope)(envelope);
                if (!profiledTransactionEvents.length) return;
                const profilesToAddToEnvelope = [];
                for (const profiledTransaction of profiledTransactionEvents){
                    const context = profiledTransaction && profiledTransaction.contexts;
                    const profile_id = context && context['profile'] && context['profile']['profile_id'];
                    const start_timestamp = context && context['profile'] && context['profile']['start_timestamp'];
                    if (typeof profile_id !== 'string') {
                        (0, $70zzf.DEBUG_BUILD) && (0, $lN8pX.logger).log('[Profiling] cannot find profile for a transaction without a profile context');
                        continue;
                    }
                    if (!profile_id) {
                        (0, $70zzf.DEBUG_BUILD) && (0, $lN8pX.logger).log('[Profiling] cannot find profile for a transaction without a profile context');
                        continue;
                    }
                    // Remove the profile from the transaction context before sending, relay will take care of the rest.
                    if (context && context['profile']) delete context.profile;
                    const profile = (0, $izYtH.takeProfileFromGlobalCache)(profile_id);
                    if (!profile) {
                        (0, $70zzf.DEBUG_BUILD) && (0, $lN8pX.logger).log(`[Profiling] Could not retrieve profile for transaction: ${profile_id}`);
                        continue;
                    }
                    const profileEvent = (0, $izYtH.createProfilingEvent)(profile_id, start_timestamp, profile, profiledTransaction);
                    if (profileEvent) profilesToAddToEnvelope.push(profileEvent);
                }
                (0, $izYtH.addProfilesToEnvelope)(envelope, profilesToAddToEnvelope);
            });
        }
    };
};
const $3936024573a3a9af$export$2c7b5d6dd5622f23 = (0, $6emiv.defineIntegration)($3936024573a3a9af$var$_browserProfilingIntegration);
/**
 * Browser profiling integration. Stores any event that has contexts["profile"]["profile_id"]
 * This exists because we do not want to await async profiler.stop calls as transaction.finish is called
 * in a synchronous context. Instead, we handle sending the profile async from the promise callback and
 * rely on being able to pull the event from the cache when we need to construct the envelope. This makes the
 * integration less reliable as we might be dropping profiles when the cache is full.
 *
 * @experimental
 * @deprecated Use `browserProfilingIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $3936024573a3a9af$export$b0fe88803ed435e0 = (0, $6emiv.convertIntegrationFnToClass)($3936024573a3a9af$var$INTEGRATION_NAME, $3936024573a3a9af$export$2c7b5d6dd5622f23);

});


parcelRegister("8oLfs", function(module, exports) {

parcelRequire("bIffi");




// Need to disable this because this affects how files are bundled together
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $bc7c56fac95ede45$var$lazyImports = ()=>{
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    (parcelRequire("irJ4w"));
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    (parcelRequire("5tsrJ"));
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    (parcelRequire("5PrLw"));
};
// We set this global variable to ensure it is available to all environments
// and then overwrite its value to TRUE in the JiraSPA entries: SSR and non-SSR
$parcel$global.__SPA__ = false;

});
parcelRegister("bIffi", function(module, exports) {

var $fq6gA = parcelRequire("fq6gA");

var $jMqau = parcelRequire("jMqau");

var $3d7d8 = parcelRequire("3d7d8");

var $jp5kW = parcelRequire("jp5kW");

var $6kzEx = parcelRequire("6kzEx");
if (!(0, $jp5kW.default)('fe_platform_error_tracking_enabled_sentry')) (0, $3d7d8.installGlobalHandler)();
(0, $jMqau.installErrorHandler)((0, $6kzEx.platformErrorHandler));
(0, $fq6gA.default)();

});
parcelRegister("3d7d8", function(module, exports) {

$parcel$export(module.exports, "installGlobalHandler", () => $a8b71c3901fb899d$export$7da675e3dd1bd6b5);

var $1rHqO = parcelRequire("1rHqO");
const $a8b71c3901fb899d$export$7da675e3dd1bd6b5 = ()=>false ? undefined : (0, $1rHqO.installGlobalHandler)();

});
parcelRegister("1rHqO", function(module, exports) {

$parcel$export(module.exports, "installGlobalHandler", () => $7c65112c2954e7ac$export$7da675e3dd1bd6b5);

var $egVmm = parcelRequire("egVmm");
var $5kOsg = parcelRequire("5kOsg");
var $8Xuap = parcelRequire("8Xuap");

var $13Shy = parcelRequire("13Shy");
var $cDASn = parcelRequire("cDASn");
var $24Tbz = parcelRequire("24Tbz");
var $8jpeT = parcelRequire("8jpeT");

var $c04PQ = parcelRequire("c04PQ");

var $4Pf62 = parcelRequire("4Pf62");

var $4R6GH = parcelRequire("4R6GH");

var $j8DrX = parcelRequire("j8DrX");

var $4iGWF = parcelRequire("4iGWF");

var $lUCeS = parcelRequire("lUCeS");
const $7c65112c2954e7ac$var$SENTRY_URL = 'https://12742a0abbd1484686195dca8ba74be6@o55978.ingest.sentry.io/5988809';
const $7c65112c2954e7ac$var$FRONTEND_RESOURCES = [
    // Our DEV and PROD environments in Micros Static
    /https:\/\/jira-frontend.*\..*\.atl-paas\.net\//,
    // For devs using `yarn start`
    /atlastunnel/,
    /localhost/,
    // Old S3 DEV environment
    /https:\/\/d398cwy4pffc4s\.cloudfront\.net\//,
    // Monolith staging|hello|ap|us environment
    /https:\/\/(d25s903c0x7s6j|dgjotco7y2aa|d9x1z07c483jl|d1vkjhvgh6tvn1).cloudfront.net\//,
    // Old S3 PROD environment
    /https:\/\/d2oj435jmh0qvz\.cloudfront\.net\//,
    // Automation S3 dev|staging|prod environment
    /https:\/\/(d3r49bgl1frqoy|d2v2wiwzx86dg|d283vu6e5qi87p).cloudfront.net\//
];
// https://docs.sentry.io/platforms/javascript/#removing-an-integration
// Remove Breadcrumbs integration from the Sentry default integrations
// we will re-add it manually with custom options
const $7c65112c2954e7ac$var$getFilteredIntegrations = (integrations)=>integrations.filter(({ name: name })=>name !== 'Breadcrumbs');
// This is used to mark which frames of the stacktrace are part of our app. They will be
// displayed in a different UI in Sentry.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $7c65112c2954e7ac$var$rewriteFramesIteratee = (frame)=>{
    const curFrame = frame;
    if (curFrame.filename) curFrame.in_app = $7c65112c2954e7ac$var$FRONTEND_RESOURCES.some((resource)=>resource.test(frame.filename));
    return curFrame;
};
const $7c65112c2954e7ac$var$getSentryEnvironment = ()=>{
    if ((0, $4R6GH.fg)('jira-bypass-sentry-environment-filter')) return 'dev';
    return (0, $4Pf62.getTenantContext_DEPRECATED_DO_NOT_USE)().environment ?? 'no-environment';
};
/**
 * Initializes Sentry for error logging with configurations tailored to the application's environment. It ensures error reports are not duplicated if Sentry is already active, and sets up custom handling for errors and breadcrumbs, enhancing error reporting with specific application context like bundler version, build variant, and user information.
 */ const $7c65112c2954e7ac$export$7da675e3dd1bd6b5 = ()=>{
    // Check for sentry already enabled to be defensive in case two fragments are loaded in the same page, we
    // don't want duplicated error reports
    const sentryClient = (0, $egVmm.getCurrentHub)().getClient();
    if (sentryClient && sentryClient.getOptions().enabled) return;
    let environment = $7c65112c2954e7ac$var$getSentryEnvironment();
    if (environment === 'prod') environment = 'production';
    const tags = {
        region: (0, $j8DrX.default)('ajs-region') || 'unknown'
    };
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (window.BUNDLER_VERSION) {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const bundlerVersionTag = window.BUNDLER_VERSION.includes('@') ? window.BUNDLER_VERSION : `webpack@${window.BUNDLER_VERSION}`;
        tags.bundler = bundlerVersionTag;
    }
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (window.BUILD_VARIANT) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    tags.variant = window.BUILD_VARIANT;
    const config = {
        // This is evaluated against the *first* frame of the stack trace.
        // If it doesn't match, the error is not sent.
        allowUrls: $7c65112c2954e7ac$var$FRONTEND_RESOURCES,
        beforeSend: (0, $lUCeS.normaliseSentryEvent),
        // Sentry dom adds more attrs (like title, alt...) to breadcrumbs
        // but they might contain UGC/PII so we need to force strip them
        beforeBreadcrumb: (0, $4iGWF.normaliseSentryBreadcrumbs),
        dsn: (0, $c04PQ.isFedRamp)() ? undefined : $7c65112c2954e7ac$var$SENTRY_URL,
        environment: environment,
        initialScope: {
            tags: tags,
            user: {
                id: (0, $4Pf62.getTenantContext_DEPRECATED_DO_NOT_USE)().atlassianAccountId ?? undefined
            }
        },
        integrations: (integrations)=>[
                ...$7c65112c2954e7ac$var$getFilteredIntegrations(integrations),
                new (0, $8Xuap.Integrations).Breadcrumbs({
                    // only enable breadcrumbs for dom (UI clicks and inputs)
                    // include 'data-test-id', 'data-testid' in the breadcrumbs if they are found
                    dom: {
                        serializeAttribute: (0, $4iGWF.SERIALIZABLE_ATTRIBUTES),
                        maxStringLength: 300
                    },
                    fetch: false,
                    xhr: false,
                    console: false,
                    history: false,
                    sentry: false
                }),
                new (0, $cDASn.Dedupe)(),
                new (0, $24Tbz.ExtraErrorData)(),
                new (0, $8jpeT.RewriteFrames)({
                    iteratee: $7c65112c2954e7ac$var$rewriteFramesIteratee
                }),
                ...(0, $4R6GH.fg)('jira-capture-console-errors-in-sentry') ? [
                    new (0, $13Shy.CaptureConsole)({
                        levels: [
                            'error'
                        ]
                    })
                ] : []
            ],
        maxBreadcrumbs: 15,
        release: globalThis.BUILD_KEY,
        dist: globalThis.BUILD_VARIANT || 'default'
    };
    (0, $5kOsg.init)(config);
};

});
parcelRegister("4Pf62", function(module, exports) {

$parcel$export(module.exports, "LICENSED_PRODUCTS", () => $1fcaa46a1ea1c586$export$88049c64f9286584);
$parcel$export(module.exports, "getLicensedProducts", () => $1fcaa46a1ea1c586$export$8cc688f27940ac);
$parcel$export(module.exports, "getInitialProductList", () => $1fcaa46a1ea1c586$export$971bd624a4cf068e);
$parcel$export(module.exports, "getFirstActivationDate", () => $1fcaa46a1ea1c586$export$2fc3e4b3f0460c2f);
$parcel$export(module.exports, "determineProductCrossSellConfig", () => $1fcaa46a1ea1c586$export$2885d42113231825);
$parcel$export(module.exports, "_haveValuesArrived", () => $1fcaa46a1ea1c586$export$8ece9c90e8293278);
$parcel$export(module.exports, "getTenantContext_DEPRECATED_DO_NOT_USE", () => $1fcaa46a1ea1c586$export$374aeba69d52d74d);

var $8QpSo = parcelRequire("8QpSo");

var $c04PQ = parcelRequire("c04PQ");

var $lzeFL = parcelRequire("lzeFL");

var $j8DrX = parcelRequire("j8DrX");

var $4tcSU = parcelRequire("4tcSU");

var $g5X3G = parcelRequire("g5X3G");

var $ef5Xn = parcelRequire("ef5Xn");

var $7qPn9 = parcelRequire("7qPn9");

var $4R6GH = parcelRequire("4R6GH");

var $lpLR9 = parcelRequire("lpLR9");

var $aMLAs = parcelRequire("aMLAs");

var $cI4Bv = parcelRequire("cI4Bv");
const $1fcaa46a1ea1c586$export$88049c64f9286584 = {
    ATLASSIAN_ANALYTICS: 'atlassian-analytics-free',
    JIRA_SOFTWARE: 'jira-software',
    JIRA_SERVICEDESK: 'jira-servicedesk',
    JIRA_PORTFOLIO: 'com.radiantminds.roadmaps-jira',
    JIRA_CORE: 'jira-core',
    JIRA_PRODUCT_DISCOVERY: 'jira-product-discovery',
    CONFLUENCE: 'confluence',
    OPSGENIE: 'opsgenie',
    BITBUCKET: 'com.atlassian.bitbucket',
    STATUS_PAGE: 'statuspage',
    LOOM: 'loom',
    COMPASS: 'compass'
};
const $1fcaa46a1ea1c586$export$b4187945225b3132 = (getMetaCustom)=>{
    const getMetaImpl = getMetaCustom === undefined ? (0, $j8DrX.default) : getMetaCustom;
    const metaValue = getMetaImpl('ajs-is-admin');
    if (metaValue === null) return 'unknown';
    return metaValue === 'true' ? 'admin' : 'non-admin';
};
const $1fcaa46a1ea1c586$export$8cc688f27940ac = (getMetaCustom)=>{
    const getMetaImpl = getMetaCustom === undefined ? (0, $j8DrX.default) : getMetaCustom;
    try {
        return JSON.parse(getMetaImpl('ajs-licensed-products') || '{}');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // eslint-disable-next-line no-console
        console.warn(`Invalid list of licensed products: ${error}`);
        return {};
    }
};
const $1fcaa46a1ea1c586$export$875713824cd90c85 = (getMetaCustom)=>{
    const getMetaImpl = getMetaCustom === undefined ? (0, $j8DrX.default) : getMetaCustom;
    try {
        return JSON.parse(getMetaImpl('ajs-product-entitlement-details') || '{}');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        return {};
    }
};
const $1fcaa46a1ea1c586$export$971bd624a4cf068e = (getMetaCustom)=>{
    const getMetaImpl = getMetaCustom === undefined ? (0, $j8DrX.default) : getMetaCustom;
    const metaValue = getMetaImpl('ajs-initial-product-list');
    if (metaValue === null) return '';
    return metaValue;
};
const $1fcaa46a1ea1c586$export$2fc3e4b3f0460c2f = (getMetaCustom)=>{
    const getMetaImpl = getMetaCustom === undefined ? (0, $j8DrX.default) : getMetaCustom;
    const metaValue = getMetaImpl('ajs-first-activation-date');
    if (metaValue === null) return null;
    const timestamp = parseInt(metaValue, 10);
    if (Number.isNaN(timestamp)) return null;
    return timestamp;
};
const $1fcaa46a1ea1c586$export$c3fee804514cdf76 = (getMetaCustom)=>{
    const getMetaImpl = getMetaCustom === undefined ? (0, $j8DrX.default) : getMetaCustom;
    const metaValue = getMetaImpl('ajs-app-updates-available');
    if (metaValue === null) return null;
    const hasAppUpdates = parseInt(metaValue, 10);
    if (Number.isNaN(hasAppUpdates)) return null;
    return hasAppUpdates;
};
const $1fcaa46a1ea1c586$export$2885d42113231825 = (getMetaCustom)=>{
    const getMetaImpl = getMetaCustom === undefined ? (0, $j8DrX.default) : getMetaCustom;
    const metaValue = getMetaImpl('ajs-xflow-product-suggestions-enabled');
    if (metaValue === null) return 'unknown';
    return metaValue === 'true' ? 'enabled' : 'disabled';
};
const $1fcaa46a1ea1c586$export$57570b1603cf6adb = ()=>(0, $7qPn9.toEnvironment)((0, $j8DrX.default)('ajs-environment'));
const $1fcaa46a1ea1c586$export$8ece9c90e8293278 = ()=>{
    return(// Cloud ID is flushed early. Checking only this means critical values are available, but not "all of them".
    typeof (0, $j8DrX.default)('ajs-cloud-id') === 'string' && // Version number is retrieved via slow metadata provider call. its presence should indicate "the rest" are available, too.
    typeof (0, $j8DrX.default)('ajs-version-number') === 'string');
};
/**
 * Use hooks from @atlassian/jira-tenant-context-controller instead of this function. Because reading from 30 <meta> tags in DOM on each call slows page down considerably.
 * More info: https://hello.atlassian.net/wiki/spaces/MAGMA/blog/2022/01/12/1479453433/PSA+getTenantContext+is+now+deprecated
 */ const $1fcaa46a1ea1c586$var$getTenantContextFromMeta = (getMetaCustom)=>{
    const getMetaImpl = getMetaCustom === undefined ? (0, $j8DrX.default) : getMetaCustom;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    const cloudId = getMetaImpl('ajs-cloud-id');
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    const activationId = getMetaImpl('ajs-activation-id');
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    const cloudName = getMetaImpl('ajs-cloud-name');
    const xsrfToken = getMetaImpl === (0, $j8DrX.default) ? (0, $4tcSU.default)() || null : getMetaImpl('atlassian-token');
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const languageTag = getMetaImpl('ajs-fspage-locale');
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    const locale = getMetaImpl('ajs-user-locale');
    const userFullname = getMetaImpl('ajs-remote-user-fullname');
    const username = getMetaImpl('ajs-remote-user');
    const isAdmin = getMetaImpl('ajs-is-admin') === 'true';
    const isSiteAdmin = getMetaImpl('ajs-is-site-admin') === 'true';
    const fabricActivityUrl = '/gateway/api/activity';
    const fabricNotificationLogUrl = '/gateway/api/notification-log';
    const fabricPfDirUrl = getMetaImpl('ajs-fabric-pf-dir-url');
    const appPermissions = (0, $7qPn9.populateApplicationPermissions)({
        hasSoftwareAccess: getMetaImpl('ajs-has-jira-software') === 'true',
        hasServiceDeskAccess: getMetaImpl('ajs-has-jira-service-desk') === 'true',
        hasCoreAccess: getMetaImpl('ajs-has-jira-core') === 'true',
        hasProductDiscoveryAccess: getMetaImpl('ajs-has-jira-product-discovery') === 'true',
        hasCustomerServiceAccess: getMetaImpl('ajs-has-jira-customer-service') === 'true'
    });
    const accountId = getMetaImpl('ajs-atlassian-account-id');
    const isAnonymous = accountId === '';
    const applicationKey = getMetaImpl('ajs-application-key');
    const environment = (0, $7qPn9.toEnvironment)(getMetaImpl('ajs-environment'));
    const areProductSuggestionsEnabled = getMetaImpl('ajs-xflow-product-suggestions-enabled') === 'true';
    const licensedProducts = $1fcaa46a1ea1c586$export$8cc688f27940ac(getMetaImpl);
    const productEntitlementDetails = $1fcaa46a1ea1c586$export$875713824cd90c85(getMetaImpl);
    if (accountId === null || locale === null || cloudId === null) throw new Error('Unable to find tenant context');
    if (!(0, $lzeFL.default).includes(locale)) // eslint-disable-next-line no-console
    console.warn(`Non supported locale in tenant context: ${locale}`);
    const siteAdminStatus = $1fcaa46a1ea1c586$export$b4187945225b3132(getMetaImpl);
    const productCrossSellConfig = $1fcaa46a1ea1c586$export$2885d42113231825(getMetaImpl);
    const appEditions = (0, $lpLR9.default)(getMetaImpl);
    const productPermissionGated = (0, $cI4Bv.default)(getMetaImpl);
    let licenseStates;
    if (getMetaImpl('ajs-product-license-states') !== null) licenseStates = (0, $aMLAs.default)(getMetaImpl);
    else /**
		 * When feature flag is OFF, the value of licenseStates will just depend on ajs-has-* tags.
		 * At the moment, there's no other usages besides <LicenseStateCheck>, so this is safe
		 */ licenseStates = (0, $ef5Xn.populateApplicationLicenseStates)({
        core: appPermissions.hasCoreAccess ? (0, $ef5Xn.LICENSE_STATE_ACTIVE) : (0, $ef5Xn.LICENSE_STATE_UNLICENSED),
        software: appPermissions.hasSoftwareAccess ? (0, $ef5Xn.LICENSE_STATE_ACTIVE) : (0, $ef5Xn.LICENSE_STATE_UNLICENSED),
        serviceDesk: appPermissions.hasServiceDeskAccess ? (0, $ef5Xn.LICENSE_STATE_ACTIVE) : (0, $ef5Xn.LICENSE_STATE_UNLICENSED),
        customerService: appPermissions.hasCustomerServiceAccess ? (0, $ef5Xn.LICENSE_STATE_ACTIVE) : (0, $ef5Xn.LICENSE_STATE_UNLICENSED),
        productDiscovery: appPermissions.hasProductDiscoveryAccess ? (0, $ef5Xn.LICENSE_STATE_ACTIVE) : (0, $ef5Xn.LICENSE_STATE_UNLICENSED)
    });
    const loggedInUser = username === '' ? null : username;
    const atlassianAccountId = accountId === '' ? null : (0, $g5X3G.toAccountId)(accountId);
    const isDevMode = getMetaImpl('ajs-dev-mode') === 'true';
    const firstActivationDateMs = $1fcaa46a1ea1c586$export$2fc3e4b3f0460c2f(getMetaImpl);
    const isDevopsProjectCreationScenario = getMetaImpl('ajs-devops-project-creation-scenario') === 'true';
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const devopsProjectSignupSource = getMetaImpl('ajs-devops-signup-source-scenario');
    const isMarketingOptOut = getMetaImpl('ajs-marketing-opt-out') === 'true';
    const hasDlpEnabled = getMetaImpl('ajs-has-dlp') === 'true';
    const appUpdatesAvailable = $1fcaa46a1ea1c586$export$c3fee804514cdf76(getMetaImpl);
    const avpWorkspaceId = getMetaImpl('ajs-avp-workspace-id');
    let cmdbDisabledInFedRAMP = null;
    if ((0, $c04PQ.isFedRamp)() && (0, $4R6GH.fg)('use_cmdb_scr12_enabled')) cmdbDisabledInFedRAMP = getMetaImpl('ajs-cmdb-disabled-in-fedramp') === 'true';
    return {
        appEditions: appEditions,
        applicationKey: applicationKey,
        appPermissions: appPermissions,
        appUpdatesAvailable: appUpdatesAvailable,
        areProductSuggestionsEnabled: areProductSuggestionsEnabled,
        atlassianAccountId: atlassianAccountId,
        // TODO cleanup after START-3337 is done
        baseUrl: (0, $g5X3G.toBaseUrl)(''),
        cloudId: cloudId,
        orgId: getMetaImpl('ajs-org-id') ?? undefined,
        activationId: activationId,
        cloudName: cloudName,
        devopsProjectSignupSource: devopsProjectSignupSource,
        environment: environment,
        fabricActivityUrl: fabricActivityUrl,
        fabricNotificationLogUrl: fabricNotificationLogUrl,
        fabricPfDirUrl: fabricPfDirUrl,
        firstActivationDateMs: firstActivationDateMs,
        isAdmin: isAdmin,
        isAnonymous: isAnonymous,
        isDevMode: isDevMode,
        isDevopsProjectCreationScenario: isDevopsProjectCreationScenario,
        isMarketingOptOut: isMarketingOptOut,
        isSiteAdmin: isSiteAdmin,
        languageTag: languageTag,
        licensedProducts: licensedProducts,
        licenseStates: licenseStates,
        locale: locale,
        loggedInUser: loggedInUser,
        productCrossSellConfig: productCrossSellConfig,
        productEntitlementDetails: productEntitlementDetails,
        productPermissionGated: productPermissionGated,
        siteAdminStatus: siteAdminStatus,
        userFullname: userFullname,
        xsrfToken: xsrfToken,
        hasDlpEnabled: hasDlpEnabled,
        avpWorkspaceId: avpWorkspaceId,
        cmdbDisabledInFedRAMP: cmdbDisabledInFedRAMP
    };
};
const $1fcaa46a1ea1c586$export$374aeba69d52d74d = (0, $8QpSo.default)($1fcaa46a1ea1c586$var$getTenantContextFromMeta);
const $1fcaa46a1ea1c586$export$5d1ad47b0845813e = $1fcaa46a1ea1c586$var$getTenantContextFromMeta;

});
parcelRegister("lzeFL", function(module, exports) {

$parcel$export(module.exports, "defaultLocale", () => $f2e848cf85654fc3$export$d7f512c98c859244);
$parcel$export(module.exports, "default", () => $f2e848cf85654fc3$export$2e2bcd8739ae039);
$parcel$export(module.exports, "standardizeLocale", () => $f2e848cf85654fc3$export$ca06804549ae25fb);

var $GmSo9 = parcelRequire("GmSo9");
const $f2e848cf85654fc3$export$d7f512c98c859244 = 'en_US';
const $f2e848cf85654fc3$export$a95850d20423e414 = 'fr_FR';
const $f2e848cf85654fc3$var$locales = Object.keys((0, (/*@__PURE__*/$parcel$interopDefault($GmSo9)))).map((locale)=>locale.replace('-', '_'));
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$f2e848cf85654fc3$export$2e2bcd8739ae039 = $f2e848cf85654fc3$var$locales;
const $f2e848cf85654fc3$export$ca06804549ae25fb = (locale)=>locale.replace('_', '-');

});
parcelRegister("GmSo9", function(module, exports) {
module.exports = JSON.parse("{\"cs-CZ\":{},\"da-DK\":{},\"de-DE\":{},\"en-GB\":{},\"en-UK\":{},\"en-US\":{},\"en-ZZ\":{},\"es-ES\":{},\"et-EE\":{},\"fi-FI\":{},\"fr-FR\":{},\"hu-HU\":{},\"is-IS\":{},\"it-IT\":{},\"ja-JP\":{},\"ko-KR\":{},\"nb-NO\":{},\"nl-NL\":{},\"pl-PL\":{},\"pt-BR\":{},\"pt-PT\":{},\"ro-RO\":{},\"ru-RU\":{},\"sk-SK\":{},\"sv-SE\":{},\"tr-TR\":{},\"zh-CN\":{},\"zh-TW\":{}}");

});


parcelRegister("4tcSU", function(module, exports) {

$parcel$export(module.exports, "default", () => $d513e689ba3da26b$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/cookie

var $eYli8 = parcelRequire("eYli8");
/**
 * Returns 'atlassian-token' aka xsrf required to secure some operation.
 *
 *
 * Security note: it is important to read from cookies - the same source backend will use to validate the operation
 * The attempt to read it from meta-data ('atlassian-token') resulted in Sev2 HOT-108450
 *
 * The cookie is a part of XSRF technology itself and is exempt from "safe cookies"/FedRAMP requirements.
 * The technology is based on one's ability to read the cookie and this is one it shall be preserved.
 *
 * There is ongoing work to migrate from legacy experiences that rely on this sort of protection
 * Until the work is not done, it shall stay untouched
 * See:
 *  - https://jplat.jira.atlassian.cloud/browse/ISSUEHELP-1198
 */ const $d513e689ba3da26b$var$getXSRFToken = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($eYli8))).get('atlassian.xsrf.token');
var $d513e689ba3da26b$export$2e2bcd8739ae039 = $d513e689ba3da26b$var$getXSRFToken;

});

parcelRegister("g5X3G", function(module, exports) {

$parcel$export(module.exports, "toHref", () => $97fde8cc528bc9d4$export$a54d91f6923c5464);
$parcel$export(module.exports, "toProjectId", () => $97fde8cc528bc9d4$export$859c6c19231e0cae);
$parcel$export(module.exports, "toProjectIdArray", () => $97fde8cc528bc9d4$export$4286301eed9f9657);
$parcel$export(module.exports, "toProjectUuid", () => $97fde8cc528bc9d4$export$612bb41d73fb11e5);
$parcel$export(module.exports, "toIssueTypeUuid", () => $97fde8cc528bc9d4$export$794befc4075c2835);
$parcel$export(module.exports, "toProjectKey", () => $97fde8cc528bc9d4$export$cb2a92f44ebd7cbe);
$parcel$export(module.exports, "toIssueId", () => $97fde8cc528bc9d4$export$a2c922a630ec0e8b);
$parcel$export(module.exports, "toIssueIdArray", () => $97fde8cc528bc9d4$export$53d0e029b96060e8);
$parcel$export(module.exports, "toIssueKey", () => $97fde8cc528bc9d4$export$aecb26efae237d79);
$parcel$export(module.exports, "toIssueStatusId", () => $97fde8cc528bc9d4$export$f76742ae029c1fc8);
$parcel$export(module.exports, "toIssueStatusCategoryId", () => $97fde8cc528bc9d4$export$b60f3955104deb9c);
$parcel$export(module.exports, "toIssueTypeId", () => $97fde8cc528bc9d4$export$82d0d80d4e8f7071);
$parcel$export(module.exports, "toIssueTypeIdArray", () => $97fde8cc528bc9d4$export$1e4024404d7db479);
$parcel$export(module.exports, "toVersionIdArray", () => $97fde8cc528bc9d4$export$44dab0418964345a);
$parcel$export(module.exports, "toComponentIdArray", () => $97fde8cc528bc9d4$export$52ef34d341740a97);
$parcel$export(module.exports, "toConfluencePageId", () => $97fde8cc528bc9d4$export$c990339ab4d5fb8c);
$parcel$export(module.exports, "toRemoteLinkGlobalId", () => $97fde8cc528bc9d4$export$ed362afc0734723b);
$parcel$export(module.exports, "toFailedRemoteLinkId", () => $97fde8cc528bc9d4$export$fc6fd899c0ba114c);
$parcel$export(module.exports, "toWebLinkId", () => $97fde8cc528bc9d4$export$f7c5e56dbe1fb);
$parcel$export(module.exports, "toUrlOrigin", () => $97fde8cc528bc9d4$export$28cf3b03487f001b);
$parcel$export(module.exports, "toBaseUrl", () => $97fde8cc528bc9d4$export$b9eeeb253b0e913a);
$parcel$export(module.exports, "toCloudId", () => $97fde8cc528bc9d4$export$23d820b01683ce88);
$parcel$export(module.exports, "toDevopsProjectSignupSource", () => $97fde8cc528bc9d4$export$da62a850b3644c3e);
$parcel$export(module.exports, "toActivationId", () => $97fde8cc528bc9d4$export$31f624ce6ffbfb24);
$parcel$export(module.exports, "toCloudName", () => $97fde8cc528bc9d4$export$fdaeb5e3e448929);
$parcel$export(module.exports, "toDisplayName", () => $97fde8cc528bc9d4$export$1c60d924084a17b4);
$parcel$export(module.exports, "toAccountId", () => $97fde8cc528bc9d4$export$ef1795c9a6f7e7ac);
$parcel$export(module.exports, "toAccountIdArray", () => $97fde8cc528bc9d4$export$4c931bf2f36c0686);
$parcel$export(module.exports, "toTimeZone", () => $97fde8cc528bc9d4$export$538b00033cc11c75);
$parcel$export(module.exports, "toFieldUuid", () => $97fde8cc528bc9d4$export$57dcf8a3df2057f2);
$parcel$export(module.exports, "toOptionUuid", () => $97fde8cc528bc9d4$export$ebcb2e81f79f291e);
$parcel$export(module.exports, "toStringArray", () => $97fde8cc528bc9d4$export$1de82121cbe727f3);
$parcel$export(module.exports, "values", () => $97fde8cc528bc9d4$export$68c286be0e7e55b7);
const $97fde8cc528bc9d4$export$a54d91f6923c5464 = (value)=>value;
const $97fde8cc528bc9d4$export$859c6c19231e0cae = (value)=>value;
const $97fde8cc528bc9d4$export$4286301eed9f9657 = (ids)=>ids;
const $97fde8cc528bc9d4$export$612bb41d73fb11e5 = (value)=>value;
const $97fde8cc528bc9d4$export$794befc4075c2835 = (value)=>value;
const $97fde8cc528bc9d4$export$cb2a92f44ebd7cbe = (value)=>value;
const $97fde8cc528bc9d4$export$a2c922a630ec0e8b = (value)=>value;
const $97fde8cc528bc9d4$export$53d0e029b96060e8 = (ids)=>ids;
const $97fde8cc528bc9d4$export$aecb26efae237d79 = (value)=>value;
const $97fde8cc528bc9d4$export$f76742ae029c1fc8 = (value)=>value;
const $97fde8cc528bc9d4$export$b60f3955104deb9c = (value)=>value;
const $97fde8cc528bc9d4$export$41c62847026740ac = (ids)=>ids;
const $97fde8cc528bc9d4$export$82d0d80d4e8f7071 = (value)=>value;
const $97fde8cc528bc9d4$export$1e4024404d7db479 = (ids)=>ids;
const $97fde8cc528bc9d4$export$4a012c414e08ecc4 = (value)=>value;
const $97fde8cc528bc9d4$export$44dab0418964345a = (ids)=>ids;
const $97fde8cc528bc9d4$export$b68c3eacfb4600f5 = (value)=>value;
const $97fde8cc528bc9d4$export$52ef34d341740a97 = (ids)=>ids;
const $97fde8cc528bc9d4$export$c990339ab4d5fb8c = (value)=>value;
const $97fde8cc528bc9d4$export$a6948b4337f07910 = (value)=>value;
const $97fde8cc528bc9d4$export$ed362afc0734723b = (value)=>value;
const $97fde8cc528bc9d4$export$fc6fd899c0ba114c = (value)=>value;
const $97fde8cc528bc9d4$export$f7c5e56dbe1fb = (value)=>value;
const $97fde8cc528bc9d4$export$28cf3b03487f001b = (value)=>value;
const $97fde8cc528bc9d4$export$b9eeeb253b0e913a = (value)=>value;
const $97fde8cc528bc9d4$export$23d820b01683ce88 = (value)=>value;
const $97fde8cc528bc9d4$export$da62a850b3644c3e = (value)=>value != null && value.length > 0 ? value : null;
const $97fde8cc528bc9d4$export$31f624ce6ffbfb24 = (value)=>value;
const $97fde8cc528bc9d4$export$fdaeb5e3e448929 = (value)=>value;
const $97fde8cc528bc9d4$export$7b7196cdd6b82c61 = (value)=>value != null && value.length > 0 ? value : null;
const $97fde8cc528bc9d4$export$1c60d924084a17b4 = (value)=>value;
const $97fde8cc528bc9d4$export$ef1795c9a6f7e7ac = (value)=>value;
const $97fde8cc528bc9d4$export$4c931bf2f36c0686 = (ids)=>ids;
const $97fde8cc528bc9d4$export$538b00033cc11c75 = (value)=>value;
const $97fde8cc528bc9d4$export$57dcf8a3df2057f2 = (value)=>value;
const $97fde8cc528bc9d4$export$b6239e8adcb3a902 = (value)=>value;
const $97fde8cc528bc9d4$export$ebcb2e81f79f291e = (value)=>value;
const $97fde8cc528bc9d4$export$10e31d74b47a44fa = (value)=>value;
const $97fde8cc528bc9d4$export$f84e8e69fd4488a5 = (value)=>value;
const $97fde8cc528bc9d4$export$1de82121cbe727f3 = (arrayValues)=>arrayValues;
function $97fde8cc528bc9d4$export$68c286be0e7e55b7(object) {
    // @ts-expect-error - TS2769 - No overload matches this call.
    return Object.values(object);
}

});

parcelRegister("ef5Xn", function(module, exports) {

$parcel$export(module.exports, "LICENSE_STATE_ACTIVE", () => $2f5a5517904e64bf$export$b1825e21241fc91);
$parcel$export(module.exports, "LICENSE_STATE_SUSPENDED", () => $2f5a5517904e64bf$export$da47d37a794d21de);
$parcel$export(module.exports, "LICENSE_STATE_EXPIRED", () => $2f5a5517904e64bf$export$7b174e57c0bd6a9c);
$parcel$export(module.exports, "LICENSE_STATE_UNLICENSED", () => $2f5a5517904e64bf$export$2547e580661cf303);
$parcel$export(module.exports, "populateApplicationLicenseStates", () => $2f5a5517904e64bf$export$d72e24da946cb239);
const $2f5a5517904e64bf$export$b1825e21241fc91 = 'ACTIVE';
const $2f5a5517904e64bf$export$da47d37a794d21de = 'SUSPENDED';
const $2f5a5517904e64bf$export$7b174e57c0bd6a9c = 'EXPIRED';
const $2f5a5517904e64bf$export$2547e580661cf303 = 'UNLICENSED';
const $2f5a5517904e64bf$export$d72e24da946cb239 = (overrides = {}, defaultLicenseState = $2f5a5517904e64bf$export$2547e580661cf303)=>({
        core: defaultLicenseState,
        software: defaultLicenseState,
        serviceDesk: defaultLicenseState,
        customerService: defaultLicenseState,
        productDiscovery: defaultLicenseState,
        ...overrides
    });

});

parcelRegister("7qPn9", function(module, exports) {

$parcel$export(module.exports, "populateApplicationPermissions", () => $0df487dc0e4b3790$export$4d9dffdb588381aa);
$parcel$export(module.exports, "toEnvironment", () => $0df487dc0e4b3790$export$a69dcd7c1d779173);
const $0df487dc0e4b3790$export$4d9dffdb588381aa = (overrides = {}, defaultPermission = false)=>({
        hasCoreAccess: defaultPermission,
        hasSoftwareAccess: defaultPermission,
        hasServiceDeskAccess: defaultPermission,
        hasCustomerServiceAccess: defaultPermission,
        hasProductDiscoveryAccess: defaultPermission,
        ...overrides
    });
const $0df487dc0e4b3790$export$a69dcd7c1d779173 = (value)=>{
    switch(value){
        case 'dev':
            return 'dev';
        case 'staging':
            return 'staging';
        case 'prod':
            return 'prod';
        case 'local':
            return 'local';
        default:
            return null;
    }
};

});

parcelRegister("lpLR9", function(module, exports) {

$parcel$export(module.exports, "default", () => $6fd5ccf7391bea73$export$2e2bcd8739ae039);

var $ldyPw = parcelRequire("ldyPw");
const $6fd5ccf7391bea73$var$parseTenantContextEdition = (tenantContextValue)=>{
    switch(tenantContextValue){
        case 'f':
            return 0, $ldyPw.FREE_EDITION;
        case 's':
            return 0, $ldyPw.STANDARD_EDITION;
        case 'p':
            return 0, $ldyPw.PREMIUM_EDITION;
        default:
            return 0, $ldyPw.UNLICENSED;
    }
};
const $6fd5ccf7391bea73$var$parseTenantContextEditions = (tenantContextEditions)=>(0, $ldyPw.populateApplicationEditions)({
        core: $6fd5ccf7391bea73$var$parseTenantContextEdition(tenantContextEditions['jira-core']),
        software: $6fd5ccf7391bea73$var$parseTenantContextEdition(tenantContextEditions['jira-software']),
        serviceDesk: $6fd5ccf7391bea73$var$parseTenantContextEdition(tenantContextEditions['jira-servicedesk']),
        customerService: $6fd5ccf7391bea73$var$parseTenantContextEdition(tenantContextEditions['jira-customer-service']),
        productDiscovery: $6fd5ccf7391bea73$var$parseTenantContextEdition(tenantContextEditions['jira-product-discovery'])
    });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6fd5ccf7391bea73$export$2e2bcd8739ae039 = (getMetaImpl)=>{
    try {
        const tenantContextEditions = JSON.parse(getMetaImpl('ajs-product-editions') || '{}');
        return $6fd5ccf7391bea73$var$parseTenantContextEditions(tenantContextEditions);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // eslint-disable-next-line no-console
        console.warn(`Error parsing application editions from tenant context: ${error}`);
        return (0, $ldyPw.populateApplicationEditions)();
    }
};

});
parcelRegister("ldyPw", function(module, exports) {

$parcel$export(module.exports, "FREE_EDITION", () => $8bc91341c0daedeb$export$e69af2c4378638a2);
$parcel$export(module.exports, "STANDARD_EDITION", () => $8bc91341c0daedeb$export$7bc7dd5faba7ad6b);
$parcel$export(module.exports, "PREMIUM_EDITION", () => $8bc91341c0daedeb$export$3fd0bbb8c68dc4c7);
$parcel$export(module.exports, "UNLICENSED", () => $8bc91341c0daedeb$export$5747d23113da6aa6);
$parcel$export(module.exports, "FREE_EDITION_KEY", () => $8bc91341c0daedeb$export$c8c756d9ef774404);
$parcel$export(module.exports, "STANDARD_EDITION_KEY", () => $8bc91341c0daedeb$export$6ad005c3d13398a0);
$parcel$export(module.exports, "PREMIUM_EDITION_KEY", () => $8bc91341c0daedeb$export$ee574a74f490a9e8);
$parcel$export(module.exports, "editionKeyToEdition", () => $8bc91341c0daedeb$export$21d25cf944084a5e);
$parcel$export(module.exports, "editionToEditionKey", () => $8bc91341c0daedeb$export$564d24f5605eb83d);
$parcel$export(module.exports, "populateApplicationEditions", () => $8bc91341c0daedeb$export$6bdd11dc05a96fbd);
$parcel$export(module.exports, "getEdition", () => $8bc91341c0daedeb$export$acf25cbc735b9b90);
$parcel$export(module.exports, "getEditionForProject", () => $8bc91341c0daedeb$export$7f5fd5f8e6705012);
$parcel$export(module.exports, "toEdition", () => $8bc91341c0daedeb$export$59f6e933a5e0096b);

var $efvDm = parcelRequire("efvDm");
const $8bc91341c0daedeb$export$e69af2c4378638a2 = 'FREE_EDITION';
const $8bc91341c0daedeb$export$7bc7dd5faba7ad6b = 'STANDARD_EDITION';
const $8bc91341c0daedeb$export$3fd0bbb8c68dc4c7 = 'PREMIUM_EDITION';
const $8bc91341c0daedeb$export$5747d23113da6aa6 = 'UNLICENSED';
const $8bc91341c0daedeb$export$c8c756d9ef774404 = 'free';
const $8bc91341c0daedeb$export$6ad005c3d13398a0 = 'standard';
const $8bc91341c0daedeb$export$ee574a74f490a9e8 = 'premium';
const $8bc91341c0daedeb$export$21d25cf944084a5e = (editionShort)=>{
    if (editionShort === $8bc91341c0daedeb$export$c8c756d9ef774404) return $8bc91341c0daedeb$export$e69af2c4378638a2;
    if (editionShort === $8bc91341c0daedeb$export$6ad005c3d13398a0) return $8bc91341c0daedeb$export$7bc7dd5faba7ad6b;
    if (editionShort === $8bc91341c0daedeb$export$ee574a74f490a9e8) return $8bc91341c0daedeb$export$3fd0bbb8c68dc4c7;
    return $8bc91341c0daedeb$export$5747d23113da6aa6;
};
const $8bc91341c0daedeb$export$564d24f5605eb83d = (edition)=>{
    switch(edition){
        case $8bc91341c0daedeb$export$e69af2c4378638a2:
            return $8bc91341c0daedeb$export$c8c756d9ef774404;
        case $8bc91341c0daedeb$export$7bc7dd5faba7ad6b:
            return $8bc91341c0daedeb$export$6ad005c3d13398a0;
        case $8bc91341c0daedeb$export$3fd0bbb8c68dc4c7:
            return $8bc91341c0daedeb$export$ee574a74f490a9e8;
        default:
            return undefined;
    }
};
const $8bc91341c0daedeb$export$6bdd11dc05a96fbd = (overrides = {}, defaultEdition = $8bc91341c0daedeb$export$5747d23113da6aa6)=>({
        core: defaultEdition,
        software: defaultEdition,
        serviceDesk: defaultEdition,
        customerService: defaultEdition,
        productDiscovery: defaultEdition,
        ...overrides
    });
const $8bc91341c0daedeb$export$acf25cbc735b9b90 = (application, applicationEditions)=>{
    switch(application){
        case 0, $efvDm.JIRA_CORE:
            return applicationEditions.core;
        case 0, $efvDm.JIRA_SOFTWARE:
            return applicationEditions.software;
        case 0, $efvDm.JIRA_PRODUCT_DISCOVERY:
            return applicationEditions.productDiscovery;
        case 0, $efvDm.JIRA_SERVICE_DESK:
            return applicationEditions.serviceDesk;
        case 0, $efvDm.JIRA_CUSTOMER_SERVICE:
            return applicationEditions.customerService;
        default:
            throw new Error(`Unrecognised application: ${application}`);
    }
};
const $8bc91341c0daedeb$export$7f5fd5f8e6705012 = (projectType, applicationEditions)=>{
    const application = (0, $efvDm.getApplicationForProject)(projectType);
    return $8bc91341c0daedeb$export$acf25cbc735b9b90(application, applicationEditions);
};
const $8bc91341c0daedeb$export$59f6e933a5e0096b = (edition)=>{
    switch(edition){
        case $8bc91341c0daedeb$export$e69af2c4378638a2:
            return $8bc91341c0daedeb$export$e69af2c4378638a2;
        case $8bc91341c0daedeb$export$7bc7dd5faba7ad6b:
            return $8bc91341c0daedeb$export$7bc7dd5faba7ad6b;
        case $8bc91341c0daedeb$export$3fd0bbb8c68dc4c7:
            return $8bc91341c0daedeb$export$3fd0bbb8c68dc4c7;
        case $8bc91341c0daedeb$export$5747d23113da6aa6:
        default:
            return $8bc91341c0daedeb$export$5747d23113da6aa6;
    }
};

});
parcelRegister("efvDm", function(module, exports) {

$parcel$export(module.exports, "JIRA_PORTFOLIO", () => $26f24a4ad795a5c5$export$29c4c091cb388ff0);
$parcel$export(module.exports, "JIRA_SERVICE_DESK", () => $26f24a4ad795a5c5$export$3afc372bb8c4538c);
$parcel$export(module.exports, "JIRA_CUSTOMER_SERVICE", () => $26f24a4ad795a5c5$export$19eb54cb466391c5);
$parcel$export(module.exports, "JIRA_SOFTWARE", () => $26f24a4ad795a5c5$export$ad9850d60736acbb);
$parcel$export(module.exports, "JIRA_CORE", () => $26f24a4ad795a5c5$export$66e37ea59188c0b8);
$parcel$export(module.exports, "JIRA_PRODUCT_DISCOVERY", () => $26f24a4ad795a5c5$export$b6c5b3e2284b683b);
$parcel$export(module.exports, "getApplicationForProject", () => $26f24a4ad795a5c5$export$3804df50ba7ca359);

var $2vSU6 = parcelRequire("2vSU6");
const $26f24a4ad795a5c5$export$29c4c091cb388ff0 = 'JIRA_PORTFOLIO';
const $26f24a4ad795a5c5$export$3afc372bb8c4538c = 'JIRA_SERVICE_DESK';
const $26f24a4ad795a5c5$export$19eb54cb466391c5 = 'JIRA_CUSTOMER_SERVICE';
const $26f24a4ad795a5c5$export$ad9850d60736acbb = 'JIRA_SOFTWARE';
const $26f24a4ad795a5c5$export$66e37ea59188c0b8 = 'JIRA_CORE';
const $26f24a4ad795a5c5$export$b6c5b3e2284b683b = 'JIRA_PRODUCT_DISCOVERY';
const $26f24a4ad795a5c5$export$3804df50ba7ca359 = (projectType)=>{
    switch(projectType){
        case 0, $2vSU6.CORE_PROJECT:
            return $26f24a4ad795a5c5$export$66e37ea59188c0b8;
        case 0, $2vSU6.PRODUCT_DISCOVERY_PROJECT:
            return $26f24a4ad795a5c5$export$b6c5b3e2284b683b;
        case 0, $2vSU6.SOFTWARE_PROJECT:
            return $26f24a4ad795a5c5$export$ad9850d60736acbb;
        case 0, $2vSU6.SERVICE_DESK_PROJECT:
            return $26f24a4ad795a5c5$export$3afc372bb8c4538c;
        case 0, $2vSU6.CUSTOMER_SERVICE_PROJECT:
            return $26f24a4ad795a5c5$export$19eb54cb466391c5;
        default:
            throw new Error(`Unrecognised project type: ${projectType}`);
    }
};
const $26f24a4ad795a5c5$export$70d16cc42a798666 = (projectType)=>{
    switch(projectType){
        case 0, $2vSU6.CORE_PROJECT:
            return $26f24a4ad795a5c5$export$66e37ea59188c0b8;
        case 0, $2vSU6.PRODUCT_DISCOVERY_PROJECT:
            return $26f24a4ad795a5c5$export$b6c5b3e2284b683b;
        case 0, $2vSU6.SOFTWARE_PROJECT:
            return $26f24a4ad795a5c5$export$ad9850d60736acbb;
        case 0, $2vSU6.SERVICE_DESK_PROJECT:
            return $26f24a4ad795a5c5$export$3afc372bb8c4538c;
        case 0, $2vSU6.CUSTOMER_SERVICE_PROJECT:
            return $26f24a4ad795a5c5$export$19eb54cb466391c5;
        default:
            throw new Error(`Unrecognised project type: ${projectType}`);
    }
};

});
parcelRegister("2vSU6", function(module, exports) {

$parcel$export(module.exports, "CORE_PROJECT", () => $06cf3305fdeeefe0$export$4b79f735ed858abe);
$parcel$export(module.exports, "SOFTWARE_PROJECT", () => $06cf3305fdeeefe0$export$417275bac62d38d2);
$parcel$export(module.exports, "SERVICE_DESK_PROJECT", () => $06cf3305fdeeefe0$export$9c9c9eaf8c092006);
$parcel$export(module.exports, "CUSTOMER_SERVICE_PROJECT", () => $06cf3305fdeeefe0$export$320625d747692f94);
$parcel$export(module.exports, "SERVICE_DESK_PROJECT_ANALYTICS", () => $06cf3305fdeeefe0$export$d579a2a17bd742af);
$parcel$export(module.exports, "PRODUCT_DISCOVERY_PROJECT", () => $06cf3305fdeeefe0$export$e9fe9a39cc7f5103);
$parcel$export(module.exports, "JIRA_PROJECT_TYPE_CORE_PROJECT", () => $06cf3305fdeeefe0$export$490d3686b662c315);
$parcel$export(module.exports, "JIRA_PROJECT_TYPE_SOFTWARE_PROJECT", () => $06cf3305fdeeefe0$export$1242aa4e670b910e);
$parcel$export(module.exports, "JIRA_PROJECT_TYPE_SERVICE_DESK_PROJECT", () => $06cf3305fdeeefe0$export$bb467c3bc8f8620e);
$parcel$export(module.exports, "JIRA_PROJECT_TYPE_CUSTOMER_SERVICE_PROJECT", () => $06cf3305fdeeefe0$export$610dddac4d185bf8);
$parcel$export(module.exports, "JIRA_PROJECT_TYPE_PRODUCT_DISCOVERY_PROJECT", () => $06cf3305fdeeefe0$export$76412127fb3089d6);
$parcel$export(module.exports, "JIRA_PROJECT_STATUS_ACTIVE", () => $06cf3305fdeeefe0$export$1b784afd50592d26);
$parcel$export(module.exports, "JIRA_PROJECT_STATUS_ARCHIVED", () => $06cf3305fdeeefe0$export$c02e05d1bee347e5);
$parcel$export(module.exports, "COMPANY_MANAGED_PROJECT", () => $06cf3305fdeeefe0$export$6933c64814be01d9);
$parcel$export(module.exports, "TEAM_MANAGED_PROJECT", () => $06cf3305fdeeefe0$export$e569d8a168a85f48);
$parcel$export(module.exports, "ProjectStyle", () => $06cf3305fdeeefe0$export$1f66f9f05afa05a8);
$parcel$export(module.exports, "ProjectStyleCmpNotation", () => $06cf3305fdeeefe0$export$bde8ccac2f23fd0f);
$parcel$export(module.exports, "PROJECT_TYPES", () => $06cf3305fdeeefe0$export$9482030bf1904b0);
$parcel$export(module.exports, "toProjectType", () => $06cf3305fdeeefe0$export$cfdcd9ead66e4329);
$parcel$export(module.exports, "convertToProjectType", () => $06cf3305fdeeefe0$export$aa8444e79de3a8b6);
$parcel$export(module.exports, "convertToJiraProjectType", () => $06cf3305fdeeefe0$export$5a8b6164d1baba87);
$parcel$export(module.exports, "toAnalyticsProjectType", () => $06cf3305fdeeefe0$export$5afb6f76b5af0167);
$parcel$export(module.exports, "projectTypeToCanonicalId", () => $06cf3305fdeeefe0$export$e25a1ee2478a61d6);

var $e4eHl = parcelRequire("e4eHl");

var $9pctO = parcelRequire("9pctO");

var $4R6GH = parcelRequire("4R6GH");
const $06cf3305fdeeefe0$export$4b79f735ed858abe = 'business';
const $06cf3305fdeeefe0$export$417275bac62d38d2 = 'software';
const $06cf3305fdeeefe0$export$9c9c9eaf8c092006 = 'service_desk';
const $06cf3305fdeeefe0$export$320625d747692f94 = 'customer_service';
const $06cf3305fdeeefe0$export$d579a2a17bd742af = 'serviceDesk';
const $06cf3305fdeeefe0$export$e9fe9a39cc7f5103 = 'product_discovery';
const $06cf3305fdeeefe0$export$490d3686b662c315 = 'BUSINESS';
const $06cf3305fdeeefe0$export$1242aa4e670b910e = 'SOFTWARE';
const $06cf3305fdeeefe0$export$bb467c3bc8f8620e = 'SERVICE_DESK';
const $06cf3305fdeeefe0$export$610dddac4d185bf8 = 'CUSTOMER_SERVICE';
const $06cf3305fdeeefe0$export$76412127fb3089d6 = 'PRODUCT_DISCOVERY';
const $06cf3305fdeeefe0$export$1b784afd50592d26 = 'ACTIVE';
const $06cf3305fdeeefe0$export$c02e05d1bee347e5 = 'ARCHIVED';
const $06cf3305fdeeefe0$export$8b2d8efe30253ab3 = 'DELETED';
const $06cf3305fdeeefe0$export$6933c64814be01d9 = 'COMPANY_MANAGED_PROJECT';
const $06cf3305fdeeefe0$export$e569d8a168a85f48 = 'TEAM_MANAGED_PROJECT';
const $06cf3305fdeeefe0$export$1f66f9f05afa05a8 = {
    CLASSIC: 'classic',
    NEXT_GEN: 'next-gen'
};
const $06cf3305fdeeefe0$export$bde8ccac2f23fd0f = {
    COMPANY_MANAGED: 'companyManaged',
    TEAM_MANAGED: 'teamManaged'
};
const $06cf3305fdeeefe0$export$9482030bf1904b0 = [
    $06cf3305fdeeefe0$export$4b79f735ed858abe,
    $06cf3305fdeeefe0$export$417275bac62d38d2,
    $06cf3305fdeeefe0$export$9c9c9eaf8c092006,
    $06cf3305fdeeefe0$export$320625d747692f94,
    $06cf3305fdeeefe0$export$e9fe9a39cc7f5103
];
const $06cf3305fdeeefe0$export$cfdcd9ead66e4329 = (value)=>$06cf3305fdeeefe0$export$9482030bf1904b0.find((projectType)=>projectType === value);
function $06cf3305fdeeefe0$export$aa8444e79de3a8b6(jiraProjectType) {
    if ((0, $4R6GH.fg)('jcs_project_type_m3')) switch(jiraProjectType){
        case $06cf3305fdeeefe0$export$490d3686b662c315:
            return $06cf3305fdeeefe0$export$4b79f735ed858abe;
        case $06cf3305fdeeefe0$export$1242aa4e670b910e:
            return $06cf3305fdeeefe0$export$417275bac62d38d2;
        case $06cf3305fdeeefe0$export$bb467c3bc8f8620e:
            return $06cf3305fdeeefe0$export$9c9c9eaf8c092006;
        case $06cf3305fdeeefe0$export$610dddac4d185bf8:
            return $06cf3305fdeeefe0$export$320625d747692f94;
        case $06cf3305fdeeefe0$export$76412127fb3089d6:
            return $06cf3305fdeeefe0$export$e9fe9a39cc7f5103;
        default:
            throw new Error(`Invalid JiraProjectType: ${jiraProjectType}`);
    }
    switch(jiraProjectType){
        case $06cf3305fdeeefe0$export$490d3686b662c315:
            return $06cf3305fdeeefe0$export$4b79f735ed858abe;
        case $06cf3305fdeeefe0$export$1242aa4e670b910e:
            return $06cf3305fdeeefe0$export$417275bac62d38d2;
        case $06cf3305fdeeefe0$export$bb467c3bc8f8620e:
            return $06cf3305fdeeefe0$export$9c9c9eaf8c092006;
        case $06cf3305fdeeefe0$export$610dddac4d185bf8:
            return $06cf3305fdeeefe0$export$9c9c9eaf8c092006;
        case $06cf3305fdeeefe0$export$76412127fb3089d6:
            return $06cf3305fdeeefe0$export$e9fe9a39cc7f5103;
        default:
            throw new Error(`Invalid JiraProjectType: ${jiraProjectType}`);
    }
}
function $06cf3305fdeeefe0$export$959e77de8f16519c(jiraProjectType) {
    // At the time of writing, convertToProjectType returned "Service Desk" not "Customer Service"; this is a workaround for that
    // With jcs_project_type_m3, convertToProjectType returns "Customer Service"
    if (jiraProjectType === $06cf3305fdeeefe0$export$610dddac4d185bf8 && !(0, $4R6GH.fg)('jcs_project_type_m3')) return (0, (/*@__PURE__*/$parcel$interopDefault($9pctO)))($06cf3305fdeeefe0$export$320625d747692f94);
    const convertedProjectType = $06cf3305fdeeefe0$export$aa8444e79de3a8b6(jiraProjectType);
    if (convertedProjectType === $06cf3305fdeeefe0$export$9c9c9eaf8c092006) // 'Service Desk' is old branding
    return (0, (/*@__PURE__*/$parcel$interopDefault($9pctO)))('Service Management');
    return (0, (/*@__PURE__*/$parcel$interopDefault($9pctO)))(convertedProjectType);
}
const $06cf3305fdeeefe0$export$5a8b6164d1baba87 = (projectType)=>{
    switch(projectType){
        case $06cf3305fdeeefe0$export$417275bac62d38d2:
            return $06cf3305fdeeefe0$export$1242aa4e670b910e;
        case $06cf3305fdeeefe0$export$9c9c9eaf8c092006:
            return $06cf3305fdeeefe0$export$bb467c3bc8f8620e;
        case $06cf3305fdeeefe0$export$320625d747692f94:
            return $06cf3305fdeeefe0$export$610dddac4d185bf8;
        case $06cf3305fdeeefe0$export$4b79f735ed858abe:
            return $06cf3305fdeeefe0$export$490d3686b662c315;
        case $06cf3305fdeeefe0$export$e9fe9a39cc7f5103:
            return $06cf3305fdeeefe0$export$76412127fb3089d6;
        default:
            throw new Error(`Invalid ProjectType: ${projectType}`);
    }
};
const $06cf3305fdeeefe0$export$5afb6f76b5af0167 = (projectType)=>{
    switch(projectType){
        case $06cf3305fdeeefe0$export$9c9c9eaf8c092006:
            return $06cf3305fdeeefe0$export$d579a2a17bd742af;
        case $06cf3305fdeeefe0$export$320625d747692f94:
            return $06cf3305fdeeefe0$export$320625d747692f94;
        case $06cf3305fdeeefe0$export$417275bac62d38d2:
            return $06cf3305fdeeefe0$export$417275bac62d38d2;
        case $06cf3305fdeeefe0$export$e9fe9a39cc7f5103:
            return $06cf3305fdeeefe0$export$e9fe9a39cc7f5103;
        case $06cf3305fdeeefe0$export$4b79f735ed858abe:
            return $06cf3305fdeeefe0$export$4b79f735ed858abe;
        default:
            return undefined;
    }
};
const $06cf3305fdeeefe0$var$getFullProjectTypeKey = (style, projectType)=>(0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))(`${style}_${projectType}`);
const $06cf3305fdeeefe0$export$241adb8e9255b93c = $06cf3305fdeeefe0$var$getFullProjectTypeKey($06cf3305fdeeefe0$export$1f66f9f05afa05a8.CLASSIC, $06cf3305fdeeefe0$export$4b79f735ed858abe);
const $06cf3305fdeeefe0$export$e932928a4bf564b7 = $06cf3305fdeeefe0$var$getFullProjectTypeKey($06cf3305fdeeefe0$export$1f66f9f05afa05a8.NEXT_GEN, $06cf3305fdeeefe0$export$417275bac62d38d2);
const $06cf3305fdeeefe0$export$e25a1ee2478a61d6 = (projectType)=>{
    switch(projectType){
        case $06cf3305fdeeefe0$export$4b79f735ed858abe:
            return 'jira-core';
        case $06cf3305fdeeefe0$export$417275bac62d38d2:
            return 'jira-software';
        case $06cf3305fdeeefe0$export$9c9c9eaf8c092006:
            return 'jira-servicedesk';
        case $06cf3305fdeeefe0$export$320625d747692f94:
            return 'jira-customer-service';
        case $06cf3305fdeeefe0$export$e9fe9a39cc7f5103:
            return 'jira-product-discovery';
        default:
            return 'jira';
    }
};

});




parcelRegister("aMLAs", function(module, exports) {

$parcel$export(module.exports, "default", () => $65a351b8816a417b$export$2e2bcd8739ae039);

var $ef5Xn = parcelRequire("ef5Xn");
const $65a351b8816a417b$var$parseTenantContextLicenseState = (tenantContextValue)=>{
    switch(tenantContextValue){
        case 'ACTIVE':
            return 0, $ef5Xn.LICENSE_STATE_ACTIVE;
        case 'SUSPENDED':
            return 0, $ef5Xn.LICENSE_STATE_SUSPENDED;
        case 'EXPIRED':
            return 0, $ef5Xn.LICENSE_STATE_EXPIRED;
        default:
            return 0, $ef5Xn.LICENSE_STATE_UNLICENSED;
    }
};
const $65a351b8816a417b$var$parseTenantContextLicenseStates = (tenantContextLicenseStates)=>(0, $ef5Xn.populateApplicationLicenseStates)({
        core: $65a351b8816a417b$var$parseTenantContextLicenseState(tenantContextLicenseStates['jira-core']),
        software: $65a351b8816a417b$var$parseTenantContextLicenseState(tenantContextLicenseStates['jira-software']),
        serviceDesk: $65a351b8816a417b$var$parseTenantContextLicenseState(tenantContextLicenseStates['jira-servicedesk']),
        customerService: $65a351b8816a417b$var$parseTenantContextLicenseState(tenantContextLicenseStates['jira-customer-service']),
        productDiscovery: $65a351b8816a417b$var$parseTenantContextLicenseState(tenantContextLicenseStates['jira-product-discovery'])
    });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$65a351b8816a417b$export$2e2bcd8739ae039 = (getMetaImpl)=>{
    try {
        const tenantContextLicenseStates = JSON.parse(getMetaImpl('ajs-product-license-states') || '{}');
        return $65a351b8816a417b$var$parseTenantContextLicenseStates(tenantContextLicenseStates);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // eslint-disable-next-line no-console
        console.warn(`Error parsing application license states from tenant context: ${error}`);
        return (0, $ef5Xn.populateApplicationLicenseStates)();
    }
};

});

parcelRegister("cI4Bv", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce26d0735224f43c$export$2e2bcd8739ae039);

// Fallback to true(not allowed) if product does not exist. This makes sense, because the tenant has no product.
// If user tries to somehow access the feature they are not supposed to access, it should be blocked.
const $ce26d0735224f43c$var$parseProductPermissionGates = (productPermissionGatesRaw)=>({
        core: typeof productPermissionGatesRaw[0, $c06e1abca7c13910$export$db515c8cec1e6f79] === 'boolean' ? productPermissionGatesRaw[0, $c06e1abca7c13910$export$db515c8cec1e6f79] : true,
        software: typeof productPermissionGatesRaw[0, $c06e1abca7c13910$export$1346c9aa3cbb477d] === 'boolean' ? productPermissionGatesRaw[0, $c06e1abca7c13910$export$1346c9aa3cbb477d] : true,
        serviceDesk: typeof productPermissionGatesRaw[0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61] === 'boolean' ? productPermissionGatesRaw[0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61] : true,
        productDiscovery: typeof productPermissionGatesRaw[0, $c06e1abca7c13910$export$202f50ee62667e32] === 'boolean' ? productPermissionGatesRaw[0, $c06e1abca7c13910$export$202f50ee62667e32] : true,
        customerService: typeof productPermissionGatesRaw[0, $c06e1abca7c13910$export$e9c56aa3b027d98f] === 'boolean' ? productPermissionGatesRaw[0, $c06e1abca7c13910$export$e9c56aa3b027d98f] : true
    });
const $ce26d0735224f43c$var$defaultProductPermissionGates = {
    core: true,
    software: true,
    serviceDesk: true,
    productDiscovery: true,
    customerService: true
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ce26d0735224f43c$export$2e2bcd8739ae039 = (getMetaImpl)=>{
    try {
        const productPermissionGatesRaw = JSON.parse(getMetaImpl('ajs-product-permission-gates') || '{}');
        return $ce26d0735224f43c$var$parseProductPermissionGates(productPermissionGatesRaw);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // eslint-disable-next-line no-console
        console.warn(`Error parsing product permission gates from tenant context: ${error}`);
        return $ce26d0735224f43c$var$defaultProductPermissionGates;
    }
};

});
const $c06e1abca7c13910$export$c8c1c8c3f8ddba61 = 'jira-servicedesk';
const $c06e1abca7c13910$export$e9c56aa3b027d98f = 'jira-customer-service';
const $c06e1abca7c13910$export$1346c9aa3cbb477d = 'jira-software';
const $c06e1abca7c13910$export$202f50ee62667e32 = 'jira-product-discovery';
const $c06e1abca7c13910$export$db515c8cec1e6f79 = 'jira-core';
const $c06e1abca7c13910$export$c811f21c9ad05dc2 = 'confluence';
const $c06e1abca7c13910$export$961148c98d198270 = 'opsgenie';



parcelRegister("4iGWF", function(module, exports) {

$parcel$export(module.exports, "SERIALIZABLE_ATTRIBUTES", () => $2837b39e4f2fc15c$export$b5bdb04ea16a02e3);
$parcel$export(module.exports, "normaliseSentryBreadcrumbs", () => $2837b39e4f2fc15c$export$6f14342128c6eaa4);
const $2837b39e4f2fc15c$export$b5bdb04ea16a02e3 = [
    'data-test-id',
    'data-testid'
];
const $2837b39e4f2fc15c$var$WHITELISTED_ATTRIBNUTES = [
    'type',
    'name',
    ...$2837b39e4f2fc15c$export$b5bdb04ea16a02e3
];
const $2837b39e4f2fc15c$var$REG_MATCH_NOTALLOWED_ATTRIBUTES = new RegExp(`\\[(?!${$2837b39e4f2fc15c$var$WHITELISTED_ATTRIBNUTES.join('|')}).*?\\]`, 'gm');
// attributes may contain UGC that we need to strip out
// only allow type and name attributes
const $2837b39e4f2fc15c$var$sanitiseUiBreadcrumbMessage = (message)=>message.replace($2837b39e4f2fc15c$var$REG_MATCH_NOTALLOWED_ATTRIBUTES, '');
const $2837b39e4f2fc15c$export$6f14342128c6eaa4 = (breadcrumb)=>{
    const { category: category } = breadcrumb || {};
    // allow "ui*"" category breadcrumbs, that include clicks and inputs on DOM elements
    // they may contain UGC that needs to be stripped out
    if (category?.startsWith('ui')) {
        // sentry can include the element attributes in the data
        // which may contain UGC that we need to strip out
        const sanitisedBreadCrumb = breadcrumb;
        const { message: message } = sanitisedBreadCrumb;
        if (message !== null && message !== undefined) sanitisedBreadCrumb.message = $2837b39e4f2fc15c$var$sanitiseUiBreadcrumbMessage(message);
        return breadcrumb;
    }
    return breadcrumb;
};

});

parcelRegister("lUCeS", function(module, exports) {

$parcel$export(module.exports, "normaliseSentryEvent", () => $fb9ac88fb9092612$export$c1a1d522906bf17c);

var $jpY8v = parcelRequire("jpY8v");

var $4R6GH = parcelRequire("4R6GH");

var $fZneA = parcelRequire("fZneA");

var $cfDZ3 = parcelRequire("cfDZ3");

var $bw7Gm = parcelRequire("bw7Gm");

var $kobfu = parcelRequire("kobfu");

var $kZkBb = parcelRequire("kZkBb");

var $3gbCU = parcelRequire("3gbCU");
const $fb9ac88fb9092612$var$REPORTED_ERRORS = new WeakSet();
const $fb9ac88fb9092612$var$REPORTED_STRING_ERRORS = new WeakSet();
const $fb9ac88fb9092612$var$getFragmentNames = (stackTrace)=>{
    const re = /(?:src\/entry|src|assets)\/([^,./]+)/g;
    const fragmentNames = new Set();
    let fragmentName = re.exec(stackTrace);
    while(fragmentName){
        fragmentNames.add(fragmentName[1]);
        fragmentName = re.exec(stackTrace);
    }
    return Array.from(fragmentNames);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $fb9ac88fb9092612$var$getBackendStatus = (exception)=>exception.statusCode || exception.cause?.statusCode || exception.cause?.extensions?.statusCode || (0, $fZneA.isBackendAPIError)(exception) && 'true' || 'false';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $fb9ac88fb9092612$var$getTraceId = (exception)=>exception.traceId || exception.cause?.traceId || exception.cause?.extensions?.traceId || undefined;
// Add custom tags based on stack trace
const $fb9ac88fb9092612$var$getTaggedData = (data, hint, samplingResult)=>{
    if (!hint) return data;
    const exception = hint.originalException || hint.syntheticException;
    if (!exception) return data;
    if (typeof exception === 'string') return data;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const stackTrace = exception.stack;
    if (!stackTrace) return data;
    const taggedData = data;
    taggedData.tags = {
        backend: $fb9ac88fb9092612$var$getBackendStatus(exception),
        hash: (0, $kobfu.getErrorHash)(exception),
        userLocation: (0, $cfDZ3.getUserLocation)(),
        traceId: $fb9ac88fb9092612$var$getTraceId(exception),
        ...taggedData.tags
    };
    const fragmentNames = $fb9ac88fb9092612$var$getFragmentNames(stackTrace);
    if (!fragmentNames.length) taggedData.tags = {
        ...taggedData.tags,
        fragment: 'unknown'
    };
    else {
        taggedData.tags = {
            ...taggedData.tags,
            fragment: fragmentNames[0]
        };
        if (fragmentNames.length > 1) taggedData.extra = {
            ...taggedData.extra,
            allRelevantFragments: fragmentNames
        };
    }
    if (samplingResult && samplingResult.samplingRate !== null) // this tag indicates the true volume of the exception being sampled
    taggedData.tags.sampled = `1/${samplingResult.samplingRate}`;
    return taggedData;
};
/**
 * It's possible to receive an event with a string exception instead of an Error object.
 * This is typically the case when we catch a console.error.
 *
 * This function performs the same normalisation as `normaliseSentryEvent`, but only includes the steps that are relevant for strings
 */ const $fb9ac88fb9092612$var$normaliseStringException = (event, hint)=>{
    const exception = hint?.originalException;
    if (typeof exception !== 'string') return null;
    // If we are reporting an error with a logger tag and we already reported it, ignore
    if ($fb9ac88fb9092612$var$REPORTED_STRING_ERRORS.has(exception)) return null;
    if (event.tags?.logger) $fb9ac88fb9092612$var$REPORTED_STRING_ERRORS.add(exception);
    // Yes, we're mutating the argument, but at this point in the error handling lifecycle
    // immutability is not important and it simplifies the logic
    // Event type is documented here: https://github.com/getsentry/sentry-javascript/blob/master/packages/types/src/event.ts
    let updatedData = event;
    if (updatedData.request?.url) updatedData.request.url = (0, $bw7Gm.default)(updatedData.request.url);
    updatedData = (0, $3gbCU.stackFrameAssetRewrite)(updatedData);
    const samplingResult = (0, $kZkBb.default)(exception, updatedData.request?.url);
    // sample data sent to sentry if it matches the sampling config
    if (samplingResult.limitCaptureException) return null;
    updatedData.tags = {
        userLocation: (0, $cfDZ3.getUserLocation)(),
        ...updatedData.tags
    };
    return updatedData;
};
const $fb9ac88fb9092612$export$c1a1d522906bf17c = (event, hint)=>{
    // We want to report only real exceptions, so we filter out everything that is non-error
    const exception = hint?.originalException;
    if (!event || event.environment === 'development') return null;
    if (typeof exception === 'string' && (0, $4R6GH.fg)('jira-capture-console-errors-in-sentry')) return $fb9ac88fb9092612$var$normaliseStringException(event, hint);
    if (!(exception instanceof Error)) return null;
    // Ignore errors coming from unsupported browsers (or faking it)
    const isSupportedUA = (0, $jpY8v.isChrome)(84) || (0, $jpY8v.isFirefox)(76) || (0, $jpY8v.isSafari)(15) || (0, $jpY8v.isEdge)(84);
    if (!('allSettled' in Promise) || !isSupportedUA) return null;
    // Ignore errors that explicitly want to skip Sentry
    if ('skipSentry' in exception && (exception.skipSentry === true || typeof exception.skipSentry === 'function' && exception.skipSentry())) return null;
    // Ignore network-like errors
    if ((0, $fZneA.isClientFetchError)(exception)) return null;
    // If we are reporting an error with a logger tag and we already reported it, ignore
    if ($fb9ac88fb9092612$var$REPORTED_ERRORS.has(exception)) return null;
    if (event.tags?.logger) $fb9ac88fb9092612$var$REPORTED_ERRORS.add(exception);
    // Yes, we're mutating the argument, but at this point in the error handling lifecycle
    // immutability is not important and it simplifies the logic
    // Event type is documented here: https://github.com/getsentry/sentry-javascript/blob/master/packages/types/src/event.ts
    let updatedData = event;
    if (updatedData.request?.url) updatedData.request.url = (0, $bw7Gm.default)(updatedData.request.url);
    updatedData = (0, $3gbCU.stackFrameAssetRewrite)(updatedData);
    let samplingResult = (0, $kZkBb.default)(exception?.message, updatedData.request?.url);
    // sample data sent to sentry if it matches the sampling config
    if (samplingResult.limitCaptureException) return null;
    if ((0, $fZneA.isBackendAPIError)(exception)) {
        // capture only 1/X of backend API errors
        const samplingRate = 20;
        samplingResult = {
            limitCaptureException: Math.random() <= 1 / samplingRate,
            samplingRate: samplingRate
        };
        if (samplingResult.limitCaptureException) return null;
    }
    updatedData = $fb9ac88fb9092612$var$getTaggedData(updatedData, hint, samplingResult);
    return updatedData;
};

});
parcelRegister("bw7Gm", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e56038d36490e29$export$2e2bcd8739ae039);

var $aZsz6 = parcelRequire("aZsz6");

var $2YjXe = parcelRequire("2YjXe");
const $9e56038d36490e29$var$applyMatchers = (url, mappings)=>{
    for(let i = 0; i < mappings.length; i += 1){
        const mapping = mappings[i];
        if (!mapping.matcher) return mapping.transformer;
        const match = url.match(mapping.matcher);
        if (match) {
            if (typeof mapping.transformer === 'string') {
                if (match.length > 1) throw new Error('Grouped matcher requires a match => string transformer');
                return mapping.transformer;
            }
            if (match.length === 1) throw new Error('Basic matcher only supports a string transformer');
            return mapping.transformer(match);
        }
    }
    throw new Error('No URL mappers matched! Expected a default matcher.');
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$9e56038d36490e29$export$2e2bcd8739ae039 = (url, mappings = (0, $2YjXe.default))=>{
    let parsedUrl;
    try {
        // This is a little bit of a hack, it's really hard to actually get `url-parse` to throw an
        // error, so instead we set the default base URL to be the fallback - if parsing fails the
        // fallback URL will be the parsed URL
        parsedUrl = (0, (/*@__PURE__*/$parcel$interopDefault($aZsz6)))(url, (0, $2YjXe.PARSE_ERROR_FALLBACK_URL));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (ex) {
        // we can't log the original URL or message because we could end up with UGC, so we return a
        // safe fallback URL so we don't lose the error
        return 0, $2YjXe.PARSE_ERROR_FALLBACK_URL;
    }
    const partialUrl = `${parsedUrl.pathname}${parsedUrl.query}`;
    const result = $9e56038d36490e29$var$applyMatchers(partialUrl, mappings);
    // For the purposes of normalisation, we assume we're only returning a path im the normalised URL
    return `${parsedUrl.protocol}//${parsedUrl.host}${result}`;
};

});
parcelRegister("2YjXe", function(module, exports) {

$parcel$export(module.exports, "PARSE_ERROR_FALLBACK_URL", () => $ffe7919059c653e4$export$92f2182a552c2178);
$parcel$export(module.exports, "default", () => $ffe7919059c653e4$export$2e2bcd8739ae039);
const $ffe7919059c653e4$var$PARSE_ERROR_FALLBACK_PATH = '/could-not-parse/';
const $ffe7919059c653e4$export$92f2182a552c2178 = `https://unknown.example.com${$ffe7919059c653e4$var$PARSE_ERROR_FALLBACK_PATH}`;
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ffe7919059c653e4$export$2e2bcd8739ae039 = [
    {
        matcher: /^\/browse\/.*/i,
        transformer: '/browse/:issueKey'
    },
    {
        matcher: /^\/project\/[A-Z][A-Z0-9]+\/issues/i,
        transformer: '/project/:projectKey/issues'
    },
    {
        matcher: /^\/jira\/software\/projects\/[A-Z][A-Z0-9]+\/issues/i,
        transformer: '/jira/software/projects/:projectKey/issues'
    },
    {
        matcher: /^\/jira\/software\/c\/projects\/[A-Z][A-Z0-9]+\/issues/i,
        transformer: '/jira/software/c/projects/:projectKey/issues'
    },
    {
        matcher: /^\/jira\/servicedesk\/projects\/[A-Z][A-Z0-9]+\/issues/i,
        transformer: '/jira/servicedesk/projects/:projectKey/issues'
    },
    {
        matcher: /^\/jira\/core\/projects\/[A-Z][A-Z0-9]+\/issues/i,
        transformer: '/jira/core/projects/:projectKey/issues'
    },
    {
        matcher: /^\/issues/i,
        transformer: '/issues'
    },
    {
        matcher: /^\/jira\/issues/i,
        transformer: '/jira/issues'
    },
    {
        matcher: /^\/jira\/software\/projects\/[A-Z][A-Z0-9]+\/boards\/\d+(\/backlog|\/roadmap|\/timeline)?/i,
        transformer: (match)=>`/jira/software/projects/:projectKey/boards/:boardId${match[1] ? match[1] : ''}`
    },
    {
        matcher: /^\/jira\/software\/c\/projects\/[A-Z][A-Z0-9]+\/boards\/\d+(\/roadmap|\/timeline)?/i,
        transformer: (match)=>`/jira/software/c/projects/:projectKey/boards/:boardId${match[1] ? match[1] : ''}`
    },
    {
        matcher: /^\/rest\/agile\/(.*?)\/board\/\d+\/configuration/i,
        transformer: (match)=>`/rest/agile/${match[1]}/board/:boardId/configuration`
    },
    {
        matcher: /^\/gateway\/api\/insights\/agile\/board\/\d+\/backlog\/sprint-commitment/i,
        transformer: '/gateway/api/insights/agile/board/:boardId/backlog/sprint-commitment'
    },
    {
        matcher: /^\/rest\/internal\/board\/\d+\/sprint\/\d+\/workload/i,
        transformer: '/rest/internal/board/:boardId/sprint/:sprintId/workload'
    },
    {
        matcher: /^\/rest\/internal\/board\/\d+\/sprint\/\d+\/sprint-progress/i,
        transformer: '/rest/internal/board/:boardId/sprint/:sprintId/sprint-progress'
    },
    {
        matcher: /^\/rest\/internal\/board\/\d+\/sprint\/\d+\/blocked-issues/i,
        transformer: '/rest/internal/board/:boardId/sprint/:sprintId/blocked-issues'
    },
    {
        matcher: /^\/rest\/internal\/board\/\d+\/sprint\/\d+\/epic-progress/i,
        transformer: '/rest/internal/board/:boardId/sprint/:sprintId/epic-progress'
    },
    {
        matcher: /^\/gateway\/api\/aris\/jira\/[a-f0-9-]+\/board\/\d+\/config/i,
        transformer: '/gateway/api/aris/jira/:cloudId/board/:boardId/config'
    },
    {
        matcher: /^\/gateway\/api\/jira-insights\/settings\/board\/\d+\/permissions\/board-admin/i,
        transformer: '/gateway/api/jira-insights/settings/board/:boardId/permissions/board-admin'
    },
    {
        matcher: /\/gateway\/api\/jira-insights\/settings\/board\/\d+/i,
        transformer: '/gateway/api/jira-insights/settings/board/:boardId'
    },
    {
        matcher: /^\/gateway\/api\/insights\/agile\/board\/\d+\/sprint\/\d+\/burndown/i,
        transformer: '/gateway/api/insights/agile/board/:boardId/sprint/:sprintId/burndown'
    },
    {
        matcher: /^\/jira\/servicedesk\/projects\/[A-Z][A-Z0-9]+\/queues\/custom\/\d+/i,
        transformer: '/jira/servicedesk/projects/:projectKey/queues/custom/:queueId/:issueKey'
    },
    {
        matcher: /^\/jira\/servicedesk\/projects\/[A-Z][A-Z0-9]+\/section\/[A-Z]+\/custom\/\d+/i,
        transformer: '/jira/servicedesk/projects/:projectKey/section/:category/custom/:queueId/:issueKey'
    },
    {
        matcher: /^\/projects\/[A-Z][A-Z0-9]+\/settings(\/[a-z]+)?/i,
        transformer: (match)=>`/projects/settings${match[1] ? match[1] : ''}`
    },
    {
        matcher: /^\/projects\/[A-Z][A-Z0-9]+.*?selectedItem=com\.atlassian\.jira\.jira-projects-plugin:(\w+)/i,
        transformer: (match)=>`/projects/:projectKey?selectedItem=com.atlassian.jira.jira-projects-plugin:${match[1]}`
    },
    {
        matcher: /^\/secure\/ConfigureReport!default.jspa.*?reportKey=com.atlassian.jira.plugin.system.reports:(\w+)/i,
        transformer: (match)=>`/secure/ConfigureReport!default.jspa?reportKey=com.atlassian.jira.plugin.system.reports:${match[1]}`
    },
    {
        matcher: /^\/secure\/((.*?\/)?\w+.jspa)/i,
        transformer: (match)=>`/secure/${match[1]}`
    },
    {
        matcher: /^\/plugins\/servlet\/(\w+)/i,
        transformer: (match)=>`/plugins/servlet/${match[1]}`
    },
    {
        matcher: /^\/jira\/your-work/i,
        transformer: '/jira/your-work'
    },
    // Part of the hack around detecting invalid URLs, if we've parsed to the fallback URL, then
    // we return the fallback path instead of the generic "unknown" path
    {
        matcher: new RegExp($ffe7919059c653e4$var$PARSE_ERROR_FALLBACK_PATH),
        transformer: '/could-not-parse/'
    },
    {
        matcher: null,
        transformer: '/unknown'
    }
];

});


parcelRegister("kobfu", function(module, exports) {

$parcel$export(module.exports, "getErrorHash", () => $2e45c1264ca221d3$export$211977f0fb53738b);
/* eslint-disable no-bitwise, no-fallthrough, default-case */ /**
 * JS Implementation of MurmurHash2
 * http://github.com/garycourt/murmurhash-js
 * http://sites.google.com/site/murmurhash/
 */ const $2e45c1264ca221d3$var$murmurHash2 = (str, seed = 1)=>{
    let l = str.length;
    let h = seed ^ l;
    let i = 0;
    let k;
    while(l >= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        k ^= k >>> 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
        l -= 4;
        ++i;
    }
    switch(l){
        // @ts-expect-error - TS7029 - Fallthrough case in switch.
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        // @ts-expect-error - TS7029 - Fallthrough case in switch.
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    }
    h ^= h >>> 13;
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h ^= h >>> 15;
    return h >>> 0;
};
const $2e45c1264ca221d3$export$156fa11ef8a619c3 = (stack)=>{
    const assetPaths = stack.match(/\/([\w.~\-_]+)\.[jt]sx?/g);
    const lineCols = stack.match(/:\d+:\d+/g);
    // uncomment this to get more specific paths
    // const uniquePaths = (assetPaths || [])
    //     .slice(0, 10)
    //     .reduce((acc, v) => {
    //         const [asset] = v.split(':');
    //         if (!acc.includes(asset)) acc.push(asset);
    //         return acc;
    //     }, [])
    //     .slice(1, 5);
    return (assetPaths?.[0] ?? '') + (lineCols?.[0] ?? '');
};
const $2e45c1264ca221d3$var$cache = new WeakMap();
const $2e45c1264ca221d3$export$211977f0fb53738b = (error)=>{
    if ($2e45c1264ca221d3$var$cache.has(error)) return $2e45c1264ca221d3$var$cache.get(error);
    let stackStr = '';
    if (error.stack !== undefined) try {
        stackStr = $2e45c1264ca221d3$export$156fa11ef8a619c3(error.stack);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
    /* ignore */ }
    let errorString = `${error.name} ${stackStr || error.message}`;
    const hash = $2e45c1264ca221d3$var$murmurHash2(errorString).toString(36).toUpperCase();
    try {
        $2e45c1264ca221d3$var$cache.set(error, hash);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
    /* ignore */ }
    return hash;
};

});

parcelRegister("kZkBb", function(module, exports) {

$parcel$export(module.exports, "default", () => $a10f50d4768327e4$export$2e2bcd8739ae039);

var $hGgHi = parcelRequire("hGgHi");

var $1Vzj1 = parcelRequire("1Vzj1");
const $a10f50d4768327e4$var$checkForRuleMatch = (config, message, url)=>{
    const { matcher: matcher, route: route } = config;
    // Rule #1: no regex match on message
    if (!matcher.test(message || '')) return false;
    // Rule #2: If the config has a route specific condition
    if (route !== undefined) {
        // the sampling config requires the error originates from a certain route to be limited
        const matchesRoute = Boolean(url !== undefined && url.endsWith(route));
        if (!matchesRoute) return false;
    }
    return true;
};
// The Math.random produces a 0-1 number then multiplied by samplingRate
const $a10f50d4768327e4$var$shouldLimit = (samplingRate)=>Math.floor(Math.random() * samplingRate) !== 0;
const $a10f50d4768327e4$export$bb9cc46c6e38bd57 = (ruleSet, shouldLimitFn)=>(message, url)=>{
        // Find the matching config and store the rate, otherwise null
        const rule = ruleSet.find((config)=>$a10f50d4768327e4$var$checkForRuleMatch(config, message, url));
        const samplingRate = !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(rule) ? rule.samplingRate : null;
        return {
            limitCaptureException: !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(samplingRate) ? shouldLimitFn(samplingRate) : false,
            samplingRate: samplingRate
        };
    };
var $a10f50d4768327e4$export$2e2bcd8739ae039 = $a10f50d4768327e4$export$bb9cc46c6e38bd57((0, $1Vzj1.default), $a10f50d4768327e4$var$shouldLimit);

});
parcelRegister("1Vzj1", function(module, exports) {

$parcel$export(module.exports, "default", () => $996f8781e252701e$export$2e2bcd8739ae039);
/**
 * BEFORE adding a new sampling configuration:
 * - Ensure no recent change in volume for the error type
 * - Talk to the owners of the error. Confirm there is no other easy fix
 * - Create an issue to improve signal to noise for the error type
 */ const $996f8781e252701e$var$SENTRY_SAMPLING_CONFIG = [
    {
        // Ignore postrobot errors triggered by forge as team won't fix
        // https://atlassian.slack.com/archives/C03MMQ1B39V/p1671517439783989
        matcher: /postrobot_method/,
        samplingRate: 0
    },
    {
        // Ignore e.source.postMessage from monolith Connect JS as caused by callback on a closed window
        // https://atlassian.slack.com/archives/CFGTZ99TL/p1677032642940009
        matcher: /postMessage'\)/,
        samplingRate: 0
    },
    {
        // JFP-1542
        matcher: /^\[Frontend PubSub\] Failed to retrieve subscription configuration \[object Object\]$/,
        samplingRate: 10
    }
];
var $996f8781e252701e$export$2e2bcd8739ae039 = $996f8781e252701e$var$SENTRY_SAMPLING_CONFIG;

});


parcelRegister("3gbCU", function(module, exports) {

$parcel$export(module.exports, "stackFrameAssetRewrite", () => $62b788ecf4230a0c$export$94684a7ef5037b24);
const $62b788ecf4230a0c$export$94684a7ef5037b24 = (data)=>{
    // There isn't a strong type definition for the `data` object with
    // raven-js (it's literally `any`), so we have to do some shape validation to find the deep
    // part we're interested in (if it exists). We're also extra defensive by wrapping the whole
    // thing in a try/catch - if an error occurs we'll just return the data as-is.
    try {
        const rewriteStacktrace = (value)=>{
            if (!(value && value.stacktrace && value.stacktrace.frames && value.stacktrace.frames.length)) return;
            value.stacktrace.frames.forEach((frame)=>{
                if (!frame.filename) return;
                // Yes, we're manipulating the input, this is an implicit choice for this part
                // of the codebase
                // eslint-disable-next-line no-param-reassign
                frame.filename = frame.filename.replace('/assets-brotli/', '/assets/');
            });
        };
        // for non-error errors there can be a top-level `data.stacktrace`
        rewriteStacktrace(data);
        // for normal errors there can be exception.values, these might contain stacktraces
        if (!(data.exception && data.exception.values && data.exception.values.length)) return data;
        data.exception.values.forEach(rewriteStacktrace);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (ex) {
        // eslint-disable-next-line no-console
        console.warn('Unable to rewrite stacktrace filenames', ex);
    }
    return data;
};

});




parcelRegister("6kzEx", function(module, exports) {

$parcel$export(module.exports, "platformErrorHandler", () => $21681750cc3ac216$export$51242f403a159805);

var $b71gk = parcelRequire("b71gk");
function $21681750cc3ac216$export$51242f403a159805(payload) {
    (0, $b71gk.reportError)(payload.error, payload.errorInfo, {
        id: payload.interactionId
    });
}

});
parcelRegister("b71gk", function(module, exports) {

$parcel$export(module.exports, "reportError", () => $081c3d761234afe9$export$b33b857ad1d9900e);
$parcel$export(module.exports, "default", () => $081c3d761234afe9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $1tcYS = parcelRequire("1tcYS");

var $1u4q7 = parcelRequire("1u4q7");

var $bFU4G = parcelRequire("bFU4G");

var $g0Gtc = parcelRequire("g0Gtc");

var $2YZCu = parcelRequire("2YZCu");

var $kobfu = parcelRequire("kobfu");

var $aMh57 = parcelRequire("aMh57");

var $42c81 = parcelRequire("42c81");
const $081c3d761234afe9$var$EGRESS_LIMIT = 5;
const $081c3d761234afe9$var$getLocation = ({ id: id, packageName: packageName, prefixOverride: prefixOverride })=>{
    const prefix = prefixOverride != null ? prefixOverride : 'common';
    if (id != null) return packageName != null ? `${prefix}.error-boundary.${packageName}.${id}` : `${prefix}.error-boundary.${id}`;
    return `${prefix}.error-boundary`;
};
const $081c3d761234afe9$var$ErrorBoundary = (props)=>{
    const interactionId = (0, $5uXOq.useContext)((0, $1u4q7.default));
    const interactionContext = (0, $5uXOq.useContext)((0, $1tcYS.default));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($081c3d761234afe9$export$4b4ea7be124cdbd8, {
        ...props,
        ufoInteractionId: interactionId.current,
        ufoLabelStack: interactionContext?.labelStack
    });
};
function $081c3d761234afe9$export$b33b857ad1d9900e(error, info, { id: id, packageName: packageName, teamName: teamName, prefixOverride: prefixOverride, onError: onError, extraEventData: extraEventData = {} }, interactionId, labelStack) {
    // Somehow, the ErrorBoundary component catch an undefined error.
    // So this check helps to reduce the noise in our Sentry.
    const errorToReport = error ?? new (0, $42c81.UnknownError)();
    const hash = (0, $kobfu.getErrorHash)(errorToReport);
    const event = {
        teamName: teamName ?? null,
        ...extraEventData,
        message: errorToReport.message ?? null,
        stack: errorToReport.stack ?? null,
        // FIXME type "ErrorInfo" used to be mistyped but the type fix propagates in a non-trivial way,
        // cf. PR https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/137436/
        // Progress over perfection: I'm casting to keep the above PR type-only.
        // Next dev actively changing this code, please remove the type cast and use selective inclusion instead.
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        componentStack: info.componentStack,
        hash: hash ?? null
    };
    const location = $081c3d761234afe9$var$getLocation({
        id: id,
        packageName: packageName,
        prefixOverride: prefixOverride
    });
    $081c3d761234afe9$export$4b4ea7be124cdbd8.logErrorToSplunk(hash, location, event);
    (0, $aMh57.captureException)(location, errorToReport, // @ts-expect-error TS2345: Index signature for type string is missing in type ErrorInfo
    info);
    if (interactionId) (0, $bFU4G.addError)(interactionId, `JSErrorBoundary:${id}`, labelStack || null, errorToReport.name, errorToReport.message, errorToReport.stack);
    else (0, $bFU4G.addErrorToAll)(`JSErrorBoundary:${id}`, labelStack || null, errorToReport.name, errorToReport.message, errorToReport.stack);
    if (onError) onError(location, errorToReport, event);
}
class $081c3d761234afe9$export$4b4ea7be124cdbd8 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            children: null,
            extraEventData: {},
            render: ()=>null,
            withExperienceTracker: false,
            onError: ()=>undefined,
            ufoInteractionId: null,
            ufoLabelStack: null
        };
    }
    static{
        // go/jfe-eslint
        // eslint-disable-next-line react/sort-comp
        this.errorFrequencyMap = new Map();
    }
    // go/jfe-eslint
    // eslint-disable-next-line react/sort-comp
    static logErrorToSplunk(hash, location, event) {
        let occurrences;
        if (hash !== undefined) {
            // @ts-expect-error - TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
            occurrences = (this.errorFrequencyMap.get(hash) ?? 0) + 1;
            // @ts-expect-error - TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
            this.errorFrequencyMap.set(hash, occurrences);
        } else // If there's no hash, treat it as the first time
        occurrences = 1;
        // Only send the error log if we are below the egress limit
        if (occurrences <= $081c3d761234afe9$var$EGRESS_LIMIT) (0, $2YZCu.default).safeErrorWithoutCustomerData(location, 'Unhandled error caught by error boundary', event);
    }
    static getDerivedStateFromProps(props, state) {
        if (!!props.resetCaughtError && state.caughtError?.error === props.resetCaughtError) return {
            ...state,
            caughtError: null
        };
        return state;
    }
    componentDidCatch(error, info) {
        const { id: id, packageName: packageName, teamName: teamName, prefixOverride: prefixOverride, onError: onError, extraEventData: extraEventData } = this.props;
        this.setState({
            caughtError: {
                error: error,
                info: info
            }
        });
        // passing this.props will cause "'onError' PropType is defined but prop is never used" eslint error
        $081c3d761234afe9$export$b33b857ad1d9900e(error, info, {
            id: id,
            packageName: packageName,
            teamName: teamName,
            prefixOverride: prefixOverride,
            onError: onError,
            extraEventData: extraEventData
        }, this.props.ufoInteractionId, this.props.ufoLabelStack);
    }
    render() {
        const { caughtError: caughtError } = this.state;
        const { children: children, render: renderFallback, withExperienceTracker: withExperienceTracker, extraEventData: extraEventData } = this.props;
        if (!caughtError) return children;
        const location = $081c3d761234afe9$var$getLocation(this.props);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, renderFallback({
            error: caughtError.error
        }), withExperienceTracker && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g0Gtc.ExperienceFailureTracker), {
            location: location,
            failureEventAttributes: extraEventData
        }));
    }
    constructor(...args){
        super(...args), this.state = {
            caughtError: null
        };
    }
}
var $081c3d761234afe9$export$2e2bcd8739ae039 = $081c3d761234afe9$var$ErrorBoundary;

});
parcelRegister("g0Gtc", function(module, exports) {

$parcel$export(module.exports, "ExperienceSuccessTracker", () => $ecf22ca404bc9d65$export$b721eda798584098);
$parcel$export(module.exports, "ExperienceFailureTracker", () => $ecf22ca404bc9d65$export$7877e129ff70728d);
$parcel$export(module.exports, "ExperienceAbortTracker", () => $ecf22ca404bc9d65$export$69d4d8a5c14b1454);
$parcel$export(module.exports, "ExperienceResultFromPropsTracker", () => $ecf22ca404bc9d65$export$be2c49f6982d0964);

var $5uXOq = parcelRequire("5uXOq");

var $aD4Nm = parcelRequire("aD4Nm");
class $ecf22ca404bc9d65$export$3908b77264c263e4 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            hasSucceeded: false,
            hasFailed: false,
            hasAborted: false,
            children: null
        };
    }
    componentDidMount() {
        this.postRenderChecks();
    }
    componentDidUpdate() {
        this.postRenderChecks();
    }
    postRenderChecks() {
        const { onExperienceSuccess: onExperienceSuccess, onExperienceFailure: onExperienceFailure, onExperienceAbort: onExperienceAbort, hasSucceeded: hasSucceeded, hasFailed: hasFailed, hasAborted: hasAborted } = this.props;
        if (hasFailed) onExperienceFailure();
        else if (hasAborted) onExperienceAbort();
        else if (hasSucceeded) onExperienceSuccess();
    }
    render() {
        return this.props.children;
    }
}
const $ecf22ca404bc9d65$export$5ffc4962dc653e10 = ({ onExperienceSuccess: onExperienceSuccess, onExperienceFailure: onExperienceFailure, onExperienceAbort: onExperienceAbort, hasSucceeded: hasSucceeded = false, hasFailed: hasFailed = false, hasAborted: hasAborted = false, children: children = null })=>{
    (0, $5uXOq.useEffect)(()=>{
        if (hasFailed) onExperienceFailure();
        else if (hasAborted) onExperienceAbort();
        else if (hasSucceeded) onExperienceSuccess();
    }, [
        hasSucceeded,
        hasFailed,
        hasAborted,
        onExperienceSuccess,
        onExperienceFailure,
        onExperienceAbort
    ]);
    return children;
};
const $ecf22ca404bc9d65$export$2a8244c81400d030 = $ecf22ca404bc9d65$export$5ffc4962dc653e10;
const $ecf22ca404bc9d65$export$b721eda798584098 = ({ children: children, ...props })=>false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aD4Nm.ExperienceTracker), props, ({ onExperienceSuccess: onExperienceSuccess, onExperienceFailure: onExperienceFailure, onExperienceAbort: onExperienceAbort })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ecf22ca404bc9d65$export$2a8244c81400d030, {
            hasSucceeded: true,
            onExperienceSuccess: onExperienceSuccess,
            onExperienceFailure: onExperienceFailure,
            onExperienceAbort: onExperienceAbort
        }, children));
$ecf22ca404bc9d65$export$b721eda798584098.defaultProps = (0, $aD4Nm.defaultProps);
const $ecf22ca404bc9d65$export$7877e129ff70728d = ({ children: children, ...props })=>false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aD4Nm.ExperienceTracker), props, ({ onExperienceSuccess: onExperienceSuccess, onExperienceFailure: onExperienceFailure, onExperienceAbort: onExperienceAbort })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ecf22ca404bc9d65$export$2a8244c81400d030, {
            hasFailed: true,
            onExperienceSuccess: onExperienceSuccess,
            onExperienceFailure: onExperienceFailure,
            onExperienceAbort: onExperienceAbort
        }, children));
$ecf22ca404bc9d65$export$7877e129ff70728d.defaultProps = (0, $aD4Nm.defaultProps);
const $ecf22ca404bc9d65$export$69d4d8a5c14b1454 = ({ children: children, ...props })=>false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aD4Nm.ExperienceTracker), props, ({ onExperienceSuccess: onExperienceSuccess, onExperienceFailure: onExperienceFailure, onExperienceAbort: onExperienceAbort })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ecf22ca404bc9d65$export$2a8244c81400d030, {
            hasAborted: true,
            onExperienceSuccess: onExperienceSuccess,
            onExperienceFailure: onExperienceFailure,
            onExperienceAbort: onExperienceAbort
        }, children));
$ecf22ca404bc9d65$export$69d4d8a5c14b1454.defaultProps = (0, $aD4Nm.defaultProps);
const $ecf22ca404bc9d65$export$be2c49f6982d0964 = ({ hasSucceeded: hasSucceeded, hasFailed: hasFailed, hasAborted: hasAborted, children: children, ...trackerProps })=>false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aD4Nm.ExperienceTracker), trackerProps, ({ onExperienceSuccess: onExperienceSuccess, onExperienceFailure: onExperienceFailure, onExperienceAbort: onExperienceAbort })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ecf22ca404bc9d65$export$2a8244c81400d030, {
            hasSucceeded: hasSucceeded,
            hasFailed: hasFailed,
            hasAborted: hasAborted,
            onExperienceSuccess: onExperienceSuccess,
            onExperienceFailure: onExperienceFailure,
            onExperienceAbort: onExperienceAbort
        }, children));
$ecf22ca404bc9d65$export$be2c49f6982d0964.defaultProps = {
    hasSucceeded: false,
    hasFailed: false,
    hasAborted: false,
    ...(0, $aD4Nm.defaultProps)
};

});
parcelRegister("aD4Nm", function(module, exports) {

$parcel$export(module.exports, "defaultProps", () => $b05e9002304a249d$export$9c21a3269931e1e6);
$parcel$export(module.exports, "ExperienceTracker", () => $b05e9002304a249d$export$12b6b072930fd68f);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $2YZCu = parcelRequire("2YZCu");

var $jNwWT = parcelRequire("jNwWT");

var $fz9VZ = parcelRequire("fz9VZ");
const $b05e9002304a249d$export$9c21a3269931e1e6 = {
    failureEventAttributes: null,
    parentProviders: null,
    children: null
};
const $b05e9002304a249d$export$12b6b072930fd68f = ({ children: children, ...props })=>{
    const context = (0, $5uXOq.useContext)((0, $jNwWT.default));
    (0, $5uXOq.useEffect)(()=>{
        if (context === null) (0, $2YZCu.default).safeErrorWithoutCustomerData('experience-tracker.missing-provider', 'Experience tracker rendered without a provider');
    }, [
        context
    ]);
    if (context == null || false) return typeof children === 'function' ? children({
        onExperienceSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        onExperienceFailure: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        onExperienceAbort: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fz9VZ.default), {
        location: props.location,
        experienceContext: context,
        failureEventAttributes: props.failureEventAttributes,
        parentProvidersWhitelist: props.parentProviders
    }, children);
};
$b05e9002304a249d$export$12b6b072930fd68f.defaultProps = $b05e9002304a249d$export$9c21a3269931e1e6;

});
parcelRegister("jNwWT", function(module, exports) {

$parcel$export(module.exports, "default", () => $39d0158587a63255$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
var $39d0158587a63255$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.createContext)(null);

});

parcelRegister("fz9VZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d51c16b24bfced82$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fZneA = parcelRequire("fZneA");
class $d51c16b24bfced82$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    constructor(props){
        super(props), this.onSuccess = ()=>{
            // This guards against the possibility of the child calling `onExperienceSuccess` repeatedly.
            if (!this.hasSignalledSuccess && this.isReportingToCurrentProvider()) {
                this.hasSignalledSuccess = true;
                this.props.experienceContext.consumerCallbacks.onSuccess();
            }
        }, this.onFailure = (locationSuffix, extraFailureEventAttributes)=>{
            const { experienceContext: { consumerCallbacks: { onFailure: onFailure } }, location: location, failureEventAttributes: failureEventAttributes } = this.props;
            if (!this.hasSignalledFailure && this.isReportingToCurrentProvider()) {
                this.hasSignalledFailure = true;
                const concatenatedLocation = locationSuffix == null ? location : `${location}.${locationSuffix}`;
                const mergedFailureAttributes = {
                    ...extraFailureEventAttributes,
                    ...failureEventAttributes
                };
                onFailure(concatenatedLocation, mergedFailureAttributes);
            }
        }, this.onAbort = (locationSuffix, extraFailureEventAttributes)=>{
            const { experienceContext: { consumerCallbacks: { onAbort: onAbort } }, location: location, failureEventAttributes: failureEventAttributes } = this.props;
            if (!this.hasSignalledFailure && this.isReportingToCurrentProvider()) {
                this.hasSignalledFailure = true;
                const concatenatedLocation = locationSuffix == null ? location : `${location}.${locationSuffix}`;
                const mergedFailureAttributes = {
                    ...extraFailureEventAttributes,
                    ...failureEventAttributes
                };
                onAbort(concatenatedLocation, mergedFailureAttributes);
            }
        };
        this.resetTracker();
    }
    componentDidCatch(error) {
        if (!(0, $fZneA.isClientFetchError)(error)) this.onFailure(undefined, {
            errorMessage: error.message
        });
        // We're deliberately rethrowing the error here because we don't want to interfere with
        // any error handling the container app may have in place. This app exists only to track
        // error/success metrics; we don't want to interfere with the app that's actually rendering UI.
        throw error;
    }
    isReportingToCurrentProvider() {
        const { experience: experience } = this.props.experienceContext;
        return(// parentProviders is an OPTIONAL whitelist. If not specified, then we are definitely reporting to the current experience
        this.parentProvidersWhitelistSet == null || // otherwise make sure we are currently in one of the listed experiences
        this.parentProvidersWhitelistSet.has(experience));
    }
    // Resetting must not call setState since this can be executed in the render phase
    resetTracker() {
        this.hasSignalledFailure = false;
        this.hasSignalledSuccess = false;
        this.lastExperienceId = this.props.experienceContext.experienceId;
        // Must only respect updates to `parentProvidersWhitelist` when the experience resets, otherwise weird bugs can arise.
        // Eg: a component could call onSuccess when it never called onPending, this would result in premature experience successes.
        this.parentProvidersWhitelistSet = this.props.parentProvidersWhitelist ? new Set(this.props.parentProvidersWhitelist) : null;
        this.isReportingToCurrentProvider() && this.props.experienceContext.consumerCallbacks.onPending();
    }
    // Check every render to reset the experience state instance variables
    checkExperienceIdForExperienceReset() {
        if (this.lastExperienceId !== this.props.experienceContext.experienceId) this.resetTracker();
    }
    render() {
        this.checkExperienceIdForExperienceReset();
        const { children: children } = this.props;
        return typeof children === 'function' ? children({
            onExperienceSuccess: this.onSuccess,
            onExperienceFailure: this.onFailure,
            onExperienceAbort: this.onAbort
        }) : children;
    }
}

});



parcelRegister("42c81", function(module, exports) {

$parcel$export(module.exports, "UnknownError", () => $0d8caabb143dbf8e$export$ff4405149dbd0c5c);
class $0d8caabb143dbf8e$export$ff4405149dbd0c5c extends Error {
    constructor(){
        super();
        this.name = 'UnknownError';
        this.message = 'There is something wrong and ErrorBoundary component catch an undefined error.';
    }
}

});




parcelRegister("irJ4w", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "AnalyticsProviders", () => $0b62fcd865c46547$export$fe99df39f319f93e);
$parcel$export(module.exports, "default", () => $0b62fcd865c46547$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $bCdIp = parcelRequire("bCdIp");

var $2YZCu = parcelRequire("2YZCu");

var $iXVV6 = parcelRequire("iXVV6");

var $14XJw = parcelRequire("14XJw");

var $9OXo1 = parcelRequire("9OXo1");

var $j8DrX = parcelRequire("j8DrX");

var $kuiU5 = parcelRequire("kuiU5");

var $5gv9t = parcelRequire("5gv9t");
const $0b62fcd865c46547$export$fe99df39f319f93e = ({ children: children })=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const { data: orgId } = (0, $14XJw.useOrgId)();
    (0, $5uXOq.useEffect)(()=>{
        if (false) return;
        try {
            const success = (0, $kuiU5.default)({
                ...tenantContext,
                orgId: orgId
            });
            if (success === undefined) throw new Error('observability.analytics-providers-error: @atlassiansox/analytics-web-client AnalyticsClient in src/common/analytics-web-react/web-client/index.js failed to initialise successfully');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            (0, $2YZCu.default).safeErrorWithoutCustomerData('observability.analytics-providers.analytics', e);
        }
    }, [
        orgId,
        tenantContext
    ]);
    if (false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
    // Temporary analytics for our experiment
    const mobileAnalytics = {
        isMobileUserAgent: (0, $bCdIp.isSupportedUserAgent)(),
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        userAgent: navigator?.userAgent
    };
    /**
	 * As per Jira: Incident Detection and Reliability Uplift we need to add shard and region to the analytics context
	 * This will add shard and region to all analytics events fired throughout the application
	 * we check for false above to ensure SSR does not break with getMeta()
	 */ const shardAndRegionAnalytics = {
        shard: (0, $j8DrX.default)('ajs-shard') || '',
        region: (0, $j8DrX.default)('ajs-region') || ''
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5gv9t.JiraStructuredAnalyticsListener), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: {
            isSPA: __SPA__,
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            variant: window.BUILD_VARIANT,
            ...mobileAnalytics,
            ...shardAndRegionAnalytics
        }
    }, children));
};
var $0b62fcd865c46547$export$2e2bcd8739ae039 = $0b62fcd865c46547$export$fe99df39f319f93e;

});
parcelRegister("bCdIp", function(module, exports) {

$parcel$export(module.exports, "isSupportedUserAgent", () => $dd3d3dbe692d7cce$export$2b0f0a801c573b06);
$parcel$export(module.exports, "isAndroidUserAgent", () => $dd3d3dbe692d7cce$export$6053d3a1e6477e0f);
$parcel$export(module.exports, "isTabletUserAgent", () => $dd3d3dbe692d7cce$export$a33e336659bb3eb6);
$parcel$export(module.exports, "shouldShowReturnToMobileBanner", () => $dd3d3dbe692d7cce$export$604401c0b63e5273);
$parcel$export(module.exports, "shouldShowReturnToMobileBannerMobileMvp", () => $dd3d3dbe692d7cce$export$511710677ef866);
$parcel$export(module.exports, "shouldShowDismissButton", () => $dd3d3dbe692d7cce$export$5ad7f0440f4fd036);
$parcel$export(module.exports, "determineOperatingSystemAttribute", () => $dd3d3dbe692d7cce$export$d9f2497f8d710783);
$parcel$export(module.exports, "default", () => $dd3d3dbe692d7cce$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/cookie -- This reduced TS complexity by 3,114,190 across Jira

var $eYli8 = parcelRequire("eYli8");
/*
This logic was ported from MobileUtils class from jira monolith to
provide the same conditions for checking whether the user agent is mobile or not.
*/ const $dd3d3dbe692d7cce$var$DESKTOP_SWITCH_COOKIE_KEY = 'jira.mobile.desktop.switch';
const $dd3d3dbe692d7cce$var$MOBILE_USER_AGENT = new RegExp('(iPhone;|iPhone Simulator;|iPad;|iPod;|iPod touch|Android)');
const $dd3d3dbe692d7cce$var$MOBILE_STRING_IN_USER_AGENT = new RegExp('Mobile');
const $dd3d3dbe692d7cce$var$IPAD_USER_AGENT = new RegExp('iPad;');
const $dd3d3dbe692d7cce$var$IOS_USER_AGENT = new RegExp('(iPhone;|iPad;|iPod;)');
const $dd3d3dbe692d7cce$var$ANDROID_USER_AGENT = new RegExp('Android');
// This regex matches the following iOS rendering engines:
// 1. Chrome for iOS
// 2. Firefox for iOS
// 3. Edge for iOS
const $dd3d3dbe692d7cce$var$NON_SAFARI_IOS_RENDERING_ENGINE_USER_AGENT = new RegExp('CriOS|FxiOS|EdgiOS');
const $dd3d3dbe692d7cce$export$2b0f0a801c573b06 = ()=>{
    if (false) return false;
    if (!globalThis.navigator?.userAgent.length) return false;
    const isMobile = $dd3d3dbe692d7cce$var$MOBILE_USER_AGENT.test(globalThis.navigator?.userAgent);
    return isMobile;
};
const $dd3d3dbe692d7cce$export$6053d3a1e6477e0f = ()=>{
    return $dd3d3dbe692d7cce$var$ANDROID_USER_AGENT.test(globalThis.navigator?.userAgent);
};
const $dd3d3dbe692d7cce$export$b4161aa2f4036482 = ()=>$dd3d3dbe692d7cce$var$IOS_USER_AGENT.test(globalThis.navigator?.userAgent);
const $dd3d3dbe692d7cce$export$a33e336659bb3eb6 = ()=>{
    if (!globalThis.navigator?.userAgent.length) return false;
    return $dd3d3dbe692d7cce$var$IPAD_USER_AGENT.test(globalThis.navigator?.userAgent) || $dd3d3dbe692d7cce$export$6053d3a1e6477e0f() && !$dd3d3dbe692d7cce$var$MOBILE_STRING_IN_USER_AGENT.test(globalThis.navigator?.userAgent);
};
const $dd3d3dbe692d7cce$var$isDesktopSwitchEnabled = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($eYli8))).get($dd3d3dbe692d7cce$var$DESKTOP_SWITCH_COOKIE_KEY) === 'true';
const $dd3d3dbe692d7cce$var$isMobileUserAgent = ()=>$dd3d3dbe692d7cce$export$2b0f0a801c573b06() && !$dd3d3dbe692d7cce$var$isDesktopSwitchEnabled();
const $dd3d3dbe692d7cce$export$1cb1de725ba5b3e3 = ()=>{
    if (typeof navigator === 'undefined') return false;
    return $dd3d3dbe692d7cce$export$b4161aa2f4036482() && !$dd3d3dbe692d7cce$var$NON_SAFARI_IOS_RENDERING_ENGINE_USER_AGENT.test(globalThis.navigator?.userAgent);
};
const $dd3d3dbe692d7cce$export$604401c0b63e5273 = ()=>$dd3d3dbe692d7cce$export$2b0f0a801c573b06();
const $dd3d3dbe692d7cce$export$511710677ef866 = ()=>{
    return $dd3d3dbe692d7cce$export$2b0f0a801c573b06() && !$dd3d3dbe692d7cce$export$1cb1de725ba5b3e3();
};
const $dd3d3dbe692d7cce$export$5ad7f0440f4fd036 = ()=>$dd3d3dbe692d7cce$export$604401c0b63e5273() && $dd3d3dbe692d7cce$export$a33e336659bb3eb6();
const $dd3d3dbe692d7cce$export$d9f2497f8d710783 = ()=>{
    if ($dd3d3dbe692d7cce$export$b4161aa2f4036482()) return 'ios';
    if ($dd3d3dbe692d7cce$export$6053d3a1e6477e0f()) return 'android';
    return 'other';
};
var $dd3d3dbe692d7cce$export$2e2bcd8739ae039 = $dd3d3dbe692d7cce$var$isMobileUserAgent;

});

parcelRegister("iXVV6", function(module, exports) {

$parcel$export(module.exports, "extractContextualData", () => $5d6369e61c1f96d3$export$dc30f43798194b03);
$parcel$export(module.exports, "ContextualAnalyticsData", () => $5d6369e61c1f96d3$export$198470770171c65);
/**
 * This library is the only place where you'd use raw AnalyticsContext
 * It provides a typed wrapper around it for better user experience
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $cjFoH = parcelRequire("cjFoH");

var $9xWGk = parcelRequire("9xWGk");

var $daJ0i = parcelRequire("daJ0i");
const $5d6369e61c1f96d3$export$dc30f43798194b03 = (props)=>{
    const { children: children, sourceName: sourceName, sourceType: sourceType, ...rest } = props;
    const source = sourceName && sourceType ? `${sourceName}${sourceType}` : undefined;
    return (0, (/*@__PURE__*/$parcel$interopDefault($9xWGk)))({
        source: source,
        ...rest
    }, (0, (/*@__PURE__*/$parcel$interopDefault($cjFoH))));
};
const $5d6369e61c1f96d3$export$198470770171c65 = /*#__PURE__*/ (0, $5uXOq.memo)((props)=>{
    const data = $5d6369e61c1f96d3$export$dc30f43798194b03(props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $daJ0i.default), {
        data: data
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, props.children));
});

});

parcelRegister("14XJw", function(module, exports) {

$parcel$export(module.exports, "useOrgId", () => $758917403b87c0f3$export$52a03a3207af3687);
// eslint-disable-next-line jira/import-whitelist

var $j8DrX = parcelRequire("j8DrX");
const $758917403b87c0f3$export$52a03a3207af3687 = ()=>{
    const orgId = (0, $j8DrX.default)('ajs-org-id');
    return {
        data: orgId || undefined
    };
};

});

parcelRegister("9OXo1", function(module, exports) {

$parcel$export(module.exports, "TenantContextContainer", () => $45fec3195bf4b0e3$export$8b5d54c1fa2f746f);
$parcel$export(module.exports, "TenantContextSubscriber", () => $45fec3195bf4b0e3$export$9d1e1d1d0f8eeb35);
$parcel$export(module.exports, "useTenantContext", () => $45fec3195bf4b0e3$export$28e7c557f4d454d9);

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $51nlc = parcelRequire("51nlc");

var $dT5ak = parcelRequire("dT5ak");

var $2gywT = parcelRequire("2gywT");
const $45fec3195bf4b0e3$export$8b5d54c1fa2f746f = (0, $gg7kZ.createContainer)((0, $2gywT.default), {
    onInit: ()=>({ dispatch: dispatch })=>dispatch($dT5ak.bootstrap())
});
const $45fec3195bf4b0e3$export$9d1e1d1d0f8eeb35 = (0, $51nlc.createSubscriber)((0, $2gywT.default), {
    displayName: 'TenantContextSubscriber'
});
const $45fec3195bf4b0e3$export$b24a99788063c041 = (0, $3sQ5x.createHook)((0, $2gywT.default));
const $45fec3195bf4b0e3$export$28e7c557f4d454d9 = ()=>{
    const [{ tenantContext: tenantContext }] = $45fec3195bf4b0e3$export$b24a99788063c041();
    return tenantContext;
};

});
parcelRegister("dT5ak", function(module, exports) {

$parcel$export(module.exports, "bootstrap", () => $170d1404689e8430$export$36aff1fbb4f5dfc6);

var $4Pf62 = parcelRequire("4Pf62");
const $170d1404689e8430$export$36aff1fbb4f5dfc6 = ()=>({ setState: setState, getState: getState }, { getMeta: getMeta })=>{
        if (getState().tenantContext) return;
        const tenantContext = (0, $4Pf62.getTenantContext_DEPRECATED_DO_NOT_USE)(getMeta);
        setState({
            tenantContext: tenantContext
        });
    };

});

parcelRegister("2gywT", function(module, exports) {

$parcel$export(module.exports, "default", () => $a245e6c645156520$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iXqE5 = parcelRequire("iXqE5");

var $dT5ak = parcelRequire("dT5ak");
// @ts-expect-error - TS2322 - Type 'null' is not assignable to type 'TenantContext'.
const $a245e6c645156520$var$initialState = {
    tenantContext: null
};
var $a245e6c645156520$export$2e2bcd8739ae039 = (0, $iXqE5.createStore)({
    name: 'tenantContext',
    initialState: $a245e6c645156520$var$initialState,
    actions: $dT5ak
});

});


parcelRegister("kuiU5", function(module, exports) {

$parcel$export(module.exports, "default", () => $081317afff917bd7$export$2e2bcd8739ae039);

var $g9E9n = parcelRequire("g9E9n");

var $jc1Kl = parcelRequire("jc1Kl");

var $1h0ro = parcelRequire("1h0ro");

var $lXuk1 = parcelRequire("lXuk1");

var $7rAiW = parcelRequire("7rAiW");
var /**
 * Initializes the analytics web client with configuration tailored to the user and product environment.
 * It dynamically adjusts settings based on user and organizational details to enhance product analytics.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$081317afff917bd7$export$2e2bcd8739ae039 = ({ cloudId: cloudId, cloudName: cloudName, atlassianAccountId: atlassianAccountId, environment: environment, locale: locale, orgId: orgId, activationId: workspaceId })=>(0, $g9E9n.initAnalyticsWebClient)({
        tenantId: cloudId,
        ...atlassianAccountId ? {
            userId: atlassianAccountId
        } : undefined,
        ...orgId && {
            orgId: orgId
        },
        ...workspaceId && {
            workspaceId: workspaceId
        },
        product: 'jira',
        environment: environment === 'prod' ? 'prod' : (0, $lXuk1.default)({
            cloudId: cloudId,
            cloudName: cloudName,
            environment: environment
        }),
        callback: (0, $7rAiW.logEmau),
        subProduct: (0, $1h0ro.default),
        solutions: (0, $jc1Kl.default)(),
        locale: locale
    });

});
parcelRegister("jc1Kl", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3d31cb973660cb6$export$2e2bcd8739ae039);


var $1h0ro = parcelRequire("1h0ro");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a3d31cb973660cb6$export$2e2bcd8739ae039 = ()=>(0, $1h0ro.default)() === 'serviceDesk' ? [
        (0, $86344d58e71e925a$export$c8b406ad8ee0dab9)
    ] : undefined;

});
const $86344d58e71e925a$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';

parcelRegister("1h0ro", function(module, exports) {

$parcel$export(module.exports, "default", () => $370277a877859bbb$export$2e2bcd8739ae039);

var $j8DrX = parcelRequire("j8DrX");

var $j9l0W = parcelRequire("j9l0W");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$370277a877859bbb$export$2e2bcd8739ae039 = ()=>(0, $j9l0W.default)((0, $j8DrX.default)('ajs-application-key'));

});
parcelRegister("j9l0W", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b908af5115f433e$export$2e2bcd8739ae039);
/**
 * Transforms sub-product identifiers into a simplified or generic form, providing
 * a default when unspecified. This aids in standardizing the representation of
 * sub-product names across different contexts.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
var $2b908af5115f433e$export$2e2bcd8739ae039 = (subProduct)=>{
    if (!subProduct) return 'unknown';
    if (subProduct === 'family') return 'platform';
    if (subProduct === 'jira-servicedesk') return 'serviceDesk';
    if (subProduct.startsWith('jira-')) return subProduct.replace('jira-', '');
    return subProduct;
};

});



parcelRegister("lXuk1", function(module, exports) {

$parcel$export(module.exports, "default", () => $717acdf7c4e83754$export$2e2bcd8739ae039);
// MR - stands for the atlassian monorepo prefix
const $717acdf7c4e83754$var$isOverridingFragments = ()=>// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    !!(window?.BUILD_KEY && !/^(?:MR)?JF-PROD-\d+$/.test(window.BUILD_KEY));
const $717acdf7c4e83754$var$isOverridingSsr = ()=>// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    !!(window?.SSR_BUILD_KEY && !/^(?:MR)?JF-PROD-\d+$/i.test(window.SSR_BUILD_KEY));
const $717acdf7c4e83754$var$isVoltExplore = ({ cloudId: cloudId, cloudName: cloudName })=>/^(TEST--)/.test(cloudId) && /^(atl-vertigo--jira-jira-branch)/.test(cloudName);
/**
 * Selects the 'staging' environment under specific conditions, defaulting to 'dev' otherwise.
 * This decision is based on the current environment setting and the absence of specific overrides.
 */ const $717acdf7c4e83754$var$getStagingEnvironment = ({ environment: environment, cloudId: cloudId, cloudName: cloudName })=>{
    if (environment === 'staging' && !$717acdf7c4e83754$var$isOverridingFragments() && !$717acdf7c4e83754$var$isOverridingSsr() && !$717acdf7c4e83754$var$isVoltExplore({
        cloudId: cloudId,
        cloudName: cloudName
    })) return environment;
    return 'dev';
};
var $717acdf7c4e83754$export$2e2bcd8739ae039 = $717acdf7c4e83754$var$getStagingEnvironment;

});

parcelRegister("7rAiW", function(module, exports) {

$parcel$export(module.exports, "logEmau", () => $41fc5951dc5b9377$export$f6d9e07ca353aa2e);

var $5HnTq = parcelRequire("5HnTq");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $41fc5951dc5b9377$var$logEmauForJira = (subproduct, url, urlParams)=>{
    const body = JSON.stringify({
        eventData: {
            url: url,
            subproduct: subproduct,
            urlParams: urlParams
        }
    });
    const endpointUrl = '/rest/internal/2/log/unsafe/emau';
    const fetchOptions = {
        ...(0, $5HnTq.getDefaultOptions)(endpointUrl),
        method: 'POST',
        body: body
    };
    return fetch(endpointUrl, fetchOptions);
};
const $41fc5951dc5b9377$export$f6d9e07ca353aa2e = ({ product: product, subproduct: subproduct })=>{
    if (product === 'jira') // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    $41fc5951dc5b9377$var$logEmauForJira(subproduct, window.location.pathname, window.location.search);
};

});


parcelRegister("5gv9t", function(module, exports) {

$parcel$export(module.exports, "JiraStructuredAnalyticsListener", () => $7cbf4e8505a1a9c2$export$ba6a124597fff04a);

var $5uXOq = parcelRequire("5uXOq");

var $e8KHW = parcelRequire("e8KHW");

var $bvUB1 = parcelRequire("bvUB1");

var $9NirD = parcelRequire("9NirD");

var $2YZCu = parcelRequire("2YZCu");

var $lhVtI = parcelRequire("lhVtI");

var $fjcgS = parcelRequire("fjcgS");

var $85qyr = parcelRequire("85qyr");
const $7cbf4e8505a1a9c2$var$EXCLUDED_CHANNELS = [
    (0, $e8KHW.FabricChannel).atlaskit
];
const $7cbf4e8505a1a9c2$var$addSearchPayload = (event, isProductAnalyticsV3 = false)=>{
    try {
        const searchPayload = (0, $85qyr.addSearchSessionAttributes)();
        if (Object.keys(searchPayload).length > 0) {
            if (isProductAnalyticsV3) // eslint-disable-next-line no-param-reassign
            event.payload.attributes = {
                ...event.payload.attributes,
                ...searchPayload
            };
            else // eslint-disable-next-line no-param-reassign
            event.payload = {
                ...event.payload,
                ...searchPayload
            };
        }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $2YZCu.default).safeErrorWithoutCustomerData('observability.analytics-providers.addSearchPayload', 'Failed to dynamically add search payload', e);
    }
    return event;
};
const $7cbf4e8505a1a9c2$var$getAnalyticsWebClientInstance = ()=>(0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>client.getInstance());
const $7cbf4e8505a1a9c2$var$sendAnalyticsEvent = (event)=>{
    // Preemptively create an error so we can find who sends invalid events in Sentry
    const callError = new Error(`This ${event.type} event is not valid`);
    (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
        try {
            client.sendEvent(event);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            err.cause = callError;
            throw err;
        }
    });
};
const $7cbf4e8505a1a9c2$var$onStructuredAnalyticsEvent = (event)=>{
    const enrichedEvent = $7cbf4e8505a1a9c2$var$addSearchPayload(event);
    $7cbf4e8505a1a9c2$var$sendAnalyticsEvent((0, $9NirD.default)(enrichedEvent));
};
const $7cbf4e8505a1a9c2$var$onProductAnalyticsV3 = (event)=>{
    const enrichedEvent = $7cbf4e8505a1a9c2$var$addSearchPayload(event, true);
    $7cbf4e8505a1a9c2$var$sendAnalyticsEvent((0, $lhVtI.getEvent)(enrichedEvent));
};
const $7cbf4e8505a1a9c2$var$JiraAnalyticsListener = ({ onEvent: onEvent, onEventV3: onEventV3, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bvUB1.default), {
        onEvent: onEvent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bvUB1.default), {
        onEvent: onEventV3,
        channel: "productAnalytics"
    }, children));
const $7cbf4e8505a1a9c2$export$ba6a124597fff04a = ({ children: children })=>{
    if (false) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e8KHW.default), {
        // @ts-expect-error - Type 'GasPurePayload' is not assignable to type 'UITrackAndOperationalEventPayload'.
        client: $7cbf4e8505a1a9c2$var$getAnalyticsWebClientInstance(),
        excludedChannels: $7cbf4e8505a1a9c2$var$EXCLUDED_CHANNELS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7cbf4e8505a1a9c2$var$JiraAnalyticsListener, {
        onEvent: $7cbf4e8505a1a9c2$var$onStructuredAnalyticsEvent,
        onEventV3: $7cbf4e8505a1a9c2$var$onProductAnalyticsV3
    }, children));
};

});
parcelRegister("9NirD", function(module, exports) {

$parcel$export(module.exports, "default", () => $03530a37bde4d38a$export$2e2bcd8739ae039);

var $cjFoH = parcelRequire("cjFoH");

var $hYfgW = parcelRequire("hYfgW");

var $9xWGk = parcelRequire("9xWGk");

var $gvRPW = parcelRequire("gvRPW");

var $8nlDG = parcelRequire("8nlDG");
const $03530a37bde4d38a$var$formatActionSubjectId = (name, actionSubject)=>actionSubject ? `${name}${actionSubject[0].toUpperCase()}${actionSubject.substring(1)}` : name;
const $03530a37bde4d38a$var$getActionSubjectForEventType = (event, analyticsType)=>{
    if (analyticsType === (0, $gvRPW.TRACK_EVENT_TYPE)) return (0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))((0, $8nlDG.getActionSubjects)(event));
    return (0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))((0, $8nlDG.getComponents)(event));
};
const $03530a37bde4d38a$var$getActionSubjectIdForEventType = (event, analyticsType, actionSubject)=>{
    const name = (0, $8nlDG.getName)(event);
    // for UI and operational events, the actionSubjectId is generated
    // but for operational events name is optional, since it doesnt always make sense.
    // Consider a high level component BespokeComponent. If this fires an internal event
    // The unique instance of the component is likely to be BespokeComponent (ie there is 1)
    // so if name wasn't optional we would end up with actionSubjectId=bespokeComponentBespokeComponent
    if (analyticsType === (0, $gvRPW.OPERATIONAL_EVENT_TYPE)) return name ? $03530a37bde4d38a$var$formatActionSubjectId(name, actionSubject) : actionSubject;
    if (analyticsType === (0, $gvRPW.UI_EVENT_TYPE)) return $03530a37bde4d38a$var$formatActionSubjectId(name, actionSubject);
    return (0, $8nlDG.getActionSubjectId)(event);
};
var /**
 * This util exists to bridge the two different formats between atlaskit and the data services events. Two formats are required because
 * atlaskit needs to be able to collect aribtrary events from the tree while the data service event doesn't (and shouldn't) care about the react tree.
 *
 * Atlaskit event format:
 *
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Data Services event format:
 *  event {
 *      type: <"TRACK"|"SCREEN"|"UI"|"OPERATIONAL">
 *      payload {
 *          ...mandatoryFieldsBasedOnEventType
 *          ...optionalFieldsBasedOnEventType
 *          attributes: {
 *              ...arbirtaryAttributes
 *          }
 *      }
 *  }
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$03530a37bde4d38a$export$2e2bcd8739ae039 = (event)=>{
    const sources = (0, $8nlDG.getSources)(event);
    const analyticsType = (0, $8nlDG.getAnalyticsType)(event);
    const actionSubject = $03530a37bde4d38a$var$getActionSubjectForEventType(event, analyticsType);
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))(sources);
    const action = (0, $8nlDG.getAction)(event);
    const attributes = {
        ...(0, $8nlDG.getAttributes)(event),
        namespaces: sources.join('.')
    };
    const containers = (0, $8nlDG.getContainers)(event);
    if (action === (0, $gvRPW.PAGE_EVENT_ACTION)) return {
        type: (0, $gvRPW.SCREEN_EVENT_TYPE),
        payload: {
            name: source,
            attributes: attributes,
            containers: containers
        }
    };
    switch(analyticsType){
        case 0, $gvRPW.UI_EVENT_TYPE:
        case 0, $gvRPW.TRACK_EVENT_TYPE:
        case 0, $gvRPW.OPERATIONAL_EVENT_TYPE:
            {
                const actionSubjectId = $03530a37bde4d38a$var$getActionSubjectIdForEventType(event, analyticsType, actionSubject);
                const containerId = (0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))((0, $8nlDG.getContainerIds)(event));
                const containerType = (0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))((0, $8nlDG.getContainerTypes)(event));
                const objectId = (0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))((0, $8nlDG.getObjectIds)(event));
                const objectType = (0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))((0, $8nlDG.getObjectTypes)(event));
                const tags = (0, $8nlDG.getTags)(event);
                return {
                    type: analyticsType,
                    payload: (0, (/*@__PURE__*/$parcel$interopDefault($9xWGk)))({
                        action: action,
                        actionSubject: actionSubject,
                        actionSubjectId: actionSubjectId,
                        source: source,
                        tags: tags,
                        containerId: containerId,
                        containers: containers,
                        containerType: containerType,
                        objectType: objectType,
                        objectId: objectId,
                        attributes: attributes
                    }, (0, (/*@__PURE__*/$parcel$interopDefault($cjFoH))))
                };
            }
        default:
            return {
                payload: {
                    source: source,
                    actionSubject: actionSubject,
                    attributes: attributes,
                    containers: containers
                },
                type: undefined
            };
    }
};

});
parcelRegister("gvRPW", function(module, exports) {

$parcel$export(module.exports, "UI_EVENT_TYPE", () => $db84241d0c0cfedb$export$a1562d08625f5d7e);
$parcel$export(module.exports, "TRACK_EVENT_TYPE", () => $db84241d0c0cfedb$export$947dac6c72b26f81);
$parcel$export(module.exports, "SCREEN_EVENT_TYPE", () => $db84241d0c0cfedb$export$f1d537d508d2945a);
$parcel$export(module.exports, "OPERATIONAL_EVENT_TYPE", () => $db84241d0c0cfedb$export$12346a674644c156);
$parcel$export(module.exports, "PAGE_EVENT_ACTION", () => $db84241d0c0cfedb$export$a953886d20994732);
$parcel$export(module.exports, "ScreenTypes", () => $db84241d0c0cfedb$export$9dd85b191ff3384f);
/**
 * ANALYTICS WEB CLIENT EVENTS
 */ // those events are going to the analytics web client
const $db84241d0c0cfedb$export$a1562d08625f5d7e = 'UI';
const $db84241d0c0cfedb$export$947dac6c72b26f81 = 'TRACK';
const $db84241d0c0cfedb$export$f1d537d508d2945a = 'SCREEN';
const $db84241d0c0cfedb$export$12346a674644c156 = 'OPERATIONAL';
const $db84241d0c0cfedb$export$a953886d20994732 = 'page-view';
const $db84241d0c0cfedb$var$SCREEN = 'Screen';
const $db84241d0c0cfedb$var$DRAWER = 'Drawer';
const $db84241d0c0cfedb$var$MODAL = 'Modal';
const $db84241d0c0cfedb$var$INLINE_DIALOG = 'InlineDialog';
const $db84241d0c0cfedb$var$DROPDOWN = 'Dropdown';
const $db84241d0c0cfedb$export$9dd85b191ff3384f = {
    SCREEN: $db84241d0c0cfedb$var$SCREEN,
    MODAL: $db84241d0c0cfedb$var$MODAL,
    DRAWER: $db84241d0c0cfedb$var$DRAWER,
    INLINE_DIALOG: $db84241d0c0cfedb$var$INLINE_DIALOG,
    DROPDOWN: $db84241d0c0cfedb$var$DROPDOWN
};

});

parcelRegister("8nlDG", function(module, exports) {

$parcel$export(module.exports, "getComponents", () => $1c7f16ab1d4e6657$export$4e811121b221213b);
$parcel$export(module.exports, "getActionSubjects", () => $1c7f16ab1d4e6657$export$d9a2a7d6b7a9497b);
$parcel$export(module.exports, "getSources", () => $1c7f16ab1d4e6657$export$5f9bc633b116660f);
$parcel$export(module.exports, "getAttributes", () => $1c7f16ab1d4e6657$export$fe94072fee8a6976);
$parcel$export(module.exports, "getTags", () => $1c7f16ab1d4e6657$export$af63d7414243dad3);
$parcel$export(module.exports, "getContainerTypes", () => $1c7f16ab1d4e6657$export$94b487dda8940141);
$parcel$export(module.exports, "getContainerIds", () => $1c7f16ab1d4e6657$export$9a462447889d734e);
$parcel$export(module.exports, "getObjectTypes", () => $1c7f16ab1d4e6657$export$9ed2cbb83cd51da0);
$parcel$export(module.exports, "getObjectIds", () => $1c7f16ab1d4e6657$export$2e78a279ad2bf08);
$parcel$export(module.exports, "getActionSubjectId", () => $1c7f16ab1d4e6657$export$b6f8db3ad0711b02);
$parcel$export(module.exports, "getAnalyticsType", () => $1c7f16ab1d4e6657$export$a3569ac53b82a914);
$parcel$export(module.exports, "getName", () => $1c7f16ab1d4e6657$export$7d9f7e9c1c02b41e);
$parcel$export(module.exports, "getAction", () => $1c7f16ab1d4e6657$export$6ca3170acb89054);
$parcel$export(module.exports, "getContainers", () => $1c7f16ab1d4e6657$export$ae861c5c02c4c14c);

var $cjFoH = parcelRequire("cjFoH");

var $1UikQ = parcelRequire("1UikQ");

var $9xWGk = parcelRequire("9xWGk");

var $kGsr8 = parcelRequire("kGsr8");
const $1c7f16ab1d4e6657$var$extractFromEventContext = (propertyNames, event)=>event.context // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .reduce((acc, contextItem)=>{
        propertyNames.forEach((propertyName)=>{
            acc.push(contextItem[propertyName]);
        });
        return acc;
    }, []).filter(Boolean);
const $1c7f16ab1d4e6657$var$extractFromEventPayload = (propertyName, event)=>event.payload[propertyName];
const $1c7f16ab1d4e6657$var$extractFromPayloadOrContext = (propertyName, event)=>{
    const payloadProp = $1c7f16ab1d4e6657$var$extractFromEventPayload(propertyName, event);
    const contextProps = $1c7f16ab1d4e6657$var$extractFromEventContext([
        propertyName
    ], event);
    return payloadProp ? contextProps.concat(payloadProp) : contextProps;
};
const $1c7f16ab1d4e6657$var$extractPayloadAttributes = (event)=>{
    const { tags: tags, actionSubjectId: actionSubjectId, containerType: containerType, containerId: containerId, objectType: objectType, objectId: objectId, analyticsType: analyticsType, name: name, action: action, ...attributes } = event.payload;
    return attributes;
};
const $1c7f16ab1d4e6657$export$4e811121b221213b = (event)=>$1c7f16ab1d4e6657$var$extractFromEventContext([
        'component',
        'componentName'
    ], event);
const $1c7f16ab1d4e6657$export$d9a2a7d6b7a9497b = (event)=>$1c7f16ab1d4e6657$var$extractFromEventContext([
        'actionSubject'
    ], event);
const $1c7f16ab1d4e6657$export$5f9bc633b116660f = (event)=>$1c7f16ab1d4e6657$var$extractFromEventContext([
        'source'
    ], event);
const $1c7f16ab1d4e6657$export$fe94072fee8a6976 = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    $1c7f16ab1d4e6657$var$extractFromEventContext([
        'attributes'
    ], event).reduce((result, extraAttributes)=>(0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))(result, extraAttributes), {}), $1c7f16ab1d4e6657$var$extractPayloadAttributes(event));
const $1c7f16ab1d4e6657$export$af63d7414243dad3 = (event)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const tags = (0, (/*@__PURE__*/$parcel$interopDefault($kGsr8)))($1c7f16ab1d4e6657$var$extractFromEventContext([
        'tags'
    ], event) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .reduce((result, extraTags)=>result.concat(extraTags), []).concat($1c7f16ab1d4e6657$var$extractFromEventPayload('tags', event)).filter(Boolean));
    return tags.length > 0 ? tags : undefined;
};
const $1c7f16ab1d4e6657$export$94b487dda8940141 = (event)=>$1c7f16ab1d4e6657$var$extractFromPayloadOrContext('containerType', event);
const $1c7f16ab1d4e6657$export$9a462447889d734e = (event)=>$1c7f16ab1d4e6657$var$extractFromPayloadOrContext('containerId', event);
const $1c7f16ab1d4e6657$export$9ed2cbb83cd51da0 = (event)=>$1c7f16ab1d4e6657$var$extractFromPayloadOrContext('objectType', event);
const $1c7f16ab1d4e6657$export$2e78a279ad2bf08 = (event)=>$1c7f16ab1d4e6657$var$extractFromPayloadOrContext('objectId', event);
const $1c7f16ab1d4e6657$export$b6f8db3ad0711b02 = (event)=>$1c7f16ab1d4e6657$var$extractFromEventPayload('actionSubjectId', event);
const $1c7f16ab1d4e6657$export$a3569ac53b82a914 = (event)=>$1c7f16ab1d4e6657$var$extractFromEventPayload('analyticsType', event);
const $1c7f16ab1d4e6657$export$7d9f7e9c1c02b41e = (event)=>$1c7f16ab1d4e6657$var$extractFromEventPayload('name', event);
const $1c7f16ab1d4e6657$export$6ca3170acb89054 = (event)=>$1c7f16ab1d4e6657$var$extractFromEventPayload('action', event);
const $1c7f16ab1d4e6657$export$ae861c5c02c4c14c = (event)=>{
    const contextContainers = $1c7f16ab1d4e6657$var$extractFromEventContext([
        'containers'
    ], event);
    const payloadContainers = event.payload.containers;
    const allContainers = (0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    contextContainers.reduce((result, extraContainers)=>(0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))(result, extraContainers), {}), payloadContainers);
    const finalContainers = (0, (/*@__PURE__*/$parcel$interopDefault($9xWGk)))(allContainers, (0, (/*@__PURE__*/$parcel$interopDefault($cjFoH))));
    return Object.keys(finalContainers).length > 0 ? finalContainers : undefined;
};

});


parcelRegister("85qyr", function(module, exports) {

$parcel$export(module.exports, "addSearchSessionAttributes", () => $4e3f885a818cc422$export$ee9fabaf3a23e7bf);

var $etyzk = parcelRequire("etyzk");

var $4f8Oj = parcelRequire("4f8Oj");

var $j8DrX = parcelRequire("j8DrX");
const $4e3f885a818cc422$export$ee9fabaf3a23e7bf = (payload)=>{
    const safePayload = payload || {};
    const sessionAttributes = {
        searchSessionId: 'searchSessionId' in safePayload && safePayload.searchSessionId ? safePayload.searchSessionId : (0, $j8DrX.default)('ajs-search-session-id'),
        searchObjectId: 'searchObjectId' in safePayload && safePayload.searchObjectId ? safePayload.searchObjectId : (0, $j8DrX.default)('ajs-search-object-id'),
        searchContainerId: 'searchContainerId' in safePayload && safePayload.searchContainerId ? safePayload.searchContainerId : (0, $j8DrX.default)('ajs-search-container-id'),
        searchContentType: 'searchContentType' in safePayload && safePayload.searchContentType ? safePayload.searchContentType : (0, $j8DrX.default)('ajs-search-content-type')
    };
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return {
        ...payload,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($4f8Oj)))(sessionAttributes, (0, (/*@__PURE__*/$parcel$interopDefault($etyzk))))
    };
};

});



parcelRegister("5tsrJ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $316dafa3236a5f07$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iZhen = parcelRequire("iZhen");

var $5bWbX = parcelRequire("5bWbX");

var $TTRxY = parcelRequire("TTRxY");

var $j8DrX = parcelRequire("j8DrX");

var $fjcgS = parcelRequire("fjcgS");

var $7qPn9 = parcelRequire("7qPn9");
/**
 * Conditionally renders its children or enriches them with specific configurations for engagement and analytics. This component acts differently based on the execution environment (server vs client) and the availability of user metadata, aiming to seamlessly integrate analytics functionality where applicable.
 */ const $316dafa3236a5f07$var$EngagementProvider = (props)=>{
    if (false) return props.children;
    const environment = (0, $7qPn9.toEnvironment)((0, $j8DrX.default)('ajs-environment'));
    const getEnvironmentType = (env)=>{
        if (env === 'prod') return (0, $iZhen.envType).PROD;
        if (env === 'staging') return (0, $iZhen.envType).STAGING;
        return (0, $iZhen.envType).DEV;
    };
    const aaid = (0, $j8DrX.default)('ajs-atlassian-account-id');
    if (aaid === null) return props.children;
    const config = {
        aaid: aaid,
        cloudId: (0, $j8DrX.default)('ajs-cloud-id') || '',
        locale: (0, $j8DrX.default)('ajs-user-locale') || '',
        product: 'jira',
        stargateUrl: '/gateway/api',
        orgId: props.orgId
    };
    const coordinationOptions = {
        envType: getEnvironmentType(environment),
        enableChoreographer: true,
        additionalData: {
            sourceProductId: (0, $TTRxY.ProductIds).JIRA
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5bWbX.default), {
        ...props,
        config: config,
        analyticsClientInstance: Promise.resolve((0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>client.getInstance())),
        coordinationOptions: coordinationOptions
    });
};
var $316dafa3236a5f07$export$2e2bcd8739ae039 = $316dafa3236a5f07$var$EngagementProvider;

});

parcelRegister("5PrLw", function(module, exports) {

$parcel$export(module.exports, "localePropType", () => $9e21c8767a550759$export$ade363a7f01ce39d);
$parcel$export(module.exports, "defaultLocale", () => (parcelRequire("21iV6")).defaultLocale);
$parcel$export(module.exports, "supportedLanguagesMap", () => (parcelRequire("21iV6")).supportedLanguagesMap);
$parcel$export(module.exports, "getLocale", () => (parcelRequire("1p96B")).getLocale);
$parcel$export(module.exports, "formatTimezonedWithLocale", () => (parcelRequire("1p96B")).formatTimezonedWithLocale);
$parcel$export(module.exports, "floatDifferenceOfDates", () => (parcelRequire("1p96B")).floatDifferenceOfDates);
$parcel$export(module.exports, "formatWithLocale", () => (parcelRequire("1p96B")).formatWithLocale);
$parcel$export(module.exports, "formatDistanceWithLocale", () => (parcelRequire("1p96B")).formatDistanceWithLocale);
$parcel$export(module.exports, "formatRelativeWithLocale", () => (parcelRequire("1p96B")).formatRelativeWithLocale);
$parcel$export(module.exports, "formatDistanceStrictWithLocale", () => (parcelRequire("1p96B")).formatDistanceStrictWithLocale);
$parcel$export(module.exports, "weekStartDayWithLocale", () => (parcelRequire("1p96B")).weekStartDayWithLocale);
$parcel$export(module.exports, "formatZonedDateTimeWithZone", () => (parcelRequire("1p96B")).formatZonedDateTimeWithZone);
$parcel$export(module.exports, "parseZoneDateTime", () => (parcelRequire("1p96B")).parseZoneDateTime);
$parcel$export(module.exports, "setTimezoneOffset", () => (parcelRequire("1p96B")).setTimezoneOffset);
$parcel$export(module.exports, "setNumberOffsetToISODate", () => (parcelRequire("1p96B")).setNumberOffsetToISODate);
$parcel$export(module.exports, "formatDateStringToISO", () => (parcelRequire("1p96B")).formatDateStringToISO);
$parcel$export(module.exports, "isValidTimeZone", () => (parcelRequire("1p96B")).isValidTimeZone);
// eslint-disable-next-line jira/restricted/prop-types

var $8rCP3 = parcelRequire("8rCP3");

var $aXfUE = parcelRequire("aXfUE");

var $21iV6 = parcelRequire("21iV6");

var $1p96B = parcelRequire("1p96B");
const $9e21c8767a550759$export$ade363a7f01ce39d = (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).oneOf(Object.keys((0, (/*@__PURE__*/$parcel$interopDefault($aXfUE)))));

});
parcelRegister("aXfUE", function(module, exports) {
module.exports = JSON.parse("{\"cs_CZ\":\"cs-CZ\",\"cs\":\"cs-CZ\",\"da_DK\":\"da-DK\",\"da\":\"da-DK\",\"de_DE\":\"de-DE\",\"de\":\"de-DE\",\"en_GB\":\"en-GB\",\"en-GB\":\"en-GB\",\"en_UK\":\"en-US\",\"en-UK\":\"en-US\",\"enUS\":\"enUS\",\"en_US\":\"en-US\",\"en-US\":\"en-US\",\"es-ES\":\"es-ES\",\"es\":\"es-ES\",\"et_EE\":\"et-EE\",\"et\":\"et-EE\",\"fi_FI\":\"fi-FI\",\"fi\":\"fi-FI\",\"fr_FR\":\"fr-FR\",\"fr\":\"fr-FR\",\"hu_HU\":\"hu-HU\",\"hu\":\"hu-HU\",\"is_IS\":\"is-IS\",\"is\":\"is-IS\",\"it_IT\":\"it-IT\",\"it\":\"it-IT\",\"ja_JP\":\"ja-JP\",\"ja\":\"ja-JP\",\"ko_KR\":\"ko-KR\",\"ko\":\"ko-KR\",\"nb_NO\":\"nb-NO\",\"nb\":\"nb-NO\",\"nl_NL\":\"nl-NL\",\"nl\":\"nl-NL\",\"pl_PL\":\"pl-PL\",\"pl\":\"pl-PL\",\"pt_BR\":\"pt-BR\",\"pt-BR\":\"pt-BR\",\"pt_PT\":\"pt-PT\",\"pt\":\"pt-PT\",\"ro_RO\":\"ro-RO\",\"ro\":\"ro-RO\",\"ru_RU\":\"ru-RU\",\"ru\":\"ru-RU\",\"sk_SK\":\"sk-SK\",\"sk\":\"sk-SK\",\"sv_SE\":\"sv-SE\",\"sv\":\"sv-SE\",\"tr\":\"tr-TR\",\"tr_TR\":\"tr-TR\",\"tr-TR\":\"tr-TR\",\"zh_CN\":\"zh-CN\",\"zh-CN\":\"zh-CN\",\"zh_TW\":\"zh-TW\",\"zh-TW\":\"zh-TW\"}");

});

parcelRegister("21iV6", function(module, exports) {

$parcel$export(module.exports, "defaultLocale", () => $c007c6c39fbd09f5$export$d7f512c98c859244);
$parcel$export(module.exports, "supportedLanguagesMap", () => $c007c6c39fbd09f5$export$ff4f0d1b20f0caad);
const $c007c6c39fbd09f5$export$d7f512c98c859244 = 'enUS';
const $c007c6c39fbd09f5$var$arabicLocale = 'arDZ';
const $c007c6c39fbd09f5$export$ff4f0d1b20f0caad = {
    ar: $c007c6c39fbd09f5$var$arabicLocale,
    ar_DZ: $c007c6c39fbd09f5$var$arabicLocale,
    ar_MA: $c007c6c39fbd09f5$var$arabicLocale,
    ar_SA: $c007c6c39fbd09f5$var$arabicLocale,
    cs_CZ: 'cs',
    cs: 'cs',
    da_DK: 'da',
    da: 'da',
    de_DE: 'de',
    de: 'de',
    en_GB: 'enGB',
    'en-GB': 'enGB',
    en_UK: $c007c6c39fbd09f5$export$d7f512c98c859244,
    'en-UK': $c007c6c39fbd09f5$export$d7f512c98c859244,
    en_US: $c007c6c39fbd09f5$export$d7f512c98c859244,
    'en-US': $c007c6c39fbd09f5$export$d7f512c98c859244,
    en_AU: 'enAU',
    es_ES: 'es',
    es: 'es',
    et_EE: 'et',
    et: 'et',
    fi_FI: 'fi',
    fi: 'fi',
    fr_FR: 'fr',
    fr: 'fr',
    hu_HU: 'hu',
    hu: 'hu',
    is_IS: 'is',
    is: 'is',
    it_IT: 'it',
    it: 'it',
    ja_JP: 'ja',
    ja: 'ja',
    ko_KR: 'ko',
    ko: 'ko',
    nb_NO: 'nb',
    nb: 'nb',
    nl_NL: 'nl',
    nl: 'nl',
    pl_PL: 'pl',
    pl: 'pl',
    pt_BR: 'ptBR',
    'pt-BR': 'ptBR',
    pt_PT: 'pt',
    pt: 'pt',
    ro_RO: 'ro',
    ro: 'ro',
    ru_RU: 'ru',
    ru: 'ru',
    sk_SK: 'sk',
    sk: 'sk',
    sv_SE: 'sv',
    sv: 'sv',
    tr: 'tr',
    tr_TR: 'tr',
    zh_CN: 'zhCN',
    'zh-CN': 'zhCN',
    zh_TW: 'zhTW',
    'zh-TW': 'zhTW'
};

});

parcelRegister("1p96B", function(module, exports) {

$parcel$export(module.exports, "getLocale", () => $cdbfb9018d8e1d7f$export$180605366c04f0cd);
$parcel$export(module.exports, "parseISODate", () => $cdbfb9018d8e1d7f$export$ee8e61141c87635a);
$parcel$export(module.exports, "isValidTimeZone", () => $cdbfb9018d8e1d7f$export$c793e14020d7c7b);
$parcel$export(module.exports, "formatWithLocale", () => $cdbfb9018d8e1d7f$export$fb3485f471c77284);
$parcel$export(module.exports, "formatTimezonedWithLocale", () => $cdbfb9018d8e1d7f$export$4383dd42a084ef32);
$parcel$export(module.exports, "formatDistanceWithLocale", () => $cdbfb9018d8e1d7f$export$c2180807b950d3da);
$parcel$export(module.exports, "formatRelativeWithLocale", () => $cdbfb9018d8e1d7f$export$12b50b1737ea07fc);
$parcel$export(module.exports, "formatDistanceStrictWithLocale", () => $cdbfb9018d8e1d7f$export$7a7656c130da0e93);
$parcel$export(module.exports, "weekStartDayWithLocale", () => $cdbfb9018d8e1d7f$export$d2c1381944cd40d9);
$parcel$export(module.exports, "parseZoneDateTime", () => $cdbfb9018d8e1d7f$export$736ce978ed45f974);
$parcel$export(module.exports, "setTimezoneOffset", () => $cdbfb9018d8e1d7f$export$11ef0295ba6f3d21);
$parcel$export(module.exports, "setNumberOffsetToISODate", () => $cdbfb9018d8e1d7f$export$fe2193e77e11d739);
$parcel$export(module.exports, "formatZonedDateTimeWithZone", () => $cdbfb9018d8e1d7f$export$dd52464bfc436f72);
$parcel$export(module.exports, "formatDateStringToISO", () => $cdbfb9018d8e1d7f$export$108dbdcbc1363368);
$parcel$export(module.exports, "floatDifferenceOfDates", () => $cdbfb9018d8e1d7f$export$8b999908ff0a4991);

var $cDiyi = parcelRequire("cDiyi");
var $3DR3e = parcelRequire("3DR3e");
var $luuSM = parcelRequire("luuSM");
var $k7m40 = parcelRequire("k7m40");
var $2kh23 = parcelRequire("2kh23");
var $54a0z = parcelRequire("54a0z");
var $dGjlT = parcelRequire("dGjlT");
var $bwYrm = parcelRequire("bwYrm");
var $koreE = parcelRequire("koreE");
var $iFXjF = parcelRequire("iFXjF");
var $jovBr = parcelRequire("jovBr");
var $2753q = parcelRequire("2753q");
var $eZDAP = parcelRequire("eZDAP");
var $1GF3c = parcelRequire("1GF3c");

var $dwDIK = parcelRequire("dwDIK");
var $7CMcV = parcelRequire("7CMcV");

var $h5fUo = parcelRequire("h5fUo");
var $ffv2q = parcelRequire("ffv2q");
var $dm4b1 = parcelRequire("dm4b1");
var $aFgGS = parcelRequire("aFgGS");
var $llpfr = parcelRequire("llpfr");
var $9iTW1 = parcelRequire("9iTW1");
var $jhzA6 = parcelRequire("jhzA6");
var $kxtvT = parcelRequire("kxtvT");
var $hEliE = parcelRequire("hEliE");
var $hIVAh = parcelRequire("hIVAh");
var $5hliK = parcelRequire("5hliK");
var $jxRuk = parcelRequire("jxRuk");
var $L1VDF = parcelRequire("L1VDF");
var $jZP2w = parcelRequire("jZP2w");
var $l4n7P = parcelRequire("l4n7P");
var $eeqpy = parcelRequire("eeqpy");
var $gsxJS = parcelRequire("gsxJS");
var $30BQk = parcelRequire("30BQk");
var $9XBqA = parcelRequire("9XBqA");
var $41VsA = parcelRequire("41VsA");
var $dy8Kh = parcelRequire("dy8Kh");
var $bVTfl = parcelRequire("bVTfl");
var $hTCZG = parcelRequire("hTCZG");
var $84SrD = parcelRequire("84SrD");
var $cuiuC = parcelRequire("cuiuC");
var $7XYbY = parcelRequire("7XYbY");
var $5xGxo = parcelRequire("5xGxo");
var $bYR3G = parcelRequire("bYR3G");

var $21iV6 = parcelRequire("21iV6");
const $cdbfb9018d8e1d7f$var$locales = {
    arDZ: $h5fUo.default,
    cs: $ffv2q.default,
    cs_CZ: (0, $ffv2q.default),
    da: $dm4b1.default,
    da_DK: (0, $dm4b1.default),
    de: $aFgGS.default,
    de_DE: (0, $aFgGS.default),
    enUS: $jhzA6.default,
    en_US: (0, $jhzA6.default),
    'en-US': (0, $jhzA6.default),
    enGB: $9iTW1.default,
    en_UK: (0, $9iTW1.default),
    'en-UK': (0, $9iTW1.default),
    'en-GB': (0, $9iTW1.default),
    en_GB: (0, $9iTW1.default),
    enAU: $llpfr.default,
    es: $kxtvT.default,
    es_ES: (0, $kxtvT.default),
    et: $hEliE.default,
    et_EE: (0, $hEliE.default),
    fi: $hIVAh.default,
    fi_FI: (0, $hIVAh.default),
    fr: $5hliK.default,
    fr_FR: (0, $5hliK.default),
    hu: $jxRuk.default,
    hu_HU: (0, $jxRuk.default),
    is: $L1VDF.default,
    is_IS: (0, $L1VDF.default),
    it: $jZP2w.default,
    it_IT: (0, $jZP2w.default),
    ja: $l4n7P.default,
    ja_JP: (0, $l4n7P.default),
    ko: $eeqpy.default,
    ko_KR: (0, $eeqpy.default),
    nb: $gsxJS.default,
    nb_NO: (0, $gsxJS.default),
    nl: $30BQk.default,
    nl_NL: (0, $30BQk.default),
    pl: $9XBqA.default,
    pl_PL: (0, $9XBqA.default),
    pt: $41VsA.default,
    'pt-PT': (0, $41VsA.default),
    pt_PT: (0, $41VsA.default),
    ptBR: $dy8Kh.default,
    'pt-BR': (0, $dy8Kh.default),
    pt_BR: (0, $dy8Kh.default),
    ro: $bVTfl.default,
    ro_RO: (0, $bVTfl.default),
    ru: $hTCZG.default,
    ru_RU: (0, $hTCZG.default),
    sk: $84SrD.default,
    sk_SK: (0, $84SrD.default),
    sv: $cuiuC.default,
    sv_SE: (0, $cuiuC.default),
    tr: $7XYbY.default,
    'tr-TR': (0, $7XYbY.default),
    tr_TR: (0, $7XYbY.default),
    zhCN: $5xGxo.default,
    'zh-CN': (0, $5xGxo.default),
    zh_CN: (0, $5xGxo.default),
    zhTW: $bYR3G.default,
    'zh-TW': (0, $bYR3G.default),
    zh_TW: (0, $bYR3G.default)
};
const $cdbfb9018d8e1d7f$var$nonUTCFullZoneRegExp = new RegExp(/:\d\d(\.\d+)?[-,+]\d\d:\d\d$/);
const $cdbfb9018d8e1d7f$var$negativeZoneRegExp = new RegExp(/:\d\d(\.\d+)?-/);
const $cdbfb9018d8e1d7f$var$milliseconds\u0421oefficients = {
    seconds: 1000,
    minutes: 60000,
    // 1000 * 60
    hours: 3600000,
    // 1000 * 60 * 60
    days: 86400000,
    // 1000 * 60 * 60 * 24
    weeks: 604800000
};
const $cdbfb9018d8e1d7f$export$180605366c04f0cd = (locale)=>{
    const dateFnsLocale = (0, $21iV6.supportedLanguagesMap)[locale] || (0, $21iV6.defaultLocale);
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly arDZ: Locale; readonly cs: Locale; readonly cs_CZ: Locale; readonly da: Locale; readonly da_DK: Locale; readonly de: Locale; ... 56 more ...; readonly zh_TW: Locale; }'.
    return $cdbfb9018d8e1d7f$var$locales[dateFnsLocale];
};
const $cdbfb9018d8e1d7f$export$ee8e61141c87635a = (dateString)=>{
    const parsedDate = (0, $eZDAP.default)(dateString);
    return (0, $jovBr.default)(parsedDate) ? new Date(dateString) : undefined;
};
const $cdbfb9018d8e1d7f$export$c793e14020d7c7b = (tz)=>{
    try {
        Intl.DateTimeFormat(undefined, {
            timeZone: tz
        });
        return true;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (ex) {
        return false;
    }
};
const $cdbfb9018d8e1d7f$export$fb3485f471c77284 = (date, formatStyle, locale)=>(0, $k7m40.default)(date, formatStyle, {
        locale: $cdbfb9018d8e1d7f$export$180605366c04f0cd(locale)
    });
const $cdbfb9018d8e1d7f$export$4383dd42a084ef32 = (date, formatStyle, locale, timeZone)=>$cdbfb9018d8e1d7f$export$c793e14020d7c7b(timeZone) ? (0, $dwDIK.default)((0, $7CMcV.default)(date, timeZone), formatStyle, {
        locale: $cdbfb9018d8e1d7f$export$180605366c04f0cd(locale),
        timeZone: timeZone
    }) : (0, $dwDIK.default)((0, $7CMcV.default)(date, 'utc'), formatStyle, {
        locale: $cdbfb9018d8e1d7f$export$180605366c04f0cd(locale),
        timeZone: 'utc'
    });
const $cdbfb9018d8e1d7f$export$c2180807b950d3da = (date, baseDate, locale, addSuffix = false)=>(0, $2kh23.default)(date, baseDate, {
        locale: $cdbfb9018d8e1d7f$export$180605366c04f0cd(locale),
        addSuffix: addSuffix
    });
const $cdbfb9018d8e1d7f$export$12b50b1737ea07fc = (date, baseDate, locale)=>(0, $dGjlT.default)(date, baseDate, {
        locale: $cdbfb9018d8e1d7f$export$180605366c04f0cd(locale)
    });
const $cdbfb9018d8e1d7f$export$7a7656c130da0e93 = (date, baseDate, locale, addSuffix = false)=>(0, $54a0z.default)(date, baseDate, {
        locale: $cdbfb9018d8e1d7f$export$180605366c04f0cd(locale),
        addSuffix: addSuffix
    });
const $cdbfb9018d8e1d7f$export$d2c1381944cd40d9 = (date, locale)=>(0, $1GF3c.default)(date, {
        locale: $cdbfb9018d8e1d7f$export$180605366c04f0cd(locale)
    });
const $cdbfb9018d8e1d7f$export$736ce978ed45f974 = (parsingDate)=>{
    const date = typeof parsingDate === 'string' ? parsingDate : new Date().toISOString();
    const indxs = {
        positiveZoneStartIndex: date.indexOf('+'),
        negativeZoneStartIndex: $cdbfb9018d8e1d7f$var$negativeZoneRegExp.test(date) ? date.lastIndexOf('-') : -1,
        utcZoneStartIndex: date.indexOf('Z')
    };
    const zoneStartIndex = Object.values(indxs).find((el)=>typeof el === 'number' && el > -1);
    const parsedDate = typeof zoneStartIndex === 'number' ? date.substring(0, zoneStartIndex) : date;
    let zone = '';
    if (typeof zoneStartIndex === 'number') zone = $cdbfb9018d8e1d7f$var$nonUTCFullZoneRegExp.test(date) ? date.substring(zoneStartIndex, zoneStartIndex + 6) : `${date.substring(zoneStartIndex, zoneStartIndex + 3)}:00`;
    return {
        date: (0, $eZDAP.default)(parsedDate),
        zone: indxs.utcZoneStartIndex > -1 ? '+00:00' : zone
    };
};
const $cdbfb9018d8e1d7f$var$calcOffset = (zone)=>Number.parseInt(zone, 10) * 60 + Number.parseInt(`${zone.substring(0, 1)}${zone.substring(4)}`, 10);
const $cdbfb9018d8e1d7f$export$11ef0295ba6f3d21 = (date, offsetSource)=>{
    const dateOffset = date.getTimezoneOffset();
    const offset = $cdbfb9018d8e1d7f$var$calcOffset($cdbfb9018d8e1d7f$export$736ce978ed45f974(offsetSource).zone);
    return (0, $cDiyi.default)(date, offset + dateOffset); // plus because getTimezoneOffset returns difference in minutes (e.g. +3:00 => -180)
};
const $cdbfb9018d8e1d7f$export$fe2193e77e11d739 = (date, offsetHoursNumber)=>{
    const parsedDate = $cdbfb9018d8e1d7f$export$736ce978ed45f974(date);
    const originalOffset = $cdbfb9018d8e1d7f$var$calcOffset(parsedDate.zone);
    const calculatedDateTime = (0, $cDiyi.default)(parsedDate.date, offsetHoursNumber * 60 - originalOffset);
    return calculatedDateTime;
};
const $cdbfb9018d8e1d7f$export$dd52464bfc436f72 = (date, formatString, zone)=>{
    let res = '';
    const formatedString = (0, $k7m40.default)(date, formatString);
    const indxs = {
        positiveZoneStartIndex: formatedString.indexOf('+'),
        negativeZoneStartIndex: $cdbfb9018d8e1d7f$var$negativeZoneRegExp.test(formatedString) ? formatedString.lastIndexOf('-') : -1,
        utcZoneStartIndex: formatedString.indexOf('Z')
    };
    const zoneStartIndex = Object.values(indxs).find((el)=>typeof el === 'number' && el > -1);
    if (typeof zoneStartIndex === 'number') res = `${formatedString.substring(0, zoneStartIndex)}${zone}`; // e.g. 2021-12-12T12:00:00+13:00
    return res;
};
const $cdbfb9018d8e1d7f$export$108dbdcbc1363368 = (date, formatString = 'yyyy-MM-dd')=>{
    const defaultReturnValue = '';
    if (date == null || date === '') return defaultReturnValue;
    const parsedDate = (0, $2753q.default)(date, formatString, new Date(0, 0, 0, 0, 0, 0));
    if (!(0, $jovBr.default)(parsedDate)) return defaultReturnValue;
    return parsedDate.toISOString(); // formatISO can have issues with timezones: https://github.com/date-fns/date-fns/issues/2151 (
};
// this is copy of diff functions from moment.js
// @ts-expect-error - TS7023 - 'monthDiff' implicitly has return type 'any' because it does not have a return type annotation and is referenced directly or indirectly in one of its return expressions.
const $cdbfb9018d8e1d7f$var$monthDiff = (a, b)=>{
    if ((0, $bwYrm.default)(a) < (0, $bwYrm.default)(b)) // end-of-month calculations work correct when the start month has more
    // days than the end month.
    return -$cdbfb9018d8e1d7f$var$monthDiff(b, a);
    // difference in months
    const wholeMonthDiff = ((0, $iFXjF.default)(b) - (0, $iFXjF.default)(a)) * 12 + ((0, $koreE.default)(b) - (0, $koreE.default)(a));
    // b is in (anchor - 1 month, anchor + 1 month)
    const anchor = (0, $3DR3e.default)(a, wholeMonthDiff);
    let anchor2;
    let adjust;
    // @ts-expect-error - TS2362 - The left-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type. | TS2363 - The right-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type.
    if (b - anchor < 0) {
        anchor2 = (0, $3DR3e.default)(a, wholeMonthDiff - 1);
        // linear across the month
        // @ts-expect-error - TS2362 - The left-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type. | TS2363 - The right-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type. | TS2362 - The left-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type. | TS2363 - The right-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type.
        adjust = (b - anchor) / (anchor - anchor2);
    } else {
        anchor2 = (0, $3DR3e.default)(a, wholeMonthDiff + 1);
        // linear across the month
        // @ts-expect-error - TS2362 - The left-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type. | TS2363 - The right-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type. | TS2362 - The left-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type. | TS2363 - The right-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type.
        adjust = (b - anchor) / (anchor2 - anchor);
    }
    // check for negative zero, return zero if negative zero
    return -(wholeMonthDiff + adjust) || 0;
};
const $cdbfb9018d8e1d7f$export$8b999908ff0a4991 = (endDate, startDate, measurement)=>{
    const zoneDelta = startDate.getTimezoneOffset() * -60000 - endDate.getTimezoneOffset() * -60000; // copied from moment
    switch(measurement){
        case 'years':
            return $cdbfb9018d8e1d7f$var$monthDiff(endDate, startDate) / 12;
        case 'quarters':
            return $cdbfb9018d8e1d7f$var$monthDiff(endDate, startDate) / 3;
        case 'months':
            return $cdbfb9018d8e1d7f$var$monthDiff(endDate, startDate);
        case 'weeks':
            // @ts-expect-error - TS2362 - The left-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type. | TS2363 - The right-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type.
            return (endDate - startDate - zoneDelta) / $cdbfb9018d8e1d7f$var$milliseconds\u0421oefficients.weeks;
        // negate dst
        case 'days':
            // @ts-expect-error - TS2362 - The left-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type. | TS2363 - The right-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type.
            return (endDate - startDate - zoneDelta) / $cdbfb9018d8e1d7f$var$milliseconds\u0421oefficients.days;
        // negate dst
        case 'hours':
            // @ts-expect-error - TS2362 - The left-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type. | TS2363 - The right-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type.
            return (endDate - startDate) / $cdbfb9018d8e1d7f$var$milliseconds\u0421oefficients.hours;
        case 'minutes':
            // @ts-expect-error - TS2362 - The left-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type. | TS2363 - The right-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type.
            return (endDate - startDate) / $cdbfb9018d8e1d7f$var$milliseconds\u0421oefficients.minutes;
        case 'seconds':
            // @ts-expect-error - TS2362 - The left-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type. | TS2363 - The right-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type.
            return (endDate - startDate) / $cdbfb9018d8e1d7f$var$milliseconds\u0421oefficients.seconds;
        default:
            return (0, $luuSM.default)(endDate, startDate);
    }
};

});



parcelRegister("jD5no", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0f3e06ea1d8d794$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $bC2fB = parcelRequire("bC2fB");
/**
 * Acts as a foundational layer for applications, dynamically integrating either an error boundary or a Redux provider based on props. This component ensures that child components have access to application state via Redux and robust error handling through conditional error boundaries. It enhances application stability and state management practices by providing these critical infrastructural features.
 */ // eslint-disable-next-line jira/react/no-class-components
class $c0f3e06ea1d8d794$var$AppBase extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            id: undefined,
            store: undefined,
            hasErrorBoundary: true
        };
    }
    renderChildrenWithStore() {
        if (!this.props.store) return this.props.children;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bC2fB.Provider), {
            store: this.props.store
        }, this.props.children);
    }
    render() {
        if (this.props.hasErrorBoundary) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
            id: this.props.id ?? '@atlassian/jira-app-base::unknown-app',
            teamName: this.props.teamName,
            // JSErrorBoundary has page as the default, so we opt-out here for now
            fallback: this.props.fallback ?? 'flag',
            // TODO: packageName should be required. Every call-site
            // should be updated to pass it.
            packageName: this.props.packageName ?? '@atlassian/jira-app-base'
        }, this.renderChildrenWithStore());
        return this.renderChildrenWithStore();
    }
}
var $c0f3e06ea1d8d794$export$2e2bcd8739ae039 = $c0f3e06ea1d8d794$var$AppBase;

});
parcelRegister("7CMCs", function(module, exports) {

$parcel$export(module.exports, "JSErrorBoundary", () => $406ac8d77c9e5081$export$1e964c961b2b98bf);

var $5uXOq = parcelRequire("5uXOq");

var $i2Rm5 = parcelRequire("i2Rm5");

var $b71gk = parcelRequire("b71gk");

var $beRD7 = parcelRequire("beRD7");

var $7iJwP = parcelRequire("7iJwP");
const $406ac8d77c9e5081$var$ErrorPage = ({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $beRD7.JSErrorPageAsync), {
        error: error
    });
const $406ac8d77c9e5081$var$Empty = ()=>null;
const $406ac8d77c9e5081$var$getFallback = (fallback, ErrorFlag)=>{
    switch(fallback){
        case 'page':
            return $406ac8d77c9e5081$var$ErrorPage;
        case 'flag':
            return ErrorFlag;
        case 'unmount':
            return $406ac8d77c9e5081$var$Empty;
        default:
            return fallback;
    }
};
const $406ac8d77c9e5081$export$1e964c961b2b98bf = ({ id: id, packageName: packageName, teamName: teamName, fallback: fallback = 'page', children: children, attributes: attributes, sendToPrivacyUnsafeSplunk: sendToPrivacyUnsafeSplunk, onError: onError, ...rest })=>{
    const ErrorFlag = (0, $5uXOq.useCallback)(({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i2Rm5.ErrorFlagRenderer), {
            id: id,
            error: error
        }), [
        id
    ]);
    const onErrorHandler = (0, $5uXOq.useCallback)((location, error, errorAttributes)=>{
        if (onError) onError(location, error, errorAttributes);
    }, [
        onError
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: id,
        packageName: packageName,
        teamName: teamName,
        render: $406ac8d77c9e5081$var$getFallback(fallback, ErrorFlag),
        onError: onErrorHandler,
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7iJwP.default), {
        id: id,
        packageName: packageName,
        teamName: teamName,
        attributes: attributes,
        sendToPrivacyUnsafeSplunk: sendToPrivacyUnsafeSplunk
    }, children));
};
$406ac8d77c9e5081$export$1e964c961b2b98bf.defaultProps = {
    extraEventData: {}
};

});
parcelRegister("i2Rm5", function(module, exports) {

$parcel$export(module.exports, "ErrorFlagRenderer", () => $edf6ec4cdfceccc3$export$71d5b03f33fc194b);
$parcel$export(module.exports, "ErrorBoundaryFlag", () => $edf6ec4cdfceccc3$export$7b744ef274d5ae99);

var $5uXOq = parcelRequire("5uXOq");

var $b71gk = parcelRequire("b71gk");

var $7iJwP = parcelRequire("7iJwP");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $edf6ec4cdfceccc3$var$ErrorFlagRendererLazy = (0, $kxZPA.lazy)(()=>(parcelRequire("lbYYf")), {
    moduleId: "./src/packages/platform/ui/error-flag-renderer/src/ui/index.tsx"
});
const $edf6ec4cdfceccc3$export$71d5b03f33fc194b = (props)=>{
    const packageDetails = {
        id: 'asyncErrorFlagComponent',
        packageName: 'jiraErrorBoundary'
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), packageDetails, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7iJwP.default), {
        teamName: "magma",
        ...packageDetails
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-error-flag-renderer",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($edf6ec4cdfceccc3$var$ErrorFlagRendererLazy, props))));
};
const $edf6ec4cdfceccc3$var$renderErrorFlag = ({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($edf6ec4cdfceccc3$export$71d5b03f33fc194b, {
        id: "error-boundary",
        error: error
    });
const $edf6ec4cdfceccc3$export$7b744ef274d5ae99 = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        ...props,
        render: $edf6ec4cdfceccc3$var$renderErrorFlag
    }, children);
$edf6ec4cdfceccc3$export$7b744ef274d5ae99.defaultProps = {
    extraEventData: {},
    id: undefined
};

});
parcelRegister("7iJwP", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc17534026a24d4c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $1tcYS = parcelRequire("1tcYS");

var $2NMNM = parcelRequire("2NMNM");
var $cb25w = parcelRequire("cb25w");

var $cSD7y = parcelRequire("cSD7y");

var $4R6GH = parcelRequire("4R6GH");

var $jcw0u = parcelRequire("jcw0u");
const $fc17534026a24d4c$var$getView = (labelStack)=>{
    if (!labelStack || labelStack.length < 3) return undefined;
    // for Jira, first UFO label is jira-spa, second is route-component, third is the view
    return labelStack[2].name;
};
class $fc17534026a24d4c$var$CatchAndReportErrors extends (0, $5uXOq.Component) {
    componentDidCatch(error, errorInfo) {
        const { packageName: packageName, teamName: teamName, id: id, attributes: attributes, createAnalyticsEvent: createAnalyticsEvent, sendToPrivacyUnsafeSplunk: sendToPrivacyUnsafeSplunk, ufoLabelStack: ufoLabelStack } = this.props;
        const analyticsEvent = createAnalyticsEvent({
            action: 'failed'
        });
        (0, $jcw0u.default)({
            event: analyticsEvent,
            errorInfo: errorInfo,
            error: error,
            meta: {
                id: id,
                packageName: packageName,
                teamName: teamName
            },
            attributes: typeof attributes === 'function' ? attributes(error) : attributes,
            sendToPrivacyUnsafeSplunk: sendToPrivacyUnsafeSplunk,
            view: (0, $4R6GH.fg)('jira-report-unhandled-errors-by-view') ? $fc17534026a24d4c$var$getView(ufoLabelStack) : undefined
        });
        throw error;
    }
    render() {
        return this.props.children;
    }
}
const $fc17534026a24d4c$var$ReportErrorsWithAnalyticsNew = (props)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fc17534026a24d4c$var$CatchAndReportErrors, {
        ...props,
        createAnalyticsEvent: createAnalyticsEvent
    });
};
const $fc17534026a24d4c$var$ReportErrorsWithAnalyticsOld = (0, $cb25w.default)()($fc17534026a24d4c$var$CatchAndReportErrors);
// When cleaning up jfp-magma-concurrent-stability-error-boundary and jira-report-unhandled-errors-by-view combine into 1 wrapper for CatchAndReportErrors rather than 2
const $fc17534026a24d4c$var$ReportErrorsWithAnalytics = (0, $cSD7y.componentWithFG)('jfp-magma-concurrent-stability-error-boundary', $fc17534026a24d4c$var$ReportErrorsWithAnalyticsNew, $fc17534026a24d4c$var$ReportErrorsWithAnalyticsOld);
const $fc17534026a24d4c$var$ReportErrorsWithUFOContext = (props)=>{
    const interactionContext = (0, $1tcYS.useInteractionContext)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fc17534026a24d4c$var$ReportErrorsWithAnalytics, {
        ...props,
        ufoLabelStack: interactionContext?.labelStack
    });
};
var $fc17534026a24d4c$export$2e2bcd8739ae039 = (0, $cSD7y.componentWithFG)('jira-report-unhandled-errors-by-view', $fc17534026a24d4c$var$ReportErrorsWithUFOContext, $fc17534026a24d4c$var$ReportErrorsWithAnalytics);

});
parcelRegister("cSD7y", function(module, exports) {

$parcel$export(module.exports, "componentWithFG", () => $9b560cafc84bf9e8$export$cf56d0f54cfcce4);

var $7XYc4 = parcelRequire("7XYc4");

var $4R6GH = parcelRequire("4R6GH");
const $9b560cafc84bf9e8$export$cf56d0f54cfcce4 = (gateName, ComponentTrue, ComponentFalse)=>(0, $7XYc4.componentWithCondition)(()=>(0, $4R6GH.fg)(gateName), ComponentTrue, ComponentFalse);

});
parcelRegister("7XYc4", function(module, exports) {

$parcel$export(module.exports, "componentWithCondition", () => $d8879edec083173e$export$6e8ea24b15199873);

var $5uXOq = parcelRequire("5uXOq");
function $d8879edec083173e$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
    const ComponentWithCondition = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>condition() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ComponentTrue, {
            ...props,
            ref: ref
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ComponentFalse, {
            ...props,
            ref: ref
        }));
    if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return ComponentWithCondition;
}

});



parcelRegister("lfTZh", function(module, exports) {

$parcel$export(module.exports, "default", () => $7799bada79219a65$export$2e2bcd8739ae039);
$parcel$export(module.exports, "PlaceholderWithNativeSuspense", () => $7799bada79219a65$export$64cdcd2c25694f20);
$parcel$export(module.exports, "PlaceholderNew", () => $7799bada79219a65$export$c6bea9996b2be30e);
// eslint-disable-next-line jira/restricted/react-suspense

var $5uXOq = parcelRequire("5uXOq");

var $1tcYS = parcelRequire("1tcYS");

var $ejdXj = parcelRequire("ejdXj");

var $7hSN4 = parcelRequire("7hSN4");
var $5poak = parcelRequire("5poak");

var $c1haS = parcelRequire("c1haS");

var $7XYc4 = parcelRequire("7XYc4");

var $4R6GH = parcelRequire("4R6GH");
function $7799bada79219a65$var$Hold({ name: name }) {
    const interactionContext = (0, $5uXOq.useContext)((0, $1tcYS.default));
    const waitContext = (0, $5uXOq.useContext)((0, $5poak.WaitContext));
    // Runs synchronously, to allow us to identify async items
    (0, $ejdXj.default)(()=>{
        // if until context exists means there is a LazyWait parent component
        // we use that value
        const shouldHold = waitContext ? !!waitContext.currentValue() : true;
        if (interactionContext != null && shouldHold) return interactionContext.hold(name);
    }, [
        interactionContext,
        name,
        waitContext
    ]);
    return null;
}
function $7799bada79219a65$export$2e2bcd8739ae039({ name: name, children: children, fallback: fallback }) {
    // react-18: can use fallback directly
    const fb = fallback != null ? fallback : null;
    // react-18: can use children directly
    const kids = children != null ? children : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7hSN4.LazySuspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, fb, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7799bada79219a65$var$Hold, {
            name: name
        })),
        name: name
    }, kids);
}
function $7799bada79219a65$export$64cdcd2c25694f20({ name: name, children: children, fallback: fallback }) {
    // react-18: can use fallback directly
    const fb = fallback != null ? fallback : null;
    // react-18: can use children directly
    const kids = children != null ? children : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, fb, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7799bada79219a65$var$Hold, {
            name: name
        }))
    }, kids);
}
const $7799bada79219a65$export$c6bea9996b2be30e = (0, $7XYc4.componentWithCondition)(()=>(0, $c1haS.getIsConcurrentEnabled)() && (0, $4R6GH.fg)('concurrent-native-suspense'), $7799bada79219a65$export$64cdcd2c25694f20, $7799bada79219a65$export$2e2bcd8739ae039);

});
parcelRegister("ejdXj", function(module, exports) {

$parcel$export(module.exports, "default", () => $34b683e4c4d83a61$export$2e2bcd8739ae039);
// code-reaper-ignore-file -- Uses `useLayoutEffect` in the browser and `useEffect` in the server.

var $5uXOq = parcelRequire("5uXOq");
var // eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
$34b683e4c4d83a61$export$2e2bcd8739ae039 = (0, $5uXOq.useLayoutEffect);

});

parcelRegister("c1haS", function(module, exports) {

$parcel$export(module.exports, "getIsConcurrentEnabled", () => $096bea3561974624$export$8ff9d4f25943f0c4);

var $4R6GH = parcelRequire("4R6GH");

var $8CVvd = parcelRequire("8CVvd");
const $096bea3561974624$export$8ff9d4f25943f0c4 = ()=>{
    if ((0, $4R6GH.fg)('jira-concurrent-enabled-based-on-nav')) {
        if ((0, $8CVvd.getWillShowNav3)()) return (0, $4R6GH.fg)('jira-concurrent-enabled-for-nav-3-gate');
        return (0, $4R6GH.fg)('jira-concurrent-enabled-for-nav-4-gate');
    }
    return (0, $4R6GH.fg)('jfp-magma-concurrent-root-jira-spa');
};

});
parcelRegister("8CVvd", function(module, exports) {

$parcel$export(module.exports, "getWillShowNav3", () => $5acda4891dbe9afe$export$23a7d978e17f1720);

var $3HwlS = parcelRequire("3HwlS");
const $5acda4891dbe9afe$export$23a7d978e17f1720 = ()=>!(0, $3HwlS.getWillShowNav4)();

});
parcelRegister("3HwlS", function(module, exports) {

$parcel$export(module.exports, "getWillShowNav4", () => $30254f1a9a5ebb1a$export$f1ce4aa22fe8768a);

var $4R6GH = parcelRequire("4R6GH");

var $c0dQj = parcelRequire("c0dQj");

var $Z0r3L = parcelRequire("Z0r3L");

var $ifO6r = parcelRequire("ifO6r");

var $9qXgw = parcelRequire("9qXgw");

var $c7pE4 = parcelRequire("c7pE4");
const $30254f1a9a5ebb1a$export$f1ce4aa22fe8768a = ()=>(0, $4R6GH.fg)('jira_nav4') && ((0, $ifO6r.getWillShowNav4ForDogfooding)() || (0, $9qXgw.getWillShowNav4ForEap)() || (0, $Z0r3L.getWillShowNav4ForBeta)() || (0, $c7pE4.getWillShowNav4ForGa)() || (0, $c0dQj.isMobileAndInMvpOrExistingUsersExperiment)());

});
parcelRegister("c0dQj", function(module, exports) {

$parcel$export(module.exports, "isMobileAndInMVPExperiment", () => $7275e40842570ace$export$f29d7974ab92d702);
$parcel$export(module.exports, "isMobileAndInViewPanelIterationExperiment", () => $7275e40842570ace$export$195496e87350b513);
$parcel$export(module.exports, "isMobileAndInMvpOrExistingUsersExperiment", () => $7275e40842570ace$export$571bd36603f36f7);
$parcel$export(module.exports, "isEnabledForMobileMvpOrExistingUsersExperiment", () => $7275e40842570ace$export$41c2a1a8497c2a69);
$parcel$export(module.exports, "MobileWebExperimentExposure", () => $7275e40842570ace$export$b93f740e619fc842);
$parcel$export(module.exports, "MobileWebExperimentViewPanelExistingUserExposure", () => $7275e40842570ace$export$d97ce70c2944c480);
$parcel$export(module.exports, "MobileWebExperimentViewPanelNewTenantsExposure", () => $7275e40842570ace$export$e5aaaaa9d7ed502);

var $bCdIp = parcelRequire("bCdIp");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");
const $7275e40842570ace$var$isMobileUserAgent = ()=>false ? false : (0, $bCdIp.default)();
const $7275e40842570ace$export$f29d7974ab92d702 = ()=>{
    // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [mobileWebConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('jira_mobile_web_mvp_2');
    return(// eslint-disable-next-line jira/ff/no-preconditioning
    (0, $4R6GH.fg)('jira_mobile_web_mvp_2_feature_gate') && $7275e40842570ace$var$isMobileUserAgent() && mobileWebConfig.get('isEnabled', false));
};
const $7275e40842570ace$var$isMobileAndInViewPanelNewTenantsExperiment = ()=>{
    // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [newTenantsConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('jira_mobile_web_mvp_view_panel_new_tenants');
    return(// eslint-disable-next-line jira/ff/no-preconditioning
    (0, $4R6GH.fg)('jira_mobile_web_mvp_view_panel_kill_switch') && $7275e40842570ace$var$isMobileUserAgent() && newTenantsConfig.get('isEnabled', false));
};
const $7275e40842570ace$var$isMobileAndInViewPanelExistingUsersExperiment = ()=>{
    // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [existingUsersMobileWebConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('jira_mobile_web_mvp_view_panel_existing_users');
    return(// eslint-disable-next-line jira/ff/no-preconditioning
    (0, $4R6GH.fg)('jira_mobile_web_mvp_view_panel_kill_switch') && $7275e40842570ace$var$isMobileUserAgent() && existingUsersMobileWebConfig.get('isEnabled', false));
};
const $7275e40842570ace$export$195496e87350b513 = ()=>{
    return $7275e40842570ace$var$isMobileAndInViewPanelNewTenantsExperiment() || $7275e40842570ace$var$isMobileAndInViewPanelExistingUsersExperiment();
};
const $7275e40842570ace$export$571bd36603f36f7 = ()=>{
    return $7275e40842570ace$export$195496e87350b513() || $7275e40842570ace$export$f29d7974ab92d702();
};
const $7275e40842570ace$export$41c2a1a8497c2a69 = ()=>{
    return (0, $6s1PB.expVal)('jira_mobile_web_mvp_view_panel_new_tenants', 'isEnabled', false) || (0, $6s1PB.expVal)('jira_mobile_web_mvp_view_panel_existing_users', 'isEnabled', false) || (0, $6s1PB.expVal)('jira_mobile_web_mvp_2', 'isEnabled', false);
};
const $7275e40842570ace$export$b93f740e619fc842 = ()=>{
    // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [, manuallyFireExposure] = (0, $6s1PB.UNSAFE_noExposureExp)('jira_mobile_web_mvp_2');
    if ($7275e40842570ace$var$isMobileUserAgent()) manuallyFireExposure();
    return null;
};
const $7275e40842570ace$export$d97ce70c2944c480 = ()=>{
    // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [, manuallyFireExposure] = (0, $6s1PB.UNSAFE_noExposureExp)('jira_mobile_web_mvp_view_panel_existing_users');
    if ($7275e40842570ace$var$isMobileUserAgent()) manuallyFireExposure();
    return null;
};
const $7275e40842570ace$export$e5aaaaa9d7ed502 = ()=>{
    // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [, manuallyFireExposure] = (0, $6s1PB.UNSAFE_noExposureExp)('jira_mobile_web_mvp_view_panel_new_tenants');
    if ($7275e40842570ace$var$isMobileUserAgent()) manuallyFireExposure();
    return null;
};

});
parcelRegister("6s1PB", function(module, exports) {

$parcel$export(module.exports, "expVal", () => $d0d3e1363a65fa96$export$9db1624a8af791a4);
$parcel$export(module.exports, "expValEquals", () => $d0d3e1363a65fa96$export$45abdb3f977b5b14);
$parcel$export(module.exports, "UNSAFE_noExposureExp", () => $d0d3e1363a65fa96$export$677f9fa2e1ae6fec);
/* eslint-disable max-classes-per-file */ 
var $iEN9D = parcelRequire("iEN9D");

var $gSA3s = parcelRequire("gSA3s");

var $40Gox = parcelRequire("40Gox");

var $aMh57 = parcelRequire("aMh57");
class $d0d3e1363a65fa96$var$ErrorPointingUp extends Error {
    constructor(message){
        super(message);
        if (this.stack) {
            const stackLines = this.stack.split('\n');
            // 1 - checkIfExperimentExists
            // 2 - a caller
            this.stack = [
                ...stackLines.slice(2)
            ].join('\n');
        }
    }
}
const $d0d3e1363a65fa96$var$checkedExperiments = new Set();
const $d0d3e1363a65fa96$var$checkIfExperimentExists = (experimentName)=>{
    // perform early exist to minimize performance impact
    if ($d0d3e1363a65fa96$var$checkedExperiments.has(experimentName)) return;
    $d0d3e1363a65fa96$var$checkedExperiments.add(experimentName);
    if ((0, $iEN9D.default).checkGate('jfp_magma_jira-report-incorrect-experiments', {
        fireGateExposure: false
    })) {
        if (!(0, $iEN9D.default).isExperimentExists(experimentName)) {
            const error = new $d0d3e1363a65fa96$var$ErrorPointingUp(`Experiment ${experimentName} does not exist`);
            (0, $aMh57.captureException)('FeatureGates.isExperimentExists', error);
            // eslint-disable-next-line no-console
            console.error(`Experiment ${experimentName} does not exist`);
        }
    }
};
function $d0d3e1363a65fa96$var$readExpVal(experimentName, param, defaultValue) {
    // Handle vendorless scripts use of gates
    (0, $40Gox.UNSAFE_initIfNeeded)();
    const value = (0, $iEN9D.default).getExperimentValue(experimentName, param, defaultValue);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $gSA3s.addFeatureFlagAccessed)(`${experimentName}:${param}`, value);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return value;
}
function $d0d3e1363a65fa96$export$9db1624a8af791a4(experimentName, param, defaultValue) {
    const experiment = $d0d3e1363a65fa96$var$readExpVal(experimentName, param, defaultValue);
    $d0d3e1363a65fa96$var$checkIfExperimentExists(experimentName);
    return experiment;
}
function $d0d3e1363a65fa96$export$45abdb3f977b5b14(experimentName, param, comparatorValue, defaultValue = null) {
    const experiment = $d0d3e1363a65fa96$var$readExpVal(experimentName, param, defaultValue);
    $d0d3e1363a65fa96$var$checkIfExperimentExists(experimentName);
    return experiment === comparatorValue;
}
class $d0d3e1363a65fa96$var$ExperimentConfig {
    constructor(experimentName, config){
        this._experimentName = experimentName;
        this._config = config;
    }
    get(key, defaultValue, typeGuard) {
        // Check if the CRITERION override mechanism is available
        if (typeof globalThis?.window?.__CRITERION__?.getExperimentValueOverride === 'function') {
            const overrideValue = globalThis.window.__CRITERION__.getExperimentValueOverride(this._experimentName, key);
            if (overrideValue !== undefined && overrideValue !== null) {
                (0, $gSA3s.addFeatureFlagAccessed)(`${this._experimentName}:${key}`, overrideValue);
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                return overrideValue;
            }
        }
        const value = this._config.get(key, defaultValue, typeGuard);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $gSA3s.addFeatureFlagAccessed)(`${this._experimentName}:${key}`, value);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return value;
    }
}
const $d0d3e1363a65fa96$var$cache = new Map();
function $d0d3e1363a65fa96$export$677f9fa2e1ae6fec(experimentName) {
    let instance = $d0d3e1363a65fa96$var$cache.get(experimentName);
    const fireExposure = ()=>(0, $iEN9D.default).manuallyLogExperimentExposure(experimentName);
    if (instance == null) {
        (0, $40Gox.UNSAFE_initIfNeeded)();
        const config = (0, $iEN9D.default).getExperiment(experimentName, {
            fireExperimentExposure: false
        });
        instance = [
            new $d0d3e1363a65fa96$var$ExperimentConfig(experimentName, config),
            fireExposure
        ];
        $d0d3e1363a65fa96$var$cache.set(experimentName, instance);
    }
    return instance;
}

});


parcelRegister("Z0r3L", function(module, exports) {

$parcel$export(module.exports, "getWillShowNav4ForBeta", () => $857b5c92d68cd7c3$export$f4f16573b5c2e67b);

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $1i1R1 = parcelRequire("1i1R1");
const $857b5c92d68cd7c3$export$f4f16573b5c2e67b = ()=>// eslint-disable-next-line jira/ff/no-preconditioning
    (0, $4R6GH.fg)('jira_nav4_beta_existing-customers') && !(0, $1i1R1.getIsNav4UserOptOut)() || (0, $4R6GH.fg)('jira_nav4_beta_sandboxes') || (0, $6s1PB.expVal)('jira_nav4_beta_free-customers', 'willShowNav4', false) || (0, $6s1PB.expVal)('jira_nav4_beta_new-customers', 'willShowNav4', false) || (0, $6s1PB.expVal)('confluence_jira_nav4_new_customers', 'willShowNav4', false);

});
parcelRegister("1i1R1", function(module, exports) {

$parcel$export(module.exports, "getMetaBoolean", () => $6ef8a713d6a7457f$export$9683360b0ae70629);
$parcel$export(module.exports, "getIsAdmin", () => $6ef8a713d6a7457f$export$7d046765d192af80);
$parcel$export(module.exports, "getIsNav4TenantOptIn", () => $6ef8a713d6a7457f$export$7db4d9fca9900972);
$parcel$export(module.exports, "getIsNav4TenantOptOut", () => $6ef8a713d6a7457f$export$69ef235f5326800c);
$parcel$export(module.exports, "getIsNav4UserOptIn", () => $6ef8a713d6a7457f$export$ba89637357392be6);
$parcel$export(module.exports, "getIsNav4UserOptOut", () => $6ef8a713d6a7457f$export$3fbfe0fdf05e0f9f);

var $gJBT6 = parcelRequire("gJBT6");

var $j8DrX = parcelRequire("j8DrX");

const $6ef8a713d6a7457f$export$9683360b0ae70629 = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((name)=>(0, $j8DrX.default)(`ajs-${name}`) === 'true');
const $6ef8a713d6a7457f$export$7d046765d192af80 = ()=>$6ef8a713d6a7457f$export$9683360b0ae70629((0, $6d71942d1f781fcc$export$4261d5d429e288ec));
const $6ef8a713d6a7457f$export$7db4d9fca9900972 = ()=>$6ef8a713d6a7457f$export$9683360b0ae70629((0, $6d71942d1f781fcc$export$2eca2b4f46ed58e6));
const $6ef8a713d6a7457f$export$69ef235f5326800c = ()=>$6ef8a713d6a7457f$export$9683360b0ae70629((0, $6d71942d1f781fcc$export$a4507bf14f4bb764));
const $6ef8a713d6a7457f$export$ba89637357392be6 = ()=>$6ef8a713d6a7457f$export$9683360b0ae70629((0, $6d71942d1f781fcc$export$153ded4d539b820d));
const $6ef8a713d6a7457f$export$3fbfe0fdf05e0f9f = ()=>$6ef8a713d6a7457f$export$9683360b0ae70629((0, $6d71942d1f781fcc$export$9c962957701a4fe8));

});
const $6d71942d1f781fcc$export$4261d5d429e288ec = 'is-admin';
const $6d71942d1f781fcc$export$2eca2b4f46ed58e6 = 'is-nav4-tenant-opt-in';
const $6d71942d1f781fcc$export$a4507bf14f4bb764 = 'is-nav4-tenant-opt-out';
const $6d71942d1f781fcc$export$153ded4d539b820d = 'is-nav4-user-opt-in';
const $6d71942d1f781fcc$export$9c962957701a4fe8 = 'is-nav4-user-opt-out';



parcelRegister("ifO6r", function(module, exports) {

$parcel$export(module.exports, "getWillShowNav4ForDogfooding", () => $b6db23b0cddd1764$export$9ca0d92d31816d4f);

var $4R6GH = parcelRequire("4R6GH");

var $1i1R1 = parcelRequire("1i1R1");
const $b6db23b0cddd1764$export$9ca0d92d31816d4f = ()=>{
    if (!(0, $4R6GH.fg)('jira_nav4_dogfooding')) return false;
    // eslint-disable-next-line jira/ff/inline-usage
    const phase1 = (0, $4R6GH.fg)('jira_nav4_dogfooding_phase-1');
    // eslint-disable-next-line jira/ff/inline-usage
    const phase2 = (0, $4R6GH.fg)('jira_nav4_dogfooding_phase-2');
    const phase3 = !(phase1 || phase2);
    return phase3 || phase2 && !(0, $1i1R1.getIsNav4UserOptOut)() || phase1 && !(0, $1i1R1.getIsNav4UserOptOut)();
};

});

parcelRegister("9qXgw", function(module, exports) {

$parcel$export(module.exports, "getWillShowNav4ForEap", () => $77cd593041adc2b6$export$393f53ae320de085);

var $4R6GH = parcelRequire("4R6GH");

var $1i1R1 = parcelRequire("1i1R1");
const $77cd593041adc2b6$export$393f53ae320de085 = ()=>(0, $4R6GH.fg)('jira_nav4_eap') && !(0, $1i1R1.getIsNav4UserOptOut)();

});

parcelRegister("c7pE4", function(module, exports) {

$parcel$export(module.exports, "getWillShowNav4ForGa", () => $c7e6a1aa532c05b1$export$daa2ef3003aa7c2a);

var $4R6GH = parcelRequire("4R6GH");

var $1i1R1 = parcelRequire("1i1R1");
const $c7e6a1aa532c05b1$export$daa2ef3003aa7c2a = ()=>{
    // Later GA phases eclipse earlier phases.
    // For example, if phase 2 is on and the result is false, that should take precedence over phase 1 with a result of true.
    if ((0, $4R6GH.fg)('jira_nav4_ga_phase-3')) return true;
    if ((0, $4R6GH.fg)('jira_nav4_ga_phase-2')) return !(0, $1i1R1.getIsNav4UserOptOut)();
    if ((0, $4R6GH.fg)('jira_nav4_ga_phase-1-5')) return (0, $1i1R1.getIsAdmin)() ? !(0, $1i1R1.getIsNav4UserOptOut)() : !(0, $1i1R1.getIsNav4TenantOptOut)() && !(0, $1i1R1.getIsNav4UserOptOut)();
    if ((0, $4R6GH.fg)('jira_nav4_ga_phase-1')) return (0, $1i1R1.getIsAdmin)() ? (0, $1i1R1.getIsNav4UserOptIn)() : (0, $1i1R1.getIsNav4TenantOptIn)() && !(0, $1i1R1.getIsNav4UserOptOut)();
    if ((0, $4R6GH.fg)('jira_nav4_ga_sandboxes')) return (0, $1i1R1.getIsNav4UserOptIn)();
    return false;
};

});





parcelRegister("lbYYf", function(module, exports) {

let $f6d9eb8f274fbb52$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $f6d9eb8f274fbb52$var$load("kVX56"),
    $f6d9eb8f274fbb52$var$load("76n7a"),
    $f6d9eb8f274fbb52$var$load("l253H"),
    $f6d9eb8f274fbb52$var$load("kNFvF"),
    $f6d9eb8f274fbb52$var$load("ffQaD"),
    $f6d9eb8f274fbb52$var$load("kvRbA"),
    $f6d9eb8f274fbb52$var$load("Q3JZE")
]).then(()=>parcelRequire('k3fpw'));

});
parcelRegister("28QjX", function(module, exports) {
"use strict";


let $18f4e9fbd43d4c3b$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve(id), maxShards));
    };
module.exports = $18f4e9fbd43d4c3b$var$load;

});
parcelRegister("kPuw4", function(module, exports) {

$parcel$export(module.exports, "shardUrl", () => $f2a03df3e93d4e79$export$2bf9932c19d6a5d2, (v) => $f2a03df3e93d4e79$export$2bf9932c19d6a5d2 = v);
// TODO: convert this file to ESM once HMR issues are resolved
var $f2a03df3e93d4e79$export$2bf9932c19d6a5d2;
var $f2a03df3e93d4e79$export$1d37a31d51d1e3ed;
var $f2a03df3e93d4e79$export$b4cd98d62f81485f;
var $f2a03df3e93d4e79$export$108ff8fc702e621f;
var $f2a03df3e93d4e79$export$f6f4188f9108e61;
"use strict";
let $f2a03df3e93d4e79$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 *
 * @param {string} pathname
 * @returns {string}
 */ function $f2a03df3e93d4e79$var$getFilenameFromUrlPath(pathname) {
    let lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 *
 * @param {string} str
 * @param {number} maxShards
 * @returns {number}
 */ function $f2a03df3e93d4e79$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    let totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        let n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
let $f2a03df3e93d4e79$var$trailingShardRegex = /-\d+$/;
/**
 * @param {string} subdomain
 */ function $f2a03df3e93d4e79$var$removeTrailingShard(subdomain) {
    if (!$f2a03df3e93d4e79$var$trailingShardRegex.test(subdomain)) return subdomain;
    let shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 *
 * @param {string} domain
 * @param {number} shard
 */ function $f2a03df3e93d4e79$var$applyShardToDomain(domain, shard) {
    let i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    let shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$f2a03df3e93d4e79$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    let firstSubdomain = $f2a03df3e93d4e79$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $f2a03df3e93d4e79$var$shardUrlUnchecked(url, maxShards) {
    let parsedUrl = new URL(url);
    let fileName = $f2a03df3e93d4e79$var$getFilenameFromUrlPath(parsedUrl.pathname);
    let shardNumber = $f2a03df3e93d4e79$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $f2a03df3e93d4e79$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $f2a03df3e93d4e79$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$f2a03df3e93d4e79$var$globalKeyName]) return url;
    return $f2a03df3e93d4e79$var$shardUrlUnchecked(url, maxShards);
}
$f2a03df3e93d4e79$export$2bf9932c19d6a5d2 = $f2a03df3e93d4e79$var$shardUrl;
$f2a03df3e93d4e79$export$1d37a31d51d1e3ed = $f2a03df3e93d4e79$var$shardUrlUnchecked;
$f2a03df3e93d4e79$export$b4cd98d62f81485f = $f2a03df3e93d4e79$var$getDomainShardIndex;
$f2a03df3e93d4e79$export$108ff8fc702e621f = $f2a03df3e93d4e79$var$applyShardToDomain;
$f2a03df3e93d4e79$export$f6f4188f9108e61 = $f2a03df3e93d4e79$var$globalKeyName;

});

parcelRegister("dy9lH", function(module, exports) {

$parcel$export(module.exports, "register", () => $9dd5b3e06d7b5702$export$6503ec6e8aabbaf, (v) => $9dd5b3e06d7b5702$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $9dd5b3e06d7b5702$export$f7ad0328861e2f03, (v) => $9dd5b3e06d7b5702$export$f7ad0328861e2f03 = v);
var $9dd5b3e06d7b5702$export$6503ec6e8aabbaf;
var $9dd5b3e06d7b5702$export$f7ad0328861e2f03;
"use strict";
var $9dd5b3e06d7b5702$var$mapping = new Map();
function $9dd5b3e06d7b5702$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$9dd5b3e06d7b5702$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $9dd5b3e06d7b5702$var$resolve(id) {
    var resolved = $9dd5b3e06d7b5702$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$9dd5b3e06d7b5702$export$6503ec6e8aabbaf = $9dd5b3e06d7b5702$var$register;
$9dd5b3e06d7b5702$export$f7ad0328861e2f03 = $9dd5b3e06d7b5702$var$resolve;

});




parcelRegister("beRD7", function(module, exports) {

$parcel$export(module.exports, "JSErrorPageAsync", () => $13396a12dcd9d87b$export$f5794426a1f1dedd);
$parcel$export(module.exports, "NotFoundErrorPageAsync", () => $13396a12dcd9d87b$export$8dd04806a5b061d8);
$parcel$export(module.exports, "DashboardKnownErrorsPageAsync", () => $13396a12dcd9d87b$export$8d20107e5d7e92ab);
$parcel$export(module.exports, "WallboardPermissionErrorPageAsync", () => $13396a12dcd9d87b$export$32e11a9f76e3adb);
$parcel$export(module.exports, "GenericPermissionErrorPageAsync", () => $13396a12dcd9d87b$export$d9c0e71eccb9dcb3);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $13396a12dcd9d87b$var$LazyJSErrorPage = (0, $kxZPA.lazy)(()=>(parcelRequire("OXuzb")), {
    moduleId: "./src/packages/platform/ui/error-pages/src/ui/js-error-page/JSErrorPage.tsx"
});
const $13396a12dcd9d87b$export$f5794426a1f1dedd = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-js-error-page",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($13396a12dcd9d87b$var$LazyJSErrorPage, props));

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $13396a12dcd9d87b$var$LazyNotFoundErrorPage = (0, $kxZPA.lazy)(()=>(parcelRequire("9a2Kp")), {
    moduleId: "./src/packages/platform/ui/error-pages/src/ui/not-found-error-page/NotFoundErrorPage.tsx"
});
const $13396a12dcd9d87b$export$8dd04806a5b061d8 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-not-found-error-page",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($13396a12dcd9d87b$var$LazyNotFoundErrorPage, null));

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $13396a12dcd9d87b$var$LazyDashboardKnownErrorsPage = (0, $kxZPA.lazy)(()=>(parcelRequire("6508L")), {
    moduleId: "./src/packages/platform/ui/error-pages/src/ui/dashboard-known-errors-page/DashboardKnownErrorsPage.tsx"
});
const $13396a12dcd9d87b$export$8d20107e5d7e92ab = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-dashboard-known-errors-page",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($13396a12dcd9d87b$var$LazyDashboardKnownErrorsPage, props));

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $13396a12dcd9d87b$var$LazyWallboardPermissionErrorPage = (0, $kxZPA.lazy)(()=>(parcelRequire("kd9cm")), {
    moduleId: "./src/packages/platform/ui/error-pages/src/ui/wallboard-permission-error-page/WallboardPermissionErrorPage.tsx"
});
const $13396a12dcd9d87b$export$32e11a9f76e3adb = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-wallboard-permission-error-page",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($13396a12dcd9d87b$var$LazyWallboardPermissionErrorPage, null));

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $13396a12dcd9d87b$var$LazyGenericPermissionErrorPage = (0, $kxZPA.lazy)(()=>(parcelRequire("cuArj")), {
    moduleId: "./src/packages/platform/ui/error-pages/src/ui/generic-permission-error-page/GenericPermissionErrorPage.tsx"
});
const $13396a12dcd9d87b$export$d9c0e71eccb9dcb3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-generic-permission-error-page",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($13396a12dcd9d87b$var$LazyGenericPermissionErrorPage, null));

});
parcelRegister("OXuzb", function(module, exports) {

let $0992d17feb2e6505$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $0992d17feb2e6505$var$load("7mIf9"),
    $0992d17feb2e6505$var$load("jXweD"),
    $0992d17feb2e6505$var$load("jbxE1"),
    $0992d17feb2e6505$var$load("7imUH"),
    $0992d17feb2e6505$var$load("kVX56"),
    $0992d17feb2e6505$var$load("76n7a"),
    $0992d17feb2e6505$var$load("l253H"),
    $0992d17feb2e6505$var$load("ffQaD"),
    $0992d17feb2e6505$var$load("kvRbA"),
    $0992d17feb2e6505$var$load("kNFvF"),
    $0992d17feb2e6505$var$load("7Aq3f")
]).then(()=>parcelRequire('jLv0N'));

});

parcelRegister("9a2Kp", function(module, exports) {

let $6ab72dcfce40853b$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $6ab72dcfce40853b$var$load("7mIf9"),
    $6ab72dcfce40853b$var$load("jXweD"),
    $6ab72dcfce40853b$var$load("jbxE1"),
    $6ab72dcfce40853b$var$load("7imUH"),
    $6ab72dcfce40853b$var$load("kVX56"),
    $6ab72dcfce40853b$var$load("76n7a"),
    $6ab72dcfce40853b$var$load("l253H"),
    $6ab72dcfce40853b$var$load("ffQaD"),
    $6ab72dcfce40853b$var$load("kvRbA"),
    $6ab72dcfce40853b$var$load("kNFvF"),
    $6ab72dcfce40853b$var$load("l7pj1")
]).then(()=>parcelRequire('f82zR'));

});

parcelRegister("6508L", function(module, exports) {

let $46d3519954853f38$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $46d3519954853f38$var$load("7mIf9"),
    $46d3519954853f38$var$load("jXweD"),
    $46d3519954853f38$var$load("jbxE1"),
    $46d3519954853f38$var$load("7imUH"),
    $46d3519954853f38$var$load("kVX56"),
    $46d3519954853f38$var$load("76n7a"),
    $46d3519954853f38$var$load("l253H"),
    $46d3519954853f38$var$load("ffQaD"),
    $46d3519954853f38$var$load("kvRbA"),
    $46d3519954853f38$var$load("kNFvF"),
    $46d3519954853f38$var$load("bYj2n")
]).then(()=>parcelRequire('bxKoJ'));

});

parcelRegister("kd9cm", function(module, exports) {

let $eb6c28259dd66e8e$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $eb6c28259dd66e8e$var$load("7mIf9"),
    $eb6c28259dd66e8e$var$load("jXweD"),
    $eb6c28259dd66e8e$var$load("jbxE1"),
    $eb6c28259dd66e8e$var$load("7imUH"),
    $eb6c28259dd66e8e$var$load("kVX56"),
    $eb6c28259dd66e8e$var$load("76n7a"),
    $eb6c28259dd66e8e$var$load("l253H"),
    $eb6c28259dd66e8e$var$load("ffQaD"),
    $eb6c28259dd66e8e$var$load("kvRbA"),
    $eb6c28259dd66e8e$var$load("kNFvF"),
    $eb6c28259dd66e8e$var$load("g1o52")
]).then(()=>parcelRequire('66J4k'));

});

parcelRegister("cuArj", function(module, exports) {

let $91848d85e4e1e506$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $91848d85e4e1e506$var$load("7mIf9"),
    $91848d85e4e1e506$var$load("jXweD"),
    $91848d85e4e1e506$var$load("jbxE1"),
    $91848d85e4e1e506$var$load("7imUH"),
    $91848d85e4e1e506$var$load("kVX56"),
    $91848d85e4e1e506$var$load("76n7a"),
    $91848d85e4e1e506$var$load("l253H"),
    $91848d85e4e1e506$var$load("ffQaD"),
    $91848d85e4e1e506$var$load("kvRbA"),
    $91848d85e4e1e506$var$load("kNFvF"),
    $91848d85e4e1e506$var$load("5PpmD")
]).then(()=>parcelRequire('jI5i0'));

});




parcelRegister("x9xyg", function(module, exports) {

$parcel$export(module.exports, "getMark", () => $f046ad85828b97a9$export$f45af69d005a6ed);
$parcel$export(module.exports, "setMark", () => $f046ad85828b97a9$export$f7a1fb90d8604165);
$parcel$export(module.exports, "setMeasure", () => $f046ad85828b97a9$export$3d472a4be9f2b366);
$parcel$export(module.exports, "measureFunc", () => $f046ad85828b97a9$export$25a311d3df56652d);
/* eslint-disable no-console */ 
var $6RCeq = parcelRequire("6RCeq");
const $f046ad85828b97a9$export$f45af69d005a6ed = (markName)=>{
    if (!(0, $6RCeq.default).getEntriesByName) return null;
    const marks = (0, $6RCeq.default).getEntriesByName(markName) || [];
    return marks.length > 0 ? marks[0] : null;
};
const $f046ad85828b97a9$export$f7a1fb90d8604165 = (markName, markOptions)=>{
    if (!(0, $6RCeq.default).mark) return undefined;
    const entry = (0, $6RCeq.default).mark(markName, markOptions);
    if (console.timeStamp) console.timeStamp(markName);
    return entry;
};
const $f046ad85828b97a9$export$3d472a4be9f2b366 = (measureName, start, end)=>{
    // performance.measure will throw an exception if either start/end marks are not set
    try {
        return (0, $6RCeq.default).measure(measureName, start, end);
    // eslint-disable-next-line no-empty
    } catch (_err) {}
    return undefined;
};
function $f046ad85828b97a9$export$25a311d3df56652d(measureName, func) {
    $f046ad85828b97a9$export$f7a1fb90d8604165(`${measureName}:start`);
    const result = func();
    $f046ad85828b97a9$export$f7a1fb90d8604165(`${measureName}:end`);
    $f046ad85828b97a9$export$3d472a4be9f2b366(measureName, `${measureName}:start`, `${measureName}:end`);
    return result;
}

});
parcelRegister("6RCeq", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea33f8d65617a227$export$2e2bcd8739ae039);
/* eslint-disable no-restricted-properties */ 
var $8Rkzz = parcelRequire("8Rkzz");
const $ea33f8d65617a227$var$getPerf = ()=>{
    try {
        // TODO - Write up an explanation to why we are doing this, if this method is approved.
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.performance.clearResourceTimings && (window.performance.clearResourceTimings = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))));
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        return window.performance;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        // no op implementation
        return {
            now: ()=>0,
            mark: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            clearMarks: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            clearResourceTimings: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            getEntriesByType: (_type)=>[],
            getEntriesByName: (_name)=>[],
            // Replace with lodash/noop
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            measure: (_measureName, _start, _end)=>{}
        };
    }
};
var $ea33f8d65617a227$export$2e2bcd8739ae039 = $ea33f8d65617a227$var$getPerf();

});


parcelRegister("y7eb2", function(module, exports) {

$parcel$export(module.exports, "_haveValuesArrived", () => $f9f40ba6917739bc$export$8ece9c90e8293278);
$parcel$export(module.exports, "default", () => $f9f40ba6917739bc$export$2e2bcd8739ae039);

var $j8DrX = parcelRequire("j8DrX");
const $f9f40ba6917739bc$var$fromMetaTag = (()=>{
    // ajs-fe-feature-flags contains ALL frontend flags (boolean, string and JSON flags)
    const locator = ()=>(0, $j8DrX.default)('ajs-fe-feature-flags');
    return {
        locator: locator,
        processor: ()=>{
            const featureFlags = locator();
            if (featureFlags != null && featureFlags !== '') try {
                return JSON.parse(featureFlags);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (e) {
                throw new Error("Can't parse 'ajs-fe-feature-flags' value");
            }
            return undefined;
        }
    };
})();
const $f9f40ba6917739bc$var$createGlobalVarChecker = (name)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const globalVar = typeof window !== 'undefined' ? window : globalThis;
    return {
        locator: ()=>name in globalVar,
        processor: ()=>globalVar[name]
    };
};
const $f9f40ba6917739bc$var$fromFeatureFlagsGlobal = $f9f40ba6917739bc$var$createGlobalVarChecker('featureFlags');
const $f9f40ba6917739bc$var$fromSsrFeFeatureFlagsGlobal = $f9f40ba6917739bc$var$createGlobalVarChecker('ssr__feFeatureFlags');
const $f9f40ba6917739bc$var$fromSsrAllFeatureFlagsGlobal = $f9f40ba6917739bc$var$createGlobalVarChecker('ssr__allFeatureFlags');
const $f9f40ba6917739bc$var$FLAG_TEST_ORDER = [
    $f9f40ba6917739bc$var$fromFeatureFlagsGlobal,
    $f9f40ba6917739bc$var$fromMetaTag,
    $f9f40ba6917739bc$var$fromSsrAllFeatureFlagsGlobal,
    $f9f40ba6917739bc$var$fromSsrFeFeatureFlagsGlobal
];
const $f9f40ba6917739bc$export$8ece9c90e8293278 = ()=>{
    return $f9f40ba6917739bc$var$FLAG_TEST_ORDER.some((tester)=>tester.locator());
};
const $f9f40ba6917739bc$export$f71b0166412a3835 = ()=>{
    const featureFlags = $f9f40ba6917739bc$var$FLAG_TEST_ORDER.find((tester)=>tester.locator())?.processor();
    return featureFlags || {};
};
let $f9f40ba6917739bc$var$memoizedFeatureFlags;
const $f9f40ba6917739bc$var$memoizedGetAllFeatureFlags = ()=>{
    /**
	 * The following `isReorderEarlyScriptsEnabled` and `invalidateFeatureFlags_DO_NOT_USE` branch
	 * is a highly temporary (couple of weeks) block of code that is intended for use only for
	 * HOT mitigation #hot-110667 where we need for a short period (couple of weeks) to freeze
	 * a subset of the feature flags that are only used in the Issue View early entry script.
	 * The feature flags are set inside the `src/entry-fs` initially and then updated later
	 * after the early entry script has executed.
	 *
	 * The `window.isReorderEarlyScriptsEnabled` is a value that is set in the bifrost-template
	 * and is based on a bifrost-gateway feature-flag value. We are using this as a potential to
	 * mitigate further HOTs by turning it off.
	 */ // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const globalVar = typeof window !== 'undefined' ? window : globalThis;
    if (globalVar.isReorderEarlyScriptsEnabled === true) {
        if ($f9f40ba6917739bc$var$memoizedFeatureFlags == null || globalVar.invalidateFeatureFlags_DO_NOT_USE === true) {
            globalVar.invalidateFeatureFlags_DO_NOT_USE = false;
            $f9f40ba6917739bc$var$memoizedFeatureFlags = $f9f40ba6917739bc$export$f71b0166412a3835();
        }
        return $f9f40ba6917739bc$var$memoizedFeatureFlags;
    }
    if ($f9f40ba6917739bc$var$memoizedFeatureFlags == null) $f9f40ba6917739bc$var$memoizedFeatureFlags = $f9f40ba6917739bc$export$f71b0166412a3835();
    return $f9f40ba6917739bc$var$memoizedFeatureFlags;
};
var $f9f40ba6917739bc$export$2e2bcd8739ae039 = $f9f40ba6917739bc$var$memoizedGetAllFeatureFlags;

});

parcelRegister("5eRaS", function(module, exports) {

$parcel$export(module.exports, "ssr", () => $4064d46b003bbefd$export$ea2375f6c0c9ffdc);
$parcel$export(module.exports, "ssrExtended", () => $4064d46b003bbefd$export$b821aa3bb9044abf);

var $8QpSo = parcelRequire("8QpSo");

var $j8DrX = parcelRequire("j8DrX");

var $gTeiy = parcelRequire("gTeiy");

var $24Tby = parcelRequire("24Tby");
const $4064d46b003bbefd$var$getSSRFeatureFlags = (0, $8QpSo.default)(()=>{
    try {
        const metaTagValue = (0, $j8DrX.default)('spa-service-flags');
        if (metaTagValue === null) return null;
        return JSON.parse(metaTagValue) || null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        return null;
    }
});
const $4064d46b003bbefd$export$ea2375f6c0c9ffdc = {
    getDoneMark: (0, $gTeiy.getSSRMark),
    getTimings: (0, $24Tby.getSSRTimings),
    getFeatureFlags: $4064d46b003bbefd$var$getSSRFeatureFlags
};
const $4064d46b003bbefd$export$b821aa3bb9044abf = {
    ...$4064d46b003bbefd$export$ea2375f6c0c9ffdc,
    includeFeatureFlags: 'when-available'
};

});
parcelRegister("gTeiy", function(module, exports) {

$parcel$export(module.exports, "getSSRMark", () => $d62c30897ccea938$export$1faf7d001841a41c);

var $x9xyg = parcelRequire("x9xyg");

const $d62c30897ccea938$export$1faf7d001841a41c = ()=>(0, $x9xyg.getMark)((0, $ce556f125dee8174$export$135c96ab5afee429))?.startTime || null;

});
const $ce556f125dee8174$export$56940a9488e85199 = 'jira.fe.spa-';
const $ce556f125dee8174$export$45c4b6bf7935c69a = `${$ce556f125dee8174$export$56940a9488e85199}start`;
const $ce556f125dee8174$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $ce556f125dee8174$export$ff834eccc35b9089 = 'appBundleReady';
const $ce556f125dee8174$export$86b05e34d462ead8 = 'prefetchApiReady';
const $ce556f125dee8174$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $ce556f125dee8174$export$3ae43cc1782d058f = 'jswRenderStart';
const $ce556f125dee8174$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $ce556f125dee8174$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $ce556f125dee8174$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $ce556f125dee8174$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $ce556f125dee8174$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $ce556f125dee8174$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $ce556f125dee8174$export$99c08ec92759c71c = 'tti-raf-mark';
const $ce556f125dee8174$export$48552baa9db8ce1d = 'tti-raf';


parcelRegister("24Tby", function(module, exports) {

$parcel$export(module.exports, "getSSRTimings", () => $7627443ee23130a5$export$bf7408e83532dcd0);

var $LpImS = parcelRequire("LpImS");
const $7627443ee23130a5$export$bf7408e83532dcd0 = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (!window.SPA_STATE) return null;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const detailRenderTrace = window.SPA_STATE['ssr/detail_render_trace'];
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const detailRequestTrace = window.SPA_STATE['ssr/detail_request_trace'];
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const highLevelMetrics = window.SPA_STATE['ssr/metrics'];
    const timings = (0, (/*@__PURE__*/$parcel$interopDefault($LpImS)))(detailRenderTrace?.data?.traces) || {};
    if (highLevelMetrics?.data) {
        if ('ssrTotal' in highLevelMetrics.data) timings.total = {
            startTime: 0,
            duration: highLevelMetrics.data.ssrTotal
        };
        if ('ssrGetStyle' in highLevelMetrics.data) timings.styles = {
            startTime: highLevelMetrics.data.ssrGetStyle - highLevelMetrics.data.ssrGetStyle,
            duration: highLevelMetrics.data.ssrGetStyle
        };
        if ('ssrPrefetch' in highLevelMetrics.data) {
            const prefetchStartTime = Object.values(detailRenderTrace?.data?.traces || {}).reduce((min, { startTime: startTime })=>min === -1 || min > startTime ? startTime : min, -1);
            timings.prefetch = {
                startTime: prefetchStartTime,
                duration: highLevelMetrics.data.ssrPrefetch
            };
        }
    }
    if (detailRequestTrace?.data) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.entries(detailRequestTrace.data).forEach(([key, value])=>{
        timings[`prefetch/${key}`] = value;
    });
    return timings;
};

});


parcelRegister("aTq2A", function(module, exports) {

$parcel$export(module.exports, "initBrowserMetrics3", () => $21cf14ee000d4874$export$156d1d35be797a9d);

var $5uXOq = parcelRequire("5uXOq");

var $21pfT = parcelRequire("21pfT");

var $y7eb2 = parcelRequire("y7eb2");

var $4R6GH = parcelRequire("4R6GH");

var $j8DrX = parcelRequire("j8DrX");

var $6pIol = parcelRequire("6pIol");

var $fjcgS = parcelRequire("fjcgS");

var $atdLB = parcelRequire("atdLB");
var $49z18 = parcelRequire("49z18");
var $9na5h = parcelRequire("9na5h");

var $eTl0n = parcelRequire("eTl0n");

var $7q1e5 = parcelRequire("7q1e5");

var $9vktL = parcelRequire("9vktL");

var $6gUBx = parcelRequire("6gUBx");

var $7B43n = parcelRequire("7B43n");

var $h7Qnt = parcelRequire("h7Qnt");

var $8n0Ui = parcelRequire("8n0Ui");

var $2jgcS = parcelRequire("2jgcS");
var $7jf8R = parcelRequire("7jf8R");

var $5eRaS = parcelRequire("5eRaS");
const $21cf14ee000d4874$var$isWRMResource = (url)=>url.includes('/batch.js') || url.includes('/batch.css');
const $21cf14ee000d4874$var$getWRMAssetName = (url)=>{
    const [, resources] = /\/([\w.\-,:]*?)(?:,-|\/batch\.)/.exec(url) || [];
    const assetName = (0, $6pIol.sanitiseAssetName)(false)(url);
    if (!resources) return assetName;
    return `wrm/${resources}/${assetName}`;
};
const $21cf14ee000d4874$var$getFileName = (url)=>$21cf14ee000d4874$var$isWRMResource(url) ? $21cf14ee000d4874$var$getWRMAssetName(url) : (0, $6pIol.sanitiseAssetName)(false)(url);
const $21cf14ee000d4874$export$156d1d35be797a9d = ()=>{
    (0, $7jf8R.startLSObserver)();
    (0, $7jf8R.startLTObserver)();
    const info = {
        product: 'jira',
        app: {
            version: {
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                web: window.BUILD_KEY,
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                ssr: window.SSR_BUILD_KEY
            },
            framework: {
                name: 'react',
                version: $5uXOq.version
            }
        },
        region: (0, $j8DrX.default)('ajs-region') || 'unknown'
    };
    const endpoints = {
        eventPipelineClient: (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
            const instance = client.getInstance();
            if (!(0, $4R6GH.fg)('uip_bm3_stop-page-load')) return instance;
            return {
                sendOperationalEvent: (payload)=>{
                    const type = payload?.attributes?.properties?.['event:type'];
                    if (type === 'page-load') return;
                    return instance.sendOperationalEvent(payload);
                }
            };
        })
    };
    const resourceTimings = {
        sanitiseEndpoints: $h7Qnt.sanitiseEndpoints,
        mapResources: $21cf14ee000d4874$var$getFileName,
        hasTimingHeaders: (url)=>url.includes('jira-frontend-static') || url.includes('jira-frontend-branch') || $21cf14ee000d4874$var$isWRMResource(url),
        // @ts-expect-error - TS7006 - Parameter 'url' implicitly has an 'any' type.
        xhrFilter: (url)=>url.includes('/rest/greenhopper/')
    };
    const featureFlagClient = {
        getValue: (featureFlagName)=>{
            const allFeatureFlags = (0, $y7eb2.default)();
            if (!allFeatureFlags) return undefined;
            return allFeatureFlags[featureFlagName]?.value;
        }
    };
    const featureFlags = {
        client: Promise.resolve(featureFlagClient)
    };
    const plugins = {
        featureFlags: featureFlags,
        resourceTimings: resourceTimings,
        bundleEvalTimings: $eTl0n.bundleEvalTimings
    };
    (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
        (0, $49z18.payloadPublisher).setup({
            product: 'jira',
            app: {
                version: {
                    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                    web: window.BUILD_KEY,
                    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                    ssr: window.SSR_BUILD_KEY
                },
                framework: {
                    name: 'react',
                    version: $5uXOq.version
                }
            },
            region: (0, $j8DrX.default)('ajs-region') || 'unknown',
            tenantType: (0, $j8DrX.default)('ajs-is-synthetic') === 'true' ? (0, $9na5h.TenantType).Synthetic : (0, $9na5h.TenantType).RealUser,
            gasv3: client.getInstance(),
            bundleEvalTimings: // @ts-expect-error - TS2322 - Type '{ readonly mapPerformanceMark: (mark: string) => { name: string; type: string; } | null; }' is not assignable to type 'BundleEvalTimingsConfig'.
            $eTl0n.bundleEvalTimings,
            resourceTimings: resourceTimings,
            featureFlagClient: // @ts-expect-error - TS2322 - Type '{ getValue: (featureFlagName: string) => FeatureFlagValue | undefined; }' is not assignable to type 'FeatureFlagClient'.
            featureFlagClient,
            featureFlags: [
                ...(0, $6gUBx.featureFlagsAddedToEVERYJiraEvent),
                ...(0, $8n0Ui.jfpPerfFeatureFlags),
                ...(0, $7B43n.featureFlagsAddedToEVERYPageLoadEvent)
            ],
            plugins: [
                // all
                (0, $7q1e5.getCustomData),
                // @ts-expect-error - TS2322 - Type '(data: {    start: number;}) => Record<string, any> | null' is not assignable to type '(data: ExperienceData | PageLoadExperienceData) => CustomData | null'.
                (0, $h7Qnt.getMarks),
                (0, $h7Qnt.getMemoryMetrics),
                // page-load
                (0, $9vktL.getPageSizeMetrics),
                (0, $9vktL.getExtraNavigationTimings),
                // @ts-expect-error - TS2322 - Type '() => (() => unknown)[]' is not assignable to type '(data: ExperienceData | PageLoadExperienceData) => CustomData | null'.
                (0, $h7Qnt.getPageLoadPlugins)
            ],
            ssr: $5eRaS.ssr,
            performanceConfig: {
                histogram: {
                    [(0, $atdLB.ExperiencePerformanceTypes).PageLoad]: {
                        initial: {
                            fmp: '2500_3000_3500_4000_5000_6000',
                            tti: '4000_4500_5000_6000_7000_8000_9000'
                        },
                        transition: {
                            fmp: '2500_3000_3500_4000_5000_6000',
                            tti: '2500_3000_3500_4000_5000_6000'
                        }
                    },
                    [(0, $atdLB.ExperiencePerformanceTypes).InlineResult]: {
                        result: '100_200_500_1000_1500',
                        response: '50_100_150_200_300_500'
                    },
                    [(0, $atdLB.ExperiencePerformanceTypes).Custom]: {
                        duration: '250_500_1000_1500_2000_3000_4000'
                    }
                }
            }
        });
    });
    (0, $21pfT.browserMetrics).init({
        info: info,
        endpoints: // @ts-expect-error - TS2322 - Type '{ eventPipelineClient: Promise<AnalyticsWebClient> | Promise<IEventPipelineClient>; metalClient: Promise<MetalClient>; }' is not assignable to type '{ eventPipelineClient: Promise<{ sendOperationalEvent: (payload: GasPurePayload) => void; }>; metalClient?: Promise<{ metric: { submit: (payload: unknown) => void; }; }> | undefined; }'.
        endpoints,
        plugins: // @ts-expect-error - TS2322 - Type '{ featureFlags: { client: Promise<{ getValue: (featureFlagName: string) => FeatureFlagValue | undefined; }>; }; resourceTimings: { sanitiseEndpoints: (url: string) => string; mapResources: (url: string) => any; hasTimingHeaders: (url: string) => boolean; xhrFilter: (url: any) => any; }; bundleEvalTimings: { ...; }; }' is not assignable to type '{ resourceTimings: ResourceTimingsConfig; bundleEvalTimings?: BundleEvalTimingsConfig | undefined; featureFlags: { client: FeatureFlagsClientPromise; }; }'.
        plugins,
        events: {
            all: {
                featureFlags: [
                    ...(0, $6gUBx.featureFlagsAddedToEVERYJiraEvent),
                    ...(0, $8n0Ui.jfpPerfFeatureFlags)
                ],
                plugins: [
                    (0, $h7Qnt.getMarks),
                    (0, $h7Qnt.getMemoryMetrics),
                    (0, $2jgcS.getLighthouseMetrics),
                    (0, $7q1e5.newGetCustomData)
                ]
            },
            PAGE_LOAD: {
                featureFlags: [
                    ...(0, $7B43n.featureFlagsAddedToEVERYPageLoadEvent)
                ],
                custom: {
                    ...(0, $9vktL.getPageSizeMetrics)(),
                    ...(0, $9vktL.getExtraNavigationTimings)()
                },
                // @ts-expect-error - TS2322 - Type '(() => unknown)[]' is not assignable to type 'CustomPlugin[]'.
                plugins: (0, $h7Qnt.getPageLoadPlugins)(),
                histogram: {
                    initial: {
                        fmp: '2500_3000_3500_4000_5000_6000',
                        tti: '4000_4500_5000_6000_7000_8000_9000'
                    },
                    transition: {
                        fmp: '2500_3000_3500_4000_5000_6000',
                        tti: '2500_3000_3500_4000_5000_6000'
                    }
                }
            },
            INLINE_RESULT: {
                histogram: {
                    result: '100_200_500_1000_1500',
                    response: '50_100_150_200_300_500'
                }
            },
            CUSTOM: {
                histogram: {
                    duration: '250_500_1000_1500_2000_3000_4000'
                }
            },
            WEB_VITALS: {
                enabled: !false && (0, $j8DrX.default)('ajs-is-synthetic') === 'true'
            }
        },
        // @ts-expect-error - TS2322 - Type '{ readonly includeFeatureFlags: "when-available"; readonly getDoneMark: () => number | null; readonly getTimings: () => any; readonly getFeatureFlags: MemoizedFn<() => any>; }' is not assignable to type 'SSRConfig'.
        ssr: (0, $5eRaS.ssrExtended)
    });
    (0, $21pfT.browserMetrics).startPageLoad({
        isInitial: true
    });
};

});
parcelRegister("eTl0n", function(module, exports) {

$parcel$export(module.exports, "bundleEvalTimings", () => $67857a99f5a495dc$export$1a2bb347935fc536);

var $fDtbf = parcelRequire("fDtbf");
const $67857a99f5a495dc$export$1a2bb347935fc536 = {
    mapPerformanceMark: (mark)=>{
        if (mark.endsWith((0, $fDtbf.JS_EVAL_START))) return {
            name: mark.substring(0, mark.indexOf((0, $fDtbf.JS_EVAL_START))),
            type: 'start'
        };
        if (mark.endsWith((0, $fDtbf.JS_EVAL_STOP))) return {
            name: mark.substring(0, mark.indexOf((0, $fDtbf.JS_EVAL_STOP))),
            type: 'end'
        };
        return null;
    }
};

});

parcelRegister("7q1e5", function(module, exports) {

$parcel$export(module.exports, "newGetCustomData", () => $703a1ce1a9d99edf$export$bc962f7892f5542c);
$parcel$export(module.exports, "getCustomData", () => $703a1ce1a9d99edf$export$c740a965f4a07e8e);

var $gJBT6 = parcelRequire("gJBT6");

var $8QpSo = parcelRequire("8QpSo");

var $j8DrX = parcelRequire("j8DrX");

var $5aM2o = parcelRequire("5aM2o");

var $4R6GH = parcelRequire("4R6GH");

var $eKiSK = parcelRequire("eKiSK");

var $796oa = parcelRequire("796oa");

var $lba4B = parcelRequire("lba4B");

var $2k313 = parcelRequire("2k313");
const $703a1ce1a9d99edf$var$customData = ()=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const commonCustomData = {};
    const shard = (0, $j8DrX.default)('ajs-shard');
    if (shard !== null && shard !== '') commonCustomData.shard = shard;
    if ((0, $4R6GH.fg)('add_editions_to_bm3_splunk_events')) commonCustomData['jira:productEditions'] = (0, $5aM2o.getProductEditions)();
    commonCustomData['network:assetEncoding'] = (0, $eKiSK.getAssetEncoding)();
    const buildVariant = (0, $796oa.getBuildVariant)();
    if (buildVariant) commonCustomData['app:buildVariant'] = buildVariant;
    const bundlerVersion = (0, $lba4B.getBundlerVersion)();
    if (bundlerVersion) commonCustomData['app:bundlerVersion'] = bundlerVersion;
    const useBifrostGateway = (0, $2k313.getUseBifrostGateway)();
    if (useBifrostGateway) commonCustomData['app:useBifrostGateway'] = useBifrostGateway;
    commonCustomData.httpProtocol = // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    performance.getEntriesByType('resource')// @ts-expect-error - TS2339  - Property 'nextHopProtocol' does not exist on type 'PerformanceEntry'. | TS2339 - Property 'nextHopProtocol' does not exist on type 'PerformanceEntry'.
    .find(({ nextHopProtocol: nextHopProtocol })=>!!nextHopProtocol)?.nextHopProtocol ?? 'unknown';
    return commonCustomData;
};
const $703a1ce1a9d99edf$export$bc962f7892f5542c = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))($703a1ce1a9d99edf$var$customData, ()=>true);
const $703a1ce1a9d99edf$export$c740a965f4a07e8e = (0, $8QpSo.default)($703a1ce1a9d99edf$var$customData);

});
parcelRegister("eKiSK", function(module, exports) {

$parcel$export(module.exports, "getAssetEncoding", () => $cd17ba6cbeec46c6$export$fd12d8f45e126585);
const $cd17ba6cbeec46c6$export$fd12d8f45e126585 = ()=>{
    const assetEncodings = Array.prototype.map// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    .call(document.querySelectorAll('script[data-encoding], link[data-encoding]'), (i)=>i.getAttribute('data-encoding')) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .reduce((acc, i)=>{
        // @ts-expect-error - TS2538 - Type 'unknown' cannot be used as an index type.
        acc[i] = true;
        return acc;
    }, {});
    const uniqueEncodings = Object.keys(assetEncodings).sort();
    let result = 'unknown';
    if (uniqueEncodings.length === 1) [result] = uniqueEncodings;
    if (uniqueEncodings.length > 1) result = `mixed: ${uniqueEncodings.toString()}`;
    return result;
};

});

parcelRegister("796oa", function(module, exports) {

$parcel$export(module.exports, "getBuildVariant", () => $675880ac1af24381$export$ca0c40b5b7c3b911);
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $675880ac1af24381$export$ca0c40b5b7c3b911 = ()=>window.BUILD_VARIANT;

});

parcelRegister("lba4B", function(module, exports) {

$parcel$export(module.exports, "getBundlerVersion", () => $541758541d21ef5d$export$5dca7b2a9cf4f500);
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $541758541d21ef5d$export$5dca7b2a9cf4f500 = ()=>window.BUNDLER_VERSION;

});

parcelRegister("2k313", function(module, exports) {

$parcel$export(module.exports, "getUseBifrostGateway", () => $5f9763aabb7e14b0$export$e2e4644f912a860c);
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $5f9763aabb7e14b0$export$e2e4644f912a860c = ()=>window.USE_BIFROST_GATEWAY;

});


parcelRegister("9vktL", function(module, exports) {

$parcel$export(module.exports, "getPageSizeMetrics", () => $0705873b3ca671b0$export$84e3d676f1564c75);
$parcel$export(module.exports, "getExtraNavigationTimings", () => $0705873b3ca671b0$export$b37a70af06e58097);
$parcel$export(module.exports, "getPageSizeInfo", () => $0705873b3ca671b0$export$b72e035af6568be7);

var $6RCeq = parcelRequire("6RCeq");
const $0705873b3ca671b0$export$84e3d676f1564c75 = ()=>{
    let maxDepth = -1;
    let maxWidth = -1;
    let numElements = 0;
    // As described in the lighthouse DOM audit - https://web.dev/dom-size/
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const calculateDOMsizeAndDepth = (el = document.body, depth = 1)=>{
        if (!el) return;
        if (depth > maxDepth) maxDepth = depth;
        if (el.children.length > maxWidth) maxWidth = el.children.length;
        let child = el.firstElementChild;
        while(child){
            // @ts-expect-error - TS2345 - Argument of type 'Element' is not assignable to parameter of type 'HTMLElement'.
            calculateDOMsizeAndDepth(child, depth + 1);
            // If element has shadow dom, traverse into that tree.
            if (child.shadowRoot) // @ts-expect-error - TS2345 - Argument of type 'ShadowRoot' is not assignable to parameter of type 'HTMLElement'.
            calculateDOMsizeAndDepth(child.shadowRoot, depth + 1);
            child = child.nextElementSibling;
            numElements += 1;
        }
    };
    calculateDOMsizeAndDepth();
    return {
        totalBodyElements: numElements,
        maxNestedLevels: maxDepth,
        maxChildElements: maxWidth
    };
};
const $0705873b3ca671b0$export$b37a70af06e58097 = ()=>{
    if (!(0, $6RCeq.default)) return {};
    const navigation = (0, $6RCeq.default).getEntriesByType('navigation')[0];
    if (!navigation) return {};
    return {
        // From https://www.w3.org/TR/navigation-timing-2/
        // @ts-expect-error - TS2339 - Property 'decodedBodySize' does not exist on type 'PerformanceEntry'.
        decodedBodySize: navigation.decodedBodySize,
        // @ts-expect-error - TS2339 - Property 'encodedBodySize' does not exist on type 'PerformanceEntry'.
        encodedBodySize: navigation.encodedBodySize,
        // @ts-expect-error - TS2339 - Property 'transferSize' does not exist on type 'PerformanceEntry'.
        transferSize: navigation.transferSize
    };
};
const $0705873b3ca671b0$var$assetsTypes = [
    'script',
    'link'
];
const $0705873b3ca671b0$export$b72e035af6568be7 = ({ start: start, stop: stop })=>{
    const pageSize = $0705873b3ca671b0$export$b37a70af06e58097();
    if (!pageSize || Object.keys(pageSize).length === 0 || pageSize.decodedBodySize === 0 || start > 0) return {};
    const decoded = {
        total: pageSize.decodedBodySize,
        pageSize: pageSize.decodedBodySize,
        assets: 0,
        endpoints: 0
    };
    const encoded = {
        total: pageSize.encodedBodySize,
        pageSize: pageSize.encodedBodySize,
        assets: 0,
        endpoints: 0
    };
    const net = {
        total: pageSize.transferSize,
        assets: 0,
        endpoints: 0
    };
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    for (const entry of (0, $6RCeq.default).getEntriesByType('resource')){
        if (entry.startTime > stop) continue;
        if ($0705873b3ca671b0$var$assetsTypes.includes(entry.initiatorType)) {
            decoded.total += entry.decodedBodySize;
            decoded.assets += entry.decodedBodySize;
            encoded.total += entry.encodedBodySize;
            encoded.assets += entry.encodedBodySize;
            net.total += entry.transferSize;
            net.assets += entry.transferSize;
        } else {
            decoded.total += entry.decodedBodySize;
            decoded.endpoints += entry.decodedBodySize;
            encoded.total += entry.encodedBodySize;
            encoded.endpoints += entry.encodedBodySize;
            net.total += entry.transferSize;
            net.endpoints += entry.transferSize;
        }
    }
    const returnValue = {};
    Object.keys(decoded).forEach((key)=>{
        returnValue[`size:decoded:${key}`] = decoded[key];
    });
    Object.keys(encoded).forEach((key)=>{
        returnValue[`size:encoded:${key}`] = encoded[key];
    });
    Object.keys(net).forEach((key)=>{
        returnValue[`size:net:${key}`] = net[key];
    });
    return returnValue;
};

});

parcelRegister("6gUBx", function(module, exports) {

$parcel$export(module.exports, "featureFlagsAddedToEVERYJiraEvent", () => $6479d8a16f417341$export$8f6204c7f33d9925);
// by adding feature flag to this array you agree that this feature flag:
// * is expected to impact all performance metrics in Jira (page load, interactions, etc)
// * is expected to be short term
const $6479d8a16f417341$export$8f6204c7f33d9925 = [];

});

parcelRegister("7B43n", function(module, exports) {

$parcel$export(module.exports, "featureFlagsAddedToEVERYPageLoadEvent", () => $cdd1d69d6e521a69$export$85fd4da798ef108b);
// by adding feature flag to this array you agree that this feature flag:
// * is expected to impact *all page load* performance metrics in Jira
// * is expected to be short term
const $cdd1d69d6e521a69$export$85fd4da798ef108b = [];

});

parcelRegister("h7Qnt", function(module, exports) {

$parcel$export(module.exports, "getPageLoadPlugins", () => $749271b0e91a77d8$export$4d5c3be18e81b958);
$parcel$export(module.exports, "getMemoryMetrics", () => $749271b0e91a77d8$export$500422125b861bab);
$parcel$export(module.exports, "getMarks", () => $749271b0e91a77d8$export$9d952633c9c2237b);
$parcel$export(module.exports, "sanitiseEndpoints", () => $749271b0e91a77d8$export$6dfc8bfc2349f367);

var $aZsz6 = parcelRequire("aZsz6");

var $bobSR = parcelRequire("bobSR");

var $fDtbf = parcelRequire("fDtbf");

var $aA83m = parcelRequire("aA83m");

var $aMBlX = parcelRequire("aMBlX");

var $9vktL = parcelRequire("9vktL");

var $GCqnE = parcelRequire("GCqnE");

var $8DS9S = parcelRequire("8DS9S");

var $mLjsE = parcelRequire("mLjsE");

var $6TT7P = parcelRequire("6TT7P");
const $749271b0e91a77d8$var$endpointsWithOperationNameRegex = new RegExp('/rest/graphql/1/|/rest/gira/1/|/gateway/api/graphql|/jsw2/graphql');
const $749271b0e91a77d8$export$4d5c3be18e81b958 = ()=>{
    const pageLoadCustomData = [];
    pageLoadCustomData.push((data)=>{
        // initial load only
        const startTime = data?.start || data?.result?.startTime || 0;
        if (startTime !== 0) return {};
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return Object.entries((0, $aMBlX.getServerDurationMetrics)()).reduce(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (acc, [key, value])=>{
            acc[key] = value;
            return acc;
        }, {});
    });
    pageLoadCustomData.push((0, $mLjsE.getRouterResourceMetrics));
    pageLoadCustomData.push((0, $6TT7P.getWRMStats));
    pageLoadCustomData.push((0, $GCqnE.getCacheHitRatio));
    pageLoadCustomData.push((0, $8DS9S.getCHRInfo));
    pageLoadCustomData.push((0, $9vktL.getPageSizeInfo));
    return pageLoadCustomData;
};
const $749271b0e91a77d8$export$500422125b861bab = ()=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const customData = {};
    const memoryUsageReport = (0, $aA83m.getMemoryUsageReport)();
    if (memoryUsageReport) customData.memory = memoryUsageReport;
    return customData;
};
const $749271b0e91a77d8$export$9d952633c9c2237b = (data)=>{
    const userTiming = (0, $bobSR.getUserTiming)();
    if (userTiming === null) return null;
    const sanitizeName = (name)=>name.replace(/[\W_]+/g, '_');
    // @ts-expect-error - TS7031 - Binding element 'baseName' implicitly has an 'any' type. | TS7031 - Binding element 'collection' implicitly has an 'any' type.
    const getNextAvailableName = ({ baseName: baseName, collection: collection })=>{
        let candidateName = baseName;
        // If <name> is taken, we'll try <name>_2 and increment from there
        let counter = 2;
        let validName;
        while(!validName)if (candidateName in collection) {
            candidateName = `${baseName}_${counter}`;
            counter += 1;
        } else validName = candidateName;
        return validName;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const marks = {};
    // Excludes mark starting with '_'. This allows marks to opt-out from the report.
    userTiming.filter(// @ts-expect-error - TS7006 - Parameter 'item' implicitly has an 'any' type.
    (item)=>item.type === 'mark' && !item.name.startsWith('_') && !item.name.endsWith((0, $fDtbf.JS_EVAL_START)) && !item.name.endsWith((0, $fDtbf.JS_EVAL_STOP)) && item.startTime >= data.start)// @ts-expect-error - TS7006 - Parameter 'item' implicitly has an 'any' type.
    .forEach((item)=>{
        const name = getNextAvailableName({
            baseName: `mark__${sanitizeName(item.name)}`,
            collection: marks
        });
        marks[name] = Math.round(item.startTime - data.start);
    });
    return marks;
};
const $749271b0e91a77d8$export$6dfc8bfc2349f367 = (url)=>{
    const parsedUrl = (0, (/*@__PURE__*/$parcel$interopDefault($aZsz6)))(url, true);
    let fileName = parsedUrl.pathname.replace(/\/(\w+)-(\d+)\//i, '/<issue-key>/').replace(/[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}/i, '<uuid>').replace(/\/pq\/[a-fA-F0-9]+/i, '/pq/<id>') // persisted queries
    .replace(/\/\d+$/i, '/<id>');
    /**
	 * For these endpoints we make a special exception to add the query parameters so that we can distinguish calls using different queries
	 */ if ($749271b0e91a77d8$var$endpointsWithOperationNameRegex.test(fileName)) {
        const { operation: operation } = parsedUrl.query;
        if (operation) fileName += `?operation=${operation}`;
    }
    return fileName;
};

});
parcelRegister("aA83m", function(module, exports) {

$parcel$export(module.exports, "getMemoryUsageReport", () => $6c2d48e3a2650fa7$export$e5bd2d61c7c80651);
// This is an approximation of the start of the session
const $6c2d48e3a2650fa7$var$sessionStart = Date.now();
const $6c2d48e3a2650fa7$export$e5bd2d61c7c80651 = ()=>{
    // @ts-expect-error - TS2339 - Property 'memory' does not exist on type 'Performance'.
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (typeof performance === 'undefined' || performance?.memory == null) return null;
    const now = Date.now();
    const sessionTime = now - $6c2d48e3a2650fa7$var$sessionStart;
    // @ts-expect-error - TS2339 - Property 'memory' does not exist on type 'Performance'.
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const { jsHeapSizeLimit: jsHeapSizeLimit, totalJSHeapSize: totalJSHeapSize, usedJSHeapSize: usedJSHeapSize } = performance.memory;
    return {
        sessionTime: sessionTime,
        performanceMemoryEntry: {
            jsHeapSizeLimit: jsHeapSizeLimit,
            totalJSHeapSize: totalJSHeapSize,
            usedJSHeapSize: usedJSHeapSize
        }
    };
};

});

parcelRegister("aMBlX", function(module, exports) {

$parcel$export(module.exports, "getServerDurationMetrics", () => $9a51450b8c97149c$export$efd8b60b870e5282);
/**
 * Extracts and compiles key performance metrics from the DOM to assess server response times and request handling efficiency.
 * This includes metrics like server duration, trace IDs, concurrency levels, and timing details, which are crucial for analyzing server behavior and identifying potential bottlenecks.
 */ const $9a51450b8c97149c$export$efd8b60b870e5282 = ()=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const metrics = {};
    try {
        // server duration metric is buried in a hidden form near end of </body>
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const serverDurationElem = document.querySelector('#jira_request_timing_info [title="jira.request.server.time"]');
        if (serverDurationElem) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const serverDuration = Number(serverDurationElem.value);
            if (serverDuration > 0) metrics.serverDuration = Math.round(serverDuration);
        }
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const serverTraceIdElem = document.querySelector('#jira_request_timing_info [title="jira.request.trace.id"]');
        if (serverTraceIdElem) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const serverRequestTraceId = serverTraceIdElem.value;
            metrics.serverRequestTraceId = serverRequestTraceId;
        }
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const serverTraceSampledElem = document.querySelector('#jira_request_timing_info [title="jira.request.sampled"]');
        if (serverTraceSampledElem) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const serverRequestTraceSampled = serverTraceSampledElem.value;
            switch(serverRequestTraceSampled){
                case 'true':
                    metrics.serverRequestTraceSampled = true;
                    break;
                case 'false':
                    metrics.serverRequestTraceSampled = false;
                    break;
                default:
                    metrics.serverRequestTraceSampled = null;
                    break;
            }
        }
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const concurrentRequestsElem = document.querySelector('#jira_request_timing_info [name="jira.request.concurrent.requests"]');
        if (concurrentRequestsElem) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const concurrentRequests = concurrentRequestsElem.value;
            metrics.concurrentRequests = concurrentRequests;
        }
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const serverRequestStartTimeElem = document.querySelector('#jira_request_timing_info [name="jira.request.start.millis"]');
        if (serverRequestStartTimeElem) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const serverRequestStartTime = serverRequestStartTimeElem.value;
            metrics.serverRequestStartTime = serverRequestStartTime;
        }
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const frontendFlushStartTimeElem = document.querySelector('#jira_request_timing_info [name="jira.request.frontend.flush.start"]');
        if (frontendFlushStartTimeElem) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const frontendFlushStartTime = frontendFlushStartTimeElem.value;
            metrics.frontendFlushStartTime = frontendFlushStartTime;
        }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (ignored) {
    /* noop */ }
    return metrics;
};

});

parcelRegister("GCqnE", function(module, exports) {

$parcel$export(module.exports, "getCacheHitRatio", () => $f1965ff8f22a798b$export$e8a9322c3d9da8a6);

var $6RCeq = parcelRequire("6RCeq");
/* Borrowed from https://bitbucket.org/atlassian/atlassian-frontend/src/master/packages/performance/browser-metrics/src/plugins/timings/resource.ts */ const $f1965ff8f22a798b$var$cacheableTypes = [
    'script',
    'link'
];
const $f1965ff8f22a798b$var$CACHE_NETWORK = 'network';
const $f1965ff8f22a798b$var$CACHE_MEMORY = 'memory';
const $f1965ff8f22a798b$var$CACHE_DISK = 'disk';
const $f1965ff8f22a798b$var$calculateTransferType = (type, duration, size)=>{
    if (!$f1965ff8f22a798b$var$cacheableTypes.includes(type)) return $f1965ff8f22a798b$var$CACHE_NETWORK;
    if ((size === undefined || size === 0) && duration === 0) return $f1965ff8f22a798b$var$CACHE_MEMORY;
    if (size === 0 && duration > 0) return $f1965ff8f22a798b$var$CACHE_DISK;
    if (size === undefined) return null;
    return $f1965ff8f22a798b$var$CACHE_NETWORK;
};
const $f1965ff8f22a798b$export$e8a9322c3d9da8a6 = ({ start: start })=>{
    let fromCache = 0;
    let preloadFromCache = 0;
    let total = 0;
    let totalPreload = 0;
    // initial load only
    if (start !== 0) return {};
    try {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        for (const entry of (0, $6RCeq.default).getEntriesByType('resource')){
            // The BM3 resource timing collector checks for whether the timing information is available,
            // but we can make the assumption that it is for this Jira specific collector.
            const transferType = $f1965ff8f22a798b$var$calculateTransferType(entry.initiatorType, entry.duration, entry.transferSize);
            const isPreload = entry.initiatorType === 'link';
            if (transferType === 'disk' || transferType === 'memory') {
                fromCache += 1;
                if (isPreload) preloadFromCache += 1;
            }
            if (transferType !== null) {
                total += 1;
                if (isPreload) totalPreload += 1;
            }
        }
        const result = {};
        if (total > 0) result.cacheHitRatio = fromCache / total;
        if (totalPreload > 0) result.preloadCacheHitRatio = preloadFromCache / totalPreload;
        return result;
    } catch (e) {
        return {};
    }
};

});

parcelRegister("8DS9S", function(module, exports) {

$parcel$export(module.exports, "getCHRInfo", () => $92f75c602372419b$export$9e005e111be93521);

var $6RCeq = parcelRequire("6RCeq");

var $gTeiy = parcelRequire("gTeiy");

var $ekXvG = parcelRequire("ekXvG");
const $92f75c602372419b$export$9e005e111be93521 = ({ start: start })=>{
    // initial load only
    if (start !== 0) return {};
    const ssrMark = (0, $gTeiy.getSSRMark)();
    const reporter = new (0, $ekXvG.CHRReporter)(ssrMark);
    try {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        for (const entry of (0, $6RCeq.default).getEntriesByType('resource'))reporter.add(entry);
        const chr = reporter.get();
        return chr === null ? {} : {
            chr: chr
        };
    } catch (e) {
        return {};
    }
};

});
parcelRegister("ekXvG", function(module, exports) {

$parcel$export(module.exports, "CHRReporter", () => $c5fedb07a1d14b68$export$7d0d4cfb6455ffa5);

var $9eQtD = parcelRequire("9eQtD");

var $3WGWs = parcelRequire("3WGWs");
class $c5fedb07a1d14b68$export$7d0d4cfb6455ffa5 {
    constructor(ssrMark){
        this.preloaded = new (0, $3WGWs.CHRSummary)();
        this.all = new (0, $3WGWs.CHRSummary)();
        this.ssrMark = null;
        this.ssrMark = ssrMark;
    }
    add(item) {
        if (item.encodedBodySize === 0) return;
        if (item.initiatorType === 'link' && (0, $9eQtD.cacheableTypes).includes(item.initiatorType) && (this.ssrMark === null || item.startTime < this.ssrMark)) this.preloaded.add(item);
        this.all.add(item);
    }
    static round(n) {
        return Math.round(n * 10000) / 10000;
    }
    makePayload(summary) {
        const bundlesLoadType = {
            mem: $c5fedb07a1d14b68$export$7d0d4cfb6455ffa5.round(summary.bundles[(0, $3WGWs.CHRSummary).MEMORY_KEY] / summary.bundlesCount),
            disk: $c5fedb07a1d14b68$export$7d0d4cfb6455ffa5.round(summary.bundles[(0, $3WGWs.CHRSummary).DISK_KEY] / summary.bundlesCount),
            net: $c5fedb07a1d14b68$export$7d0d4cfb6455ffa5.round(summary.bundles[(0, $3WGWs.CHRSummary).NETWORK_KEY] / summary.bundlesCount)
        };
        const bundlesRatio = $c5fedb07a1d14b68$export$7d0d4cfb6455ffa5.round((summary.bundles[(0, $3WGWs.CHRSummary).MEMORY_KEY] + summary.bundles[(0, $3WGWs.CHRSummary).DISK_KEY]) / summary.bundlesCount);
        const sizeLoadType = {
            mem: $c5fedb07a1d14b68$export$7d0d4cfb6455ffa5.round(summary.size[(0, $3WGWs.CHRSummary).MEMORY_KEY] / summary.sizeTotal),
            disk: $c5fedb07a1d14b68$export$7d0d4cfb6455ffa5.round(summary.size[(0, $3WGWs.CHRSummary).DISK_KEY] / summary.sizeTotal),
            net: $c5fedb07a1d14b68$export$7d0d4cfb6455ffa5.round(summary.size[(0, $3WGWs.CHRSummary).NETWORK_KEY] / summary.sizeTotal)
        };
        const sizeRatio = $c5fedb07a1d14b68$export$7d0d4cfb6455ffa5.round((summary.size[(0, $3WGWs.CHRSummary).MEMORY_KEY] + summary.size[(0, $3WGWs.CHRSummary).DISK_KEY]) / summary.sizeTotal);
        return {
            bundles: {
                ratio: bundlesRatio,
                count: summary.bundlesCount,
                loadType: bundlesLoadType
            },
            size: {
                ratio: sizeRatio,
                total: summary.sizeTotal,
                loadType: sizeLoadType
            }
        };
    }
    get() {
        if (this.all.bundlesCount === 0) return null;
        return {
            preloaded: this.makePayload(this.preloaded),
            all: this.makePayload(this.all)
        };
    }
}

});
parcelRegister("9eQtD", function(module, exports) {

$parcel$export(module.exports, "cacheableTypes", () => $42743a289bbd6eda$export$5e1aa91d6932ddaa);
/* Borrowed from https://bitbucket.org/atlassian/atlassian-frontend/src/master/packages/performance/browser-metrics/src/plugins/timings/resource.ts */ const $42743a289bbd6eda$export$5e1aa91d6932ddaa = [
    'script',
    'link'
];

});

parcelRegister("3WGWs", function(module, exports) {

$parcel$export(module.exports, "CHRSummary", () => $f01a390e08ba2df1$export$783d6618ee601ba);

var $9eQtD = parcelRequire("9eQtD");
const $f01a390e08ba2df1$var$calculateTransferType = (type, duration, size)=>{
    if (!(0, $9eQtD.cacheableTypes).includes(type)) return null;
    if ((size === undefined || size === 0) && duration === 0) return $f01a390e08ba2df1$export$783d6618ee601ba.MEMORY_KEY;
    if (size === 0 && duration > 0) return $f01a390e08ba2df1$export$783d6618ee601ba.DISK_KEY;
    if (size === undefined) return null;
    return $f01a390e08ba2df1$export$783d6618ee601ba.NETWORK_KEY;
};
class $f01a390e08ba2df1$export$783d6618ee601ba {
    static{
        this.MEMORY_KEY = 'mem';
    }
    static{
        this.DISK_KEY = 'disk';
    }
    static{
        this.NETWORK_KEY = 'net';
    }
    add(item) {
        const type = $f01a390e08ba2df1$var$calculateTransferType(item.initiatorType, item.duration, item.transferSize);
        if (type === null) return;
        this.bundles[type] += 1;
        this.bundlesCount += 1;
        this.size[type] += item.encodedBodySize;
        this.sizeTotal += item.encodedBodySize;
    }
    constructor(){
        this.bundles = {
            [$f01a390e08ba2df1$export$783d6618ee601ba.MEMORY_KEY]: 0,
            [$f01a390e08ba2df1$export$783d6618ee601ba.DISK_KEY]: 0,
            [$f01a390e08ba2df1$export$783d6618ee601ba.NETWORK_KEY]: 0
        };
        this.bundlesCount = 0;
        this.size = {
            [$f01a390e08ba2df1$export$783d6618ee601ba.MEMORY_KEY]: 0,
            [$f01a390e08ba2df1$export$783d6618ee601ba.DISK_KEY]: 0,
            [$f01a390e08ba2df1$export$783d6618ee601ba.NETWORK_KEY]: 0
        };
        this.sizeTotal = 0;
    }
}

});



parcelRegister("mLjsE", function(module, exports) {

$parcel$export(module.exports, "getRouterResourceMetrics", () => $af70eb1388acffb9$export$e703af446a67c7f4);
const $af70eb1388acffb9$export$e703af446a67c7f4 = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const ssrRouterResourceTimeouts = window.SPA_STATE ? Object.keys(window.SPA_STATE).filter((key)=>{
        if (key !== key.toUpperCase()) return false;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const resource = window.SPA_STATE[key];
        if (typeof resource !== 'object') return false;
        const resourceResponse = resource[Object.keys(resource)[0]];
        return resourceResponse?.error?.name === 'TimeoutError';
    }) : [];
    return {
        ssrRouterResourceTimeouts: ssrRouterResourceTimeouts
    };
};

});

parcelRegister("6TT7P", function(module, exports) {

$parcel$export(module.exports, "getWRMStats", () => $5d89930aeb19a660$export$d2d916ddd03b82bc);
const $5d89930aeb19a660$export$d2d916ddd03b82bc = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const wrmStats = window.__WRM_INTERNAL_STATS__ ?? {};
    return {
        wrmStats: wrmStats
    };
};

});


parcelRegister("8n0Ui", function(module, exports) {

$parcel$export(module.exports, "jfpPerfFeatureFlags", () => $dc3e3d5eb91680e6$export$b1f8075e4696e880);
const $dc3e3d5eb91680e6$export$b1f8075e4696e880 = [
    // <jlane>
    'delorean.fix-locale-formats',
    // </jlane>
    // <ldurkan>
    // </ldurkan>
    // <molejniczak>
    // </molejniczak>
    // <etimothy>
    // </etimothy>
    // <lcaseiro>
    // </lcaseiro>
    // <zzheng>
    // </zzheng>
    // <lma>
    // </lma>
    // <ccarloni>
    // </ccarloni>
    // <agasparin>
    'fe_platform_error_tracking_enabled_sentry',
    // </agasparin>
    // <mbiniek>
    // </mbiniek>
    // <yvovk>
    'independent-bump-button-bento_6a9fd',
    // </yvovk>
    // <bduffin>
    // </bduffin>
    // <atay>
    // </atay>
    // <gotham>
    'issue-view-config-type-cleanup-enabled_mz6ah',
    // </gotham>
    // <nhiebl>
    'ptc.organization-id.fetch.enabled'
];

});

parcelRegister("2jgcS", function(module, exports) {

$parcel$export(module.exports, "getLighthouseMetrics", () => $ad82cb13bb351b16$export$b46cecdf698e4bb5);

var $7sZKr = parcelRequire("7sZKr");

var $bKsu9 = parcelRequire("bKsu9");

var $gd6QZ = parcelRequire("gd6QZ");

var $lLfZC = parcelRequire("lLfZC");

var $7jf8R = parcelRequire("7jf8R");
const $ad82cb13bb351b16$export$b46cecdf698e4bb5 = ({ start: start, stop: stop })=>{
    const tbt = (0, $gd6QZ.getTBT)(start, stop, (0, $lLfZC.EntriesBuffer)[(0, $bKsu9.PerformanceObserverEntryTypes).LongTask]);
    // no round as CLS is usually 0-1
    const cls = (0, $7sZKr.getCLS)(start, stop, (0, $lLfZC.EntriesBuffer)[(0, $bKsu9.PerformanceObserverEntryTypes).LayoutShift]);
    return {
        'metric:tbt': Math.round(tbt.total),
        'metric:tbt:observed': Math.round(tbt.observed),
        'metric:cls': cls
    };
};

});
parcelRegister("7sZKr", function(module, exports) {

$parcel$export(module.exports, "getCLS", () => $7d51058ba1305932$export$fc6227831ee7c7);
const $7d51058ba1305932$export$fc6227831ee7c7 = (start, stop, buffer)=>{
    const layoutShifts = buffer.getAll().filter((entry)=>entry.startTime >= start && entry.startTime <= stop);
    const sessionWindows = [];
    let currentWindow = null;
    // Group layout shifts into session windows
    for (const shift of layoutShifts){
        const { startTime: startTime } = shift;
        const endTime = shift.startTime + shift.duration;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const score = shift.value;
        if (currentWindow === null || startTime - currentWindow.endTime > 1000 || endTime - currentWindow.startTime > 5000) {
            // Start a new session window
            currentWindow = {
                startTime: startTime,
                endTime: endTime,
                score: score
            };
            sessionWindows.push(currentWindow);
        } else {
            // Add layout shift to current session window
            currentWindow.endTime = endTime;
            currentWindow.score += score;
        }
    }
    // Find session window with highest cumulative score
    const maxScore = sessionWindows.reduce((max, sessionWindow)=>sessionWindow.score > max ? sessionWindow.score : max, 0);
    // Return score of largest burst as CLS metric
    return Math.round(maxScore * 10000) / 10000;
};

});

parcelRegister("bKsu9", function(module, exports) {

$parcel$export(module.exports, "PerformanceObserverEntryTypes", () => $ef016de697a56e43$export$a4def92db6fc8e17);
const $ef016de697a56e43$export$a4def92db6fc8e17 = {
    LayoutShift: 'layout-shift',
    LongTask: 'longtask'
};

});

parcelRegister("gd6QZ", function(module, exports) {

$parcel$export(module.exports, "getTBT", () => $108918fd1d99ffe5$export$2d6e933b35bd3407);
const $108918fd1d99ffe5$var$MAX_ACCEPTABLE_TASK_DURATION = 50;
const $108918fd1d99ffe5$export$2d6e933b35bd3407 = (start, stop, buffer)=>buffer.getAll().filter((entry)=>entry.startTime <= stop && entry.duration > $108918fd1d99ffe5$var$MAX_ACCEPTABLE_TASK_DURATION && (entry.startTime >= start || entry.startTime + entry.duration >= start || entry.startTime <= start && entry.startTime + entry.duration >= stop)).reduce((tbt, entry)=>{
        const longTaskStop = entry.startTime + entry.duration;
        const intersectStart = Math.max(entry.startTime + $108918fd1d99ffe5$var$MAX_ACCEPTABLE_TASK_DURATION, start);
        const intersectStop = Math.min(longTaskStop, stop);
        const longTaskIncluded = Math.max(intersectStop - intersectStart, 0);
        // eslint-disable-next-line no-param-reassign
        tbt.observed += entry.duration - $108918fd1d99ffe5$var$MAX_ACCEPTABLE_TASK_DURATION;
        // eslint-disable-next-line no-param-reassign
        tbt.total += longTaskIncluded;
        return tbt;
    }, {
        total: 0,
        observed: 0
    });

});

parcelRegister("lLfZC", function(module, exports) {

$parcel$export(module.exports, "EntriesBuffer", () => $108d930970d565b4$export$f7dc16cbd16f7bbe);

var $bKsu9 = parcelRequire("bKsu9");
class $108d930970d565b4$export$2c6e86519c9e8188 {
    constructor(maxLength = 1000){
        this.buffer = [];
        this.full = false;
        this.maxLength = maxLength;
    }
    push(item) {
        if (this.full || this.maxLength === this.buffer.length) {
            this.full = true;
            this.buffer.shift();
        }
        this.buffer.push(item);
    }
    getAll() {
        return this.buffer;
    }
}
const $108d930970d565b4$export$f7dc16cbd16f7bbe = {
    [(0, $bKsu9.PerformanceObserverEntryTypes).LongTask]: new $108d930970d565b4$export$2c6e86519c9e8188(),
    [(0, $bKsu9.PerformanceObserverEntryTypes).LayoutShift]: new $108d930970d565b4$export$2c6e86519c9e8188()
};

});

parcelRegister("7jf8R", function(module, exports) {

$parcel$export(module.exports, "startLSObserver", () => $bfa143e31804850e$export$768ccc3ab7bac3ea);
$parcel$export(module.exports, "startLTObserver", () => $bfa143e31804850e$export$54fb8b6aaf70ec9c);

var $bKsu9 = parcelRequire("bKsu9");

var $lLfZC = parcelRequire("lLfZC");
let $bfa143e31804850e$var$pe = null;
const $bfa143e31804850e$var$getObserver = ()=>{
    if ($bfa143e31804850e$var$pe !== null) return $bfa143e31804850e$var$pe;
    $bfa143e31804850e$var$pe = new PerformanceObserver((list)=>{
        list.getEntries().forEach((entry)=>{
            if (entry.entryType === (0, $bKsu9.PerformanceObserverEntryTypes).LayoutShift) (0, $lLfZC.EntriesBuffer)[(0, $bKsu9.PerformanceObserverEntryTypes).LayoutShift].push(entry);
            if (entry.entryType === (0, $bKsu9.PerformanceObserverEntryTypes).LongTask) (0, $lLfZC.EntriesBuffer)[(0, $bKsu9.PerformanceObserverEntryTypes).LongTask].push(entry);
        });
    });
    return $bfa143e31804850e$var$pe;
};
const $bfa143e31804850e$export$768ccc3ab7bac3ea = ()=>{
    $bfa143e31804850e$var$getObserver().observe({
        type: (0, $bKsu9.PerformanceObserverEntryTypes).LayoutShift,
        buffered: true
    });
};
const $bfa143e31804850e$export$54fb8b6aaf70ec9c = ()=>{
    $bfa143e31804850e$var$getObserver().observe({
        type: (0, $bKsu9.PerformanceObserverEntryTypes).LongTask,
        buffered: true
    });
};

});



const $5f2d1e7b8a614058$export$ce553301d55c2fd8 = 'fedramp-moderate';
const $5f2d1e7b8a614058$export$f005e2e9f707cb5f = 'commercial';
const $5f2d1e7b8a614058$export$bd6b5a7802d76127 = 'fedramp-fedex';
const $5f2d1e7b8a614058$export$a739cd5aac835909 = 'stg';
const $5f2d1e7b8a614058$export$42dd0cdd351a4a9 = 'prod';
const $5f2d1e7b8a614058$export$404582bc18fe4d9e = 'dev';

const $90de389b166e701f$export$42f4885608027d0c = 'non_boolean';

const $281cbd47ba46dd7d$export$ef94a84e2990361c = 'ISSUE_VIEW';
const $281cbd47ba46dd7d$export$fc5f182fc9019b1c = 'CLASSIC_BOARD';
const $281cbd47ba46dd7d$export$664edf77d4c76110 = 'COMPANY_MANAGED_BOARD';
const $281cbd47ba46dd7d$export$f364828958cffad0 = 'TEAM_MANAGED_BOARD';
const $281cbd47ba46dd7d$export$93104dc4eba58ba4 = 'CLASSIC_BACKLOG';
const $281cbd47ba46dd7d$export$571692eec8a399e1 = 'COMPANY_MANAGED_BACKLOG';
const $281cbd47ba46dd7d$export$c17f34c425972af1 = 'TEAM_MANAGED_BACKLOG';
const $281cbd47ba46dd7d$export$d0ad1160bb95ce50 = 'NIN_NEW_ISSUE_NAVIGATOR';
const $281cbd47ba46dd7d$export$4695c1a423ffe431 = 'DASHBOARD';
const $281cbd47ba46dd7d$export$f999749ac7a2cd1 = 'PLAN_CALENDAR';
const $281cbd47ba46dd7d$export$9a80695e72849f84 = 'X-Atlassian-Capability';

// SCREENS
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';

const $6e65040b988c460f$export$f636b5b56f1d624a = 'Screen';
const $6e65040b988c460f$export$9d2de6eebf7462b5 = 'Drawer';
const $6e65040b988c460f$export$1171103ea9083ffa = 'Modal';
const $6e65040b988c460f$export$cae2783c9279926 = 'InlineDialog';
const $6e65040b988c460f$export$d1123261ca8831d2 = 'Dropdown';
const $6e65040b988c460f$export$a1562d08625f5d7e = 'UI';
const $6e65040b988c460f$export$947dac6c72b26f81 = 'TRACK';
const $6e65040b988c460f$export$f1d537d508d2945a = 'SCREEN';
const $6e65040b988c460f$export$12346a674644c156 = 'OPERATIONAL';
const $6e65040b988c460f$export$2ceccf177fae277c = 'analyticsBridge';

// Media uses a namespaced analytics context under the following key MEDIA_CONTEXT.
const $b276966247f2f12d$export$70df29c238ba7306 = 'mediaCtx'; // However we don't export any JSX component to create that namespaced analytics context.
 // In media components, analytics context is being created by this component:
 // @see packages/media/media-common/src/analytics/withMediaAnalyticsContext.tsx

const $636842cf8e8f850b$export$b98e411ae80c806f = '/';

const $b2e0d12d54fddedd$export$cf090d5281b5ae06 = 10000;
const $b2e0d12d54fddedd$export$8575e30be0feb909 = 30000;

// same types defined in analytics-web-client but avoid creating dependency with that
const $676c5e519aa5ba55$export$a1562d08625f5d7e = 'ui';
const $676c5e519aa5ba55$export$947dac6c72b26f81 = 'track';
const $676c5e519aa5ba55$export$f1d537d508d2945a = 'screen';
const $676c5e519aa5ba55$export$12346a674644c156 = 'operational';
const $676c5e519aa5ba55$export$b055de0e665cb20c = 'unknown';

const $da88f8f66d8f0f0a$export$3288b14b6745c572 = 204;
const $da88f8f66d8f0f0a$export$c09e7ea0fc79f34f = 409;
const $da88f8f66d8f0f0a$export$974c37534b0191b1 = 503;

// temp solution until a proper versioning
const $46f5b02486779691$export$93809551debf385f = '0.1.7';

const $088984e189011c8c$export$b98e411ae80c806f = '/';


$parcel$global.rlb("kGAgW")
//# sourceMappingURL=shared~commons~ar.67db8a60.js.map
